/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  bigint: { input: any; output: any }
  citext: { input: any; output: any }
  contract_locks: { input: any; output: any }
  contract_states: { input: any; output: any }
  cost_periods: { input: any; output: any }
  custom_field_value_types: { input: any; output: any }
  date: { input: any; output: any }
  day_of_week: { input: any; output: any }
  float8: { input: any; output: any }
  job_runtime_types: { input: any; output: any }
  job_state: { input: any; output: any }
  job_trigger_types: { input: any; output: any }
  job_types: { input: any; output: any }
  json: { input: any; output: any }
  jsonb: { input: any; output: any }
  roles: { input: any; output: any }
  timestamptz: { input: any; output: any }
  tstzrange: { input: any; output: any }
  uuid: { input: any; output: any }
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>
  _gt?: InputMaybe<Scalars['Boolean']['input']>
  _gte?: InputMaybe<Scalars['Boolean']['input']>
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['Boolean']['input']>
  _lte?: InputMaybe<Scalars['Boolean']['input']>
  _neq?: InputMaybe<Scalars['Boolean']['input']>
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>
}

export type GenerateJobResultS3UrlOutput = {
  __typename?: 'GenerateJobResultS3UrlOutput'
  url?: Maybe<Scalars['String']['output']>
}

export type GenerateS3UrlForUploadOutput = {
  __typename?: 'GenerateS3UrlForUploadOutput'
  url?: Maybe<Scalars['String']['output']>
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>
  _gt?: InputMaybe<Scalars['Int']['input']>
  _gte?: InputMaybe<Scalars['Int']['input']>
  _in?: InputMaybe<Array<Scalars['Int']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['Int']['input']>
  _lte?: InputMaybe<Scalars['Int']['input']>
  _neq?: InputMaybe<Scalars['Int']['input']>
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type Output = {
  __typename?: 'Output'
  reason?: Maybe<Scalars['String']['output']>
  result: Scalars['String']['output']
}

export type ResetMfaUserStatusOutput = {
  __typename?: 'ResetMfaUserStatusOutput'
  message: Scalars['String']['output']
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>
  _gt?: InputMaybe<Scalars['String']['input']>
  _gte?: InputMaybe<Scalars['String']['input']>
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>
  _in?: InputMaybe<Array<Scalars['String']['input']>>
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>
  _lt?: InputMaybe<Scalars['String']['input']>
  _lte?: InputMaybe<Scalars['String']['input']>
  _neq?: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>
  _nin?: InputMaybe<Array<Scalars['String']['input']>>
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>
}

export type TriggerJobByIdOutput = {
  __typename?: 'TriggerJobByIdOutput'
  id: Scalars['String']['output']
}

export type TriggerJobByNameOutput = {
  __typename?: 'TriggerJobByNameOutput'
  ids: Array<Scalars['String']['output']>
}

/** fields of action: "UpdateMfaStatus" */
export type UpdateMfaStatus = {
  __typename?: 'UpdateMfaStatus'
  /** the time at which this action was created */
  created_at: Scalars['timestamptz']['output']
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']['output']>
  /** the unique id of an action */
  id: Scalars['uuid']['output']
  /** the output fields of this action */
  output?: Maybe<UpdateMfaStatusOutput>
}

export type UpdateMfaStatusOutput = {
  __typename?: 'UpdateMfaStatusOutput'
  message?: Maybe<Scalars['String']['output']>
}

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>
  _gt?: InputMaybe<Scalars['bigint']['input']>
  _gte?: InputMaybe<Scalars['bigint']['input']>
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['bigint']['input']>
  _lte?: InputMaybe<Scalars['bigint']['input']>
  _neq?: InputMaybe<Scalars['bigint']['input']>
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>
}

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>
  _gt?: InputMaybe<Scalars['citext']['input']>
  _gte?: InputMaybe<Scalars['citext']['input']>
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>
  _in?: InputMaybe<Array<Scalars['citext']['input']>>
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>
  _lt?: InputMaybe<Scalars['citext']['input']>
  _lte?: InputMaybe<Scalars['citext']['input']>
  _neq?: InputMaybe<Scalars['citext']['input']>
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>
}

/** columns and relationships of "coassign.assign" */
export type Coassign_Assign = {
  __typename?: 'coassign_assign'
  /** An array relationship */
  assign_plans: Array<Coassign_Assign_Plan>
  /** An aggregate relationship */
  assign_plans_aggregate: Coassign_Assign_Plan_Aggregate
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  /** An object relationship */
  job_title: Coassign_Job_Title
  job_title_id: Scalars['String']['output']
  /** An object relationship */
  project: Coassign_Project
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
  user_id: Scalars['String']['output']
  visible: Scalars['Boolean']['output']
  /** An array relationship */
  work_on_projects: Array<Coassign_Work_On_Project>
  /** An aggregate relationship */
  work_on_projects_aggregate: Coassign_Work_On_Project_Aggregate
}

/** columns and relationships of "coassign.assign" */
export type Coassign_AssignAssign_PlansArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

/** columns and relationships of "coassign.assign" */
export type Coassign_AssignAssign_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

/** columns and relationships of "coassign.assign" */
export type Coassign_AssignWork_On_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

/** columns and relationships of "coassign.assign" */
export type Coassign_AssignWork_On_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

/** aggregated selection of "coassign.assign" */
export type Coassign_Assign_Aggregate = {
  __typename?: 'coassign_assign_aggregate'
  aggregate?: Maybe<Coassign_Assign_Aggregate_Fields>
  nodes: Array<Coassign_Assign>
}

export type Coassign_Assign_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Coassign_Assign_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Coassign_Assign_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Coassign_Assign_Aggregate_Bool_Exp_Count>
}

export type Coassign_Assign_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coassign_Assign_Select_Column_Coassign_Assign_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Assign_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Assign_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coassign_Assign_Select_Column_Coassign_Assign_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Assign_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Assign_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Assign_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.assign" */
export type Coassign_Assign_Aggregate_Fields = {
  __typename?: 'coassign_assign_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Assign_Max_Fields>
  min?: Maybe<Coassign_Assign_Min_Fields>
}

/** aggregate fields of "coassign.assign" */
export type Coassign_Assign_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.assign" */
export type Coassign_Assign_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Assign_Max_Order_By>
  min?: InputMaybe<Coassign_Assign_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.assign" */
export type Coassign_Assign_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Assign_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Assign_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.assign". All fields are combined with a logical 'AND'. */
export type Coassign_Assign_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Assign_Bool_Exp>>
  _not?: InputMaybe<Coassign_Assign_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Assign_Bool_Exp>>
  assign_plans?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
  assign_plans_aggregate?: InputMaybe<Coassign_Assign_Plan_Aggregate_Bool_Exp>
  comment?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  icon?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_title?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  job_title_id?: InputMaybe<String_Comparison_Exp>
  project?: InputMaybe<Coassign_Project_Bool_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
  visible?: InputMaybe<Boolean_Comparison_Exp>
  work_on_projects?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
  work_on_projects_aggregate?: InputMaybe<Coassign_Work_On_Project_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.assign" */
export enum Coassign_Assign_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignPkey = 'assign_pkey',
  /** unique or primary key constraint on columns "user_id", "job_title_id", "project_id" */
  AssignProjectIdJobTitleIdUserIdDeletedAt = 'assign_project_id_job_title_id_user_id_deleted_at'
}

/** columns and relationships of "coassign.assign_full_view" */
export type Coassign_Assign_Full_View = {
  __typename?: 'coassign_assign_full_view'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
  visible?: Maybe<Scalars['Boolean']['output']>
}

/** aggregated selection of "coassign.assign_full_view" */
export type Coassign_Assign_Full_View_Aggregate = {
  __typename?: 'coassign_assign_full_view_aggregate'
  aggregate?: Maybe<Coassign_Assign_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Assign_Full_View>
}

/** aggregate fields of "coassign.assign_full_view" */
export type Coassign_Assign_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_assign_full_view_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Assign_Full_View_Max_Fields>
  min?: Maybe<Coassign_Assign_Full_View_Min_Fields>
}

/** aggregate fields of "coassign.assign_full_view" */
export type Coassign_Assign_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Assign_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.assign_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Assign_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Assign_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Assign_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Assign_Full_View_Bool_Exp>>
  comment?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  icon?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_title_id?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
  visible?: InputMaybe<Boolean_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Assign_Full_View_Max_Fields = {
  __typename?: 'coassign_assign_full_view_max_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Assign_Full_View_Min_Fields = {
  __typename?: 'coassign_assign_full_view_min_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** Ordering options when selecting data from "coassign.assign_full_view". */
export type Coassign_Assign_Full_View_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
  visible?: InputMaybe<Order_By>
}

/** select columns of table "coassign.assign_full_view" */
export enum Coassign_Assign_Full_View_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visible = 'visible'
}

/** Streaming cursor of the table "coassign_assign_full_view" */
export type Coassign_Assign_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Assign_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Assign_Full_View_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** columns and relationships of "coassign.assign_history" */
export type Coassign_Assign_History = {
  __typename?: 'coassign_assign_history'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  job_title_id: Scalars['String']['output']
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  user_id: Scalars['String']['output']
  visible: Scalars['Boolean']['output']
}

/** aggregated selection of "coassign.assign_history" */
export type Coassign_Assign_History_Aggregate = {
  __typename?: 'coassign_assign_history_aggregate'
  aggregate?: Maybe<Coassign_Assign_History_Aggregate_Fields>
  nodes: Array<Coassign_Assign_History>
}

/** aggregate fields of "coassign.assign_history" */
export type Coassign_Assign_History_Aggregate_Fields = {
  __typename?: 'coassign_assign_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Assign_History_Max_Fields>
  min?: Maybe<Coassign_Assign_History_Min_Fields>
}

/** aggregate fields of "coassign.assign_history" */
export type Coassign_Assign_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Assign_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.assign_history". All fields are combined with a logical 'AND'. */
export type Coassign_Assign_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Assign_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Assign_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Assign_History_Bool_Exp>>
  comment?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  icon?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_title_id?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
  visible?: InputMaybe<Boolean_Comparison_Exp>
}

/** input type for inserting data into table "coassign.assign_history" */
export type Coassign_Assign_History_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate max on columns */
export type Coassign_Assign_History_Max_Fields = {
  __typename?: 'coassign_assign_history_max_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Assign_History_Min_Fields = {
  __typename?: 'coassign_assign_history_min_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "coassign.assign_history" */
export type Coassign_Assign_History_Mutation_Response = {
  __typename?: 'coassign_assign_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Assign_History>
}

/** Ordering options when selecting data from "coassign.assign_history". */
export type Coassign_Assign_History_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
  visible?: InputMaybe<Order_By>
}

/** select columns of table "coassign.assign_history" */
export enum Coassign_Assign_History_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "coassign.assign_history" */
export type Coassign_Assign_History_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** Streaming cursor of the table "coassign_assign_history" */
export type Coassign_Assign_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Assign_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Assign_History_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

export type Coassign_Assign_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Assign_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Assign_History_Bool_Exp
}

/** input type for inserting data into table "coassign.assign" */
export type Coassign_Assign_Insert_Input = {
  assign_plans?: InputMaybe<Coassign_Assign_Plan_Arr_Rel_Insert_Input>
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title?: InputMaybe<Coassign_Job_Title_Obj_Rel_Insert_Input>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project?: InputMaybe<Coassign_Project_Obj_Rel_Insert_Input>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['String']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
  work_on_projects?: InputMaybe<Coassign_Work_On_Project_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_Assign_Max_Fields = {
  __typename?: 'coassign_assign_max_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.assign" */
export type Coassign_Assign_Max_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Assign_Min_Fields = {
  __typename?: 'coassign_assign_min_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.assign" */
export type Coassign_Assign_Min_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.assign" */
export type Coassign_Assign_Mutation_Response = {
  __typename?: 'coassign_assign_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Assign>
}

/** input type for inserting object relation for remote table "coassign.assign" */
export type Coassign_Assign_Obj_Rel_Insert_Input = {
  data: Coassign_Assign_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Assign_On_Conflict>
}

/** on_conflict condition type for table "coassign.assign" */
export type Coassign_Assign_On_Conflict = {
  constraint: Coassign_Assign_Constraint
  update_columns?: Array<Coassign_Assign_Update_Column>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.assign". */
export type Coassign_Assign_Order_By = {
  assign_plans_aggregate?: InputMaybe<Coassign_Assign_Plan_Aggregate_Order_By>
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title?: InputMaybe<Coassign_Job_Title_Order_By>
  job_title_id?: InputMaybe<Order_By>
  project?: InputMaybe<Coassign_Project_Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
  user_id?: InputMaybe<Order_By>
  visible?: InputMaybe<Order_By>
  work_on_projects_aggregate?: InputMaybe<Coassign_Work_On_Project_Aggregate_Order_By>
}

/** primary key columns input for table: coassign.assign */
export type Coassign_Assign_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** columns and relationships of "coassign.assign_plan" */
export type Coassign_Assign_Plan = {
  __typename?: 'coassign_assign_plan'
  assign_id: Scalars['String']['output']
  /** An object relationship */
  assign_plan_assign: Coassign_Assign
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset: Scalars['Int']['output']
  estimate: Scalars['Int']['output']
  id: Scalars['String']['output']
  start_offset: Scalars['Int']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.assign_plan" */
export type Coassign_Assign_Plan_Aggregate = {
  __typename?: 'coassign_assign_plan_aggregate'
  aggregate?: Maybe<Coassign_Assign_Plan_Aggregate_Fields>
  nodes: Array<Coassign_Assign_Plan>
}

export type Coassign_Assign_Plan_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Assign_Plan_Aggregate_Bool_Exp_Count>
}

export type Coassign_Assign_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.assign_plan" */
export type Coassign_Assign_Plan_Aggregate_Fields = {
  __typename?: 'coassign_assign_plan_aggregate_fields'
  avg?: Maybe<Coassign_Assign_Plan_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Assign_Plan_Max_Fields>
  min?: Maybe<Coassign_Assign_Plan_Min_Fields>
  stddev?: Maybe<Coassign_Assign_Plan_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Assign_Plan_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Assign_Plan_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Assign_Plan_Sum_Fields>
  var_pop?: Maybe<Coassign_Assign_Plan_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Assign_Plan_Var_Samp_Fields>
  variance?: Maybe<Coassign_Assign_Plan_Variance_Fields>
}

/** aggregate fields of "coassign.assign_plan" */
export type Coassign_Assign_Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Assign_Plan_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Assign_Plan_Max_Order_By>
  min?: InputMaybe<Coassign_Assign_Plan_Min_Order_By>
  stddev?: InputMaybe<Coassign_Assign_Plan_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Assign_Plan_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Assign_Plan_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Assign_Plan_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Assign_Plan_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Assign_Plan_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Assign_Plan_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Assign_Plan_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Assign_Plan_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Assign_Plan_Avg_Fields = {
  __typename?: 'coassign_assign_plan_avg_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Avg_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.assign_plan". All fields are combined with a logical 'AND'. */
export type Coassign_Assign_Plan_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Assign_Plan_Bool_Exp>>
  _not?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Assign_Plan_Bool_Exp>>
  assign_id?: InputMaybe<String_Comparison_Exp>
  assign_plan_assign?: InputMaybe<Coassign_Assign_Bool_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  end_offset?: InputMaybe<Int_Comparison_Exp>
  estimate?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  start_offset?: InputMaybe<Int_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.assign_plan" */
export enum Coassign_Assign_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignPlanPkey = 'assign_plan_pkey'
}

/** columns and relationships of "coassign.assign_plan_full_view" */
export type Coassign_Assign_Plan_Full_View = {
  __typename?: 'coassign_assign_plan_full_view'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregated selection of "coassign.assign_plan_full_view" */
export type Coassign_Assign_Plan_Full_View_Aggregate = {
  __typename?: 'coassign_assign_plan_full_view_aggregate'
  aggregate?: Maybe<Coassign_Assign_Plan_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Assign_Plan_Full_View>
}

/** aggregate fields of "coassign.assign_plan_full_view" */
export type Coassign_Assign_Plan_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_assign_plan_full_view_aggregate_fields'
  avg?: Maybe<Coassign_Assign_Plan_Full_View_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Assign_Plan_Full_View_Max_Fields>
  min?: Maybe<Coassign_Assign_Plan_Full_View_Min_Fields>
  stddev?: Maybe<Coassign_Assign_Plan_Full_View_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Assign_Plan_Full_View_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Assign_Plan_Full_View_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Assign_Plan_Full_View_Sum_Fields>
  var_pop?: Maybe<Coassign_Assign_Plan_Full_View_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Assign_Plan_Full_View_Var_Samp_Fields>
  variance?: Maybe<Coassign_Assign_Plan_Full_View_Variance_Fields>
}

/** aggregate fields of "coassign.assign_plan_full_view" */
export type Coassign_Assign_Plan_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Coassign_Assign_Plan_Full_View_Avg_Fields = {
  __typename?: 'coassign_assign_plan_full_view_avg_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "coassign.assign_plan_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Assign_Plan_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Assign_Plan_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Bool_Exp>>
  assign_id?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  end_offset?: InputMaybe<Int_Comparison_Exp>
  estimate?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  start_offset?: InputMaybe<Int_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Assign_Plan_Full_View_Max_Fields = {
  __typename?: 'coassign_assign_plan_full_view_max_fields'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Assign_Plan_Full_View_Min_Fields = {
  __typename?: 'coassign_assign_plan_full_view_min_fields'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** Ordering options when selecting data from "coassign.assign_plan_full_view". */
export type Coassign_Assign_Plan_Full_View_Order_By = {
  assign_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "coassign.assign_plan_full_view" */
export enum Coassign_Assign_Plan_Full_View_Select_Column {
  /** column name */
  AssignId = 'assign_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndOffset = 'end_offset',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  Id = 'id',
  /** column name */
  StartOffset = 'start_offset',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Coassign_Assign_Plan_Full_View_Stddev_Fields = {
  __typename?: 'coassign_assign_plan_full_view_stddev_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Coassign_Assign_Plan_Full_View_Stddev_Pop_Fields = {
  __typename?: 'coassign_assign_plan_full_view_stddev_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Coassign_Assign_Plan_Full_View_Stddev_Samp_Fields = {
  __typename?: 'coassign_assign_plan_full_view_stddev_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "coassign_assign_plan_full_view" */
export type Coassign_Assign_Plan_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Assign_Plan_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Assign_Plan_Full_View_Stream_Cursor_Value_Input = {
  assign_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Assign_Plan_Full_View_Sum_Fields = {
  __typename?: 'coassign_assign_plan_full_view_sum_fields'
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
}

/** aggregate var_pop on columns */
export type Coassign_Assign_Plan_Full_View_Var_Pop_Fields = {
  __typename?: 'coassign_assign_plan_full_view_var_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Coassign_Assign_Plan_Full_View_Var_Samp_Fields = {
  __typename?: 'coassign_assign_plan_full_view_var_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Coassign_Assign_Plan_Full_View_Variance_Fields = {
  __typename?: 'coassign_assign_plan_full_view_variance_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "coassign.assign_plan_history" */
export type Coassign_Assign_Plan_History = {
  __typename?: 'coassign_assign_plan_history'
  assign_id: Scalars['String']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset: Scalars['Int']['output']
  estimate: Scalars['Int']['output']
  id: Scalars['String']['output']
  start_offset: Scalars['Int']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.assign_plan_history" */
export type Coassign_Assign_Plan_History_Aggregate = {
  __typename?: 'coassign_assign_plan_history_aggregate'
  aggregate?: Maybe<Coassign_Assign_Plan_History_Aggregate_Fields>
  nodes: Array<Coassign_Assign_Plan_History>
}

/** aggregate fields of "coassign.assign_plan_history" */
export type Coassign_Assign_Plan_History_Aggregate_Fields = {
  __typename?: 'coassign_assign_plan_history_aggregate_fields'
  avg?: Maybe<Coassign_Assign_Plan_History_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Assign_Plan_History_Max_Fields>
  min?: Maybe<Coassign_Assign_Plan_History_Min_Fields>
  stddev?: Maybe<Coassign_Assign_Plan_History_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Assign_Plan_History_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Assign_Plan_History_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Assign_Plan_History_Sum_Fields>
  var_pop?: Maybe<Coassign_Assign_Plan_History_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Assign_Plan_History_Var_Samp_Fields>
  variance?: Maybe<Coassign_Assign_Plan_History_Variance_Fields>
}

/** aggregate fields of "coassign.assign_plan_history" */
export type Coassign_Assign_Plan_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Assign_Plan_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Coassign_Assign_Plan_History_Avg_Fields = {
  __typename?: 'coassign_assign_plan_history_avg_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "coassign.assign_plan_history". All fields are combined with a logical 'AND'. */
export type Coassign_Assign_Plan_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Assign_Plan_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Assign_Plan_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Assign_Plan_History_Bool_Exp>>
  assign_id?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  end_offset?: InputMaybe<Int_Comparison_Exp>
  estimate?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  start_offset?: InputMaybe<Int_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** input type for incrementing numeric columns in table "coassign.assign_plan_history" */
export type Coassign_Assign_Plan_History_Inc_Input = {
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "coassign.assign_plan_history" */
export type Coassign_Assign_Plan_History_Insert_Input = {
  assign_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Assign_Plan_History_Max_Fields = {
  __typename?: 'coassign_assign_plan_history_max_fields'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Assign_Plan_History_Min_Fields = {
  __typename?: 'coassign_assign_plan_history_min_fields'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "coassign.assign_plan_history" */
export type Coassign_Assign_Plan_History_Mutation_Response = {
  __typename?: 'coassign_assign_plan_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Assign_Plan_History>
}

/** Ordering options when selecting data from "coassign.assign_plan_history". */
export type Coassign_Assign_Plan_History_Order_By = {
  assign_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "coassign.assign_plan_history" */
export enum Coassign_Assign_Plan_History_Select_Column {
  /** column name */
  AssignId = 'assign_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndOffset = 'end_offset',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  Id = 'id',
  /** column name */
  StartOffset = 'start_offset',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.assign_plan_history" */
export type Coassign_Assign_Plan_History_Set_Input = {
  assign_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Assign_Plan_History_Stddev_Fields = {
  __typename?: 'coassign_assign_plan_history_stddev_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Coassign_Assign_Plan_History_Stddev_Pop_Fields = {
  __typename?: 'coassign_assign_plan_history_stddev_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Coassign_Assign_Plan_History_Stddev_Samp_Fields = {
  __typename?: 'coassign_assign_plan_history_stddev_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "coassign_assign_plan_history" */
export type Coassign_Assign_Plan_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Assign_Plan_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Assign_Plan_History_Stream_Cursor_Value_Input = {
  assign_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Assign_Plan_History_Sum_Fields = {
  __typename?: 'coassign_assign_plan_history_sum_fields'
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
}

export type Coassign_Assign_Plan_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Assign_Plan_History_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Assign_Plan_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Assign_Plan_History_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Assign_Plan_History_Var_Pop_Fields = {
  __typename?: 'coassign_assign_plan_history_var_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Coassign_Assign_Plan_History_Var_Samp_Fields = {
  __typename?: 'coassign_assign_plan_history_var_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Coassign_Assign_Plan_History_Variance_Fields = {
  __typename?: 'coassign_assign_plan_history_variance_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** input type for incrementing numeric columns in table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Inc_Input = {
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Insert_Input = {
  assign_id?: InputMaybe<Scalars['String']['input']>
  assign_plan_assign?: InputMaybe<Coassign_Assign_Obj_Rel_Insert_Input>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Assign_Plan_Max_Fields = {
  __typename?: 'coassign_assign_plan_max_fields'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Max_Order_By = {
  assign_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Assign_Plan_Min_Fields = {
  __typename?: 'coassign_assign_plan_min_fields'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Min_Order_By = {
  assign_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Mutation_Response = {
  __typename?: 'coassign_assign_plan_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Assign_Plan>
}

/** on_conflict condition type for table "coassign.assign_plan" */
export type Coassign_Assign_Plan_On_Conflict = {
  constraint: Coassign_Assign_Plan_Constraint
  update_columns?: Array<Coassign_Assign_Plan_Update_Column>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.assign_plan". */
export type Coassign_Assign_Plan_Order_By = {
  assign_id?: InputMaybe<Order_By>
  assign_plan_assign?: InputMaybe<Coassign_Assign_Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.assign_plan */
export type Coassign_Assign_Plan_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.assign_plan" */
export enum Coassign_Assign_Plan_Select_Column {
  /** column name */
  AssignId = 'assign_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndOffset = 'end_offset',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  Id = 'id',
  /** column name */
  StartOffset = 'start_offset',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Set_Input = {
  assign_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Assign_Plan_Stddev_Fields = {
  __typename?: 'coassign_assign_plan_stddev_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Stddev_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Assign_Plan_Stddev_Pop_Fields = {
  __typename?: 'coassign_assign_plan_stddev_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Stddev_Pop_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Assign_Plan_Stddev_Samp_Fields = {
  __typename?: 'coassign_assign_plan_stddev_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Stddev_Samp_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_assign_plan" */
export type Coassign_Assign_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Assign_Plan_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Assign_Plan_Stream_Cursor_Value_Input = {
  assign_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Assign_Plan_Sum_Fields = {
  __typename?: 'coassign_assign_plan_sum_fields'
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Sum_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** update columns of table "coassign.assign_plan" */
export enum Coassign_Assign_Plan_Update_Column {
  /** column name */
  AssignId = 'assign_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndOffset = 'end_offset',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  Id = 'id',
  /** column name */
  StartOffset = 'start_offset',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Assign_Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Assign_Plan_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Assign_Plan_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Assign_Plan_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Assign_Plan_Var_Pop_Fields = {
  __typename?: 'coassign_assign_plan_var_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Var_Pop_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Assign_Plan_Var_Samp_Fields = {
  __typename?: 'coassign_assign_plan_var_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Var_Samp_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Assign_Plan_Variance_Fields = {
  __typename?: 'coassign_assign_plan_variance_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.assign_plan" */
export type Coassign_Assign_Plan_Variance_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** select columns of table "coassign.assign" */
export enum Coassign_Assign_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visible = 'visible'
}

/** select "coassign_assign_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coassign.assign" */
export enum Coassign_Assign_Select_Column_Coassign_Assign_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Visible = 'visible'
}

/** select "coassign_assign_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coassign.assign" */
export enum Coassign_Assign_Select_Column_Coassign_Assign_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "coassign.assign" */
export type Coassign_Assign_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** Streaming cursor of the table "coassign_assign" */
export type Coassign_Assign_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Assign_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Assign_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** update columns of table "coassign.assign" */
export enum Coassign_Assign_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visible = 'visible'
}

export type Coassign_Assign_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Assign_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Assign_Bool_Exp
}

/** columns and relationships of "coassign.attendance" */
export type Coassign_Attendance = {
  __typename?: 'coassign_attendance'
  clocks: Scalars['jsonb']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  month: Scalars['date']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
  user_id: Scalars['String']['output']
}

/** columns and relationships of "coassign.attendance" */
export type Coassign_AttendanceClocksArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.attendance" */
export type Coassign_Attendance_Aggregate = {
  __typename?: 'coassign_attendance_aggregate'
  aggregate?: Maybe<Coassign_Attendance_Aggregate_Fields>
  nodes: Array<Coassign_Attendance>
}

export type Coassign_Attendance_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Attendance_Aggregate_Bool_Exp_Count>
}

export type Coassign_Attendance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Attendance_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Attendance_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.attendance" */
export type Coassign_Attendance_Aggregate_Fields = {
  __typename?: 'coassign_attendance_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Attendance_Max_Fields>
  min?: Maybe<Coassign_Attendance_Min_Fields>
}

/** aggregate fields of "coassign.attendance" */
export type Coassign_Attendance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Attendance_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.attendance" */
export type Coassign_Attendance_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Attendance_Max_Order_By>
  min?: InputMaybe<Coassign_Attendance_Min_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Attendance_Append_Input = {
  clocks?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "coassign.attendance" */
export type Coassign_Attendance_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Attendance_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Attendance_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.attendance". All fields are combined with a logical 'AND'. */
export type Coassign_Attendance_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Attendance_Bool_Exp>>
  _not?: InputMaybe<Coassign_Attendance_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Attendance_Bool_Exp>>
  clocks?: InputMaybe<Jsonb_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  month?: InputMaybe<Date_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.attendance" */
export enum Coassign_Attendance_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttendancePkey = 'attendance_pkey',
  /** unique or primary key constraint on columns "user_id", "month" */
  AttendanceUserIdMonth = 'attendance_user_id_month'
}

/** columns and relationships of "coassign.attendance_contract" */
export type Coassign_Attendance_Contract = {
  __typename?: 'coassign_attendance_contract'
  attendance_id: Scalars['String']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  lock: Scalars['contract_locks']['output']
  signer_id: Scalars['String']['output']
  state: Scalars['contract_states']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Aggregate = {
  __typename?: 'coassign_attendance_contract_aggregate'
  aggregate?: Maybe<Coassign_Attendance_Contract_Aggregate_Fields>
  nodes: Array<Coassign_Attendance_Contract>
}

export type Coassign_Attendance_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Attendance_Contract_Aggregate_Bool_Exp_Count>
}

export type Coassign_Attendance_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Attendance_Contract_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Aggregate_Fields = {
  __typename?: 'coassign_attendance_contract_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Attendance_Contract_Max_Fields>
  min?: Maybe<Coassign_Attendance_Contract_Min_Fields>
}

/** aggregate fields of "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Attendance_Contract_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Attendance_Contract_Max_Order_By>
  min?: InputMaybe<Coassign_Attendance_Contract_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Attendance_Contract_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Attendance_Contract_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.attendance_contract". All fields are combined with a logical 'AND'. */
export type Coassign_Attendance_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Attendance_Contract_Bool_Exp>>
  _not?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Attendance_Contract_Bool_Exp>>
  attendance_id?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  lock?: InputMaybe<Contract_Locks_Comparison_Exp>
  signer_id?: InputMaybe<String_Comparison_Exp>
  state?: InputMaybe<Contract_States_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.attendance_contract" */
export enum Coassign_Attendance_Contract_Constraint {
  /** unique or primary key constraint on columns "attendance_id" */
  AttendanceContractAttendanceId = 'attendance_contract_attendance_id',
  /** unique or primary key constraint on columns "id" */
  AttendanceContractPkey = 'attendance_contract_pkey'
}

/** columns and relationships of "coassign.attendance_contract_history" */
export type Coassign_Attendance_Contract_History = {
  __typename?: 'coassign_attendance_contract_history'
  attendance_id: Scalars['String']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  lock: Scalars['contract_locks']['output']
  signer_id: Scalars['String']['output']
  state: Scalars['contract_states']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.attendance_contract_history" */
export type Coassign_Attendance_Contract_History_Aggregate = {
  __typename?: 'coassign_attendance_contract_history_aggregate'
  aggregate?: Maybe<Coassign_Attendance_Contract_History_Aggregate_Fields>
  nodes: Array<Coassign_Attendance_Contract_History>
}

/** aggregate fields of "coassign.attendance_contract_history" */
export type Coassign_Attendance_Contract_History_Aggregate_Fields = {
  __typename?: 'coassign_attendance_contract_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Attendance_Contract_History_Max_Fields>
  min?: Maybe<Coassign_Attendance_Contract_History_Min_Fields>
}

/** aggregate fields of "coassign.attendance_contract_history" */
export type Coassign_Attendance_Contract_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Attendance_Contract_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.attendance_contract_history". All fields are combined with a logical 'AND'. */
export type Coassign_Attendance_Contract_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Attendance_Contract_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Attendance_Contract_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Attendance_Contract_History_Bool_Exp>>
  attendance_id?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  lock?: InputMaybe<Contract_Locks_Comparison_Exp>
  signer_id?: InputMaybe<String_Comparison_Exp>
  state?: InputMaybe<Contract_States_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** input type for inserting data into table "coassign.attendance_contract_history" */
export type Coassign_Attendance_Contract_History_Insert_Input = {
  attendance_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Attendance_Contract_History_Max_Fields = {
  __typename?: 'coassign_attendance_contract_history_max_fields'
  attendance_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  lock?: Maybe<Scalars['contract_locks']['output']>
  signer_id?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Attendance_Contract_History_Min_Fields = {
  __typename?: 'coassign_attendance_contract_history_min_fields'
  attendance_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  lock?: Maybe<Scalars['contract_locks']['output']>
  signer_id?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "coassign.attendance_contract_history" */
export type Coassign_Attendance_Contract_History_Mutation_Response = {
  __typename?: 'coassign_attendance_contract_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Attendance_Contract_History>
}

/** Ordering options when selecting data from "coassign.attendance_contract_history". */
export type Coassign_Attendance_Contract_History_Order_By = {
  attendance_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lock?: InputMaybe<Order_By>
  signer_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "coassign.attendance_contract_history" */
export enum Coassign_Attendance_Contract_History_Select_Column {
  /** column name */
  AttendanceId = 'attendance_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lock = 'lock',
  /** column name */
  SignerId = 'signer_id',
  /** column name */
  State = 'state',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.attendance_contract_history" */
export type Coassign_Attendance_Contract_History_Set_Input = {
  attendance_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_attendance_contract_history" */
export type Coassign_Attendance_Contract_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Attendance_Contract_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Attendance_Contract_History_Stream_Cursor_Value_Input = {
  attendance_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

export type Coassign_Attendance_Contract_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Attendance_Contract_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Attendance_Contract_History_Bool_Exp
}

/** input type for inserting data into table "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Insert_Input = {
  attendance_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Attendance_Contract_Max_Fields = {
  __typename?: 'coassign_attendance_contract_max_fields'
  attendance_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  lock?: Maybe<Scalars['contract_locks']['output']>
  signer_id?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Max_Order_By = {
  attendance_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lock?: InputMaybe<Order_By>
  signer_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Attendance_Contract_Min_Fields = {
  __typename?: 'coassign_attendance_contract_min_fields'
  attendance_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  lock?: Maybe<Scalars['contract_locks']['output']>
  signer_id?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Min_Order_By = {
  attendance_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lock?: InputMaybe<Order_By>
  signer_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Mutation_Response = {
  __typename?: 'coassign_attendance_contract_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Attendance_Contract>
}

/** on_conflict condition type for table "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_On_Conflict = {
  constraint: Coassign_Attendance_Contract_Constraint
  update_columns?: Array<Coassign_Attendance_Contract_Update_Column>
  where?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.attendance_contract". */
export type Coassign_Attendance_Contract_Order_By = {
  attendance_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lock?: InputMaybe<Order_By>
  signer_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.attendance_contract */
export type Coassign_Attendance_Contract_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.attendance_contract" */
export enum Coassign_Attendance_Contract_Select_Column {
  /** column name */
  AttendanceId = 'attendance_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lock = 'lock',
  /** column name */
  SignerId = 'signer_id',
  /** column name */
  State = 'state',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.attendance_contract" */
export type Coassign_Attendance_Contract_Set_Input = {
  attendance_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_attendance_contract" */
export type Coassign_Attendance_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Attendance_Contract_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Attendance_Contract_Stream_Cursor_Value_Input = {
  attendance_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.attendance_contract" */
export enum Coassign_Attendance_Contract_Update_Column {
  /** column name */
  AttendanceId = 'attendance_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lock = 'lock',
  /** column name */
  SignerId = 'signer_id',
  /** column name */
  State = 'state',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Attendance_Contract_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Attendance_Contract_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Attendance_Contract_Bool_Exp
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Attendance_Delete_At_Path_Input = {
  clocks?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Attendance_Delete_Elem_Input = {
  clocks?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Attendance_Delete_Key_Input = {
  clocks?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "coassign.attendance" */
export type Coassign_Attendance_Insert_Input = {
  clocks?: InputMaybe<Scalars['jsonb']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Attendance_Max_Fields = {
  __typename?: 'coassign_attendance_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  month?: Maybe<Scalars['date']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.attendance" */
export type Coassign_Attendance_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Attendance_Min_Fields = {
  __typename?: 'coassign_attendance_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  month?: Maybe<Scalars['date']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.attendance" */
export type Coassign_Attendance_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.attendance" */
export type Coassign_Attendance_Mutation_Response = {
  __typename?: 'coassign_attendance_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Attendance>
}

/** on_conflict condition type for table "coassign.attendance" */
export type Coassign_Attendance_On_Conflict = {
  constraint: Coassign_Attendance_Constraint
  update_columns?: Array<Coassign_Attendance_Update_Column>
  where?: InputMaybe<Coassign_Attendance_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.attendance". */
export type Coassign_Attendance_Order_By = {
  clocks?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.attendance */
export type Coassign_Attendance_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Attendance_Prepend_Input = {
  clocks?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "coassign.attendance" */
export enum Coassign_Attendance_Select_Column {
  /** column name */
  Clocks = 'clocks',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coassign.attendance" */
export type Coassign_Attendance_Set_Input = {
  clocks?: InputMaybe<Scalars['jsonb']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_attendance" */
export type Coassign_Attendance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Attendance_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Attendance_Stream_Cursor_Value_Input = {
  clocks?: InputMaybe<Scalars['jsonb']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.attendance" */
export enum Coassign_Attendance_Update_Column {
  /** column name */
  Clocks = 'clocks',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Coassign_Attendance_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Attendance_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Attendance_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Attendance_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Attendance_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Attendance_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Attendance_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Attendance_Bool_Exp
}

/** columns and relationships of "coassign.client" */
export type Coassign_Client = {
  __typename?: 'coassign_client'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  order: Scalars['float8']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.client" */
export type Coassign_Client_Aggregate = {
  __typename?: 'coassign_client_aggregate'
  aggregate?: Maybe<Coassign_Client_Aggregate_Fields>
  nodes: Array<Coassign_Client>
}

export type Coassign_Client_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Avg>
  corr?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Corr>
  count?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Count>
  covar_samp?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Covar_Samp>
  max?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Max>
  min?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Min>
  stddev_samp?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Stddev_Samp>
  sum?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Sum>
  var_samp?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp_Var_Samp>
}

export type Coassign_Client_Aggregate_Bool_Exp_Avg = {
  arguments: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Avg_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Client_Aggregate_Bool_Exp_Corr = {
  arguments: Coassign_Client_Aggregate_Bool_Exp_Corr_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Client_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Corr_Arguments_Columns
  Y: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Corr_Arguments_Columns
}

export type Coassign_Client_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Client_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Int_Comparison_Exp
}

export type Coassign_Client_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Coassign_Client_Aggregate_Bool_Exp_Covar_Samp_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Client_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
  Y: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
}

export type Coassign_Client_Aggregate_Bool_Exp_Max = {
  arguments: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Max_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Client_Aggregate_Bool_Exp_Min = {
  arguments: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Min_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Client_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Client_Aggregate_Bool_Exp_Sum = {
  arguments: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Sum_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Client_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Client_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

/** aggregate fields of "coassign.client" */
export type Coassign_Client_Aggregate_Fields = {
  __typename?: 'coassign_client_aggregate_fields'
  avg?: Maybe<Coassign_Client_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Client_Max_Fields>
  min?: Maybe<Coassign_Client_Min_Fields>
  stddev?: Maybe<Coassign_Client_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Client_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Client_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Client_Sum_Fields>
  var_pop?: Maybe<Coassign_Client_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Client_Var_Samp_Fields>
  variance?: Maybe<Coassign_Client_Variance_Fields>
}

/** aggregate fields of "coassign.client" */
export type Coassign_Client_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Client_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.client" */
export type Coassign_Client_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Client_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Client_Max_Order_By>
  min?: InputMaybe<Coassign_Client_Min_Order_By>
  stddev?: InputMaybe<Coassign_Client_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Client_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Client_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Client_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Client_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Client_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Client_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.client" */
export type Coassign_Client_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Client_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Client_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Client_Avg_Fields = {
  __typename?: 'coassign_client_avg_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.client" */
export type Coassign_Client_Avg_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.client". All fields are combined with a logical 'AND'. */
export type Coassign_Client_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Client_Bool_Exp>>
  _not?: InputMaybe<Coassign_Client_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Client_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  order?: InputMaybe<Float8_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.client" */
export enum Coassign_Client_Constraint {
  /** unique or primary key constraint on columns "name", "tenant_id" */
  ClientNameTenantIdDeletedAt = 'client_name_tenant_id_deleted_at',
  /** unique or primary key constraint on columns "id" */
  ClientPkey = 'client_pkey'
}

/** input type for incrementing numeric columns in table "coassign.client" */
export type Coassign_Client_Inc_Input = {
  order?: InputMaybe<Scalars['float8']['input']>
}

/** input type for inserting data into table "coassign.client" */
export type Coassign_Client_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Client_Max_Fields = {
  __typename?: 'coassign_client_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.client" */
export type Coassign_Client_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Client_Min_Fields = {
  __typename?: 'coassign_client_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.client" */
export type Coassign_Client_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.client" */
export type Coassign_Client_Mutation_Response = {
  __typename?: 'coassign_client_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Client>
}

/** input type for inserting object relation for remote table "coassign.client" */
export type Coassign_Client_Obj_Rel_Insert_Input = {
  data: Coassign_Client_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Client_On_Conflict>
}

/** on_conflict condition type for table "coassign.client" */
export type Coassign_Client_On_Conflict = {
  constraint: Coassign_Client_Constraint
  update_columns?: Array<Coassign_Client_Update_Column>
  where?: InputMaybe<Coassign_Client_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.client". */
export type Coassign_Client_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.client */
export type Coassign_Client_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.client" */
export enum Coassign_Client_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "coassign_client_aggregate_bool_exp_avg_arguments_columns" columns of table "coassign.client" */
export enum Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_client_aggregate_bool_exp_corr_arguments_columns" columns of table "coassign.client" */
export enum Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_client_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coassign.client" */
export enum Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_client_aggregate_bool_exp_max_arguments_columns" columns of table "coassign.client" */
export enum Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_client_aggregate_bool_exp_min_arguments_columns" columns of table "coassign.client" */
export enum Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_client_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coassign.client" */
export enum Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_client_aggregate_bool_exp_sum_arguments_columns" columns of table "coassign.client" */
export enum Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_client_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coassign.client" */
export enum Coassign_Client_Select_Column_Coassign_Client_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "coassign.client" */
export type Coassign_Client_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Client_Stddev_Fields = {
  __typename?: 'coassign_client_stddev_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.client" */
export type Coassign_Client_Stddev_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Client_Stddev_Pop_Fields = {
  __typename?: 'coassign_client_stddev_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.client" */
export type Coassign_Client_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Client_Stddev_Samp_Fields = {
  __typename?: 'coassign_client_stddev_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.client" */
export type Coassign_Client_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_client" */
export type Coassign_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Client_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Client_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Client_Sum_Fields = {
  __typename?: 'coassign_client_sum_fields'
  order?: Maybe<Scalars['float8']['output']>
}

/** order by sum() on columns of table "coassign.client" */
export type Coassign_Client_Sum_Order_By = {
  order?: InputMaybe<Order_By>
}

/** update columns of table "coassign.client" */
export enum Coassign_Client_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Client_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Client_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Client_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Client_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Client_Var_Pop_Fields = {
  __typename?: 'coassign_client_var_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.client" */
export type Coassign_Client_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Client_Var_Samp_Fields = {
  __typename?: 'coassign_client_var_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.client" */
export type Coassign_Client_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Client_Variance_Fields = {
  __typename?: 'coassign_client_variance_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.client" */
export type Coassign_Client_Variance_Order_By = {
  order?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.commit" */
export type Coassign_Commit = {
  __typename?: 'coassign_commit'
  committer: Scalars['String']['output']
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['json']['output']>
  id: Scalars['String']['output']
  message?: Maybe<Scalars['String']['output']>
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "coassign.commit" */
export type Coassign_CommitDetailArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.commit" */
export type Coassign_Commit_Aggregate = {
  __typename?: 'coassign_commit_aggregate'
  aggregate?: Maybe<Coassign_Commit_Aggregate_Fields>
  nodes: Array<Coassign_Commit>
}

export type Coassign_Commit_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Commit_Aggregate_Bool_Exp_Count>
}

export type Coassign_Commit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Commit_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Commit_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.commit" */
export type Coassign_Commit_Aggregate_Fields = {
  __typename?: 'coassign_commit_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Commit_Max_Fields>
  min?: Maybe<Coassign_Commit_Min_Fields>
}

/** aggregate fields of "coassign.commit" */
export type Coassign_Commit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Commit_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.commit" */
export type Coassign_Commit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Commit_Max_Order_By>
  min?: InputMaybe<Coassign_Commit_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.commit" */
export type Coassign_Commit_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Commit_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Commit_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.commit". All fields are combined with a logical 'AND'. */
export type Coassign_Commit_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Commit_Bool_Exp>>
  _not?: InputMaybe<Coassign_Commit_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Commit_Bool_Exp>>
  committer?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  detail?: InputMaybe<Json_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  message?: InputMaybe<String_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.commit" */
export enum Coassign_Commit_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommitPkey = 'commit_pkey'
}

/** input type for inserting data into table "coassign.commit" */
export type Coassign_Commit_Insert_Input = {
  committer?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['json']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Commit_Max_Fields = {
  __typename?: 'coassign_commit_max_fields'
  committer?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.commit" */
export type Coassign_Commit_Max_Order_By = {
  committer?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  message?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Commit_Min_Fields = {
  __typename?: 'coassign_commit_min_fields'
  committer?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.commit" */
export type Coassign_Commit_Min_Order_By = {
  committer?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  message?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.commit" */
export type Coassign_Commit_Mutation_Response = {
  __typename?: 'coassign_commit_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Commit>
}

/** on_conflict condition type for table "coassign.commit" */
export type Coassign_Commit_On_Conflict = {
  constraint: Coassign_Commit_Constraint
  update_columns?: Array<Coassign_Commit_Update_Column>
  where?: InputMaybe<Coassign_Commit_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.commit". */
export type Coassign_Commit_Order_By = {
  committer?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  detail?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  message?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.commit */
export type Coassign_Commit_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.commit" */
export enum Coassign_Commit_Select_Column {
  /** column name */
  Committer = 'committer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Detail = 'detail',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.commit" */
export type Coassign_Commit_Set_Input = {
  committer?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['json']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_commit" */
export type Coassign_Commit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Commit_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Commit_Stream_Cursor_Value_Input = {
  committer?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['json']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.commit" */
export enum Coassign_Commit_Update_Column {
  /** column name */
  Committer = 'committer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Detail = 'detail',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Commit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Commit_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Commit_Bool_Exp
}

/** columns and relationships of "coassign.commit_with_project_view" */
export type Coassign_Commit_With_Project_View = {
  __typename?: 'coassign_commit_with_project_view'
  change_type?: Maybe<Scalars['String']['output']>
  commit_at?: Maybe<Scalars['timestamptz']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  /** An object relationship */
  commit_user?: Maybe<Coassign_User>
  committer?: Maybe<Scalars['String']['output']>
  context?: Maybe<Scalars['jsonb']['output']>
  diff?: Maybe<Scalars['jsonb']['output']>
  message?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  target?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
}

/** columns and relationships of "coassign.commit_with_project_view" */
export type Coassign_Commit_With_Project_ViewContextArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.commit_with_project_view" */
export type Coassign_Commit_With_Project_ViewDiffArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.commit_with_project_view" */
export type Coassign_Commit_With_Project_View_Aggregate = {
  __typename?: 'coassign_commit_with_project_view_aggregate'
  aggregate?: Maybe<Coassign_Commit_With_Project_View_Aggregate_Fields>
  nodes: Array<Coassign_Commit_With_Project_View>
}

/** aggregate fields of "coassign.commit_with_project_view" */
export type Coassign_Commit_With_Project_View_Aggregate_Fields = {
  __typename?: 'coassign_commit_with_project_view_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Commit_With_Project_View_Max_Fields>
  min?: Maybe<Coassign_Commit_With_Project_View_Min_Fields>
}

/** aggregate fields of "coassign.commit_with_project_view" */
export type Coassign_Commit_With_Project_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Commit_With_Project_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.commit_with_project_view". All fields are combined with a logical 'AND'. */
export type Coassign_Commit_With_Project_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Commit_With_Project_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Commit_With_Project_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Commit_With_Project_View_Bool_Exp>>
  change_type?: InputMaybe<String_Comparison_Exp>
  commit_at?: InputMaybe<Timestamptz_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  commit_user?: InputMaybe<Coassign_User_Bool_Exp>
  committer?: InputMaybe<String_Comparison_Exp>
  context?: InputMaybe<Jsonb_Comparison_Exp>
  diff?: InputMaybe<Jsonb_Comparison_Exp>
  message?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  target?: InputMaybe<String_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Commit_With_Project_View_Max_Fields = {
  __typename?: 'coassign_commit_with_project_view_max_fields'
  change_type?: Maybe<Scalars['String']['output']>
  commit_at?: Maybe<Scalars['timestamptz']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  committer?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  target?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Commit_With_Project_View_Min_Fields = {
  __typename?: 'coassign_commit_with_project_view_min_fields'
  change_type?: Maybe<Scalars['String']['output']>
  commit_at?: Maybe<Scalars['timestamptz']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  committer?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  target?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
}

/** Ordering options when selecting data from "coassign.commit_with_project_view". */
export type Coassign_Commit_With_Project_View_Order_By = {
  change_type?: InputMaybe<Order_By>
  commit_at?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  commit_user?: InputMaybe<Coassign_User_Order_By>
  committer?: InputMaybe<Order_By>
  context?: InputMaybe<Order_By>
  diff?: InputMaybe<Order_By>
  message?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  target?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.commit_with_project_view" */
export enum Coassign_Commit_With_Project_View_Select_Column {
  /** column name */
  ChangeType = 'change_type',
  /** column name */
  CommitAt = 'commit_at',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  Committer = 'committer',
  /** column name */
  Context = 'context',
  /** column name */
  Diff = 'diff',
  /** column name */
  Message = 'message',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Target = 'target',
  /** column name */
  TenantId = 'tenant_id'
}

/** Streaming cursor of the table "coassign_commit_with_project_view" */
export type Coassign_Commit_With_Project_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Commit_With_Project_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Commit_With_Project_View_Stream_Cursor_Value_Input = {
  change_type?: InputMaybe<Scalars['String']['input']>
  commit_at?: InputMaybe<Scalars['timestamptz']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  committer?: InputMaybe<Scalars['String']['input']>
  context?: InputMaybe<Scalars['jsonb']['input']>
  diff?: InputMaybe<Scalars['jsonb']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  target?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.custom_field" */
export type Coassign_Custom_Field = {
  __typename?: 'coassign_custom_field'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  /** An array relationship */
  custom_field_choices: Array<Coassign_Custom_Field_Choice>
  /** An aggregate relationship */
  custom_field_choices_aggregate: Coassign_Custom_Field_Choice_Aggregate
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  key: Scalars['String']['output']
  name: Scalars['String']['output']
  order: Scalars['float8']['output']
  required: Scalars['Boolean']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  value_type: Scalars['custom_field_value_types']['output']
  visible: Scalars['Boolean']['output']
}

/** columns and relationships of "coassign.custom_field" */
export type Coassign_Custom_FieldCustom_Field_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Choice_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

/** columns and relationships of "coassign.custom_field" */
export type Coassign_Custom_FieldCustom_Field_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Choice_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

/** aggregated selection of "coassign.custom_field" */
export type Coassign_Custom_Field_Aggregate = {
  __typename?: 'coassign_custom_field_aggregate'
  aggregate?: Maybe<Coassign_Custom_Field_Aggregate_Fields>
  nodes: Array<Coassign_Custom_Field>
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Avg>
  bool_and?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Bool_Or>
  corr?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Corr>
  count?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Count>
  covar_samp?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Covar_Samp>
  max?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Max>
  min?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Min>
  stddev_samp?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Stddev_Samp>
  sum?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Sum>
  var_samp?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp_Var_Samp>
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Avg = {
  arguments: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Avg_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Corr = {
  arguments: Coassign_Custom_Field_Aggregate_Bool_Exp_Corr_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Corr_Arguments_Columns
  Y: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Corr_Arguments_Columns
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Custom_Field_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Int_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Coassign_Custom_Field_Aggregate_Bool_Exp_Covar_Samp_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
  Y: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Max = {
  arguments: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Max_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Min = {
  arguments: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Min_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Sum = {
  arguments: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Sum_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

/** aggregate fields of "coassign.custom_field" */
export type Coassign_Custom_Field_Aggregate_Fields = {
  __typename?: 'coassign_custom_field_aggregate_fields'
  avg?: Maybe<Coassign_Custom_Field_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Custom_Field_Max_Fields>
  min?: Maybe<Coassign_Custom_Field_Min_Fields>
  stddev?: Maybe<Coassign_Custom_Field_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Custom_Field_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Custom_Field_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Custom_Field_Sum_Fields>
  var_pop?: Maybe<Coassign_Custom_Field_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Custom_Field_Var_Samp_Fields>
  variance?: Maybe<Coassign_Custom_Field_Variance_Fields>
}

/** aggregate fields of "coassign.custom_field" */
export type Coassign_Custom_Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Custom_Field_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.custom_field" */
export type Coassign_Custom_Field_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Custom_Field_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Custom_Field_Max_Order_By>
  min?: InputMaybe<Coassign_Custom_Field_Min_Order_By>
  stddev?: InputMaybe<Coassign_Custom_Field_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Custom_Field_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Custom_Field_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Custom_Field_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Custom_Field_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Custom_Field_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Custom_Field_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.custom_field" */
export type Coassign_Custom_Field_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Custom_Field_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Custom_Field_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Custom_Field_Avg_Fields = {
  __typename?: 'coassign_custom_field_avg_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Avg_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.custom_field". All fields are combined with a logical 'AND'. */
export type Coassign_Custom_Field_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Custom_Field_Bool_Exp>>
  _not?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Custom_Field_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  custom_field_choices?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  custom_field_choices_aggregate?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  key?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  order?: InputMaybe<Float8_Comparison_Exp>
  required?: InputMaybe<Boolean_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  value_type?: InputMaybe<Custom_Field_Value_Types_Comparison_Exp>
  visible?: InputMaybe<Boolean_Comparison_Exp>
}

/** columns and relationships of "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice = {
  __typename?: 'coassign_custom_field_choice'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  custom_field_id: Scalars['String']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  key: Scalars['String']['output']
  name: Scalars['String']['output']
  order: Scalars['float8']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  visible: Scalars['Boolean']['output']
}

/** aggregated selection of "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Aggregate = {
  __typename?: 'coassign_custom_field_choice_aggregate'
  aggregate?: Maybe<Coassign_Custom_Field_Choice_Aggregate_Fields>
  nodes: Array<Coassign_Custom_Field_Choice>
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Avg>
  bool_and?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Bool_Or>
  corr?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Corr>
  count?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Count>
  covar_samp?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Covar_Samp>
  max?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Max>
  min?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Min>
  stddev_samp?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Stddev_Samp>
  sum?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Sum>
  var_samp?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Var_Samp>
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Avg = {
  arguments: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Avg_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Corr = {
  arguments: Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Corr_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Corr_Arguments_Columns
  Y: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Corr_Arguments_Columns
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Int_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Covar_Samp_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
  Y: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Max = {
  arguments: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Max_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Min = {
  arguments: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Min_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Sum = {
  arguments: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Sum_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

/** aggregate fields of "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Aggregate_Fields = {
  __typename?: 'coassign_custom_field_choice_aggregate_fields'
  avg?: Maybe<Coassign_Custom_Field_Choice_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Custom_Field_Choice_Max_Fields>
  min?: Maybe<Coassign_Custom_Field_Choice_Min_Fields>
  stddev?: Maybe<Coassign_Custom_Field_Choice_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Custom_Field_Choice_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Custom_Field_Choice_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Custom_Field_Choice_Sum_Fields>
  var_pop?: Maybe<Coassign_Custom_Field_Choice_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Custom_Field_Choice_Var_Samp_Fields>
  variance?: Maybe<Coassign_Custom_Field_Choice_Variance_Fields>
}

/** aggregate fields of "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Custom_Field_Choice_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Custom_Field_Choice_Max_Order_By>
  min?: InputMaybe<Coassign_Custom_Field_Choice_Min_Order_By>
  stddev?: InputMaybe<Coassign_Custom_Field_Choice_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Custom_Field_Choice_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Custom_Field_Choice_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Custom_Field_Choice_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Custom_Field_Choice_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Custom_Field_Choice_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Custom_Field_Choice_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Custom_Field_Choice_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Custom_Field_Choice_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Custom_Field_Choice_Avg_Fields = {
  __typename?: 'coassign_custom_field_choice_avg_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Avg_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.custom_field_choice". All fields are combined with a logical 'AND'. */
export type Coassign_Custom_Field_Choice_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Custom_Field_Choice_Bool_Exp>>
  _not?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Custom_Field_Choice_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  custom_field_id?: InputMaybe<String_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  key?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  order?: InputMaybe<Float8_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  visible?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Constraint {
  /** unique or primary key constraint on columns "key", "custom_field_id", "tenant_id" */
  CustomFieldChoiceCustomFieldIdKeyTenantIdDeletedAt = 'custom_field_choice_custom_field_id_key_tenant_id_deleted_at',
  /** unique or primary key constraint on columns "id" */
  CustomFieldChoicePkey = 'custom_field_choice_pkey'
}

/** input type for incrementing numeric columns in table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Inc_Input = {
  order?: InputMaybe<Scalars['float8']['input']>
}

/** input type for inserting data into table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_field_id?: InputMaybe<Scalars['String']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate max on columns */
export type Coassign_Custom_Field_Choice_Max_Fields = {
  __typename?: 'coassign_custom_field_choice_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  custom_field_id?: Maybe<Scalars['String']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  key?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  custom_field_id?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  key?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Custom_Field_Choice_Min_Fields = {
  __typename?: 'coassign_custom_field_choice_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  custom_field_id?: Maybe<Scalars['String']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  key?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  custom_field_id?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  key?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Mutation_Response = {
  __typename?: 'coassign_custom_field_choice_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Custom_Field_Choice>
}

/** on_conflict condition type for table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_On_Conflict = {
  constraint: Coassign_Custom_Field_Choice_Constraint
  update_columns?: Array<Coassign_Custom_Field_Choice_Update_Column>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.custom_field_choice". */
export type Coassign_Custom_Field_Choice_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  custom_field_id?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  key?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  visible?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.custom_field_choice */
export type Coassign_Custom_Field_Choice_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFieldId = 'custom_field_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_avg_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Visible = 'visible'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Visible = 'visible'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_corr_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_max_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_min_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_sum_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_choice_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Select_Column_Coassign_Custom_Field_Choice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_field_id?: InputMaybe<Scalars['String']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Custom_Field_Choice_Stddev_Fields = {
  __typename?: 'coassign_custom_field_choice_stddev_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Stddev_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Custom_Field_Choice_Stddev_Pop_Fields = {
  __typename?: 'coassign_custom_field_choice_stddev_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Custom_Field_Choice_Stddev_Samp_Fields = {
  __typename?: 'coassign_custom_field_choice_stddev_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_custom_field_choice" */
export type Coassign_Custom_Field_Choice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Custom_Field_Choice_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Custom_Field_Choice_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_field_id?: InputMaybe<Scalars['String']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate sum on columns */
export type Coassign_Custom_Field_Choice_Sum_Fields = {
  __typename?: 'coassign_custom_field_choice_sum_fields'
  order?: Maybe<Scalars['float8']['output']>
}

/** order by sum() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Sum_Order_By = {
  order?: InputMaybe<Order_By>
}

/** update columns of table "coassign.custom_field_choice" */
export enum Coassign_Custom_Field_Choice_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFieldId = 'custom_field_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

export type Coassign_Custom_Field_Choice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Custom_Field_Choice_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Custom_Field_Choice_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Custom_Field_Choice_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Custom_Field_Choice_Var_Pop_Fields = {
  __typename?: 'coassign_custom_field_choice_var_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Custom_Field_Choice_Var_Samp_Fields = {
  __typename?: 'coassign_custom_field_choice_var_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Custom_Field_Choice_Variance_Fields = {
  __typename?: 'coassign_custom_field_choice_variance_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.custom_field_choice" */
export type Coassign_Custom_Field_Choice_Variance_Order_By = {
  order?: InputMaybe<Order_By>
}

/** unique or primary key constraints on table "coassign.custom_field" */
export enum Coassign_Custom_Field_Constraint {
  /** unique or primary key constraint on columns "key", "tenant_id" */
  CustomFieldKeyTenantIdDeletedAt = 'custom_field_key_tenant_id_deleted_at',
  /** unique or primary key constraint on columns "name", "tenant_id" */
  CustomFieldNameTenantIdDeletedAt = 'custom_field_name_tenant_id_deleted_at',
  /** unique or primary key constraint on columns "id" */
  CustomFieldPkey = 'custom_field_pkey'
}

/** input type for incrementing numeric columns in table "coassign.custom_field" */
export type Coassign_Custom_Field_Inc_Input = {
  order?: InputMaybe<Scalars['float8']['input']>
}

/** input type for inserting data into table "coassign.custom_field" */
export type Coassign_Custom_Field_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_field_choices?: InputMaybe<Coassign_Custom_Field_Choice_Arr_Rel_Insert_Input>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  required?: InputMaybe<Scalars['Boolean']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  value_type?: InputMaybe<Scalars['custom_field_value_types']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate max on columns */
export type Coassign_Custom_Field_Max_Fields = {
  __typename?: 'coassign_custom_field_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  description?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  key?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  value_type?: Maybe<Scalars['custom_field_value_types']['output']>
}

/** order by max() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  key?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  value_type?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Custom_Field_Min_Fields = {
  __typename?: 'coassign_custom_field_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  description?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  key?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  value_type?: Maybe<Scalars['custom_field_value_types']['output']>
}

/** order by min() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  key?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  value_type?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.custom_field" */
export type Coassign_Custom_Field_Mutation_Response = {
  __typename?: 'coassign_custom_field_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Custom_Field>
}

/** on_conflict condition type for table "coassign.custom_field" */
export type Coassign_Custom_Field_On_Conflict = {
  constraint: Coassign_Custom_Field_Constraint
  update_columns?: Array<Coassign_Custom_Field_Update_Column>
  where?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.custom_field". */
export type Coassign_Custom_Field_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  custom_field_choices_aggregate?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Order_By>
  deleted_at?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  key?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  required?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  value_type?: InputMaybe<Order_By>
  visible?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.custom_field */
export type Coassign_Custom_Field_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Required = 'required',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueType = 'value_type',
  /** column name */
  Visible = 'visible'
}

/** select "coassign_custom_field_aggregate_bool_exp_avg_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Required = 'required',
  /** column name */
  Visible = 'visible'
}

/** select "coassign_custom_field_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Required = 'required',
  /** column name */
  Visible = 'visible'
}

/** select "coassign_custom_field_aggregate_bool_exp_corr_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_aggregate_bool_exp_max_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_aggregate_bool_exp_min_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_aggregate_bool_exp_sum_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_custom_field_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Select_Column_Coassign_Custom_Field_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "coassign.custom_field" */
export type Coassign_Custom_Field_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  required?: InputMaybe<Scalars['Boolean']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  value_type?: InputMaybe<Scalars['custom_field_value_types']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Custom_Field_Stddev_Fields = {
  __typename?: 'coassign_custom_field_stddev_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Stddev_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Custom_Field_Stddev_Pop_Fields = {
  __typename?: 'coassign_custom_field_stddev_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Custom_Field_Stddev_Samp_Fields = {
  __typename?: 'coassign_custom_field_stddev_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_custom_field" */
export type Coassign_Custom_Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Custom_Field_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Custom_Field_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  required?: InputMaybe<Scalars['Boolean']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  value_type?: InputMaybe<Scalars['custom_field_value_types']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate sum on columns */
export type Coassign_Custom_Field_Sum_Fields = {
  __typename?: 'coassign_custom_field_sum_fields'
  order?: Maybe<Scalars['float8']['output']>
}

/** order by sum() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Sum_Order_By = {
  order?: InputMaybe<Order_By>
}

/** update columns of table "coassign.custom_field" */
export enum Coassign_Custom_Field_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Required = 'required',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueType = 'value_type',
  /** column name */
  Visible = 'visible'
}

export type Coassign_Custom_Field_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Custom_Field_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Custom_Field_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Custom_Field_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Custom_Field_Var_Pop_Fields = {
  __typename?: 'coassign_custom_field_var_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Custom_Field_Var_Samp_Fields = {
  __typename?: 'coassign_custom_field_var_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Custom_Field_Variance_Fields = {
  __typename?: 'coassign_custom_field_variance_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.custom_field" */
export type Coassign_Custom_Field_Variance_Order_By = {
  order?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.department" */
export type Coassign_Department = {
  __typename?: 'coassign_department'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  order: Scalars['float8']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An array relationship */
  user_to_departments: Array<Coassign_User_To_Department>
  /** An aggregate relationship */
  user_to_departments_aggregate: Coassign_User_To_Department_Aggregate
}

/** columns and relationships of "coassign.department" */
export type Coassign_DepartmentUser_To_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.department" */
export type Coassign_DepartmentUser_To_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

/** aggregated selection of "coassign.department" */
export type Coassign_Department_Aggregate = {
  __typename?: 'coassign_department_aggregate'
  aggregate?: Maybe<Coassign_Department_Aggregate_Fields>
  nodes: Array<Coassign_Department>
}

export type Coassign_Department_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Avg>
  corr?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Corr>
  count?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Count>
  covar_samp?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Covar_Samp>
  max?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Max>
  min?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Min>
  stddev_samp?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Stddev_Samp>
  sum?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Sum>
  var_samp?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp_Var_Samp>
}

export type Coassign_Department_Aggregate_Bool_Exp_Avg = {
  arguments: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Avg_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Department_Aggregate_Bool_Exp_Corr = {
  arguments: Coassign_Department_Aggregate_Bool_Exp_Corr_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Department_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Corr_Arguments_Columns
  Y: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Corr_Arguments_Columns
}

export type Coassign_Department_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Department_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Int_Comparison_Exp
}

export type Coassign_Department_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Coassign_Department_Aggregate_Bool_Exp_Covar_Samp_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Department_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
  Y: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
}

export type Coassign_Department_Aggregate_Bool_Exp_Max = {
  arguments: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Max_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Department_Aggregate_Bool_Exp_Min = {
  arguments: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Min_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Department_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Department_Aggregate_Bool_Exp_Sum = {
  arguments: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Sum_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Department_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Department_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

/** aggregate fields of "coassign.department" */
export type Coassign_Department_Aggregate_Fields = {
  __typename?: 'coassign_department_aggregate_fields'
  avg?: Maybe<Coassign_Department_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Department_Max_Fields>
  min?: Maybe<Coassign_Department_Min_Fields>
  stddev?: Maybe<Coassign_Department_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Department_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Department_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Department_Sum_Fields>
  var_pop?: Maybe<Coassign_Department_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Department_Var_Samp_Fields>
  variance?: Maybe<Coassign_Department_Variance_Fields>
}

/** aggregate fields of "coassign.department" */
export type Coassign_Department_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Department_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.department" */
export type Coassign_Department_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Department_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Department_Max_Order_By>
  min?: InputMaybe<Coassign_Department_Min_Order_By>
  stddev?: InputMaybe<Coassign_Department_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Department_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Department_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Department_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Department_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Department_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Department_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.department" */
export type Coassign_Department_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Department_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Department_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Department_Avg_Fields = {
  __typename?: 'coassign_department_avg_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.department" */
export type Coassign_Department_Avg_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.department". All fields are combined with a logical 'AND'. */
export type Coassign_Department_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Department_Bool_Exp>>
  _not?: InputMaybe<Coassign_Department_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Department_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  order?: InputMaybe<Float8_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_to_departments?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
  user_to_departments_aggregate?: InputMaybe<Coassign_User_To_Department_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.department" */
export enum Coassign_Department_Constraint {
  /** unique or primary key constraint on columns "id" */
  DepartmentPkey = 'department_pkey',
  /** unique or primary key constraint on columns "name", "tenant_id" */
  DepartmentTenantIdNameDeletedAt = 'department_tenant_id_name_deleted_at'
}

/** input type for incrementing numeric columns in table "coassign.department" */
export type Coassign_Department_Inc_Input = {
  order?: InputMaybe<Scalars['float8']['input']>
}

/** input type for inserting data into table "coassign.department" */
export type Coassign_Department_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_to_departments?: InputMaybe<Coassign_User_To_Department_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_Department_Max_Fields = {
  __typename?: 'coassign_department_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.department" */
export type Coassign_Department_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Department_Min_Fields = {
  __typename?: 'coassign_department_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.department" */
export type Coassign_Department_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.department" */
export type Coassign_Department_Mutation_Response = {
  __typename?: 'coassign_department_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Department>
}

/** input type for inserting object relation for remote table "coassign.department" */
export type Coassign_Department_Obj_Rel_Insert_Input = {
  data: Coassign_Department_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Department_On_Conflict>
}

/** on_conflict condition type for table "coassign.department" */
export type Coassign_Department_On_Conflict = {
  constraint: Coassign_Department_Constraint
  update_columns?: Array<Coassign_Department_Update_Column>
  where?: InputMaybe<Coassign_Department_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.department". */
export type Coassign_Department_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_to_departments_aggregate?: InputMaybe<Coassign_User_To_Department_Aggregate_Order_By>
}

/** primary key columns input for table: coassign.department */
export type Coassign_Department_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.department" */
export enum Coassign_Department_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "coassign_department_aggregate_bool_exp_avg_arguments_columns" columns of table "coassign.department" */
export enum Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_department_aggregate_bool_exp_corr_arguments_columns" columns of table "coassign.department" */
export enum Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_department_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coassign.department" */
export enum Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_department_aggregate_bool_exp_max_arguments_columns" columns of table "coassign.department" */
export enum Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_department_aggregate_bool_exp_min_arguments_columns" columns of table "coassign.department" */
export enum Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_department_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coassign.department" */
export enum Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_department_aggregate_bool_exp_sum_arguments_columns" columns of table "coassign.department" */
export enum Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_department_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coassign.department" */
export enum Coassign_Department_Select_Column_Coassign_Department_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "coassign.department" */
export type Coassign_Department_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Department_Stddev_Fields = {
  __typename?: 'coassign_department_stddev_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.department" */
export type Coassign_Department_Stddev_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Department_Stddev_Pop_Fields = {
  __typename?: 'coassign_department_stddev_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.department" */
export type Coassign_Department_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Department_Stddev_Samp_Fields = {
  __typename?: 'coassign_department_stddev_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.department" */
export type Coassign_Department_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_department" */
export type Coassign_Department_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Department_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Department_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Department_Sum_Fields = {
  __typename?: 'coassign_department_sum_fields'
  order?: Maybe<Scalars['float8']['output']>
}

/** order by sum() on columns of table "coassign.department" */
export type Coassign_Department_Sum_Order_By = {
  order?: InputMaybe<Order_By>
}

/** update columns of table "coassign.department" */
export enum Coassign_Department_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Department_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Department_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Department_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Department_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Department_Var_Pop_Fields = {
  __typename?: 'coassign_department_var_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.department" */
export type Coassign_Department_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Department_Var_Samp_Fields = {
  __typename?: 'coassign_department_var_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.department" */
export type Coassign_Department_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Department_Variance_Fields = {
  __typename?: 'coassign_department_variance_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.department" */
export type Coassign_Department_Variance_Order_By = {
  order?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.employment" */
export type Coassign_Employment = {
  __typename?: 'coassign_employment'
  commit_id?: Maybe<Scalars['String']['output']>
  contract?: Maybe<Scalars['String']['output']>
  cost: Scalars['Int']['output']
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  /** An object relationship */
  partner?: Maybe<Coassign_Partner>
  partner_id?: Maybe<Scalars['String']['output']>
  start?: Maybe<Scalars['date']['output']>
  tenant_id: Scalars['String']['output']
  type: Scalars['cost_periods']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
  user_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.employment" */
export type Coassign_Employment_Aggregate = {
  __typename?: 'coassign_employment_aggregate'
  aggregate?: Maybe<Coassign_Employment_Aggregate_Fields>
  nodes: Array<Coassign_Employment>
}

export type Coassign_Employment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Employment_Aggregate_Bool_Exp_Count>
}

export type Coassign_Employment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Employment_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.employment" */
export type Coassign_Employment_Aggregate_Fields = {
  __typename?: 'coassign_employment_aggregate_fields'
  avg?: Maybe<Coassign_Employment_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Employment_Max_Fields>
  min?: Maybe<Coassign_Employment_Min_Fields>
  stddev?: Maybe<Coassign_Employment_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Employment_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Employment_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Employment_Sum_Fields>
  var_pop?: Maybe<Coassign_Employment_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Employment_Var_Samp_Fields>
  variance?: Maybe<Coassign_Employment_Variance_Fields>
}

/** aggregate fields of "coassign.employment" */
export type Coassign_Employment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.employment" */
export type Coassign_Employment_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Employment_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Employment_Max_Order_By>
  min?: InputMaybe<Coassign_Employment_Min_Order_By>
  stddev?: InputMaybe<Coassign_Employment_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Employment_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Employment_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Employment_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Employment_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Employment_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Employment_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.employment" */
export type Coassign_Employment_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Employment_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Employment_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Employment_Avg_Fields = {
  __typename?: 'coassign_employment_avg_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.employment" */
export type Coassign_Employment_Avg_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.employment". All fields are combined with a logical 'AND'. */
export type Coassign_Employment_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Employment_Bool_Exp>>
  _not?: InputMaybe<Coassign_Employment_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Employment_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  contract?: InputMaybe<String_Comparison_Exp>
  cost?: InputMaybe<Int_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  partner?: InputMaybe<Coassign_Partner_Bool_Exp>
  partner_id?: InputMaybe<String_Comparison_Exp>
  start?: InputMaybe<Date_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<Cost_Periods_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.employment" */
export enum Coassign_Employment_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmploymentPkey = 'employment_pkey',
  /** unique or primary key constraint on columns "user_id", "tenant_id" */
  EmploymentStartEnforceSingleNullUserIdTenantId = 'employment_start_enforce_single_null_user_id_tenant_id',
  /** unique or primary key constraint on columns "user_id", "tenant_id", "start" */
  EmploymentTenantIdStartUserIdDeletedAt = 'employment_tenant_id_start_user_id_deleted_at'
}

/** columns and relationships of "coassign.employment_contract" */
export type Coassign_Employment_Contract = {
  __typename?: 'coassign_employment_contract'
  commit_id?: Maybe<Scalars['String']['output']>
  contractor: Scalars['String']['output']
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  lock: Scalars['contract_locks']['output']
  state: Scalars['contract_states']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.employment_contract" */
export type Coassign_Employment_Contract_Aggregate = {
  __typename?: 'coassign_employment_contract_aggregate'
  aggregate?: Maybe<Coassign_Employment_Contract_Aggregate_Fields>
  nodes: Array<Coassign_Employment_Contract>
}

export type Coassign_Employment_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Employment_Contract_Aggregate_Bool_Exp_Count>
}

export type Coassign_Employment_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Employment_Contract_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.employment_contract" */
export type Coassign_Employment_Contract_Aggregate_Fields = {
  __typename?: 'coassign_employment_contract_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Employment_Contract_Max_Fields>
  min?: Maybe<Coassign_Employment_Contract_Min_Fields>
}

/** aggregate fields of "coassign.employment_contract" */
export type Coassign_Employment_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Employment_Contract_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.employment_contract" */
export type Coassign_Employment_Contract_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Employment_Contract_Max_Order_By>
  min?: InputMaybe<Coassign_Employment_Contract_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.employment_contract" */
export type Coassign_Employment_Contract_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Employment_Contract_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Employment_Contract_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.employment_contract". All fields are combined with a logical 'AND'. */
export type Coassign_Employment_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Employment_Contract_Bool_Exp>>
  _not?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Employment_Contract_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  contractor?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  lock?: InputMaybe<Contract_Locks_Comparison_Exp>
  state?: InputMaybe<Contract_States_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.employment_contract" */
export enum Coassign_Employment_Contract_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmploymentContractPkey = 'employment_contract_pkey'
}

/** input type for inserting data into table "coassign.employment_contract" */
export type Coassign_Employment_Contract_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  contractor?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Employment_Contract_Max_Fields = {
  __typename?: 'coassign_employment_contract_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  contractor?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  lock?: Maybe<Scalars['contract_locks']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.employment_contract" */
export type Coassign_Employment_Contract_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  contractor?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lock?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Employment_Contract_Min_Fields = {
  __typename?: 'coassign_employment_contract_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  contractor?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  lock?: Maybe<Scalars['contract_locks']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.employment_contract" */
export type Coassign_Employment_Contract_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  contractor?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lock?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.employment_contract" */
export type Coassign_Employment_Contract_Mutation_Response = {
  __typename?: 'coassign_employment_contract_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Employment_Contract>
}

/** on_conflict condition type for table "coassign.employment_contract" */
export type Coassign_Employment_Contract_On_Conflict = {
  constraint: Coassign_Employment_Contract_Constraint
  update_columns?: Array<Coassign_Employment_Contract_Update_Column>
  where?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.employment_contract". */
export type Coassign_Employment_Contract_Order_By = {
  commit_id?: InputMaybe<Order_By>
  contractor?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lock?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.employment_contract */
export type Coassign_Employment_Contract_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.employment_contract" */
export enum Coassign_Employment_Contract_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  Contractor = 'contractor',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lock = 'lock',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.employment_contract" */
export type Coassign_Employment_Contract_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  contractor?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_employment_contract" */
export type Coassign_Employment_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Employment_Contract_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Employment_Contract_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  contractor?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lock?: InputMaybe<Scalars['contract_locks']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.employment_contract" */
export enum Coassign_Employment_Contract_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  Contractor = 'contractor',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lock = 'lock',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Employment_Contract_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Employment_Contract_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Employment_Contract_Bool_Exp
}

/** input type for incrementing numeric columns in table "coassign.employment" */
export type Coassign_Employment_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "coassign.employment" */
export type Coassign_Employment_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  contract?: InputMaybe<Scalars['String']['input']>
  cost?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  partner?: InputMaybe<Coassign_Partner_Obj_Rel_Insert_Input>
  partner_id?: InputMaybe<Scalars['String']['input']>
  start?: InputMaybe<Scalars['date']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['cost_periods']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Employment_Max_Fields = {
  __typename?: 'coassign_employment_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  contract?: Maybe<Scalars['String']['output']>
  cost?: Maybe<Scalars['Int']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  partner_id?: Maybe<Scalars['String']['output']>
  start?: Maybe<Scalars['date']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['cost_periods']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.employment" */
export type Coassign_Employment_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  contract?: InputMaybe<Order_By>
  cost?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  partner_id?: InputMaybe<Order_By>
  start?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Employment_Min_Fields = {
  __typename?: 'coassign_employment_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  contract?: Maybe<Scalars['String']['output']>
  cost?: Maybe<Scalars['Int']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  partner_id?: Maybe<Scalars['String']['output']>
  start?: Maybe<Scalars['date']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['cost_periods']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.employment" */
export type Coassign_Employment_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  contract?: InputMaybe<Order_By>
  cost?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  partner_id?: InputMaybe<Order_By>
  start?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.employment" */
export type Coassign_Employment_Mutation_Response = {
  __typename?: 'coassign_employment_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Employment>
}

/** on_conflict condition type for table "coassign.employment" */
export type Coassign_Employment_On_Conflict = {
  constraint: Coassign_Employment_Constraint
  update_columns?: Array<Coassign_Employment_Update_Column>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.employment". */
export type Coassign_Employment_Order_By = {
  commit_id?: InputMaybe<Order_By>
  contract?: InputMaybe<Order_By>
  cost?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  partner?: InputMaybe<Coassign_Partner_Order_By>
  partner_id?: InputMaybe<Order_By>
  start?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.employment */
export type Coassign_Employment_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.employment" */
export enum Coassign_Employment_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  Contract = 'contract',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Start = 'start',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coassign.employment" */
export type Coassign_Employment_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  contract?: InputMaybe<Scalars['String']['input']>
  cost?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  partner_id?: InputMaybe<Scalars['String']['input']>
  start?: InputMaybe<Scalars['date']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['cost_periods']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Employment_Stddev_Fields = {
  __typename?: 'coassign_employment_stddev_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.employment" */
export type Coassign_Employment_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Employment_Stddev_Pop_Fields = {
  __typename?: 'coassign_employment_stddev_pop_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.employment" */
export type Coassign_Employment_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Employment_Stddev_Samp_Fields = {
  __typename?: 'coassign_employment_stddev_samp_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.employment" */
export type Coassign_Employment_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_employment" */
export type Coassign_Employment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Employment_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Employment_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  contract?: InputMaybe<Scalars['String']['input']>
  cost?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  partner_id?: InputMaybe<Scalars['String']['input']>
  start?: InputMaybe<Scalars['date']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['cost_periods']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Coassign_Employment_Sum_Fields = {
  __typename?: 'coassign_employment_sum_fields'
  cost?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "coassign.employment" */
export type Coassign_Employment_Sum_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** update columns of table "coassign.employment" */
export enum Coassign_Employment_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  Contract = 'contract',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Start = 'start',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Coassign_Employment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Employment_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Employment_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Employment_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Employment_Var_Pop_Fields = {
  __typename?: 'coassign_employment_var_pop_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.employment" */
export type Coassign_Employment_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Employment_Var_Samp_Fields = {
  __typename?: 'coassign_employment_var_samp_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.employment" */
export type Coassign_Employment_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Employment_Variance_Fields = {
  __typename?: 'coassign_employment_variance_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.employment" */
export type Coassign_Employment_Variance_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.holiday" */
export type Coassign_Holiday = {
  __typename?: 'coassign_holiday'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  date: Scalars['date']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.holiday" */
export type Coassign_Holiday_Aggregate = {
  __typename?: 'coassign_holiday_aggregate'
  aggregate?: Maybe<Coassign_Holiday_Aggregate_Fields>
  nodes: Array<Coassign_Holiday>
}

export type Coassign_Holiday_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Holiday_Aggregate_Bool_Exp_Count>
}

export type Coassign_Holiday_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Holiday_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Holiday_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.holiday" */
export type Coassign_Holiday_Aggregate_Fields = {
  __typename?: 'coassign_holiday_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Holiday_Max_Fields>
  min?: Maybe<Coassign_Holiday_Min_Fields>
}

/** aggregate fields of "coassign.holiday" */
export type Coassign_Holiday_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Holiday_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.holiday" */
export type Coassign_Holiday_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Holiday_Max_Order_By>
  min?: InputMaybe<Coassign_Holiday_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.holiday" */
export type Coassign_Holiday_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Holiday_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Holiday_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.holiday". All fields are combined with a logical 'AND'. */
export type Coassign_Holiday_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Holiday_Bool_Exp>>
  _not?: InputMaybe<Coassign_Holiday_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Holiday_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  date?: InputMaybe<Date_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.holiday" */
export enum Coassign_Holiday_Constraint {
  /** unique or primary key constraint on columns "date", "name", "tenant_id" */
  HolidayNameTenantIdDateDeletedAt = 'holiday_name_tenant_id_date_deleted_at',
  /** unique or primary key constraint on columns "id" */
  HolidayPkey = 'holiday_pkey'
}

/** input type for inserting data into table "coassign.holiday" */
export type Coassign_Holiday_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  date?: InputMaybe<Scalars['date']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Holiday_Max_Fields = {
  __typename?: 'coassign_holiday_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  date?: Maybe<Scalars['date']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.holiday" */
export type Coassign_Holiday_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  date?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Holiday_Min_Fields = {
  __typename?: 'coassign_holiday_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  date?: Maybe<Scalars['date']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.holiday" */
export type Coassign_Holiday_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  date?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.holiday" */
export type Coassign_Holiday_Mutation_Response = {
  __typename?: 'coassign_holiday_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Holiday>
}

/** on_conflict condition type for table "coassign.holiday" */
export type Coassign_Holiday_On_Conflict = {
  constraint: Coassign_Holiday_Constraint
  update_columns?: Array<Coassign_Holiday_Update_Column>
  where?: InputMaybe<Coassign_Holiday_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.holiday". */
export type Coassign_Holiday_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  date?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.holiday */
export type Coassign_Holiday_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.holiday" */
export enum Coassign_Holiday_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.holiday" */
export type Coassign_Holiday_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  date?: InputMaybe<Scalars['date']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_holiday" */
export type Coassign_Holiday_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Holiday_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Holiday_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  date?: InputMaybe<Scalars['date']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.holiday" */
export enum Coassign_Holiday_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Holiday_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Holiday_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Holiday_Bool_Exp
}

/** columns and relationships of "coassign.job" */
export type Coassign_Job = {
  __typename?: 'coassign_job'
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  /** An object relationship */
  job_definition: Coassign_Job_Definition
  job_definition_id: Scalars['String']['output']
  name: Scalars['String']['output']
  params?: Maybe<Scalars['jsonb']['output']>
  /** An object relationship */
  tenant: Coassign_Tenant
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "coassign.job" */
export type Coassign_JobParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.job" */
export type Coassign_Job_Aggregate = {
  __typename?: 'coassign_job_aggregate'
  aggregate?: Maybe<Coassign_Job_Aggregate_Fields>
  nodes: Array<Coassign_Job>
}

export type Coassign_Job_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Job_Aggregate_Bool_Exp_Count>
}

export type Coassign_Job_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Job_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.job" */
export type Coassign_Job_Aggregate_Fields = {
  __typename?: 'coassign_job_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Job_Max_Fields>
  min?: Maybe<Coassign_Job_Min_Fields>
}

/** aggregate fields of "coassign.job" */
export type Coassign_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Job_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.job" */
export type Coassign_Job_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Job_Max_Order_By>
  min?: InputMaybe<Coassign_Job_Min_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Job_Append_Input = {
  params?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "coassign.job" */
export type Coassign_Job_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Job_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.job". All fields are combined with a logical 'AND'. */
export type Coassign_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Job_Bool_Exp>>
  _not?: InputMaybe<Coassign_Job_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Job_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_definition?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
  job_definition_id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  params?: InputMaybe<Jsonb_Comparison_Exp>
  tenant?: InputMaybe<Coassign_Tenant_Bool_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.job" */
export enum Coassign_Job_Constraint {
  /** unique or primary key constraint on columns "name", "tenant_id" */
  JobNameTenantId = 'job_name_tenant_id',
  /** unique or primary key constraint on columns "id" */
  JobPkey = 'job_pkey'
}

/** columns and relationships of "coassign.job_definition" */
export type Coassign_Job_Definition = {
  __typename?: 'coassign_job_definition'
  code: Scalars['String']['output']
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  description: Scalars['String']['output']
  document_url?: Maybe<Scalars['String']['output']>
  extension?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  job_type: Scalars['job_types']['output']
  maintainer_id?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  param_schema?: Maybe<Scalars['jsonb']['output']>
  runtime: Scalars['job_runtime_types']['output']
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at: Scalars['timestamptz']['output']
  version: Scalars['String']['output']
}

/** columns and relationships of "coassign.job_definition" */
export type Coassign_Job_DefinitionParam_SchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.job_definition" */
export type Coassign_Job_Definition_Aggregate = {
  __typename?: 'coassign_job_definition_aggregate'
  aggregate?: Maybe<Coassign_Job_Definition_Aggregate_Fields>
  nodes: Array<Coassign_Job_Definition>
}

export type Coassign_Job_Definition_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Job_Definition_Aggregate_Bool_Exp_Count>
}

export type Coassign_Job_Definition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Job_Definition_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.job_definition" */
export type Coassign_Job_Definition_Aggregate_Fields = {
  __typename?: 'coassign_job_definition_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Job_Definition_Max_Fields>
  min?: Maybe<Coassign_Job_Definition_Min_Fields>
}

/** aggregate fields of "coassign.job_definition" */
export type Coassign_Job_Definition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Job_Definition_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.job_definition" */
export type Coassign_Job_Definition_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Job_Definition_Max_Order_By>
  min?: InputMaybe<Coassign_Job_Definition_Min_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Job_Definition_Append_Input = {
  param_schema?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "coassign.job_definition" */
export type Coassign_Job_Definition_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Job_Definition_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_Definition_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.job_definition". All fields are combined with a logical 'AND'. */
export type Coassign_Job_Definition_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Job_Definition_Bool_Exp>>
  _not?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Job_Definition_Bool_Exp>>
  code?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  document_url?: InputMaybe<String_Comparison_Exp>
  extension?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_type?: InputMaybe<Job_Types_Comparison_Exp>
  maintainer_id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  param_schema?: InputMaybe<Jsonb_Comparison_Exp>
  runtime?: InputMaybe<Job_Runtime_Types_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  version?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.job_definition" */
export enum Coassign_Job_Definition_Constraint {
  /** unique or primary key constraint on columns "name", "tenant_id" */
  JobDefinitionNameTenantId = 'job_definition_name_tenant_id',
  /** unique or primary key constraint on columns "id" */
  JobDefinitionPkey = 'job_definition_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Job_Definition_Delete_At_Path_Input = {
  param_schema?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Job_Definition_Delete_Elem_Input = {
  param_schema?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Job_Definition_Delete_Key_Input = {
  param_schema?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "coassign.job_definition" */
export type Coassign_Job_Definition_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  document_url?: InputMaybe<Scalars['String']['input']>
  extension?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_type?: InputMaybe<Scalars['job_types']['input']>
  maintainer_id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  param_schema?: InputMaybe<Scalars['jsonb']['input']>
  runtime?: InputMaybe<Scalars['job_runtime_types']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Job_Definition_Max_Fields = {
  __typename?: 'coassign_job_definition_max_fields'
  code?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  description?: Maybe<Scalars['String']['output']>
  document_url?: Maybe<Scalars['String']['output']>
  extension?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_type?: Maybe<Scalars['job_types']['output']>
  maintainer_id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  runtime?: Maybe<Scalars['job_runtime_types']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  version?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.job_definition" */
export type Coassign_Job_Definition_Max_Order_By = {
  code?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  document_url?: InputMaybe<Order_By>
  extension?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_type?: InputMaybe<Order_By>
  maintainer_id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  runtime?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  version?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Job_Definition_Min_Fields = {
  __typename?: 'coassign_job_definition_min_fields'
  code?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  description?: Maybe<Scalars['String']['output']>
  document_url?: Maybe<Scalars['String']['output']>
  extension?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_type?: Maybe<Scalars['job_types']['output']>
  maintainer_id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  runtime?: Maybe<Scalars['job_runtime_types']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  version?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.job_definition" */
export type Coassign_Job_Definition_Min_Order_By = {
  code?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  document_url?: InputMaybe<Order_By>
  extension?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_type?: InputMaybe<Order_By>
  maintainer_id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  runtime?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  version?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.job_definition" */
export type Coassign_Job_Definition_Mutation_Response = {
  __typename?: 'coassign_job_definition_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Job_Definition>
}

/** input type for inserting object relation for remote table "coassign.job_definition" */
export type Coassign_Job_Definition_Obj_Rel_Insert_Input = {
  data: Coassign_Job_Definition_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_Definition_On_Conflict>
}

/** on_conflict condition type for table "coassign.job_definition" */
export type Coassign_Job_Definition_On_Conflict = {
  constraint: Coassign_Job_Definition_Constraint
  update_columns?: Array<Coassign_Job_Definition_Update_Column>
  where?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.job_definition". */
export type Coassign_Job_Definition_Order_By = {
  code?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  document_url?: InputMaybe<Order_By>
  extension?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_type?: InputMaybe<Order_By>
  maintainer_id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  param_schema?: InputMaybe<Order_By>
  runtime?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  version?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.job_definition */
export type Coassign_Job_Definition_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Job_Definition_Prepend_Input = {
  param_schema?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "coassign.job_definition" */
export enum Coassign_Job_Definition_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  Extension = 'extension',
  /** column name */
  Id = 'id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  MaintainerId = 'maintainer_id',
  /** column name */
  Name = 'name',
  /** column name */
  ParamSchema = 'param_schema',
  /** column name */
  Runtime = 'runtime',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "coassign.job_definition" */
export type Coassign_Job_Definition_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  document_url?: InputMaybe<Scalars['String']['input']>
  extension?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_type?: InputMaybe<Scalars['job_types']['input']>
  maintainer_id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  param_schema?: InputMaybe<Scalars['jsonb']['input']>
  runtime?: InputMaybe<Scalars['job_runtime_types']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_job_definition" */
export type Coassign_Job_Definition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Job_Definition_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Job_Definition_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  document_url?: InputMaybe<Scalars['String']['input']>
  extension?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_type?: InputMaybe<Scalars['job_types']['input']>
  maintainer_id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  param_schema?: InputMaybe<Scalars['jsonb']['input']>
  runtime?: InputMaybe<Scalars['job_runtime_types']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.job_definition" */
export enum Coassign_Job_Definition_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  Extension = 'extension',
  /** column name */
  Id = 'id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  MaintainerId = 'maintainer_id',
  /** column name */
  Name = 'name',
  /** column name */
  ParamSchema = 'param_schema',
  /** column name */
  Runtime = 'runtime',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

export type Coassign_Job_Definition_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Job_Definition_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Job_Definition_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Job_Definition_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Job_Definition_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Job_Definition_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Job_Definition_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Job_Definition_Bool_Exp
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Job_Delete_At_Path_Input = {
  params?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Job_Delete_Elem_Input = {
  params?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Job_Delete_Key_Input = {
  params?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "coassign.job" */
export type Coassign_Job_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_definition?: InputMaybe<Coassign_Job_Definition_Obj_Rel_Insert_Input>
  job_definition_id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['jsonb']['input']>
  tenant?: InputMaybe<Coassign_Tenant_Obj_Rel_Insert_Input>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Job_Max_Fields = {
  __typename?: 'coassign_job_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_definition_id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.job" */
export type Coassign_Job_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_definition_id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Job_Min_Fields = {
  __typename?: 'coassign_job_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_definition_id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.job" */
export type Coassign_Job_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_definition_id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.job" */
export type Coassign_Job_Mutation_Response = {
  __typename?: 'coassign_job_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Job>
}

/** input type for inserting object relation for remote table "coassign.job" */
export type Coassign_Job_Obj_Rel_Insert_Input = {
  data: Coassign_Job_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_On_Conflict>
}

/** on_conflict condition type for table "coassign.job" */
export type Coassign_Job_On_Conflict = {
  constraint: Coassign_Job_Constraint
  update_columns?: Array<Coassign_Job_Update_Column>
  where?: InputMaybe<Coassign_Job_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.job". */
export type Coassign_Job_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_definition?: InputMaybe<Coassign_Job_Definition_Order_By>
  job_definition_id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  params?: InputMaybe<Order_By>
  tenant?: InputMaybe<Coassign_Tenant_Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.job */
export type Coassign_Job_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Job_Prepend_Input = {
  params?: InputMaybe<Scalars['jsonb']['input']>
}

/** columns and relationships of "coassign.job_result" */
export type Coassign_Job_Result = {
  __typename?: 'coassign_job_result'
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  executed_user_id: Scalars['String']['output']
  id: Scalars['String']['output']
  /** An object relationship */
  job: Coassign_Job
  /** An object relationship */
  job_definition: Coassign_Job_Definition
  job_definition_id: Scalars['String']['output']
  job_definition_version: Scalars['String']['output']
  job_id: Scalars['String']['output']
  log?: Maybe<Scalars['String']['output']>
  result?: Maybe<Scalars['String']['output']>
  state: Scalars['job_state']['output']
  /** An object relationship */
  tenant: Coassign_Tenant
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
}

/** aggregated selection of "coassign.job_result" */
export type Coassign_Job_Result_Aggregate = {
  __typename?: 'coassign_job_result_aggregate'
  aggregate?: Maybe<Coassign_Job_Result_Aggregate_Fields>
  nodes: Array<Coassign_Job_Result>
}

export type Coassign_Job_Result_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Job_Result_Aggregate_Bool_Exp_Count>
}

export type Coassign_Job_Result_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Job_Result_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Result_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.job_result" */
export type Coassign_Job_Result_Aggregate_Fields = {
  __typename?: 'coassign_job_result_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Job_Result_Max_Fields>
  min?: Maybe<Coassign_Job_Result_Min_Fields>
}

/** aggregate fields of "coassign.job_result" */
export type Coassign_Job_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Job_Result_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.job_result" */
export type Coassign_Job_Result_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Job_Result_Max_Order_By>
  min?: InputMaybe<Coassign_Job_Result_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.job_result" */
export type Coassign_Job_Result_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Job_Result_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_Result_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.job_result". All fields are combined with a logical 'AND'. */
export type Coassign_Job_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Job_Result_Bool_Exp>>
  _not?: InputMaybe<Coassign_Job_Result_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Job_Result_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  executed_user_id?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job?: InputMaybe<Coassign_Job_Bool_Exp>
  job_definition?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
  job_definition_id?: InputMaybe<String_Comparison_Exp>
  job_definition_version?: InputMaybe<String_Comparison_Exp>
  job_id?: InputMaybe<String_Comparison_Exp>
  log?: InputMaybe<String_Comparison_Exp>
  result?: InputMaybe<String_Comparison_Exp>
  state?: InputMaybe<Job_State_Comparison_Exp>
  tenant?: InputMaybe<Coassign_Tenant_Bool_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.job_result" */
export enum Coassign_Job_Result_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobResultPkey = 'job_result_pkey'
}

/** input type for inserting data into table "coassign.job_result" */
export type Coassign_Job_Result_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  executed_user_id?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job?: InputMaybe<Coassign_Job_Obj_Rel_Insert_Input>
  job_definition?: InputMaybe<Coassign_Job_Definition_Obj_Rel_Insert_Input>
  job_definition_id?: InputMaybe<Scalars['String']['input']>
  job_definition_version?: InputMaybe<Scalars['String']['input']>
  job_id?: InputMaybe<Scalars['String']['input']>
  log?: InputMaybe<Scalars['String']['input']>
  result?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['job_state']['input']>
  tenant?: InputMaybe<Coassign_Tenant_Obj_Rel_Insert_Input>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_Job_Result_Max_Fields = {
  __typename?: 'coassign_job_result_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  executed_user_id?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_definition_id?: Maybe<Scalars['String']['output']>
  job_definition_version?: Maybe<Scalars['String']['output']>
  job_id?: Maybe<Scalars['String']['output']>
  log?: Maybe<Scalars['String']['output']>
  result?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['job_state']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.job_result" */
export type Coassign_Job_Result_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  executed_user_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_definition_id?: InputMaybe<Order_By>
  job_definition_version?: InputMaybe<Order_By>
  job_id?: InputMaybe<Order_By>
  log?: InputMaybe<Order_By>
  result?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Job_Result_Min_Fields = {
  __typename?: 'coassign_job_result_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  executed_user_id?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_definition_id?: Maybe<Scalars['String']['output']>
  job_definition_version?: Maybe<Scalars['String']['output']>
  job_id?: Maybe<Scalars['String']['output']>
  log?: Maybe<Scalars['String']['output']>
  result?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['job_state']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.job_result" */
export type Coassign_Job_Result_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  executed_user_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_definition_id?: InputMaybe<Order_By>
  job_definition_version?: InputMaybe<Order_By>
  job_id?: InputMaybe<Order_By>
  log?: InputMaybe<Order_By>
  result?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.job_result" */
export type Coassign_Job_Result_Mutation_Response = {
  __typename?: 'coassign_job_result_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Job_Result>
}

/** on_conflict condition type for table "coassign.job_result" */
export type Coassign_Job_Result_On_Conflict = {
  constraint: Coassign_Job_Result_Constraint
  update_columns?: Array<Coassign_Job_Result_Update_Column>
  where?: InputMaybe<Coassign_Job_Result_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.job_result". */
export type Coassign_Job_Result_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  executed_user_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job?: InputMaybe<Coassign_Job_Order_By>
  job_definition?: InputMaybe<Coassign_Job_Definition_Order_By>
  job_definition_id?: InputMaybe<Order_By>
  job_definition_version?: InputMaybe<Order_By>
  job_id?: InputMaybe<Order_By>
  log?: InputMaybe<Order_By>
  result?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant?: InputMaybe<Coassign_Tenant_Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
}

/** primary key columns input for table: coassign.job_result */
export type Coassign_Job_Result_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.job_result" */
export enum Coassign_Job_Result_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExecutedUserId = 'executed_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobDefinitionId = 'job_definition_id',
  /** column name */
  JobDefinitionVersion = 'job_definition_version',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Log = 'log',
  /** column name */
  Result = 'result',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.job_result" */
export type Coassign_Job_Result_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  executed_user_id?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_definition_id?: InputMaybe<Scalars['String']['input']>
  job_definition_version?: InputMaybe<Scalars['String']['input']>
  job_id?: InputMaybe<Scalars['String']['input']>
  log?: InputMaybe<Scalars['String']['input']>
  result?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['job_state']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_job_result" */
export type Coassign_Job_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Job_Result_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Job_Result_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  executed_user_id?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_definition_id?: InputMaybe<Scalars['String']['input']>
  job_definition_version?: InputMaybe<Scalars['String']['input']>
  job_id?: InputMaybe<Scalars['String']['input']>
  log?: InputMaybe<Scalars['String']['input']>
  result?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['job_state']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.job_result" */
export enum Coassign_Job_Result_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExecutedUserId = 'executed_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobDefinitionId = 'job_definition_id',
  /** column name */
  JobDefinitionVersion = 'job_definition_version',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Log = 'log',
  /** column name */
  Result = 'result',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Job_Result_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Job_Result_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Job_Result_Bool_Exp
}

/** select columns of table "coassign.job" */
export enum Coassign_Job_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JobDefinitionId = 'job_definition_id',
  /** column name */
  Name = 'name',
  /** column name */
  Params = 'params',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.job" */
export type Coassign_Job_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_definition_id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** columns and relationships of "coassign.job_skill" */
export type Coassign_Job_Skill = {
  __typename?: 'coassign_job_skill'
  choosable: Scalars['Boolean']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  order: Scalars['float8']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An array relationship */
  user_to_job_skills: Array<Coassign_User_To_Job_Skill>
  /** An aggregate relationship */
  user_to_job_skills_aggregate: Coassign_User_To_Job_Skill_Aggregate
}

/** columns and relationships of "coassign.job_skill" */
export type Coassign_Job_SkillUser_To_Job_SkillsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.job_skill" */
export type Coassign_Job_SkillUser_To_Job_Skills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

/** aggregated selection of "coassign.job_skill" */
export type Coassign_Job_Skill_Aggregate = {
  __typename?: 'coassign_job_skill_aggregate'
  aggregate?: Maybe<Coassign_Job_Skill_Aggregate_Fields>
  nodes: Array<Coassign_Job_Skill>
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Avg>
  bool_and?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Bool_Or>
  corr?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Corr>
  count?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Count>
  covar_samp?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Covar_Samp>
  max?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Max>
  min?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Min>
  stddev_samp?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Stddev_Samp>
  sum?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Sum>
  var_samp?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp_Var_Samp>
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Avg = {
  arguments: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Avg_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Corr = {
  arguments: Coassign_Job_Skill_Aggregate_Bool_Exp_Corr_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Corr_Arguments_Columns
  Y: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Corr_Arguments_Columns
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Job_Skill_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Int_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Coassign_Job_Skill_Aggregate_Bool_Exp_Covar_Samp_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
  Y: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Max = {
  arguments: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Max_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Min = {
  arguments: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Min_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Sum = {
  arguments: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Sum_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Skill_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

/** aggregate fields of "coassign.job_skill" */
export type Coassign_Job_Skill_Aggregate_Fields = {
  __typename?: 'coassign_job_skill_aggregate_fields'
  avg?: Maybe<Coassign_Job_Skill_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Job_Skill_Max_Fields>
  min?: Maybe<Coassign_Job_Skill_Min_Fields>
  stddev?: Maybe<Coassign_Job_Skill_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Job_Skill_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Job_Skill_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Job_Skill_Sum_Fields>
  var_pop?: Maybe<Coassign_Job_Skill_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Job_Skill_Var_Samp_Fields>
  variance?: Maybe<Coassign_Job_Skill_Variance_Fields>
}

/** aggregate fields of "coassign.job_skill" */
export type Coassign_Job_Skill_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Job_Skill_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.job_skill" */
export type Coassign_Job_Skill_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Job_Skill_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Job_Skill_Max_Order_By>
  min?: InputMaybe<Coassign_Job_Skill_Min_Order_By>
  stddev?: InputMaybe<Coassign_Job_Skill_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Job_Skill_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Job_Skill_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Job_Skill_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Job_Skill_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Job_Skill_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Job_Skill_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.job_skill" */
export type Coassign_Job_Skill_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Job_Skill_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_Skill_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Job_Skill_Avg_Fields = {
  __typename?: 'coassign_job_skill_avg_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Avg_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.job_skill". All fields are combined with a logical 'AND'. */
export type Coassign_Job_Skill_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Job_Skill_Bool_Exp>>
  _not?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Job_Skill_Bool_Exp>>
  choosable?: InputMaybe<Boolean_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  order?: InputMaybe<Float8_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_to_job_skills?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
  user_to_job_skills_aggregate?: InputMaybe<Coassign_User_To_Job_Skill_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.job_skill" */
export enum Coassign_Job_Skill_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobSkillPkey = 'job_skill_pkey',
  /** unique or primary key constraint on columns "name", "tenant_id" */
  JobSkillTenantIdNameDeletedAt = 'job_skill_tenant_id_name_deleted_at'
}

/** input type for incrementing numeric columns in table "coassign.job_skill" */
export type Coassign_Job_Skill_Inc_Input = {
  order?: InputMaybe<Scalars['float8']['input']>
}

/** input type for inserting data into table "coassign.job_skill" */
export type Coassign_Job_Skill_Insert_Input = {
  choosable?: InputMaybe<Scalars['Boolean']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_to_job_skills?: InputMaybe<Coassign_User_To_Job_Skill_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_Job_Skill_Max_Fields = {
  __typename?: 'coassign_job_skill_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Job_Skill_Min_Fields = {
  __typename?: 'coassign_job_skill_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.job_skill" */
export type Coassign_Job_Skill_Mutation_Response = {
  __typename?: 'coassign_job_skill_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Job_Skill>
}

/** input type for inserting object relation for remote table "coassign.job_skill" */
export type Coassign_Job_Skill_Obj_Rel_Insert_Input = {
  data: Coassign_Job_Skill_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_Skill_On_Conflict>
}

/** on_conflict condition type for table "coassign.job_skill" */
export type Coassign_Job_Skill_On_Conflict = {
  constraint: Coassign_Job_Skill_Constraint
  update_columns?: Array<Coassign_Job_Skill_Update_Column>
  where?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.job_skill". */
export type Coassign_Job_Skill_Order_By = {
  choosable?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_to_job_skills_aggregate?: InputMaybe<Coassign_User_To_Job_Skill_Aggregate_Order_By>
}

/** primary key columns input for table: coassign.job_skill */
export type Coassign_Job_Skill_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column {
  /** column name */
  Choosable = 'choosable',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "coassign_job_skill_aggregate_bool_exp_avg_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_skill_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Choosable = 'choosable'
}

/** select "coassign_job_skill_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Choosable = 'choosable'
}

/** select "coassign_job_skill_aggregate_bool_exp_corr_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_skill_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_skill_aggregate_bool_exp_max_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_skill_aggregate_bool_exp_min_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_skill_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_skill_aggregate_bool_exp_sum_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_skill_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Select_Column_Coassign_Job_Skill_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "coassign.job_skill" */
export type Coassign_Job_Skill_Set_Input = {
  choosable?: InputMaybe<Scalars['Boolean']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Job_Skill_Stddev_Fields = {
  __typename?: 'coassign_job_skill_stddev_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Stddev_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Job_Skill_Stddev_Pop_Fields = {
  __typename?: 'coassign_job_skill_stddev_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Job_Skill_Stddev_Samp_Fields = {
  __typename?: 'coassign_job_skill_stddev_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_job_skill" */
export type Coassign_Job_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Job_Skill_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Job_Skill_Stream_Cursor_Value_Input = {
  choosable?: InputMaybe<Scalars['Boolean']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Job_Skill_Sum_Fields = {
  __typename?: 'coassign_job_skill_sum_fields'
  order?: Maybe<Scalars['float8']['output']>
}

/** order by sum() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Sum_Order_By = {
  order?: InputMaybe<Order_By>
}

/** update columns of table "coassign.job_skill" */
export enum Coassign_Job_Skill_Update_Column {
  /** column name */
  Choosable = 'choosable',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Job_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Job_Skill_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Job_Skill_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Job_Skill_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Job_Skill_Var_Pop_Fields = {
  __typename?: 'coassign_job_skill_var_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Job_Skill_Var_Samp_Fields = {
  __typename?: 'coassign_job_skill_var_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Job_Skill_Variance_Fields = {
  __typename?: 'coassign_job_skill_variance_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.job_skill" */
export type Coassign_Job_Skill_Variance_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_job" */
export type Coassign_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Job_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Job_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_definition_id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** columns and relationships of "coassign.job_title" */
export type Coassign_Job_Title = {
  __typename?: 'coassign_job_title'
  choosable: Scalars['Boolean']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  order: Scalars['float8']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An array relationship */
  user_to_job_titles: Array<Coassign_User_To_Job_Title>
  /** An aggregate relationship */
  user_to_job_titles_aggregate: Coassign_User_To_Job_Title_Aggregate
}

/** columns and relationships of "coassign.job_title" */
export type Coassign_Job_TitleUser_To_Job_TitlesArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

/** columns and relationships of "coassign.job_title" */
export type Coassign_Job_TitleUser_To_Job_Titles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

/** aggregated selection of "coassign.job_title" */
export type Coassign_Job_Title_Aggregate = {
  __typename?: 'coassign_job_title_aggregate'
  aggregate?: Maybe<Coassign_Job_Title_Aggregate_Fields>
  nodes: Array<Coassign_Job_Title>
}

export type Coassign_Job_Title_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Avg>
  bool_and?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Bool_Or>
  corr?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Corr>
  count?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Count>
  covar_samp?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Covar_Samp>
  max?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Max>
  min?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Min>
  stddev_samp?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Stddev_Samp>
  sum?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Sum>
  var_samp?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp_Var_Samp>
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Avg = {
  arguments: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Avg_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Corr = {
  arguments: Coassign_Job_Title_Aggregate_Bool_Exp_Corr_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Corr_Arguments_Columns
  Y: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Corr_Arguments_Columns
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Job_Title_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Int_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Coassign_Job_Title_Aggregate_Bool_Exp_Covar_Samp_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
  Y: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Max = {
  arguments: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Max_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Min = {
  arguments: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Min_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Sum = {
  arguments: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Sum_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Job_Title_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

/** aggregate fields of "coassign.job_title" */
export type Coassign_Job_Title_Aggregate_Fields = {
  __typename?: 'coassign_job_title_aggregate_fields'
  avg?: Maybe<Coassign_Job_Title_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Job_Title_Max_Fields>
  min?: Maybe<Coassign_Job_Title_Min_Fields>
  stddev?: Maybe<Coassign_Job_Title_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Job_Title_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Job_Title_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Job_Title_Sum_Fields>
  var_pop?: Maybe<Coassign_Job_Title_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Job_Title_Var_Samp_Fields>
  variance?: Maybe<Coassign_Job_Title_Variance_Fields>
}

/** aggregate fields of "coassign.job_title" */
export type Coassign_Job_Title_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Job_Title_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.job_title" */
export type Coassign_Job_Title_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Job_Title_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Job_Title_Max_Order_By>
  min?: InputMaybe<Coassign_Job_Title_Min_Order_By>
  stddev?: InputMaybe<Coassign_Job_Title_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Job_Title_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Job_Title_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Job_Title_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Job_Title_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Job_Title_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Job_Title_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.job_title" */
export type Coassign_Job_Title_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Job_Title_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_Title_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Job_Title_Avg_Fields = {
  __typename?: 'coassign_job_title_avg_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Avg_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.job_title". All fields are combined with a logical 'AND'. */
export type Coassign_Job_Title_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Job_Title_Bool_Exp>>
  _not?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Job_Title_Bool_Exp>>
  choosable?: InputMaybe<Boolean_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  order?: InputMaybe<Float8_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_to_job_titles?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
  user_to_job_titles_aggregate?: InputMaybe<Coassign_User_To_Job_Title_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.job_title" */
export enum Coassign_Job_Title_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobTitlePkey = 'job_title_pkey',
  /** unique or primary key constraint on columns "name", "tenant_id" */
  JobTitleTenantIdNameDeletedAt = 'job_title_tenant_id_name_deleted_at'
}

/** input type for incrementing numeric columns in table "coassign.job_title" */
export type Coassign_Job_Title_Inc_Input = {
  order?: InputMaybe<Scalars['float8']['input']>
}

/** input type for inserting data into table "coassign.job_title" */
export type Coassign_Job_Title_Insert_Input = {
  choosable?: InputMaybe<Scalars['Boolean']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_to_job_titles?: InputMaybe<Coassign_User_To_Job_Title_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_Job_Title_Max_Fields = {
  __typename?: 'coassign_job_title_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Job_Title_Min_Fields = {
  __typename?: 'coassign_job_title_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.job_title" */
export type Coassign_Job_Title_Mutation_Response = {
  __typename?: 'coassign_job_title_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Job_Title>
}

/** input type for inserting object relation for remote table "coassign.job_title" */
export type Coassign_Job_Title_Obj_Rel_Insert_Input = {
  data: Coassign_Job_Title_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_Title_On_Conflict>
}

/** on_conflict condition type for table "coassign.job_title" */
export type Coassign_Job_Title_On_Conflict = {
  constraint: Coassign_Job_Title_Constraint
  update_columns?: Array<Coassign_Job_Title_Update_Column>
  where?: InputMaybe<Coassign_Job_Title_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.job_title". */
export type Coassign_Job_Title_Order_By = {
  choosable?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_to_job_titles_aggregate?: InputMaybe<Coassign_User_To_Job_Title_Aggregate_Order_By>
}

/** primary key columns input for table: coassign.job_title */
export type Coassign_Job_Title_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column {
  /** column name */
  Choosable = 'choosable',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "coassign_job_title_aggregate_bool_exp_avg_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_title_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Choosable = 'choosable'
}

/** select "coassign_job_title_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Choosable = 'choosable'
}

/** select "coassign_job_title_aggregate_bool_exp_corr_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_title_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_title_aggregate_bool_exp_max_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_title_aggregate_bool_exp_min_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_title_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_title_aggregate_bool_exp_sum_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_job_title_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Select_Column_Coassign_Job_Title_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "coassign.job_title" */
export type Coassign_Job_Title_Set_Input = {
  choosable?: InputMaybe<Scalars['Boolean']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Job_Title_Stddev_Fields = {
  __typename?: 'coassign_job_title_stddev_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Stddev_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Job_Title_Stddev_Pop_Fields = {
  __typename?: 'coassign_job_title_stddev_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Job_Title_Stddev_Samp_Fields = {
  __typename?: 'coassign_job_title_stddev_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_job_title" */
export type Coassign_Job_Title_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Job_Title_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Job_Title_Stream_Cursor_Value_Input = {
  choosable?: InputMaybe<Scalars['Boolean']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Job_Title_Sum_Fields = {
  __typename?: 'coassign_job_title_sum_fields'
  order?: Maybe<Scalars['float8']['output']>
}

/** order by sum() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Sum_Order_By = {
  order?: InputMaybe<Order_By>
}

/** update columns of table "coassign.job_title" */
export enum Coassign_Job_Title_Update_Column {
  /** column name */
  Choosable = 'choosable',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Job_Title_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Job_Title_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Job_Title_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Job_Title_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Job_Title_Var_Pop_Fields = {
  __typename?: 'coassign_job_title_var_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Job_Title_Var_Samp_Fields = {
  __typename?: 'coassign_job_title_var_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Job_Title_Variance_Fields = {
  __typename?: 'coassign_job_title_variance_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.job_title" */
export type Coassign_Job_Title_Variance_Order_By = {
  order?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.job_trigger" */
export type Coassign_Job_Trigger = {
  __typename?: 'coassign_job_trigger'
  claim: Scalars['jsonb']['output']
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  job_id: Scalars['String']['output']
  params?: Maybe<Scalars['jsonb']['output']>
  tenant_id: Scalars['String']['output']
  timing?: Maybe<Scalars['String']['output']>
  trigger_type: Scalars['job_trigger_types']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "coassign.job_trigger" */
export type Coassign_Job_TriggerClaimArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.job_trigger" */
export type Coassign_Job_TriggerParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.job_trigger" */
export type Coassign_Job_Trigger_Aggregate = {
  __typename?: 'coassign_job_trigger_aggregate'
  aggregate?: Maybe<Coassign_Job_Trigger_Aggregate_Fields>
  nodes: Array<Coassign_Job_Trigger>
}

export type Coassign_Job_Trigger_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Job_Trigger_Aggregate_Bool_Exp_Count>
}

export type Coassign_Job_Trigger_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Job_Trigger_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.job_trigger" */
export type Coassign_Job_Trigger_Aggregate_Fields = {
  __typename?: 'coassign_job_trigger_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Job_Trigger_Max_Fields>
  min?: Maybe<Coassign_Job_Trigger_Min_Fields>
}

/** aggregate fields of "coassign.job_trigger" */
export type Coassign_Job_Trigger_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Job_Trigger_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.job_trigger" */
export type Coassign_Job_Trigger_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Job_Trigger_Max_Order_By>
  min?: InputMaybe<Coassign_Job_Trigger_Min_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Job_Trigger_Append_Input = {
  claim?: InputMaybe<Scalars['jsonb']['input']>
  params?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "coassign.job_trigger" */
export type Coassign_Job_Trigger_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Job_Trigger_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Job_Trigger_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.job_trigger". All fields are combined with a logical 'AND'. */
export type Coassign_Job_Trigger_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Job_Trigger_Bool_Exp>>
  _not?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Job_Trigger_Bool_Exp>>
  claim?: InputMaybe<Jsonb_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_id?: InputMaybe<String_Comparison_Exp>
  params?: InputMaybe<Jsonb_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  timing?: InputMaybe<String_Comparison_Exp>
  trigger_type?: InputMaybe<Job_Trigger_Types_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.job_trigger" */
export enum Coassign_Job_Trigger_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobTriggerPkey = 'job_trigger_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Job_Trigger_Delete_At_Path_Input = {
  claim?: InputMaybe<Array<Scalars['String']['input']>>
  params?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Job_Trigger_Delete_Elem_Input = {
  claim?: InputMaybe<Scalars['Int']['input']>
  params?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Job_Trigger_Delete_Key_Input = {
  claim?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "coassign.job_trigger" */
export type Coassign_Job_Trigger_Insert_Input = {
  claim?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_id?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  timing?: InputMaybe<Scalars['String']['input']>
  trigger_type?: InputMaybe<Scalars['job_trigger_types']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Job_Trigger_Max_Fields = {
  __typename?: 'coassign_job_trigger_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  timing?: Maybe<Scalars['String']['output']>
  trigger_type?: Maybe<Scalars['job_trigger_types']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.job_trigger" */
export type Coassign_Job_Trigger_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  timing?: InputMaybe<Order_By>
  trigger_type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Job_Trigger_Min_Fields = {
  __typename?: 'coassign_job_trigger_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  timing?: Maybe<Scalars['String']['output']>
  trigger_type?: Maybe<Scalars['job_trigger_types']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.job_trigger" */
export type Coassign_Job_Trigger_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  timing?: InputMaybe<Order_By>
  trigger_type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.job_trigger" */
export type Coassign_Job_Trigger_Mutation_Response = {
  __typename?: 'coassign_job_trigger_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Job_Trigger>
}

/** on_conflict condition type for table "coassign.job_trigger" */
export type Coassign_Job_Trigger_On_Conflict = {
  constraint: Coassign_Job_Trigger_Constraint
  update_columns?: Array<Coassign_Job_Trigger_Update_Column>
  where?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.job_trigger". */
export type Coassign_Job_Trigger_Order_By = {
  claim?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_id?: InputMaybe<Order_By>
  params?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  timing?: InputMaybe<Order_By>
  trigger_type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.job_trigger */
export type Coassign_Job_Trigger_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Job_Trigger_Prepend_Input = {
  claim?: InputMaybe<Scalars['jsonb']['input']>
  params?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "coassign.job_trigger" */
export enum Coassign_Job_Trigger_Select_Column {
  /** column name */
  Claim = 'claim',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Params = 'params',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Timing = 'timing',
  /** column name */
  TriggerType = 'trigger_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.job_trigger" */
export type Coassign_Job_Trigger_Set_Input = {
  claim?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_id?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  timing?: InputMaybe<Scalars['String']['input']>
  trigger_type?: InputMaybe<Scalars['job_trigger_types']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_job_trigger" */
export type Coassign_Job_Trigger_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Job_Trigger_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Job_Trigger_Stream_Cursor_Value_Input = {
  claim?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_id?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  timing?: InputMaybe<Scalars['String']['input']>
  trigger_type?: InputMaybe<Scalars['job_trigger_types']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.job_trigger" */
export enum Coassign_Job_Trigger_Update_Column {
  /** column name */
  Claim = 'claim',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Params = 'params',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Timing = 'timing',
  /** column name */
  TriggerType = 'trigger_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Job_Trigger_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Job_Trigger_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Job_Trigger_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Job_Trigger_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Job_Trigger_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Job_Trigger_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Job_Trigger_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Job_Trigger_Bool_Exp
}

/** update columns of table "coassign.job" */
export enum Coassign_Job_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JobDefinitionId = 'job_definition_id',
  /** column name */
  Name = 'name',
  /** column name */
  Params = 'params',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Job_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Job_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Job_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Job_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Job_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Job_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Job_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Job_Bool_Exp
}

/** columns and relationships of "coassign.partner" */
export type Coassign_Partner = {
  __typename?: 'coassign_partner'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  /** An array relationship */
  employments: Array<Coassign_Employment>
  /** An aggregate relationship */
  employments_aggregate: Coassign_Employment_Aggregate
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  order: Scalars['float8']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "coassign.partner" */
export type Coassign_PartnerEmploymentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

/** columns and relationships of "coassign.partner" */
export type Coassign_PartnerEmployments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

/** aggregated selection of "coassign.partner" */
export type Coassign_Partner_Aggregate = {
  __typename?: 'coassign_partner_aggregate'
  aggregate?: Maybe<Coassign_Partner_Aggregate_Fields>
  nodes: Array<Coassign_Partner>
}

export type Coassign_Partner_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Avg>
  corr?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Corr>
  count?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Count>
  covar_samp?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Covar_Samp>
  max?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Max>
  min?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Min>
  stddev_samp?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Stddev_Samp>
  sum?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Sum>
  var_samp?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp_Var_Samp>
}

export type Coassign_Partner_Aggregate_Bool_Exp_Avg = {
  arguments: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Avg_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Partner_Aggregate_Bool_Exp_Corr = {
  arguments: Coassign_Partner_Aggregate_Bool_Exp_Corr_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Partner_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Corr_Arguments_Columns
  Y: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Corr_Arguments_Columns
}

export type Coassign_Partner_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Partner_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Int_Comparison_Exp
}

export type Coassign_Partner_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Coassign_Partner_Aggregate_Bool_Exp_Covar_Samp_Arguments
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Partner_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
  Y: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns
}

export type Coassign_Partner_Aggregate_Bool_Exp_Max = {
  arguments: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Max_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Partner_Aggregate_Bool_Exp_Min = {
  arguments: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Min_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Partner_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Partner_Aggregate_Bool_Exp_Sum = {
  arguments: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Sum_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

export type Coassign_Partner_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Partner_Bool_Exp>
  predicate: Float8_Comparison_Exp
}

/** aggregate fields of "coassign.partner" */
export type Coassign_Partner_Aggregate_Fields = {
  __typename?: 'coassign_partner_aggregate_fields'
  avg?: Maybe<Coassign_Partner_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Partner_Max_Fields>
  min?: Maybe<Coassign_Partner_Min_Fields>
  stddev?: Maybe<Coassign_Partner_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Partner_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Partner_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Partner_Sum_Fields>
  var_pop?: Maybe<Coassign_Partner_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Partner_Var_Samp_Fields>
  variance?: Maybe<Coassign_Partner_Variance_Fields>
}

/** aggregate fields of "coassign.partner" */
export type Coassign_Partner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Partner_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.partner" */
export type Coassign_Partner_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Partner_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Partner_Max_Order_By>
  min?: InputMaybe<Coassign_Partner_Min_Order_By>
  stddev?: InputMaybe<Coassign_Partner_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Partner_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Partner_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Partner_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Partner_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Partner_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Partner_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.partner" */
export type Coassign_Partner_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Partner_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Partner_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Partner_Avg_Fields = {
  __typename?: 'coassign_partner_avg_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.partner" */
export type Coassign_Partner_Avg_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.partner". All fields are combined with a logical 'AND'. */
export type Coassign_Partner_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Partner_Bool_Exp>>
  _not?: InputMaybe<Coassign_Partner_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Partner_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  employments?: InputMaybe<Coassign_Employment_Bool_Exp>
  employments_aggregate?: InputMaybe<Coassign_Employment_Aggregate_Bool_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  order?: InputMaybe<Float8_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.partner" */
export enum Coassign_Partner_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerPkey = 'partner_pkey',
  /** unique or primary key constraint on columns "name", "tenant_id" */
  PartnerTenantIdNameDeletedAt = 'partner_tenant_id_name_deleted_at'
}

/** input type for incrementing numeric columns in table "coassign.partner" */
export type Coassign_Partner_Inc_Input = {
  order?: InputMaybe<Scalars['float8']['input']>
}

/** input type for inserting data into table "coassign.partner" */
export type Coassign_Partner_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  employments?: InputMaybe<Coassign_Employment_Arr_Rel_Insert_Input>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Partner_Max_Fields = {
  __typename?: 'coassign_partner_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.partner" */
export type Coassign_Partner_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Partner_Min_Fields = {
  __typename?: 'coassign_partner_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['float8']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.partner" */
export type Coassign_Partner_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.partner" */
export type Coassign_Partner_Mutation_Response = {
  __typename?: 'coassign_partner_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Partner>
}

/** input type for inserting object relation for remote table "coassign.partner" */
export type Coassign_Partner_Obj_Rel_Insert_Input = {
  data: Coassign_Partner_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Partner_On_Conflict>
}

/** on_conflict condition type for table "coassign.partner" */
export type Coassign_Partner_On_Conflict = {
  constraint: Coassign_Partner_Constraint
  update_columns?: Array<Coassign_Partner_Update_Column>
  where?: InputMaybe<Coassign_Partner_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.partner". */
export type Coassign_Partner_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  employments_aggregate?: InputMaybe<Coassign_Employment_Aggregate_Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  order?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.partner */
export type Coassign_Partner_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "coassign_partner_aggregate_bool_exp_avg_arguments_columns" columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_partner_aggregate_bool_exp_corr_arguments_columns" columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_partner_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_partner_aggregate_bool_exp_max_arguments_columns" columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_partner_aggregate_bool_exp_min_arguments_columns" columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_partner_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_partner_aggregate_bool_exp_sum_arguments_columns" columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** select "coassign_partner_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coassign.partner" */
export enum Coassign_Partner_Select_Column_Coassign_Partner_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "coassign.partner" */
export type Coassign_Partner_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Partner_Stddev_Fields = {
  __typename?: 'coassign_partner_stddev_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.partner" */
export type Coassign_Partner_Stddev_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Partner_Stddev_Pop_Fields = {
  __typename?: 'coassign_partner_stddev_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.partner" */
export type Coassign_Partner_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Partner_Stddev_Samp_Fields = {
  __typename?: 'coassign_partner_stddev_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.partner" */
export type Coassign_Partner_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_partner" */
export type Coassign_Partner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Partner_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Partner_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  order?: InputMaybe<Scalars['float8']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Partner_Sum_Fields = {
  __typename?: 'coassign_partner_sum_fields'
  order?: Maybe<Scalars['float8']['output']>
}

/** order by sum() on columns of table "coassign.partner" */
export type Coassign_Partner_Sum_Order_By = {
  order?: InputMaybe<Order_By>
}

/** update columns of table "coassign.partner" */
export enum Coassign_Partner_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Partner_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Partner_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Partner_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Partner_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Partner_Var_Pop_Fields = {
  __typename?: 'coassign_partner_var_pop_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.partner" */
export type Coassign_Partner_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Partner_Var_Samp_Fields = {
  __typename?: 'coassign_partner_var_samp_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.partner" */
export type Coassign_Partner_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Partner_Variance_Fields = {
  __typename?: 'coassign_partner_variance_fields'
  order?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.partner" */
export type Coassign_Partner_Variance_Order_By = {
  order?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.project" */
export type Coassign_Project = {
  __typename?: 'coassign_project'
  /** An array relationship */
  assigns: Array<Coassign_Assign>
  /** An aggregate relationship */
  assigns_aggregate: Coassign_Assign_Aggregate
  /** An object relationship */
  client?: Maybe<Coassign_Client>
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  custom_fields?: Maybe<Scalars['jsonb']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date: Scalars['date']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  /** An array relationship */
  project_to_departments: Array<Coassign_Project_To_Department>
  /** An aggregate relationship */
  project_to_departments_aggregate: Coassign_Project_To_Department_Aggregate
  /** An array relationship */
  project_to_users: Array<Coassign_Project_To_User>
  /** An aggregate relationship */
  project_to_users_aggregate: Coassign_Project_To_User_Aggregate
  start_date: Scalars['date']['output']
  sys_period: Scalars['tstzrange']['output']
  target_cost?: Maybe<Scalars['Int']['output']>
  /** An array relationship */
  target_cost_others: Array<Coassign_Target_Cost_Other>
  /** An aggregate relationship */
  target_cost_others_aggregate: Coassign_Target_Cost_Other_Aggregate
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  target_sales_breakdown_plan: Scalars['jsonb']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An array relationship */
  volumed_assigns: Array<Coassign_Volumed_Assign>
  /** An aggregate relationship */
  volumed_assigns_aggregate: Coassign_Volumed_Assign_Aggregate
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectAssignsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Order_By>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectAssigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Order_By>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectCustom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectProject_To_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectProject_To_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectProject_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectProject_To_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectTarget_Cost_OthersArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectTarget_Cost_Others_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectTarget_Sales_Breakdown_PlanArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectVolumed_AssignsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

/** columns and relationships of "coassign.project" */
export type Coassign_ProjectVolumed_Assigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

/** aggregated selection of "coassign.project" */
export type Coassign_Project_Aggregate = {
  __typename?: 'coassign_project_aggregate'
  aggregate?: Maybe<Coassign_Project_Aggregate_Fields>
  nodes: Array<Coassign_Project>
}

export type Coassign_Project_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Project_Aggregate_Bool_Exp_Count>
}

export type Coassign_Project_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Project_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Project_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.project" */
export type Coassign_Project_Aggregate_Fields = {
  __typename?: 'coassign_project_aggregate_fields'
  avg?: Maybe<Coassign_Project_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_Max_Fields>
  min?: Maybe<Coassign_Project_Min_Fields>
  stddev?: Maybe<Coassign_Project_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Project_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Project_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Project_Sum_Fields>
  var_pop?: Maybe<Coassign_Project_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Project_Var_Samp_Fields>
  variance?: Maybe<Coassign_Project_Variance_Fields>
}

/** aggregate fields of "coassign.project" */
export type Coassign_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.project" */
export type Coassign_Project_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Project_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Project_Max_Order_By>
  min?: InputMaybe<Coassign_Project_Min_Order_By>
  stddev?: InputMaybe<Coassign_Project_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Project_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Project_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Project_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Project_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Project_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Project_Variance_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Project_Append_Input = {
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "coassign.project" */
export type Coassign_Project_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Project_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Project_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Project_Avg_Fields = {
  __typename?: 'coassign_project_avg_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.project" */
export type Coassign_Project_Avg_Order_By = {
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.project". All fields are combined with a logical 'AND'. */
export type Coassign_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_Bool_Exp>>
  assigns?: InputMaybe<Coassign_Assign_Bool_Exp>
  assigns_aggregate?: InputMaybe<Coassign_Assign_Aggregate_Bool_Exp>
  client?: InputMaybe<Coassign_Client_Bool_Exp>
  client_id?: InputMaybe<String_Comparison_Exp>
  code?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  custom_fields?: InputMaybe<Jsonb_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  detail?: InputMaybe<String_Comparison_Exp>
  end_date?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  project_to_departments?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
  project_to_departments_aggregate?: InputMaybe<Coassign_Project_To_Department_Aggregate_Bool_Exp>
  project_to_users?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
  project_to_users_aggregate?: InputMaybe<Coassign_Project_To_User_Aggregate_Bool_Exp>
  start_date?: InputMaybe<Date_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  target_cost?: InputMaybe<Int_Comparison_Exp>
  target_cost_others?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
  target_cost_others_aggregate?: InputMaybe<Coassign_Target_Cost_Other_Aggregate_Bool_Exp>
  target_man_hours_in_sec?: InputMaybe<Int_Comparison_Exp>
  target_sales?: InputMaybe<Bigint_Comparison_Exp>
  target_sales_breakdown_plan?: InputMaybe<Jsonb_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assigns?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
  volumed_assigns_aggregate?: InputMaybe<Coassign_Volumed_Assign_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.project" */
export enum Coassign_Project_Constraint {
  /** unique or primary key constraint on columns "code", "tenant_id" */
  ProjectCodeTenantIdDeletedAt = 'project_code_tenant_id_deleted_at',
  /** unique or primary key constraint on columns "id" */
  ProjectPkey = 'project_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Project_Delete_At_Path_Input = {
  custom_fields?: InputMaybe<Array<Scalars['String']['input']>>
  target_sales_breakdown_plan?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Project_Delete_Elem_Input = {
  custom_fields?: InputMaybe<Scalars['Int']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Project_Delete_Key_Input = {
  custom_fields?: InputMaybe<Scalars['String']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.project_full_view" */
export type Coassign_Project_Full_View = {
  __typename?: 'coassign_project_full_view'
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  custom_fields?: Maybe<Scalars['jsonb']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  start_date?: Maybe<Scalars['date']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  target_sales_breakdown_plan?: Maybe<Scalars['jsonb']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** columns and relationships of "coassign.project_full_view" */
export type Coassign_Project_Full_ViewCustom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.project_full_view" */
export type Coassign_Project_Full_ViewTarget_Sales_Breakdown_PlanArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.project_full_view" */
export type Coassign_Project_Full_View_Aggregate = {
  __typename?: 'coassign_project_full_view_aggregate'
  aggregate?: Maybe<Coassign_Project_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Project_Full_View>
}

/** aggregate fields of "coassign.project_full_view" */
export type Coassign_Project_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_project_full_view_aggregate_fields'
  avg?: Maybe<Coassign_Project_Full_View_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_Full_View_Max_Fields>
  min?: Maybe<Coassign_Project_Full_View_Min_Fields>
  stddev?: Maybe<Coassign_Project_Full_View_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Project_Full_View_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Project_Full_View_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Project_Full_View_Sum_Fields>
  var_pop?: Maybe<Coassign_Project_Full_View_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Project_Full_View_Var_Samp_Fields>
  variance?: Maybe<Coassign_Project_Full_View_Variance_Fields>
}

/** aggregate fields of "coassign.project_full_view" */
export type Coassign_Project_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Coassign_Project_Full_View_Avg_Fields = {
  __typename?: 'coassign_project_full_view_avg_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "coassign.project_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Project_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_Full_View_Bool_Exp>>
  client_id?: InputMaybe<String_Comparison_Exp>
  code?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  custom_fields?: InputMaybe<Jsonb_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  detail?: InputMaybe<String_Comparison_Exp>
  end_date?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  start_date?: InputMaybe<Date_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  target_cost?: InputMaybe<Int_Comparison_Exp>
  target_man_hours_in_sec?: InputMaybe<Int_Comparison_Exp>
  target_sales?: InputMaybe<Bigint_Comparison_Exp>
  target_sales_breakdown_plan?: InputMaybe<Jsonb_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Project_Full_View_Max_Fields = {
  __typename?: 'coassign_project_full_view_max_fields'
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  start_date?: Maybe<Scalars['date']['output']>
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Project_Full_View_Min_Fields = {
  __typename?: 'coassign_project_full_view_min_fields'
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  start_date?: Maybe<Scalars['date']['output']>
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** Ordering options when selecting data from "coassign.project_full_view". */
export type Coassign_Project_Full_View_Order_By = {
  client_id?: InputMaybe<Order_By>
  code?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  custom_fields?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  detail?: InputMaybe<Order_By>
  end_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  start_date?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
  target_sales_breakdown_plan?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "coassign.project_full_view" */
export enum Coassign_Project_Full_View_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Code = 'code',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Detail = 'detail',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TargetCost = 'target_cost',
  /** column name */
  TargetManHoursInSec = 'target_man_hours_in_sec',
  /** column name */
  TargetSales = 'target_sales',
  /** column name */
  TargetSalesBreakdownPlan = 'target_sales_breakdown_plan',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Coassign_Project_Full_View_Stddev_Fields = {
  __typename?: 'coassign_project_full_view_stddev_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Coassign_Project_Full_View_Stddev_Pop_Fields = {
  __typename?: 'coassign_project_full_view_stddev_pop_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Coassign_Project_Full_View_Stddev_Samp_Fields = {
  __typename?: 'coassign_project_full_view_stddev_samp_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "coassign_project_full_view" */
export type Coassign_Project_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_Full_View_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['String']['input']>
  end_date?: InputMaybe<Scalars['date']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  start_date?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Project_Full_View_Sum_Fields = {
  __typename?: 'coassign_project_full_view_sum_fields'
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
}

/** aggregate var_pop on columns */
export type Coassign_Project_Full_View_Var_Pop_Fields = {
  __typename?: 'coassign_project_full_view_var_pop_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Coassign_Project_Full_View_Var_Samp_Fields = {
  __typename?: 'coassign_project_full_view_var_samp_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Coassign_Project_Full_View_Variance_Fields = {
  __typename?: 'coassign_project_full_view_variance_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "coassign.project_history" */
export type Coassign_Project_History = {
  __typename?: 'coassign_project_history'
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  custom_fields?: Maybe<Scalars['jsonb']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date: Scalars['date']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  start_date: Scalars['date']['output']
  sys_period: Scalars['tstzrange']['output']
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  target_sales_breakdown_plan: Scalars['jsonb']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "coassign.project_history" */
export type Coassign_Project_HistoryCustom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.project_history" */
export type Coassign_Project_HistoryTarget_Sales_Breakdown_PlanArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.project_history" */
export type Coassign_Project_History_Aggregate = {
  __typename?: 'coassign_project_history_aggregate'
  aggregate?: Maybe<Coassign_Project_History_Aggregate_Fields>
  nodes: Array<Coassign_Project_History>
}

/** aggregate fields of "coassign.project_history" */
export type Coassign_Project_History_Aggregate_Fields = {
  __typename?: 'coassign_project_history_aggregate_fields'
  avg?: Maybe<Coassign_Project_History_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_History_Max_Fields>
  min?: Maybe<Coassign_Project_History_Min_Fields>
  stddev?: Maybe<Coassign_Project_History_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Project_History_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Project_History_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Project_History_Sum_Fields>
  var_pop?: Maybe<Coassign_Project_History_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Project_History_Var_Samp_Fields>
  variance?: Maybe<Coassign_Project_History_Variance_Fields>
}

/** aggregate fields of "coassign.project_history" */
export type Coassign_Project_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Project_History_Append_Input = {
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
}

/** aggregate avg on columns */
export type Coassign_Project_History_Avg_Fields = {
  __typename?: 'coassign_project_history_avg_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "coassign.project_history". All fields are combined with a logical 'AND'. */
export type Coassign_Project_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_History_Bool_Exp>>
  client_id?: InputMaybe<String_Comparison_Exp>
  code?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  custom_fields?: InputMaybe<Jsonb_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  detail?: InputMaybe<String_Comparison_Exp>
  end_date?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  start_date?: InputMaybe<Date_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  target_cost?: InputMaybe<Int_Comparison_Exp>
  target_man_hours_in_sec?: InputMaybe<Int_Comparison_Exp>
  target_sales?: InputMaybe<Bigint_Comparison_Exp>
  target_sales_breakdown_plan?: InputMaybe<Jsonb_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Project_History_Delete_At_Path_Input = {
  custom_fields?: InputMaybe<Array<Scalars['String']['input']>>
  target_sales_breakdown_plan?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Project_History_Delete_Elem_Input = {
  custom_fields?: InputMaybe<Scalars['Int']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Project_History_Delete_Key_Input = {
  custom_fields?: InputMaybe<Scalars['String']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "coassign.project_history" */
export type Coassign_Project_History_Inc_Input = {
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
}

/** input type for inserting data into table "coassign.project_history" */
export type Coassign_Project_History_Insert_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['String']['input']>
  end_date?: InputMaybe<Scalars['date']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  start_date?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Project_History_Max_Fields = {
  __typename?: 'coassign_project_history_max_fields'
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  start_date?: Maybe<Scalars['date']['output']>
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Project_History_Min_Fields = {
  __typename?: 'coassign_project_history_min_fields'
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  start_date?: Maybe<Scalars['date']['output']>
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "coassign.project_history" */
export type Coassign_Project_History_Mutation_Response = {
  __typename?: 'coassign_project_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Project_History>
}

/** Ordering options when selecting data from "coassign.project_history". */
export type Coassign_Project_History_Order_By = {
  client_id?: InputMaybe<Order_By>
  code?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  custom_fields?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  detail?: InputMaybe<Order_By>
  end_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  start_date?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
  target_sales_breakdown_plan?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Project_History_Prepend_Input = {
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "coassign.project_history" */
export enum Coassign_Project_History_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Code = 'code',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Detail = 'detail',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TargetCost = 'target_cost',
  /** column name */
  TargetManHoursInSec = 'target_man_hours_in_sec',
  /** column name */
  TargetSales = 'target_sales',
  /** column name */
  TargetSalesBreakdownPlan = 'target_sales_breakdown_plan',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.project_history" */
export type Coassign_Project_History_Set_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['String']['input']>
  end_date?: InputMaybe<Scalars['date']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  start_date?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Project_History_Stddev_Fields = {
  __typename?: 'coassign_project_history_stddev_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Coassign_Project_History_Stddev_Pop_Fields = {
  __typename?: 'coassign_project_history_stddev_pop_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Coassign_Project_History_Stddev_Samp_Fields = {
  __typename?: 'coassign_project_history_stddev_samp_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "coassign_project_history" */
export type Coassign_Project_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_History_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['String']['input']>
  end_date?: InputMaybe<Scalars['date']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  start_date?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Project_History_Sum_Fields = {
  __typename?: 'coassign_project_history_sum_fields'
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
}

export type Coassign_Project_History_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Project_History_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Project_History_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Project_History_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Project_History_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Project_History_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Project_History_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Project_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Project_History_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Project_History_Var_Pop_Fields = {
  __typename?: 'coassign_project_history_var_pop_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Coassign_Project_History_Var_Samp_Fields = {
  __typename?: 'coassign_project_history_var_samp_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Coassign_Project_History_Variance_Fields = {
  __typename?: 'coassign_project_history_variance_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** input type for incrementing numeric columns in table "coassign.project" */
export type Coassign_Project_Inc_Input = {
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
}

/** input type for inserting data into table "coassign.project" */
export type Coassign_Project_Insert_Input = {
  assigns?: InputMaybe<Coassign_Assign_Arr_Rel_Insert_Input>
  client?: InputMaybe<Coassign_Client_Obj_Rel_Insert_Input>
  client_id?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['String']['input']>
  end_date?: InputMaybe<Scalars['date']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  project_to_departments?: InputMaybe<Coassign_Project_To_Department_Arr_Rel_Insert_Input>
  project_to_users?: InputMaybe<Coassign_Project_To_User_Arr_Rel_Insert_Input>
  start_date?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_cost_others?: InputMaybe<Coassign_Target_Cost_Other_Arr_Rel_Insert_Input>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assigns?: InputMaybe<Coassign_Volumed_Assign_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_Project_Max_Fields = {
  __typename?: 'coassign_project_max_fields'
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  start_date?: Maybe<Scalars['date']['output']>
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.project" */
export type Coassign_Project_Max_Order_By = {
  client_id?: InputMaybe<Order_By>
  code?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  detail?: InputMaybe<Order_By>
  end_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  start_date?: InputMaybe<Order_By>
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Project_Min_Fields = {
  __typename?: 'coassign_project_min_fields'
  client_id?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  detail?: Maybe<Scalars['String']['output']>
  end_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  start_date?: Maybe<Scalars['date']['output']>
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.project" */
export type Coassign_Project_Min_Order_By = {
  client_id?: InputMaybe<Order_By>
  code?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  detail?: InputMaybe<Order_By>
  end_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  start_date?: InputMaybe<Order_By>
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.project" */
export type Coassign_Project_Mutation_Response = {
  __typename?: 'coassign_project_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Project>
}

/** input type for inserting object relation for remote table "coassign.project" */
export type Coassign_Project_Obj_Rel_Insert_Input = {
  data: Coassign_Project_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Project_On_Conflict>
}

/** on_conflict condition type for table "coassign.project" */
export type Coassign_Project_On_Conflict = {
  constraint: Coassign_Project_Constraint
  update_columns?: Array<Coassign_Project_Update_Column>
  where?: InputMaybe<Coassign_Project_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.project". */
export type Coassign_Project_Order_By = {
  assigns_aggregate?: InputMaybe<Coassign_Assign_Aggregate_Order_By>
  client?: InputMaybe<Coassign_Client_Order_By>
  client_id?: InputMaybe<Order_By>
  code?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  custom_fields?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  detail?: InputMaybe<Order_By>
  end_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  project_to_departments_aggregate?: InputMaybe<Coassign_Project_To_Department_Aggregate_Order_By>
  project_to_users_aggregate?: InputMaybe<Coassign_Project_To_User_Aggregate_Order_By>
  start_date?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  target_cost?: InputMaybe<Order_By>
  target_cost_others_aggregate?: InputMaybe<Coassign_Target_Cost_Other_Aggregate_Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
  target_sales_breakdown_plan?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assigns_aggregate?: InputMaybe<Coassign_Volumed_Assign_Aggregate_Order_By>
}

/** primary key columns input for table: coassign.project */
export type Coassign_Project_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Project_Prepend_Input = {
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "coassign.project" */
export enum Coassign_Project_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Code = 'code',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Detail = 'detail',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TargetCost = 'target_cost',
  /** column name */
  TargetManHoursInSec = 'target_man_hours_in_sec',
  /** column name */
  TargetSales = 'target_sales',
  /** column name */
  TargetSalesBreakdownPlan = 'target_sales_breakdown_plan',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.project" */
export type Coassign_Project_Set_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['String']['input']>
  end_date?: InputMaybe<Scalars['date']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  start_date?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Project_Stddev_Fields = {
  __typename?: 'coassign_project_stddev_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.project" */
export type Coassign_Project_Stddev_Order_By = {
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Project_Stddev_Pop_Fields = {
  __typename?: 'coassign_project_stddev_pop_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.project" */
export type Coassign_Project_Stddev_Pop_Order_By = {
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Project_Stddev_Samp_Fields = {
  __typename?: 'coassign_project_stddev_samp_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.project" */
export type Coassign_Project_Stddev_Samp_Order_By = {
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_project" */
export type Coassign_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  detail?: InputMaybe<Scalars['String']['input']>
  end_date?: InputMaybe<Scalars['date']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  start_date?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost?: InputMaybe<Scalars['Int']['input']>
  target_man_hours_in_sec?: InputMaybe<Scalars['Int']['input']>
  target_sales?: InputMaybe<Scalars['bigint']['input']>
  target_sales_breakdown_plan?: InputMaybe<Scalars['jsonb']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Project_Sum_Fields = {
  __typename?: 'coassign_project_sum_fields'
  target_cost?: Maybe<Scalars['Int']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Int']['output']>
  target_sales?: Maybe<Scalars['bigint']['output']>
}

/** order by sum() on columns of table "coassign.project" */
export type Coassign_Project_Sum_Order_By = {
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.project_to_department" */
export type Coassign_Project_To_Department = {
  __typename?: 'coassign_project_to_department'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  department: Coassign_Department
  department_id: Scalars['String']['output']
  /** An object relationship */
  project: Coassign_Project
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.project_to_department" */
export type Coassign_Project_To_Department_Aggregate = {
  __typename?: 'coassign_project_to_department_aggregate'
  aggregate?: Maybe<Coassign_Project_To_Department_Aggregate_Fields>
  nodes: Array<Coassign_Project_To_Department>
}

export type Coassign_Project_To_Department_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Project_To_Department_Aggregate_Bool_Exp_Count>
}

export type Coassign_Project_To_Department_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.project_to_department" */
export type Coassign_Project_To_Department_Aggregate_Fields = {
  __typename?: 'coassign_project_to_department_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_To_Department_Max_Fields>
  min?: Maybe<Coassign_Project_To_Department_Min_Fields>
}

/** aggregate fields of "coassign.project_to_department" */
export type Coassign_Project_To_Department_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.project_to_department" */
export type Coassign_Project_To_Department_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Project_To_Department_Max_Order_By>
  min?: InputMaybe<Coassign_Project_To_Department_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.project_to_department" */
export type Coassign_Project_To_Department_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Project_To_Department_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Project_To_Department_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.project_to_department". All fields are combined with a logical 'AND'. */
export type Coassign_Project_To_Department_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_To_Department_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_To_Department_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  department?: InputMaybe<Coassign_Department_Bool_Exp>
  department_id?: InputMaybe<String_Comparison_Exp>
  project?: InputMaybe<Coassign_Project_Bool_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.project_to_department" */
export enum Coassign_Project_To_Department_Constraint {
  /** unique or primary key constraint on columns "department_id", "project_id" */
  ProjectToDepartmentEnforceSingleNullDeletedAt = 'project_to_department_enforce_single_null_deleted_at',
  /** unique or primary key constraint on columns "deleted_at", "department_id", "project_id" */
  ProjectToDepartmentUnique = 'project_to_department_unique'
}

/** columns and relationships of "coassign.project_to_department_full_view" */
export type Coassign_Project_To_Department_Full_View = {
  __typename?: 'coassign_project_to_department_full_view'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregated selection of "coassign.project_to_department_full_view" */
export type Coassign_Project_To_Department_Full_View_Aggregate = {
  __typename?: 'coassign_project_to_department_full_view_aggregate'
  aggregate?: Maybe<Coassign_Project_To_Department_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Project_To_Department_Full_View>
}

/** aggregate fields of "coassign.project_to_department_full_view" */
export type Coassign_Project_To_Department_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_project_to_department_full_view_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_To_Department_Full_View_Max_Fields>
  min?: Maybe<Coassign_Project_To_Department_Full_View_Min_Fields>
}

/** aggregate fields of "coassign.project_to_department_full_view" */
export type Coassign_Project_To_Department_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.project_to_department_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Project_To_Department_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_To_Department_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  department_id?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Project_To_Department_Full_View_Max_Fields = {
  __typename?: 'coassign_project_to_department_full_view_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Project_To_Department_Full_View_Min_Fields = {
  __typename?: 'coassign_project_to_department_full_view_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** Ordering options when selecting data from "coassign.project_to_department_full_view". */
export type Coassign_Project_To_Department_Full_View_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "coassign.project_to_department_full_view" */
export enum Coassign_Project_To_Department_Full_View_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "coassign_project_to_department_full_view" */
export type Coassign_Project_To_Department_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_To_Department_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_To_Department_Full_View_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** columns and relationships of "coassign.project_to_department_history" */
export type Coassign_Project_To_Department_History = {
  __typename?: 'coassign_project_to_department_history'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id: Scalars['String']['output']
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.project_to_department_history" */
export type Coassign_Project_To_Department_History_Aggregate = {
  __typename?: 'coassign_project_to_department_history_aggregate'
  aggregate?: Maybe<Coassign_Project_To_Department_History_Aggregate_Fields>
  nodes: Array<Coassign_Project_To_Department_History>
}

/** aggregate fields of "coassign.project_to_department_history" */
export type Coassign_Project_To_Department_History_Aggregate_Fields = {
  __typename?: 'coassign_project_to_department_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_To_Department_History_Max_Fields>
  min?: Maybe<Coassign_Project_To_Department_History_Min_Fields>
}

/** aggregate fields of "coassign.project_to_department_history" */
export type Coassign_Project_To_Department_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_To_Department_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.project_to_department_history". All fields are combined with a logical 'AND'. */
export type Coassign_Project_To_Department_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_To_Department_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_To_Department_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_To_Department_History_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  department_id?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** input type for inserting data into table "coassign.project_to_department_history" */
export type Coassign_Project_To_Department_History_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Project_To_Department_History_Max_Fields = {
  __typename?: 'coassign_project_to_department_history_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Project_To_Department_History_Min_Fields = {
  __typename?: 'coassign_project_to_department_history_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "coassign.project_to_department_history" */
export type Coassign_Project_To_Department_History_Mutation_Response = {
  __typename?: 'coassign_project_to_department_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Project_To_Department_History>
}

/** Ordering options when selecting data from "coassign.project_to_department_history". */
export type Coassign_Project_To_Department_History_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "coassign.project_to_department_history" */
export enum Coassign_Project_To_Department_History_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.project_to_department_history" */
export type Coassign_Project_To_Department_History_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_project_to_department_history" */
export type Coassign_Project_To_Department_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_To_Department_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_To_Department_History_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

export type Coassign_Project_To_Department_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Project_To_Department_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Project_To_Department_History_Bool_Exp
}

/** input type for inserting data into table "coassign.project_to_department" */
export type Coassign_Project_To_Department_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department?: InputMaybe<Coassign_Department_Obj_Rel_Insert_Input>
  department_id?: InputMaybe<Scalars['String']['input']>
  project?: InputMaybe<Coassign_Project_Obj_Rel_Insert_Input>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Project_To_Department_Max_Fields = {
  __typename?: 'coassign_project_to_department_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.project_to_department" */
export type Coassign_Project_To_Department_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Project_To_Department_Min_Fields = {
  __typename?: 'coassign_project_to_department_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.project_to_department" */
export type Coassign_Project_To_Department_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.project_to_department" */
export type Coassign_Project_To_Department_Mutation_Response = {
  __typename?: 'coassign_project_to_department_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Project_To_Department>
}

/** on_conflict condition type for table "coassign.project_to_department" */
export type Coassign_Project_To_Department_On_Conflict = {
  constraint: Coassign_Project_To_Department_Constraint
  update_columns?: Array<Coassign_Project_To_Department_Update_Column>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.project_to_department". */
export type Coassign_Project_To_Department_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department?: InputMaybe<Coassign_Department_Order_By>
  department_id?: InputMaybe<Order_By>
  project?: InputMaybe<Coassign_Project_Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "coassign.project_to_department" */
export enum Coassign_Project_To_Department_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.project_to_department" */
export type Coassign_Project_To_Department_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_project_to_department" */
export type Coassign_Project_To_Department_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_To_Department_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_To_Department_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.project_to_department" */
export enum Coassign_Project_To_Department_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Project_To_Department_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Project_To_Department_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Project_To_Department_Bool_Exp
}

/** columns and relationships of "coassign.project_to_user" */
export type Coassign_Project_To_User = {
  __typename?: 'coassign_project_to_user'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  project: Coassign_Project
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
  user_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.project_to_user" */
export type Coassign_Project_To_User_Aggregate = {
  __typename?: 'coassign_project_to_user_aggregate'
  aggregate?: Maybe<Coassign_Project_To_User_Aggregate_Fields>
  nodes: Array<Coassign_Project_To_User>
}

export type Coassign_Project_To_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Project_To_User_Aggregate_Bool_Exp_Count>
}

export type Coassign_Project_To_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.project_to_user" */
export type Coassign_Project_To_User_Aggregate_Fields = {
  __typename?: 'coassign_project_to_user_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_To_User_Max_Fields>
  min?: Maybe<Coassign_Project_To_User_Min_Fields>
}

/** aggregate fields of "coassign.project_to_user" */
export type Coassign_Project_To_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.project_to_user" */
export type Coassign_Project_To_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Project_To_User_Max_Order_By>
  min?: InputMaybe<Coassign_Project_To_User_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.project_to_user" */
export type Coassign_Project_To_User_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Project_To_User_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Project_To_User_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.project_to_user". All fields are combined with a logical 'AND'. */
export type Coassign_Project_To_User_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_To_User_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_To_User_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  project?: InputMaybe<Coassign_Project_Bool_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.project_to_user" */
export enum Coassign_Project_To_User_Constraint {
  /** unique or primary key constraint on columns "user_id", "project_id" */
  ProjectToUserEnforceSingleNullDeletedAt = 'project_to_user_enforce_single_null_deleted_at',
  /** unique or primary key constraint on columns "user_id", "deleted_at", "project_id" */
  ProjectToUserUnique = 'project_to_user_unique'
}

/** columns and relationships of "coassign.project_to_user_full_view" */
export type Coassign_Project_To_User_Full_View = {
  __typename?: 'coassign_project_to_user_full_view'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** aggregated selection of "coassign.project_to_user_full_view" */
export type Coassign_Project_To_User_Full_View_Aggregate = {
  __typename?: 'coassign_project_to_user_full_view_aggregate'
  aggregate?: Maybe<Coassign_Project_To_User_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Project_To_User_Full_View>
}

/** aggregate fields of "coassign.project_to_user_full_view" */
export type Coassign_Project_To_User_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_project_to_user_full_view_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_To_User_Full_View_Max_Fields>
  min?: Maybe<Coassign_Project_To_User_Full_View_Min_Fields>
}

/** aggregate fields of "coassign.project_to_user_full_view" */
export type Coassign_Project_To_User_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.project_to_user_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Project_To_User_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_To_User_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Project_To_User_Full_View_Max_Fields = {
  __typename?: 'coassign_project_to_user_full_view_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Project_To_User_Full_View_Min_Fields = {
  __typename?: 'coassign_project_to_user_full_view_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** Ordering options when selecting data from "coassign.project_to_user_full_view". */
export type Coassign_Project_To_User_Full_View_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.project_to_user_full_view" */
export enum Coassign_Project_To_User_Full_View_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "coassign_project_to_user_full_view" */
export type Coassign_Project_To_User_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_To_User_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_To_User_Full_View_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.project_to_user_history" */
export type Coassign_Project_To_User_History = {
  __typename?: 'coassign_project_to_user_history'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  user_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.project_to_user_history" */
export type Coassign_Project_To_User_History_Aggregate = {
  __typename?: 'coassign_project_to_user_history_aggregate'
  aggregate?: Maybe<Coassign_Project_To_User_History_Aggregate_Fields>
  nodes: Array<Coassign_Project_To_User_History>
}

/** aggregate fields of "coassign.project_to_user_history" */
export type Coassign_Project_To_User_History_Aggregate_Fields = {
  __typename?: 'coassign_project_to_user_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Project_To_User_History_Max_Fields>
  min?: Maybe<Coassign_Project_To_User_History_Min_Fields>
}

/** aggregate fields of "coassign.project_to_user_history" */
export type Coassign_Project_To_User_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Project_To_User_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.project_to_user_history". All fields are combined with a logical 'AND'. */
export type Coassign_Project_To_User_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Project_To_User_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Project_To_User_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Project_To_User_History_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** input type for inserting data into table "coassign.project_to_user_history" */
export type Coassign_Project_To_User_History_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Project_To_User_History_Max_Fields = {
  __typename?: 'coassign_project_to_user_history_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Project_To_User_History_Min_Fields = {
  __typename?: 'coassign_project_to_user_history_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "coassign.project_to_user_history" */
export type Coassign_Project_To_User_History_Mutation_Response = {
  __typename?: 'coassign_project_to_user_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Project_To_User_History>
}

/** Ordering options when selecting data from "coassign.project_to_user_history". */
export type Coassign_Project_To_User_History_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.project_to_user_history" */
export enum Coassign_Project_To_User_History_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coassign.project_to_user_history" */
export type Coassign_Project_To_User_History_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_project_to_user_history" */
export type Coassign_Project_To_User_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_To_User_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_To_User_History_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

export type Coassign_Project_To_User_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Project_To_User_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Project_To_User_History_Bool_Exp
}

/** input type for inserting data into table "coassign.project_to_user" */
export type Coassign_Project_To_User_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  project?: InputMaybe<Coassign_Project_Obj_Rel_Insert_Input>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Project_To_User_Max_Fields = {
  __typename?: 'coassign_project_to_user_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.project_to_user" */
export type Coassign_Project_To_User_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Project_To_User_Min_Fields = {
  __typename?: 'coassign_project_to_user_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.project_to_user" */
export type Coassign_Project_To_User_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.project_to_user" */
export type Coassign_Project_To_User_Mutation_Response = {
  __typename?: 'coassign_project_to_user_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Project_To_User>
}

/** on_conflict condition type for table "coassign.project_to_user" */
export type Coassign_Project_To_User_On_Conflict = {
  constraint: Coassign_Project_To_User_Constraint
  update_columns?: Array<Coassign_Project_To_User_Update_Column>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.project_to_user". */
export type Coassign_Project_To_User_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  project?: InputMaybe<Coassign_Project_Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.project_to_user" */
export enum Coassign_Project_To_User_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coassign.project_to_user" */
export type Coassign_Project_To_User_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_project_to_user" */
export type Coassign_Project_To_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Project_To_User_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Project_To_User_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.project_to_user" */
export enum Coassign_Project_To_User_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Coassign_Project_To_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Project_To_User_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Project_To_User_Bool_Exp
}

/** update columns of table "coassign.project" */
export enum Coassign_Project_Update_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Code = 'code',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Detail = 'detail',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TargetCost = 'target_cost',
  /** column name */
  TargetManHoursInSec = 'target_man_hours_in_sec',
  /** column name */
  TargetSales = 'target_sales',
  /** column name */
  TargetSalesBreakdownPlan = 'target_sales_breakdown_plan',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Project_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Project_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Project_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Project_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Project_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Project_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Project_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Project_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Project_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Project_Var_Pop_Fields = {
  __typename?: 'coassign_project_var_pop_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.project" */
export type Coassign_Project_Var_Pop_Order_By = {
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Project_Var_Samp_Fields = {
  __typename?: 'coassign_project_var_samp_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.project" */
export type Coassign_Project_Var_Samp_Order_By = {
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Project_Variance_Fields = {
  __typename?: 'coassign_project_variance_fields'
  target_cost?: Maybe<Scalars['Float']['output']>
  target_man_hours_in_sec?: Maybe<Scalars['Float']['output']>
  target_sales?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.project" */
export type Coassign_Project_Variance_Order_By = {
  target_cost?: InputMaybe<Order_By>
  target_man_hours_in_sec?: InputMaybe<Order_By>
  target_sales?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.regular_holiday" */
export type Coassign_Regular_Holiday = {
  __typename?: 'coassign_regular_holiday'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  day_of_week: Scalars['day_of_week']['output']
  day_off: Scalars['Boolean']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  year: Scalars['Int']['output']
}

/** aggregated selection of "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Aggregate = {
  __typename?: 'coassign_regular_holiday_aggregate'
  aggregate?: Maybe<Coassign_Regular_Holiday_Aggregate_Fields>
  nodes: Array<Coassign_Regular_Holiday>
}

export type Coassign_Regular_Holiday_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Coassign_Regular_Holiday_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Coassign_Regular_Holiday_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Coassign_Regular_Holiday_Aggregate_Bool_Exp_Count>
}

export type Coassign_Regular_Holiday_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coassign_Regular_Holiday_Select_Column_Coassign_Regular_Holiday_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Regular_Holiday_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coassign_Regular_Holiday_Select_Column_Coassign_Regular_Holiday_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Regular_Holiday_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Regular_Holiday_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Aggregate_Fields = {
  __typename?: 'coassign_regular_holiday_aggregate_fields'
  avg?: Maybe<Coassign_Regular_Holiday_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Regular_Holiday_Max_Fields>
  min?: Maybe<Coassign_Regular_Holiday_Min_Fields>
  stddev?: Maybe<Coassign_Regular_Holiday_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Regular_Holiday_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Regular_Holiday_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Regular_Holiday_Sum_Fields>
  var_pop?: Maybe<Coassign_Regular_Holiday_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Regular_Holiday_Var_Samp_Fields>
  variance?: Maybe<Coassign_Regular_Holiday_Variance_Fields>
}

/** aggregate fields of "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Regular_Holiday_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Regular_Holiday_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Regular_Holiday_Max_Order_By>
  min?: InputMaybe<Coassign_Regular_Holiday_Min_Order_By>
  stddev?: InputMaybe<Coassign_Regular_Holiday_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Regular_Holiday_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Regular_Holiday_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Regular_Holiday_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Regular_Holiday_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Regular_Holiday_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Regular_Holiday_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Regular_Holiday_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Regular_Holiday_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Regular_Holiday_Avg_Fields = {
  __typename?: 'coassign_regular_holiday_avg_fields'
  year?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Avg_Order_By = {
  year?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.regular_holiday". All fields are combined with a logical 'AND'. */
export type Coassign_Regular_Holiday_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Regular_Holiday_Bool_Exp>>
  _not?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Regular_Holiday_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  day_of_week?: InputMaybe<Day_Of_Week_Comparison_Exp>
  day_off?: InputMaybe<Boolean_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  year?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.regular_holiday" */
export enum Coassign_Regular_Holiday_Constraint {
  /** unique or primary key constraint on columns "day_of_week", "year", "tenant_id" */
  RegularHolidayDayOfWeekTenantIdYear = 'regular_holiday_day_of_week_tenant_id_year',
  /** unique or primary key constraint on columns "id" */
  RegularHolidayPkey = 'regular_holiday_pkey'
}

/** input type for incrementing numeric columns in table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Inc_Input = {
  year?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  day_of_week?: InputMaybe<Scalars['day_of_week']['input']>
  day_off?: InputMaybe<Scalars['Boolean']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type Coassign_Regular_Holiday_Max_Fields = {
  __typename?: 'coassign_regular_holiday_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  day_of_week?: Maybe<Scalars['day_of_week']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  year?: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  day_of_week?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  year?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Regular_Holiday_Min_Fields = {
  __typename?: 'coassign_regular_holiday_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  day_of_week?: Maybe<Scalars['day_of_week']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  year?: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  day_of_week?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  year?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Mutation_Response = {
  __typename?: 'coassign_regular_holiday_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Regular_Holiday>
}

/** on_conflict condition type for table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_On_Conflict = {
  constraint: Coassign_Regular_Holiday_Constraint
  update_columns?: Array<Coassign_Regular_Holiday_Update_Column>
  where?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.regular_holiday". */
export type Coassign_Regular_Holiday_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  day_of_week?: InputMaybe<Order_By>
  day_off?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  year?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.regular_holiday */
export type Coassign_Regular_Holiday_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.regular_holiday" */
export enum Coassign_Regular_Holiday_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayOfWeek = 'day_of_week',
  /** column name */
  DayOff = 'day_off',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

/** select "coassign_regular_holiday_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coassign.regular_holiday" */
export enum Coassign_Regular_Holiday_Select_Column_Coassign_Regular_Holiday_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DayOff = 'day_off'
}

/** select "coassign_regular_holiday_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coassign.regular_holiday" */
export enum Coassign_Regular_Holiday_Select_Column_Coassign_Regular_Holiday_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DayOff = 'day_off'
}

/** input type for updating data in table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  day_of_week?: InputMaybe<Scalars['day_of_week']['input']>
  day_off?: InputMaybe<Scalars['Boolean']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Regular_Holiday_Stddev_Fields = {
  __typename?: 'coassign_regular_holiday_stddev_fields'
  year?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Stddev_Order_By = {
  year?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Regular_Holiday_Stddev_Pop_Fields = {
  __typename?: 'coassign_regular_holiday_stddev_pop_fields'
  year?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Stddev_Pop_Order_By = {
  year?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Regular_Holiday_Stddev_Samp_Fields = {
  __typename?: 'coassign_regular_holiday_stddev_samp_fields'
  year?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Stddev_Samp_Order_By = {
  year?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_regular_holiday" */
export type Coassign_Regular_Holiday_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Regular_Holiday_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Regular_Holiday_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  day_of_week?: InputMaybe<Scalars['day_of_week']['input']>
  day_off?: InputMaybe<Scalars['Boolean']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type Coassign_Regular_Holiday_Sum_Fields = {
  __typename?: 'coassign_regular_holiday_sum_fields'
  year?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Sum_Order_By = {
  year?: InputMaybe<Order_By>
}

/** update columns of table "coassign.regular_holiday" */
export enum Coassign_Regular_Holiday_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayOfWeek = 'day_of_week',
  /** column name */
  DayOff = 'day_off',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

export type Coassign_Regular_Holiday_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Regular_Holiday_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Regular_Holiday_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Regular_Holiday_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Regular_Holiday_Var_Pop_Fields = {
  __typename?: 'coassign_regular_holiday_var_pop_fields'
  year?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Var_Pop_Order_By = {
  year?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Regular_Holiday_Var_Samp_Fields = {
  __typename?: 'coassign_regular_holiday_var_samp_fields'
  year?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Var_Samp_Order_By = {
  year?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Regular_Holiday_Variance_Fields = {
  __typename?: 'coassign_regular_holiday_variance_fields'
  year?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.regular_holiday" */
export type Coassign_Regular_Holiday_Variance_Order_By = {
  year?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other = {
  __typename?: 'coassign_target_cost_other'
  commit_id?: Maybe<Scalars['String']['output']>
  costs_plan: Scalars['jsonb']['output']
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  /** An object relationship */
  project: Coassign_Project
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  /** An array relationship */
  target_cost_other_actuals: Array<Coassign_Target_Cost_Other_Actual>
  /** An aggregate relationship */
  target_cost_other_actuals_aggregate: Coassign_Target_Cost_Other_Actual_Aggregate
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "coassign.target_cost_other" */
export type Coassign_Target_Cost_OtherCosts_PlanArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.target_cost_other" */
export type Coassign_Target_Cost_OtherTarget_Cost_Other_ActualsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
}

/** columns and relationships of "coassign.target_cost_other" */
export type Coassign_Target_Cost_OtherTarget_Cost_Other_Actuals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
}

/** columns and relationships of "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual = {
  __typename?: 'coassign_target_cost_other_actual'
  commit_id?: Maybe<Scalars['String']['output']>
  cost: Scalars['Int']['output']
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  month: Scalars['date']['output']
  sys_period: Scalars['tstzrange']['output']
  /** An object relationship */
  target_cost_other: Coassign_Target_Cost_Other
  target_cost_other_id: Scalars['String']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Aggregate = {
  __typename?: 'coassign_target_cost_other_actual_aggregate'
  aggregate?: Maybe<Coassign_Target_Cost_Other_Actual_Aggregate_Fields>
  nodes: Array<Coassign_Target_Cost_Other_Actual>
}

export type Coassign_Target_Cost_Other_Actual_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Target_Cost_Other_Actual_Aggregate_Bool_Exp_Count>
}

export type Coassign_Target_Cost_Other_Actual_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Aggregate_Fields = {
  __typename?: 'coassign_target_cost_other_actual_aggregate_fields'
  avg?: Maybe<Coassign_Target_Cost_Other_Actual_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Target_Cost_Other_Actual_Max_Fields>
  min?: Maybe<Coassign_Target_Cost_Other_Actual_Min_Fields>
  stddev?: Maybe<Coassign_Target_Cost_Other_Actual_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Target_Cost_Other_Actual_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Target_Cost_Other_Actual_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Target_Cost_Other_Actual_Sum_Fields>
  var_pop?: Maybe<Coassign_Target_Cost_Other_Actual_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Target_Cost_Other_Actual_Var_Samp_Fields>
  variance?: Maybe<Coassign_Target_Cost_Other_Actual_Variance_Fields>
}

/** aggregate fields of "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Target_Cost_Other_Actual_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Target_Cost_Other_Actual_Max_Order_By>
  min?: InputMaybe<Coassign_Target_Cost_Other_Actual_Min_Order_By>
  stddev?: InputMaybe<Coassign_Target_Cost_Other_Actual_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Target_Cost_Other_Actual_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Target_Cost_Other_Actual_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Target_Cost_Other_Actual_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Target_Cost_Other_Actual_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Target_Cost_Other_Actual_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Target_Cost_Other_Actual_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Target_Cost_Other_Actual_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Target_Cost_Other_Actual_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Target_Cost_Other_Actual_Avg_Fields = {
  __typename?: 'coassign_target_cost_other_actual_avg_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Avg_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.target_cost_other_actual". All fields are combined with a logical 'AND'. */
export type Coassign_Target_Cost_Other_Actual_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Bool_Exp>>
  _not?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  cost?: InputMaybe<Int_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  month?: InputMaybe<Date_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  target_cost_other?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
  target_cost_other_id?: InputMaybe<String_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.target_cost_other_actual" */
export enum Coassign_Target_Cost_Other_Actual_Constraint {
  /** unique or primary key constraint on columns "id" */
  TargetCostOtherActualPkey = 'target_cost_other_actual_pkey',
  /** unique or primary key constraint on columns "target_cost_other_id", "month" */
  TargetCostOtherActualTargetCostOtherIdMonthDeletedAt = 'target_cost_other_actual_target_cost_other_id_month_deleted_at'
}

/** input type for incrementing numeric columns in table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  cost?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost_other?: InputMaybe<Coassign_Target_Cost_Other_Obj_Rel_Insert_Input>
  target_cost_other_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Target_Cost_Other_Actual_Max_Fields = {
  __typename?: 'coassign_target_cost_other_actual_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  cost?: Maybe<Scalars['Int']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  month?: Maybe<Scalars['date']['output']>
  target_cost_other_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  cost?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  target_cost_other_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Target_Cost_Other_Actual_Min_Fields = {
  __typename?: 'coassign_target_cost_other_actual_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  cost?: Maybe<Scalars['Int']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  month?: Maybe<Scalars['date']['output']>
  target_cost_other_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  cost?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  target_cost_other_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Mutation_Response = {
  __typename?: 'coassign_target_cost_other_actual_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Target_Cost_Other_Actual>
}

/** on_conflict condition type for table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_On_Conflict = {
  constraint: Coassign_Target_Cost_Other_Actual_Constraint
  update_columns?: Array<Coassign_Target_Cost_Other_Actual_Update_Column>
  where?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.target_cost_other_actual". */
export type Coassign_Target_Cost_Other_Actual_Order_By = {
  commit_id?: InputMaybe<Order_By>
  cost?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  target_cost_other?: InputMaybe<Coassign_Target_Cost_Other_Order_By>
  target_cost_other_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.target_cost_other_actual */
export type Coassign_Target_Cost_Other_Actual_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.target_cost_other_actual" */
export enum Coassign_Target_Cost_Other_Actual_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TargetCostOtherId = 'target_cost_other_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  cost?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost_other_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Target_Cost_Other_Actual_Stddev_Fields = {
  __typename?: 'coassign_target_cost_other_actual_stddev_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Target_Cost_Other_Actual_Stddev_Pop_Fields = {
  __typename?: 'coassign_target_cost_other_actual_stddev_pop_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Target_Cost_Other_Actual_Stddev_Samp_Fields = {
  __typename?: 'coassign_target_cost_other_actual_stddev_samp_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Target_Cost_Other_Actual_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Target_Cost_Other_Actual_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  cost?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost_other_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_Target_Cost_Other_Actual_Sum_Fields = {
  __typename?: 'coassign_target_cost_other_actual_sum_fields'
  cost?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Sum_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** update columns of table "coassign.target_cost_other_actual" */
export enum Coassign_Target_Cost_Other_Actual_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TargetCostOtherId = 'target_cost_other_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Target_Cost_Other_Actual_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Target_Cost_Other_Actual_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Target_Cost_Other_Actual_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Target_Cost_Other_Actual_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Target_Cost_Other_Actual_Var_Pop_Fields = {
  __typename?: 'coassign_target_cost_other_actual_var_pop_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Target_Cost_Other_Actual_Var_Samp_Fields = {
  __typename?: 'coassign_target_cost_other_actual_var_samp_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Target_Cost_Other_Actual_Variance_Fields = {
  __typename?: 'coassign_target_cost_other_actual_variance_fields'
  cost?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.target_cost_other_actual" */
export type Coassign_Target_Cost_Other_Actual_Variance_Order_By = {
  cost?: InputMaybe<Order_By>
}

/** aggregated selection of "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Aggregate = {
  __typename?: 'coassign_target_cost_other_aggregate'
  aggregate?: Maybe<Coassign_Target_Cost_Other_Aggregate_Fields>
  nodes: Array<Coassign_Target_Cost_Other>
}

export type Coassign_Target_Cost_Other_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Target_Cost_Other_Aggregate_Bool_Exp_Count>
}

export type Coassign_Target_Cost_Other_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Aggregate_Fields = {
  __typename?: 'coassign_target_cost_other_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Target_Cost_Other_Max_Fields>
  min?: Maybe<Coassign_Target_Cost_Other_Min_Fields>
}

/** aggregate fields of "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Target_Cost_Other_Max_Order_By>
  min?: InputMaybe<Coassign_Target_Cost_Other_Min_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Target_Cost_Other_Append_Input = {
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Target_Cost_Other_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Target_Cost_Other_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.target_cost_other". All fields are combined with a logical 'AND'. */
export type Coassign_Target_Cost_Other_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Target_Cost_Other_Bool_Exp>>
  _not?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Target_Cost_Other_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  costs_plan?: InputMaybe<Jsonb_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  project?: InputMaybe<Coassign_Project_Bool_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  target_cost_other_actuals?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
  target_cost_other_actuals_aggregate?: InputMaybe<Coassign_Target_Cost_Other_Actual_Aggregate_Bool_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.target_cost_other" */
export enum Coassign_Target_Cost_Other_Constraint {
  /** unique or primary key constraint on columns "id" */
  TargetCostOtherPkey = 'target_cost_other_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Target_Cost_Other_Delete_At_Path_Input = {
  costs_plan?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Target_Cost_Other_Delete_Elem_Input = {
  costs_plan?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Target_Cost_Other_Delete_Key_Input = {
  costs_plan?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.target_cost_other_full_view" */
export type Coassign_Target_Cost_Other_Full_View = {
  __typename?: 'coassign_target_cost_other_full_view'
  commit_id?: Maybe<Scalars['String']['output']>
  costs_plan?: Maybe<Scalars['jsonb']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** columns and relationships of "coassign.target_cost_other_full_view" */
export type Coassign_Target_Cost_Other_Full_ViewCosts_PlanArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.target_cost_other_full_view" */
export type Coassign_Target_Cost_Other_Full_View_Aggregate = {
  __typename?: 'coassign_target_cost_other_full_view_aggregate'
  aggregate?: Maybe<Coassign_Target_Cost_Other_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Target_Cost_Other_Full_View>
}

/** aggregate fields of "coassign.target_cost_other_full_view" */
export type Coassign_Target_Cost_Other_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_target_cost_other_full_view_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Target_Cost_Other_Full_View_Max_Fields>
  min?: Maybe<Coassign_Target_Cost_Other_Full_View_Min_Fields>
}

/** aggregate fields of "coassign.target_cost_other_full_view" */
export type Coassign_Target_Cost_Other_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.target_cost_other_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Target_Cost_Other_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Target_Cost_Other_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  costs_plan?: InputMaybe<Jsonb_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Target_Cost_Other_Full_View_Max_Fields = {
  __typename?: 'coassign_target_cost_other_full_view_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Target_Cost_Other_Full_View_Min_Fields = {
  __typename?: 'coassign_target_cost_other_full_view_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** Ordering options when selecting data from "coassign.target_cost_other_full_view". */
export type Coassign_Target_Cost_Other_Full_View_Order_By = {
  commit_id?: InputMaybe<Order_By>
  costs_plan?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "coassign.target_cost_other_full_view" */
export enum Coassign_Target_Cost_Other_Full_View_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CostsPlan = 'costs_plan',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "coassign_target_cost_other_full_view" */
export type Coassign_Target_Cost_Other_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Target_Cost_Other_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Target_Cost_Other_Full_View_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** columns and relationships of "coassign.target_cost_other_history" */
export type Coassign_Target_Cost_Other_History = {
  __typename?: 'coassign_target_cost_other_history'
  commit_id?: Maybe<Scalars['String']['output']>
  costs_plan: Scalars['jsonb']['output']
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "coassign.target_cost_other_history" */
export type Coassign_Target_Cost_Other_HistoryCosts_PlanArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.target_cost_other_history" */
export type Coassign_Target_Cost_Other_History_Aggregate = {
  __typename?: 'coassign_target_cost_other_history_aggregate'
  aggregate?: Maybe<Coassign_Target_Cost_Other_History_Aggregate_Fields>
  nodes: Array<Coassign_Target_Cost_Other_History>
}

/** aggregate fields of "coassign.target_cost_other_history" */
export type Coassign_Target_Cost_Other_History_Aggregate_Fields = {
  __typename?: 'coassign_target_cost_other_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Target_Cost_Other_History_Max_Fields>
  min?: Maybe<Coassign_Target_Cost_Other_History_Min_Fields>
}

/** aggregate fields of "coassign.target_cost_other_history" */
export type Coassign_Target_Cost_Other_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Target_Cost_Other_History_Append_Input = {
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "coassign.target_cost_other_history". All fields are combined with a logical 'AND'. */
export type Coassign_Target_Cost_Other_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Target_Cost_Other_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  costs_plan?: InputMaybe<Jsonb_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Target_Cost_Other_History_Delete_At_Path_Input = {
  costs_plan?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Target_Cost_Other_History_Delete_Elem_Input = {
  costs_plan?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Target_Cost_Other_History_Delete_Key_Input = {
  costs_plan?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "coassign.target_cost_other_history" */
export type Coassign_Target_Cost_Other_History_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Target_Cost_Other_History_Max_Fields = {
  __typename?: 'coassign_target_cost_other_history_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Target_Cost_Other_History_Min_Fields = {
  __typename?: 'coassign_target_cost_other_history_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "coassign.target_cost_other_history" */
export type Coassign_Target_Cost_Other_History_Mutation_Response = {
  __typename?: 'coassign_target_cost_other_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Target_Cost_Other_History>
}

/** Ordering options when selecting data from "coassign.target_cost_other_history". */
export type Coassign_Target_Cost_Other_History_Order_By = {
  commit_id?: InputMaybe<Order_By>
  costs_plan?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Target_Cost_Other_History_Prepend_Input = {
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "coassign.target_cost_other_history" */
export enum Coassign_Target_Cost_Other_History_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CostsPlan = 'costs_plan',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.target_cost_other_history" */
export type Coassign_Target_Cost_Other_History_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_target_cost_other_history" */
export type Coassign_Target_Cost_Other_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Target_Cost_Other_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Target_Cost_Other_History_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

export type Coassign_Target_Cost_Other_History_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Target_Cost_Other_History_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Target_Cost_Other_History_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Target_Cost_Other_History_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Target_Cost_Other_History_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Target_Cost_Other_History_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Target_Cost_Other_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Target_Cost_Other_History_Bool_Exp
}

/** input type for inserting data into table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  project?: InputMaybe<Coassign_Project_Obj_Rel_Insert_Input>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  target_cost_other_actuals?: InputMaybe<Coassign_Target_Cost_Other_Actual_Arr_Rel_Insert_Input>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Target_Cost_Other_Max_Fields = {
  __typename?: 'coassign_target_cost_other_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Target_Cost_Other_Min_Fields = {
  __typename?: 'coassign_target_cost_other_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Mutation_Response = {
  __typename?: 'coassign_target_cost_other_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Target_Cost_Other>
}

/** input type for inserting object relation for remote table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Obj_Rel_Insert_Input = {
  data: Coassign_Target_Cost_Other_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Target_Cost_Other_On_Conflict>
}

/** on_conflict condition type for table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_On_Conflict = {
  constraint: Coassign_Target_Cost_Other_Constraint
  update_columns?: Array<Coassign_Target_Cost_Other_Update_Column>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.target_cost_other". */
export type Coassign_Target_Cost_Other_Order_By = {
  commit_id?: InputMaybe<Order_By>
  costs_plan?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  project?: InputMaybe<Coassign_Project_Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  target_cost_other_actuals_aggregate?: InputMaybe<Coassign_Target_Cost_Other_Actual_Aggregate_Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.target_cost_other */
export type Coassign_Target_Cost_Other_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Target_Cost_Other_Prepend_Input = {
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "coassign.target_cost_other" */
export enum Coassign_Target_Cost_Other_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CostsPlan = 'costs_plan',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.target_cost_other" */
export type Coassign_Target_Cost_Other_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_target_cost_other" */
export type Coassign_Target_Cost_Other_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Target_Cost_Other_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Target_Cost_Other_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  costs_plan?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.target_cost_other" */
export enum Coassign_Target_Cost_Other_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CostsPlan = 'costs_plan',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Target_Cost_Other_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Target_Cost_Other_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Target_Cost_Other_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Target_Cost_Other_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Target_Cost_Other_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Target_Cost_Other_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Target_Cost_Other_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Target_Cost_Other_Bool_Exp
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_Tenant = {
  __typename?: 'coassign_tenant'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  firebase_tenant_id?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  settings: Scalars['json']['output']
  subdomain: Scalars['String']['output']
  /** An array relationship */
  tenant: Array<Coassign_Tenant>
  /** An aggregate relationship */
  tenant_aggregate: Coassign_Tenant_Aggregate
  /** An array relationship */
  tenant_assign_plans: Array<Coassign_Assign_Plan>
  /** An aggregate relationship */
  tenant_assign_plans_aggregate: Coassign_Assign_Plan_Aggregate
  /** An array relationship */
  tenant_assigns: Array<Coassign_Assign>
  /** An aggregate relationship */
  tenant_assigns_aggregate: Coassign_Assign_Aggregate
  /** An array relationship */
  tenant_attendance_contracts: Array<Coassign_Attendance_Contract>
  /** An aggregate relationship */
  tenant_attendance_contracts_aggregate: Coassign_Attendance_Contract_Aggregate
  /** An array relationship */
  tenant_attendances: Array<Coassign_Attendance>
  /** An aggregate relationship */
  tenant_attendances_aggregate: Coassign_Attendance_Aggregate
  /** An array relationship */
  tenant_clients: Array<Coassign_Client>
  /** An aggregate relationship */
  tenant_clients_aggregate: Coassign_Client_Aggregate
  /** An array relationship */
  tenant_commits: Array<Coassign_Commit>
  /** An aggregate relationship */
  tenant_commits_aggregate: Coassign_Commit_Aggregate
  /** An array relationship */
  tenant_custom_field: Array<Coassign_Custom_Field>
  /** An aggregate relationship */
  tenant_custom_field_aggregate: Coassign_Custom_Field_Aggregate
  /** An array relationship */
  tenant_custom_field_choice: Array<Coassign_Custom_Field_Choice>
  /** An aggregate relationship */
  tenant_custom_field_choice_aggregate: Coassign_Custom_Field_Choice_Aggregate
  /** An array relationship */
  tenant_departments: Array<Coassign_Department>
  /** An aggregate relationship */
  tenant_departments_aggregate: Coassign_Department_Aggregate
  /** An array relationship */
  tenant_employment_contracts: Array<Coassign_Employment_Contract>
  /** An aggregate relationship */
  tenant_employment_contracts_aggregate: Coassign_Employment_Contract_Aggregate
  /** An array relationship */
  tenant_employments: Array<Coassign_Employment>
  /** An aggregate relationship */
  tenant_employments_aggregate: Coassign_Employment_Aggregate
  /** An array relationship */
  tenant_holidays: Array<Coassign_Holiday>
  /** An aggregate relationship */
  tenant_holidays_aggregate: Coassign_Holiday_Aggregate
  /** An array relationship */
  tenant_job_definitions: Array<Coassign_Job_Definition>
  /** An aggregate relationship */
  tenant_job_definitions_aggregate: Coassign_Job_Definition_Aggregate
  /** An array relationship */
  tenant_job_results: Array<Coassign_Job_Result>
  /** An aggregate relationship */
  tenant_job_results_aggregate: Coassign_Job_Result_Aggregate
  /** An array relationship */
  tenant_job_skills: Array<Coassign_Job_Skill>
  /** An aggregate relationship */
  tenant_job_skills_aggregate: Coassign_Job_Skill_Aggregate
  /** An array relationship */
  tenant_job_titles: Array<Coassign_Job_Title>
  /** An aggregate relationship */
  tenant_job_titles_aggregate: Coassign_Job_Title_Aggregate
  /** An array relationship */
  tenant_job_triggers: Array<Coassign_Job_Trigger>
  /** An aggregate relationship */
  tenant_job_triggers_aggregate: Coassign_Job_Trigger_Aggregate
  /** An array relationship */
  tenant_jobs: Array<Coassign_Job>
  /** An aggregate relationship */
  tenant_jobs_aggregate: Coassign_Job_Aggregate
  /** An array relationship */
  tenant_partners: Array<Coassign_Partner>
  /** An aggregate relationship */
  tenant_partners_aggregate: Coassign_Partner_Aggregate
  /** An array relationship */
  tenant_project_to_departments: Array<Coassign_Project_To_Department>
  /** An aggregate relationship */
  tenant_project_to_departments_aggregate: Coassign_Project_To_Department_Aggregate
  /** An array relationship */
  tenant_project_to_users: Array<Coassign_Project_To_User>
  /** An aggregate relationship */
  tenant_project_to_users_aggregate: Coassign_Project_To_User_Aggregate
  /** An array relationship */
  tenant_projects: Array<Coassign_Project>
  /** An aggregate relationship */
  tenant_projects_aggregate: Coassign_Project_Aggregate
  /** An array relationship */
  tenant_regular_holidays: Array<Coassign_Regular_Holiday>
  /** An aggregate relationship */
  tenant_regular_holidays_aggregate: Coassign_Regular_Holiday_Aggregate
  /** An array relationship */
  tenant_target_cost_others: Array<Coassign_Target_Cost_Other>
  /** An aggregate relationship */
  tenant_target_cost_others_aggregate: Coassign_Target_Cost_Other_Aggregate
  /** An array relationship */
  tenant_user_to_departments: Array<Coassign_User_To_Department>
  /** An aggregate relationship */
  tenant_user_to_departments_aggregate: Coassign_User_To_Department_Aggregate
  /** An array relationship */
  tenant_user_to_job_skills: Array<Coassign_User_To_Job_Skill>
  /** An aggregate relationship */
  tenant_user_to_job_skills_aggregate: Coassign_User_To_Job_Skill_Aggregate
  /** An array relationship */
  tenant_user_to_job_titles: Array<Coassign_User_To_Job_Title>
  /** An aggregate relationship */
  tenant_user_to_job_titles_aggregate: Coassign_User_To_Job_Title_Aggregate
  /** An array relationship */
  tenant_users: Array<Coassign_User>
  /** An aggregate relationship */
  tenant_users_aggregate: Coassign_User_Aggregate
  /** An array relationship */
  tenant_volumed_assign_plans: Array<Coassign_Volumed_Assign_Plan>
  /** An aggregate relationship */
  tenant_volumed_assign_plans_aggregate: Coassign_Volumed_Assign_Plan_Aggregate
  /** An array relationship */
  tenant_volumed_assign_to_job_skills: Array<Coassign_Volumed_Assign_To_Job_Skill>
  /** An aggregate relationship */
  tenant_volumed_assign_to_job_skills_aggregate: Coassign_Volumed_Assign_To_Job_Skill_Aggregate
  /** An array relationship */
  tenant_volumed_assigns: Array<Coassign_Volumed_Assign>
  /** An aggregate relationship */
  tenant_volumed_assigns_aggregate: Coassign_Volumed_Assign_Aggregate
  /** An array relationship */
  tenant_work_on_project_contracts: Array<Coassign_Work_On_Project_Contract>
  /** An aggregate relationship */
  tenant_work_on_project_contracts_aggregate: Coassign_Work_On_Project_Contract_Aggregate
  /** An array relationship */
  tenant_work_on_projects: Array<Coassign_Work_On_Project>
  /** An aggregate relationship */
  tenant_work_on_projects_aggregate: Coassign_Work_On_Project_Aggregate
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenantArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Tenant_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Tenant_Order_By>>
  where?: InputMaybe<Coassign_Tenant_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Tenant_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Tenant_Order_By>>
  where?: InputMaybe<Coassign_Tenant_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Assign_PlansArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Assign_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_AssignsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Order_By>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Assigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Order_By>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Attendance_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Attendance_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_AttendancesArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Attendances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_ClientsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Client_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Client_Order_By>>
  where?: InputMaybe<Coassign_Client_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Clients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Client_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Client_Order_By>>
  where?: InputMaybe<Coassign_Client_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_CommitsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_Order_By>>
  where?: InputMaybe<Coassign_Commit_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Commits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_Order_By>>
  where?: InputMaybe<Coassign_Commit_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Custom_FieldArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Custom_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Custom_Field_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Choice_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Custom_Field_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Choice_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Department_Order_By>>
  where?: InputMaybe<Coassign_Department_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Department_Order_By>>
  where?: InputMaybe<Coassign_Department_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Employment_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Contract_Order_By>>
  where?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Employment_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Contract_Order_By>>
  where?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_EmploymentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Employments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_HolidaysArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Holiday_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Holidays_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Holiday_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_DefinitionsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Definition_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Definition_Order_By>>
  where?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_Definitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Definition_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Definition_Order_By>>
  where?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Result_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Result_Order_By>>
  where?: InputMaybe<Coassign_Job_Result_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Result_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Result_Order_By>>
  where?: InputMaybe<Coassign_Job_Result_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_SkillsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_Skills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_TitlesArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_Job_Title_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_Titles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_Job_Title_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Trigger_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Trigger_Order_By>>
  where?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Job_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Trigger_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Trigger_Order_By>>
  where?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_JobsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Order_By>>
  where?: InputMaybe<Coassign_Job_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Order_By>>
  where?: InputMaybe<Coassign_Job_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_PartnersArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Partner_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Partner_Order_By>>
  where?: InputMaybe<Coassign_Partner_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Partners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Partner_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Partner_Order_By>>
  where?: InputMaybe<Coassign_Partner_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Project_To_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Project_To_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Project_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Project_To_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Order_By>>
  where?: InputMaybe<Coassign_Project_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Order_By>>
  where?: InputMaybe<Coassign_Project_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Regular_HolidaysArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Regular_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Regular_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Regular_Holidays_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Regular_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Regular_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Target_Cost_OthersArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Target_Cost_Others_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_User_To_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_User_To_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_User_To_Job_SkillsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_User_To_Job_Skills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_User_To_Job_TitlesArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_User_To_Job_Titles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_Order_By>>
  where?: InputMaybe<Coassign_User_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_Order_By>>
  where?: InputMaybe<Coassign_User_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Volumed_Assign_PlansArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Volumed_Assign_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Volumed_Assign_To_Job_SkillsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Volumed_Assign_To_Job_Skills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Volumed_AssignsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Volumed_Assigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Work_On_Project_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Work_On_Project_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Work_On_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

/** columns and relationships of "coassign.tenant" */
export type Coassign_TenantTenant_Work_On_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

/** aggregated selection of "coassign.tenant" */
export type Coassign_Tenant_Aggregate = {
  __typename?: 'coassign_tenant_aggregate'
  aggregate?: Maybe<Coassign_Tenant_Aggregate_Fields>
  nodes: Array<Coassign_Tenant>
}

export type Coassign_Tenant_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Tenant_Aggregate_Bool_Exp_Count>
}

export type Coassign_Tenant_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Tenant_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Tenant_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.tenant" */
export type Coassign_Tenant_Aggregate_Fields = {
  __typename?: 'coassign_tenant_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Tenant_Max_Fields>
  min?: Maybe<Coassign_Tenant_Min_Fields>
}

/** aggregate fields of "coassign.tenant" */
export type Coassign_Tenant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Tenant_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.tenant" */
export type Coassign_Tenant_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Tenant_Max_Order_By>
  min?: InputMaybe<Coassign_Tenant_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.tenant" */
export type Coassign_Tenant_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Tenant_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Tenant_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.tenant". All fields are combined with a logical 'AND'. */
export type Coassign_Tenant_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Tenant_Bool_Exp>>
  _not?: InputMaybe<Coassign_Tenant_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Tenant_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  firebase_tenant_id?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  settings?: InputMaybe<Json_Comparison_Exp>
  subdomain?: InputMaybe<String_Comparison_Exp>
  tenant?: InputMaybe<Coassign_Tenant_Bool_Exp>
  tenant_aggregate?: InputMaybe<Coassign_Tenant_Aggregate_Bool_Exp>
  tenant_assign_plans?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
  tenant_assign_plans_aggregate?: InputMaybe<Coassign_Assign_Plan_Aggregate_Bool_Exp>
  tenant_assigns?: InputMaybe<Coassign_Assign_Bool_Exp>
  tenant_assigns_aggregate?: InputMaybe<Coassign_Assign_Aggregate_Bool_Exp>
  tenant_attendance_contracts?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
  tenant_attendance_contracts_aggregate?: InputMaybe<Coassign_Attendance_Contract_Aggregate_Bool_Exp>
  tenant_attendances?: InputMaybe<Coassign_Attendance_Bool_Exp>
  tenant_attendances_aggregate?: InputMaybe<Coassign_Attendance_Aggregate_Bool_Exp>
  tenant_clients?: InputMaybe<Coassign_Client_Bool_Exp>
  tenant_clients_aggregate?: InputMaybe<Coassign_Client_Aggregate_Bool_Exp>
  tenant_commits?: InputMaybe<Coassign_Commit_Bool_Exp>
  tenant_commits_aggregate?: InputMaybe<Coassign_Commit_Aggregate_Bool_Exp>
  tenant_custom_field?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
  tenant_custom_field_aggregate?: InputMaybe<Coassign_Custom_Field_Aggregate_Bool_Exp>
  tenant_custom_field_choice?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
  tenant_custom_field_choice_aggregate?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Bool_Exp>
  tenant_departments?: InputMaybe<Coassign_Department_Bool_Exp>
  tenant_departments_aggregate?: InputMaybe<Coassign_Department_Aggregate_Bool_Exp>
  tenant_employment_contracts?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
  tenant_employment_contracts_aggregate?: InputMaybe<Coassign_Employment_Contract_Aggregate_Bool_Exp>
  tenant_employments?: InputMaybe<Coassign_Employment_Bool_Exp>
  tenant_employments_aggregate?: InputMaybe<Coassign_Employment_Aggregate_Bool_Exp>
  tenant_holidays?: InputMaybe<Coassign_Holiday_Bool_Exp>
  tenant_holidays_aggregate?: InputMaybe<Coassign_Holiday_Aggregate_Bool_Exp>
  tenant_job_definitions?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
  tenant_job_definitions_aggregate?: InputMaybe<Coassign_Job_Definition_Aggregate_Bool_Exp>
  tenant_job_results?: InputMaybe<Coassign_Job_Result_Bool_Exp>
  tenant_job_results_aggregate?: InputMaybe<Coassign_Job_Result_Aggregate_Bool_Exp>
  tenant_job_skills?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  tenant_job_skills_aggregate?: InputMaybe<Coassign_Job_Skill_Aggregate_Bool_Exp>
  tenant_job_titles?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  tenant_job_titles_aggregate?: InputMaybe<Coassign_Job_Title_Aggregate_Bool_Exp>
  tenant_job_triggers?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
  tenant_job_triggers_aggregate?: InputMaybe<Coassign_Job_Trigger_Aggregate_Bool_Exp>
  tenant_jobs?: InputMaybe<Coassign_Job_Bool_Exp>
  tenant_jobs_aggregate?: InputMaybe<Coassign_Job_Aggregate_Bool_Exp>
  tenant_partners?: InputMaybe<Coassign_Partner_Bool_Exp>
  tenant_partners_aggregate?: InputMaybe<Coassign_Partner_Aggregate_Bool_Exp>
  tenant_project_to_departments?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
  tenant_project_to_departments_aggregate?: InputMaybe<Coassign_Project_To_Department_Aggregate_Bool_Exp>
  tenant_project_to_users?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
  tenant_project_to_users_aggregate?: InputMaybe<Coassign_Project_To_User_Aggregate_Bool_Exp>
  tenant_projects?: InputMaybe<Coassign_Project_Bool_Exp>
  tenant_projects_aggregate?: InputMaybe<Coassign_Project_Aggregate_Bool_Exp>
  tenant_regular_holidays?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
  tenant_regular_holidays_aggregate?: InputMaybe<Coassign_Regular_Holiday_Aggregate_Bool_Exp>
  tenant_target_cost_others?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
  tenant_target_cost_others_aggregate?: InputMaybe<Coassign_Target_Cost_Other_Aggregate_Bool_Exp>
  tenant_user_to_departments?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
  tenant_user_to_departments_aggregate?: InputMaybe<Coassign_User_To_Department_Aggregate_Bool_Exp>
  tenant_user_to_job_skills?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
  tenant_user_to_job_skills_aggregate?: InputMaybe<Coassign_User_To_Job_Skill_Aggregate_Bool_Exp>
  tenant_user_to_job_titles?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
  tenant_user_to_job_titles_aggregate?: InputMaybe<Coassign_User_To_Job_Title_Aggregate_Bool_Exp>
  tenant_users?: InputMaybe<Coassign_User_Bool_Exp>
  tenant_users_aggregate?: InputMaybe<Coassign_User_Aggregate_Bool_Exp>
  tenant_volumed_assign_plans?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
  tenant_volumed_assign_plans_aggregate?: InputMaybe<Coassign_Volumed_Assign_Plan_Aggregate_Bool_Exp>
  tenant_volumed_assign_to_job_skills?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
  tenant_volumed_assign_to_job_skills_aggregate?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Bool_Exp>
  tenant_volumed_assigns?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
  tenant_volumed_assigns_aggregate?: InputMaybe<Coassign_Volumed_Assign_Aggregate_Bool_Exp>
  tenant_work_on_project_contracts?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
  tenant_work_on_project_contracts_aggregate?: InputMaybe<Coassign_Work_On_Project_Contract_Aggregate_Bool_Exp>
  tenant_work_on_projects?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
  tenant_work_on_projects_aggregate?: InputMaybe<Coassign_Work_On_Project_Aggregate_Bool_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.tenant" */
export enum Coassign_Tenant_Constraint {
  /** unique or primary key constraint on columns "id" */
  TenantPkey = 'tenant_pkey',
  /** unique or primary key constraint on columns "subdomain" */
  TenantSubdomainKey = 'tenant_subdomain_key'
}

/** input type for inserting data into table "coassign.tenant" */
export type Coassign_Tenant_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  firebase_tenant_id?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  settings?: InputMaybe<Scalars['json']['input']>
  subdomain?: InputMaybe<Scalars['String']['input']>
  tenant?: InputMaybe<Coassign_Tenant_Arr_Rel_Insert_Input>
  tenant_assign_plans?: InputMaybe<Coassign_Assign_Plan_Arr_Rel_Insert_Input>
  tenant_assigns?: InputMaybe<Coassign_Assign_Arr_Rel_Insert_Input>
  tenant_attendance_contracts?: InputMaybe<Coassign_Attendance_Contract_Arr_Rel_Insert_Input>
  tenant_attendances?: InputMaybe<Coassign_Attendance_Arr_Rel_Insert_Input>
  tenant_clients?: InputMaybe<Coassign_Client_Arr_Rel_Insert_Input>
  tenant_commits?: InputMaybe<Coassign_Commit_Arr_Rel_Insert_Input>
  tenant_custom_field?: InputMaybe<Coassign_Custom_Field_Arr_Rel_Insert_Input>
  tenant_custom_field_choice?: InputMaybe<Coassign_Custom_Field_Choice_Arr_Rel_Insert_Input>
  tenant_departments?: InputMaybe<Coassign_Department_Arr_Rel_Insert_Input>
  tenant_employment_contracts?: InputMaybe<Coassign_Employment_Contract_Arr_Rel_Insert_Input>
  tenant_employments?: InputMaybe<Coassign_Employment_Arr_Rel_Insert_Input>
  tenant_holidays?: InputMaybe<Coassign_Holiday_Arr_Rel_Insert_Input>
  tenant_job_definitions?: InputMaybe<Coassign_Job_Definition_Arr_Rel_Insert_Input>
  tenant_job_results?: InputMaybe<Coassign_Job_Result_Arr_Rel_Insert_Input>
  tenant_job_skills?: InputMaybe<Coassign_Job_Skill_Arr_Rel_Insert_Input>
  tenant_job_titles?: InputMaybe<Coassign_Job_Title_Arr_Rel_Insert_Input>
  tenant_job_triggers?: InputMaybe<Coassign_Job_Trigger_Arr_Rel_Insert_Input>
  tenant_jobs?: InputMaybe<Coassign_Job_Arr_Rel_Insert_Input>
  tenant_partners?: InputMaybe<Coassign_Partner_Arr_Rel_Insert_Input>
  tenant_project_to_departments?: InputMaybe<Coassign_Project_To_Department_Arr_Rel_Insert_Input>
  tenant_project_to_users?: InputMaybe<Coassign_Project_To_User_Arr_Rel_Insert_Input>
  tenant_projects?: InputMaybe<Coassign_Project_Arr_Rel_Insert_Input>
  tenant_regular_holidays?: InputMaybe<Coassign_Regular_Holiday_Arr_Rel_Insert_Input>
  tenant_target_cost_others?: InputMaybe<Coassign_Target_Cost_Other_Arr_Rel_Insert_Input>
  tenant_user_to_departments?: InputMaybe<Coassign_User_To_Department_Arr_Rel_Insert_Input>
  tenant_user_to_job_skills?: InputMaybe<Coassign_User_To_Job_Skill_Arr_Rel_Insert_Input>
  tenant_user_to_job_titles?: InputMaybe<Coassign_User_To_Job_Title_Arr_Rel_Insert_Input>
  tenant_users?: InputMaybe<Coassign_User_Arr_Rel_Insert_Input>
  tenant_volumed_assign_plans?: InputMaybe<Coassign_Volumed_Assign_Plan_Arr_Rel_Insert_Input>
  tenant_volumed_assign_to_job_skills?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Arr_Rel_Insert_Input>
  tenant_volumed_assigns?: InputMaybe<Coassign_Volumed_Assign_Arr_Rel_Insert_Input>
  tenant_work_on_project_contracts?: InputMaybe<Coassign_Work_On_Project_Contract_Arr_Rel_Insert_Input>
  tenant_work_on_projects?: InputMaybe<Coassign_Work_On_Project_Arr_Rel_Insert_Input>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Coassign_Tenant_Max_Fields = {
  __typename?: 'coassign_tenant_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  firebase_tenant_id?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  subdomain?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.tenant" */
export type Coassign_Tenant_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  firebase_tenant_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  subdomain?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Tenant_Min_Fields = {
  __typename?: 'coassign_tenant_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  firebase_tenant_id?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  subdomain?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.tenant" */
export type Coassign_Tenant_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  firebase_tenant_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  subdomain?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.tenant" */
export type Coassign_Tenant_Mutation_Response = {
  __typename?: 'coassign_tenant_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Tenant>
}

/** input type for inserting object relation for remote table "coassign.tenant" */
export type Coassign_Tenant_Obj_Rel_Insert_Input = {
  data: Coassign_Tenant_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Tenant_On_Conflict>
}

/** on_conflict condition type for table "coassign.tenant" */
export type Coassign_Tenant_On_Conflict = {
  constraint: Coassign_Tenant_Constraint
  update_columns?: Array<Coassign_Tenant_Update_Column>
  where?: InputMaybe<Coassign_Tenant_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.tenant". */
export type Coassign_Tenant_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  firebase_tenant_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  settings?: InputMaybe<Order_By>
  subdomain?: InputMaybe<Order_By>
  tenant_aggregate?: InputMaybe<Coassign_Tenant_Aggregate_Order_By>
  tenant_assign_plans_aggregate?: InputMaybe<Coassign_Assign_Plan_Aggregate_Order_By>
  tenant_assigns_aggregate?: InputMaybe<Coassign_Assign_Aggregate_Order_By>
  tenant_attendance_contracts_aggregate?: InputMaybe<Coassign_Attendance_Contract_Aggregate_Order_By>
  tenant_attendances_aggregate?: InputMaybe<Coassign_Attendance_Aggregate_Order_By>
  tenant_clients_aggregate?: InputMaybe<Coassign_Client_Aggregate_Order_By>
  tenant_commits_aggregate?: InputMaybe<Coassign_Commit_Aggregate_Order_By>
  tenant_custom_field_aggregate?: InputMaybe<Coassign_Custom_Field_Aggregate_Order_By>
  tenant_custom_field_choice_aggregate?: InputMaybe<Coassign_Custom_Field_Choice_Aggregate_Order_By>
  tenant_departments_aggregate?: InputMaybe<Coassign_Department_Aggregate_Order_By>
  tenant_employment_contracts_aggregate?: InputMaybe<Coassign_Employment_Contract_Aggregate_Order_By>
  tenant_employments_aggregate?: InputMaybe<Coassign_Employment_Aggregate_Order_By>
  tenant_holidays_aggregate?: InputMaybe<Coassign_Holiday_Aggregate_Order_By>
  tenant_job_definitions_aggregate?: InputMaybe<Coassign_Job_Definition_Aggregate_Order_By>
  tenant_job_results_aggregate?: InputMaybe<Coassign_Job_Result_Aggregate_Order_By>
  tenant_job_skills_aggregate?: InputMaybe<Coassign_Job_Skill_Aggregate_Order_By>
  tenant_job_titles_aggregate?: InputMaybe<Coassign_Job_Title_Aggregate_Order_By>
  tenant_job_triggers_aggregate?: InputMaybe<Coassign_Job_Trigger_Aggregate_Order_By>
  tenant_jobs_aggregate?: InputMaybe<Coassign_Job_Aggregate_Order_By>
  tenant_partners_aggregate?: InputMaybe<Coassign_Partner_Aggregate_Order_By>
  tenant_project_to_departments_aggregate?: InputMaybe<Coassign_Project_To_Department_Aggregate_Order_By>
  tenant_project_to_users_aggregate?: InputMaybe<Coassign_Project_To_User_Aggregate_Order_By>
  tenant_projects_aggregate?: InputMaybe<Coassign_Project_Aggregate_Order_By>
  tenant_regular_holidays_aggregate?: InputMaybe<Coassign_Regular_Holiday_Aggregate_Order_By>
  tenant_target_cost_others_aggregate?: InputMaybe<Coassign_Target_Cost_Other_Aggregate_Order_By>
  tenant_user_to_departments_aggregate?: InputMaybe<Coassign_User_To_Department_Aggregate_Order_By>
  tenant_user_to_job_skills_aggregate?: InputMaybe<Coassign_User_To_Job_Skill_Aggregate_Order_By>
  tenant_user_to_job_titles_aggregate?: InputMaybe<Coassign_User_To_Job_Title_Aggregate_Order_By>
  tenant_users_aggregate?: InputMaybe<Coassign_User_Aggregate_Order_By>
  tenant_volumed_assign_plans_aggregate?: InputMaybe<Coassign_Volumed_Assign_Plan_Aggregate_Order_By>
  tenant_volumed_assign_to_job_skills_aggregate?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Order_By>
  tenant_volumed_assigns_aggregate?: InputMaybe<Coassign_Volumed_Assign_Aggregate_Order_By>
  tenant_work_on_project_contracts_aggregate?: InputMaybe<Coassign_Work_On_Project_Contract_Aggregate_Order_By>
  tenant_work_on_projects_aggregate?: InputMaybe<Coassign_Work_On_Project_Aggregate_Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.tenant */
export type Coassign_Tenant_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.tenant" */
export enum Coassign_Tenant_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FirebaseTenantId = 'firebase_tenant_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Settings = 'settings',
  /** column name */
  Subdomain = 'subdomain',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coassign.tenant" */
export type Coassign_Tenant_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  firebase_tenant_id?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  settings?: InputMaybe<Scalars['json']['input']>
  subdomain?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "coassign_tenant" */
export type Coassign_Tenant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Tenant_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Tenant_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  firebase_tenant_id?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  settings?: InputMaybe<Scalars['json']['input']>
  subdomain?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "coassign.tenant" */
export enum Coassign_Tenant_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FirebaseTenantId = 'firebase_tenant_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Settings = 'settings',
  /** column name */
  Subdomain = 'subdomain',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_Tenant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Tenant_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Tenant_Bool_Exp
}

/** columns and relationships of "coassign.user" */
export type Coassign_User = {
  __typename?: 'coassign_user'
  available: Scalars['Boolean']['output']
  chat_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  display_order: Scalars['Int']['output']
  email: Scalars['citext']['output']
  /** An array relationship */
  employments: Array<Coassign_Employment>
  /** An aggregate relationship */
  employments_aggregate: Coassign_Employment_Aggregate
  firebase_uid?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  note?: Maybe<Scalars['String']['output']>
  role: Scalars['roles']['output']
  /** An object relationship */
  tenant: Coassign_Tenant
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An array relationship */
  user_to_departments: Array<Coassign_User_To_Department>
  /** An aggregate relationship */
  user_to_departments_aggregate: Coassign_User_To_Department_Aggregate
  /** An array relationship */
  user_to_job_skills: Array<Coassign_User_To_Job_Skill>
  /** An aggregate relationship */
  user_to_job_skills_aggregate: Coassign_User_To_Job_Skill_Aggregate
  /** An array relationship */
  user_to_job_titles: Array<Coassign_User_To_Job_Title>
  /** An aggregate relationship */
  user_to_job_titles_aggregate: Coassign_User_To_Job_Title_Aggregate
}

/** columns and relationships of "coassign.user" */
export type Coassign_UserEmploymentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

/** columns and relationships of "coassign.user" */
export type Coassign_UserEmployments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

/** columns and relationships of "coassign.user" */
export type Coassign_UserUser_To_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.user" */
export type Coassign_UserUser_To_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.user" */
export type Coassign_UserUser_To_Job_SkillsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.user" */
export type Coassign_UserUser_To_Job_Skills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.user" */
export type Coassign_UserUser_To_Job_TitlesArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

/** columns and relationships of "coassign.user" */
export type Coassign_UserUser_To_Job_Titles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

/** aggregated selection of "coassign.user" */
export type Coassign_User_Aggregate = {
  __typename?: 'coassign_user_aggregate'
  aggregate?: Maybe<Coassign_User_Aggregate_Fields>
  nodes: Array<Coassign_User>
}

export type Coassign_User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Coassign_User_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Coassign_User_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Coassign_User_Aggregate_Bool_Exp_Count>
}

export type Coassign_User_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coassign_User_Select_Column_Coassign_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_User_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coassign_User_Select_Column_Coassign_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_User_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_User_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_User_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.user" */
export type Coassign_User_Aggregate_Fields = {
  __typename?: 'coassign_user_aggregate_fields'
  avg?: Maybe<Coassign_User_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_User_Max_Fields>
  min?: Maybe<Coassign_User_Min_Fields>
  stddev?: Maybe<Coassign_User_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_User_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_User_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_User_Sum_Fields>
  var_pop?: Maybe<Coassign_User_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_User_Var_Samp_Fields>
  variance?: Maybe<Coassign_User_Variance_Fields>
}

/** aggregate fields of "coassign.user" */
export type Coassign_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_User_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.user" */
export type Coassign_User_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_User_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_User_Max_Order_By>
  min?: InputMaybe<Coassign_User_Min_Order_By>
  stddev?: InputMaybe<Coassign_User_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_User_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_User_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_User_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_User_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_User_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_User_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.user" */
export type Coassign_User_Arr_Rel_Insert_Input = {
  data: Array<Coassign_User_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_User_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_User_Avg_Fields = {
  __typename?: 'coassign_user_avg_fields'
  display_order?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.user" */
export type Coassign_User_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.user". All fields are combined with a logical 'AND'. */
export type Coassign_User_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_User_Bool_Exp>>
  _not?: InputMaybe<Coassign_User_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_User_Bool_Exp>>
  available?: InputMaybe<Boolean_Comparison_Exp>
  chat_id?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  display_order?: InputMaybe<Int_Comparison_Exp>
  email?: InputMaybe<Citext_Comparison_Exp>
  employments?: InputMaybe<Coassign_Employment_Bool_Exp>
  employments_aggregate?: InputMaybe<Coassign_Employment_Aggregate_Bool_Exp>
  firebase_uid?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  note?: InputMaybe<String_Comparison_Exp>
  role?: InputMaybe<Roles_Comparison_Exp>
  tenant?: InputMaybe<Coassign_Tenant_Bool_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_to_departments?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
  user_to_departments_aggregate?: InputMaybe<Coassign_User_To_Department_Aggregate_Bool_Exp>
  user_to_job_skills?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
  user_to_job_skills_aggregate?: InputMaybe<Coassign_User_To_Job_Skill_Aggregate_Bool_Exp>
  user_to_job_titles?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
  user_to_job_titles_aggregate?: InputMaybe<Coassign_User_To_Job_Title_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.user" */
export enum Coassign_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey',
  /** unique or primary key constraint on columns "email", "tenant_id" */
  UserTenantIdEmailDeletedAt = 'user_tenant_id_email_deleted_at'
}

/** input type for incrementing numeric columns in table "coassign.user" */
export type Coassign_User_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "coassign.user" */
export type Coassign_User_Insert_Input = {
  available?: InputMaybe<Scalars['Boolean']['input']>
  chat_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  display_order?: InputMaybe<Scalars['Int']['input']>
  email?: InputMaybe<Scalars['citext']['input']>
  employments?: InputMaybe<Coassign_Employment_Arr_Rel_Insert_Input>
  firebase_uid?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['roles']['input']>
  tenant?: InputMaybe<Coassign_Tenant_Obj_Rel_Insert_Input>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_to_departments?: InputMaybe<Coassign_User_To_Department_Arr_Rel_Insert_Input>
  user_to_job_skills?: InputMaybe<Coassign_User_To_Job_Skill_Arr_Rel_Insert_Input>
  user_to_job_titles?: InputMaybe<Coassign_User_To_Job_Title_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_User_Max_Fields = {
  __typename?: 'coassign_user_max_fields'
  chat_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  display_order?: Maybe<Scalars['Int']['output']>
  email?: Maybe<Scalars['citext']['output']>
  firebase_uid?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['roles']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.user" */
export type Coassign_User_Max_Order_By = {
  chat_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  display_order?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  firebase_uid?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  note?: InputMaybe<Order_By>
  role?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_User_Min_Fields = {
  __typename?: 'coassign_user_min_fields'
  chat_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  display_order?: Maybe<Scalars['Int']['output']>
  email?: Maybe<Scalars['citext']['output']>
  firebase_uid?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['roles']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.user" */
export type Coassign_User_Min_Order_By = {
  chat_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  display_order?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  firebase_uid?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  note?: InputMaybe<Order_By>
  role?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.user" */
export type Coassign_User_Mutation_Response = {
  __typename?: 'coassign_user_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_User>
}

/** input type for inserting object relation for remote table "coassign.user" */
export type Coassign_User_Obj_Rel_Insert_Input = {
  data: Coassign_User_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_User_On_Conflict>
}

/** on_conflict condition type for table "coassign.user" */
export type Coassign_User_On_Conflict = {
  constraint: Coassign_User_Constraint
  update_columns?: Array<Coassign_User_Update_Column>
  where?: InputMaybe<Coassign_User_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.user". */
export type Coassign_User_Order_By = {
  available?: InputMaybe<Order_By>
  chat_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  display_order?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  employments_aggregate?: InputMaybe<Coassign_Employment_Aggregate_Order_By>
  firebase_uid?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  note?: InputMaybe<Order_By>
  role?: InputMaybe<Order_By>
  tenant?: InputMaybe<Coassign_Tenant_Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_to_departments_aggregate?: InputMaybe<Coassign_User_To_Department_Aggregate_Order_By>
  user_to_job_skills_aggregate?: InputMaybe<Coassign_User_To_Job_Skill_Aggregate_Order_By>
  user_to_job_titles_aggregate?: InputMaybe<Coassign_User_To_Job_Title_Aggregate_Order_By>
}

/** primary key columns input for table: coassign.user */
export type Coassign_User_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.user" */
export enum Coassign_User_Select_Column {
  /** column name */
  Available = 'available',
  /** column name */
  ChatId = 'chat_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Email = 'email',
  /** column name */
  FirebaseUid = 'firebase_uid',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Note = 'note',
  /** column name */
  Role = 'role',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "coassign_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coassign.user" */
export enum Coassign_User_Select_Column_Coassign_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Available = 'available'
}

/** select "coassign_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coassign.user" */
export enum Coassign_User_Select_Column_Coassign_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Available = 'available'
}

/** input type for updating data in table "coassign.user" */
export type Coassign_User_Set_Input = {
  available?: InputMaybe<Scalars['Boolean']['input']>
  chat_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  display_order?: InputMaybe<Scalars['Int']['input']>
  email?: InputMaybe<Scalars['citext']['input']>
  firebase_uid?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['roles']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Coassign_User_Stddev_Fields = {
  __typename?: 'coassign_user_stddev_fields'
  display_order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.user" */
export type Coassign_User_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_User_Stddev_Pop_Fields = {
  __typename?: 'coassign_user_stddev_pop_fields'
  display_order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.user" */
export type Coassign_User_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_User_Stddev_Samp_Fields = {
  __typename?: 'coassign_user_stddev_samp_fields'
  display_order?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.user" */
export type Coassign_User_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_user" */
export type Coassign_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_User_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_User_Stream_Cursor_Value_Input = {
  available?: InputMaybe<Scalars['Boolean']['input']>
  chat_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  display_order?: InputMaybe<Scalars['Int']['input']>
  email?: InputMaybe<Scalars['citext']['input']>
  firebase_uid?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['roles']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Coassign_User_Sum_Fields = {
  __typename?: 'coassign_user_sum_fields'
  display_order?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "coassign.user" */
export type Coassign_User_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.user_to_department" */
export type Coassign_User_To_Department = {
  __typename?: 'coassign_user_to_department'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  department: Coassign_Department
  department_id: Scalars['String']['output']
  /** An object relationship */
  tenant: Coassign_Tenant
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
  user_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.user_to_department" */
export type Coassign_User_To_Department_Aggregate = {
  __typename?: 'coassign_user_to_department_aggregate'
  aggregate?: Maybe<Coassign_User_To_Department_Aggregate_Fields>
  nodes: Array<Coassign_User_To_Department>
}

export type Coassign_User_To_Department_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_User_To_Department_Aggregate_Bool_Exp_Count>
}

export type Coassign_User_To_Department_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.user_to_department" */
export type Coassign_User_To_Department_Aggregate_Fields = {
  __typename?: 'coassign_user_to_department_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_User_To_Department_Max_Fields>
  min?: Maybe<Coassign_User_To_Department_Min_Fields>
}

/** aggregate fields of "coassign.user_to_department" */
export type Coassign_User_To_Department_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.user_to_department" */
export type Coassign_User_To_Department_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_User_To_Department_Max_Order_By>
  min?: InputMaybe<Coassign_User_To_Department_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.user_to_department" */
export type Coassign_User_To_Department_Arr_Rel_Insert_Input = {
  data: Array<Coassign_User_To_Department_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_User_To_Department_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.user_to_department". All fields are combined with a logical 'AND'. */
export type Coassign_User_To_Department_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_User_To_Department_Bool_Exp>>
  _not?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_User_To_Department_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  department?: InputMaybe<Coassign_Department_Bool_Exp>
  department_id?: InputMaybe<String_Comparison_Exp>
  tenant?: InputMaybe<Coassign_Tenant_Bool_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.user_to_department" */
export enum Coassign_User_To_Department_Constraint {
  /** unique or primary key constraint on columns "user_id", "department_id" */
  UserToDepartmentEnforceSingleNullDeletedAt = 'user_to_department_enforce_single_null_deleted_at',
  /** unique or primary key constraint on columns "user_id", "deleted_at", "department_id" */
  UserToDepartmentUnique = 'user_to_department_unique'
}

/** input type for inserting data into table "coassign.user_to_department" */
export type Coassign_User_To_Department_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department?: InputMaybe<Coassign_Department_Obj_Rel_Insert_Input>
  department_id?: InputMaybe<Scalars['String']['input']>
  tenant?: InputMaybe<Coassign_Tenant_Obj_Rel_Insert_Input>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_User_To_Department_Max_Fields = {
  __typename?: 'coassign_user_to_department_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.user_to_department" */
export type Coassign_User_To_Department_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_User_To_Department_Min_Fields = {
  __typename?: 'coassign_user_to_department_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.user_to_department" */
export type Coassign_User_To_Department_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.user_to_department" */
export type Coassign_User_To_Department_Mutation_Response = {
  __typename?: 'coassign_user_to_department_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_User_To_Department>
}

/** on_conflict condition type for table "coassign.user_to_department" */
export type Coassign_User_To_Department_On_Conflict = {
  constraint: Coassign_User_To_Department_Constraint
  update_columns?: Array<Coassign_User_To_Department_Update_Column>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.user_to_department". */
export type Coassign_User_To_Department_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department?: InputMaybe<Coassign_Department_Order_By>
  department_id?: InputMaybe<Order_By>
  tenant?: InputMaybe<Coassign_Tenant_Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.user_to_department" */
export enum Coassign_User_To_Department_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coassign.user_to_department" */
export type Coassign_User_To_Department_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_user_to_department" */
export type Coassign_User_To_Department_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_User_To_Department_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_User_To_Department_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.user_to_department" */
export enum Coassign_User_To_Department_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Coassign_User_To_Department_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_User_To_Department_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_User_To_Department_Bool_Exp
}

/** columns and relationships of "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill = {
  __typename?: 'coassign_user_to_job_skill'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  job_skill: Coassign_Job_Skill
  job_skill_id: Scalars['String']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
  user_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Aggregate = {
  __typename?: 'coassign_user_to_job_skill_aggregate'
  aggregate?: Maybe<Coassign_User_To_Job_Skill_Aggregate_Fields>
  nodes: Array<Coassign_User_To_Job_Skill>
}

export type Coassign_User_To_Job_Skill_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_User_To_Job_Skill_Aggregate_Bool_Exp_Count>
}

export type Coassign_User_To_Job_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Aggregate_Fields = {
  __typename?: 'coassign_user_to_job_skill_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_User_To_Job_Skill_Max_Fields>
  min?: Maybe<Coassign_User_To_Job_Skill_Min_Fields>
}

/** aggregate fields of "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_User_To_Job_Skill_Max_Order_By>
  min?: InputMaybe<Coassign_User_To_Job_Skill_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Arr_Rel_Insert_Input = {
  data: Array<Coassign_User_To_Job_Skill_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_User_To_Job_Skill_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.user_to_job_skill". All fields are combined with a logical 'AND'. */
export type Coassign_User_To_Job_Skill_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_User_To_Job_Skill_Bool_Exp>>
  _not?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_User_To_Job_Skill_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  job_skill?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  job_skill_id?: InputMaybe<String_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.user_to_job_skill" */
export enum Coassign_User_To_Job_Skill_Constraint {
  /** unique or primary key constraint on columns "user_id", "job_skill_id" */
  UserToJobSkillEnforceSingleNullDeletedAt = 'user_to_job_skill_enforce_single_null_deleted_at',
  /** unique or primary key constraint on columns "user_id", "deleted_at", "job_skill_id" */
  UserToJobSkillUnique = 'user_to_job_skill_unique'
}

/** input type for inserting data into table "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill?: InputMaybe<Coassign_Job_Skill_Obj_Rel_Insert_Input>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_User_To_Job_Skill_Max_Fields = {
  __typename?: 'coassign_user_to_job_skill_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_skill_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_User_To_Job_Skill_Min_Fields = {
  __typename?: 'coassign_user_to_job_skill_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_skill_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Mutation_Response = {
  __typename?: 'coassign_user_to_job_skill_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_User_To_Job_Skill>
}

/** on_conflict condition type for table "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_On_Conflict = {
  constraint: Coassign_User_To_Job_Skill_Constraint
  update_columns?: Array<Coassign_User_To_Job_Skill_Update_Column>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.user_to_job_skill". */
export type Coassign_User_To_Job_Skill_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_skill?: InputMaybe<Coassign_Job_Skill_Order_By>
  job_skill_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.user_to_job_skill" */
export enum Coassign_User_To_Job_Skill_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  JobSkillId = 'job_skill_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coassign.user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_user_to_job_skill" */
export type Coassign_User_To_Job_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_User_To_Job_Skill_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_User_To_Job_Skill_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.user_to_job_skill" */
export enum Coassign_User_To_Job_Skill_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  JobSkillId = 'job_skill_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Coassign_User_To_Job_Skill_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_User_To_Job_Skill_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_User_To_Job_Skill_Bool_Exp
}

/** columns and relationships of "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title = {
  __typename?: 'coassign_user_to_job_title'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  job_title: Coassign_Job_Title
  job_title_id: Scalars['String']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
  user_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Aggregate = {
  __typename?: 'coassign_user_to_job_title_aggregate'
  aggregate?: Maybe<Coassign_User_To_Job_Title_Aggregate_Fields>
  nodes: Array<Coassign_User_To_Job_Title>
}

export type Coassign_User_To_Job_Title_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_User_To_Job_Title_Aggregate_Bool_Exp_Count>
}

export type Coassign_User_To_Job_Title_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Aggregate_Fields = {
  __typename?: 'coassign_user_to_job_title_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_User_To_Job_Title_Max_Fields>
  min?: Maybe<Coassign_User_To_Job_Title_Min_Fields>
}

/** aggregate fields of "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_User_To_Job_Title_Max_Order_By>
  min?: InputMaybe<Coassign_User_To_Job_Title_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Arr_Rel_Insert_Input = {
  data: Array<Coassign_User_To_Job_Title_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_User_To_Job_Title_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.user_to_job_title". All fields are combined with a logical 'AND'. */
export type Coassign_User_To_Job_Title_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_User_To_Job_Title_Bool_Exp>>
  _not?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_User_To_Job_Title_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  job_title?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  job_title_id?: InputMaybe<String_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.user_to_job_title" */
export enum Coassign_User_To_Job_Title_Constraint {
  /** unique or primary key constraint on columns "user_id", "job_title_id" */
  UserToJobTitleEnforceSingleNullDeletedAt = 'user_to_job_title_enforce_single_null_deleted_at',
  /** unique or primary key constraint on columns "user_id", "deleted_at", "job_title_id" */
  UserToJobTitleUnique = 'user_to_job_title_unique'
}

/** input type for inserting data into table "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_title?: InputMaybe<Coassign_Job_Title_Obj_Rel_Insert_Input>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_User_To_Job_Title_Max_Fields = {
  __typename?: 'coassign_user_to_job_title_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_User_To_Job_Title_Min_Fields = {
  __typename?: 'coassign_user_to_job_title_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Mutation_Response = {
  __typename?: 'coassign_user_to_job_title_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_User_To_Job_Title>
}

/** on_conflict condition type for table "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_On_Conflict = {
  constraint: Coassign_User_To_Job_Title_Constraint
  update_columns?: Array<Coassign_User_To_Job_Title_Update_Column>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.user_to_job_title". */
export type Coassign_User_To_Job_Title_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_title?: InputMaybe<Coassign_Job_Title_Order_By>
  job_title_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.user_to_job_title" */
export enum Coassign_User_To_Job_Title_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coassign.user_to_job_title" */
export type Coassign_User_To_Job_Title_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_user_to_job_title" */
export type Coassign_User_To_Job_Title_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_User_To_Job_Title_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_User_To_Job_Title_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.user_to_job_title" */
export enum Coassign_User_To_Job_Title_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Coassign_User_To_Job_Title_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_User_To_Job_Title_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_User_To_Job_Title_Bool_Exp
}

/** update columns of table "coassign.user" */
export enum Coassign_User_Update_Column {
  /** column name */
  Available = 'available',
  /** column name */
  ChatId = 'chat_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Email = 'email',
  /** column name */
  FirebaseUid = 'firebase_uid',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Note = 'note',
  /** column name */
  Role = 'role',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coassign_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_User_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_User_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_User_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_User_Var_Pop_Fields = {
  __typename?: 'coassign_user_var_pop_fields'
  display_order?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.user" */
export type Coassign_User_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_User_Var_Samp_Fields = {
  __typename?: 'coassign_user_var_samp_fields'
  display_order?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.user" */
export type Coassign_User_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_User_Variance_Fields = {
  __typename?: 'coassign_user_variance_fields'
  display_order?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.user" */
export type Coassign_User_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>
}

/** columns and relationships of "coassign.volumed_assign" */
export type Coassign_Volumed_Assign = {
  __typename?: 'coassign_volumed_assign'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  /** An object relationship */
  job_title: Coassign_Job_Title
  job_title_id: Scalars['String']['output']
  /** An object relationship */
  project: Coassign_Project
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  visible: Scalars['Boolean']['output']
  /** An array relationship */
  volumed_assign_plans: Array<Coassign_Volumed_Assign_Plan>
  /** An aggregate relationship */
  volumed_assign_plans_aggregate: Coassign_Volumed_Assign_Plan_Aggregate
  /** An array relationship */
  volumed_assign_to_department: Array<Coassign_Volumed_Assign_To_Department>
  /** An aggregate relationship */
  volumed_assign_to_department_aggregate: Coassign_Volumed_Assign_To_Department_Aggregate
  /** An array relationship */
  volumed_assign_to_job_skills: Array<Coassign_Volumed_Assign_To_Job_Skill>
  /** An aggregate relationship */
  volumed_assign_to_job_skills_aggregate: Coassign_Volumed_Assign_To_Job_Skill_Aggregate
}

/** columns and relationships of "coassign.volumed_assign" */
export type Coassign_Volumed_AssignVolumed_Assign_PlansArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

/** columns and relationships of "coassign.volumed_assign" */
export type Coassign_Volumed_AssignVolumed_Assign_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

/** columns and relationships of "coassign.volumed_assign" */
export type Coassign_Volumed_AssignVolumed_Assign_To_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.volumed_assign" */
export type Coassign_Volumed_AssignVolumed_Assign_To_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
}

/** columns and relationships of "coassign.volumed_assign" */
export type Coassign_Volumed_AssignVolumed_Assign_To_Job_SkillsArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

/** columns and relationships of "coassign.volumed_assign" */
export type Coassign_Volumed_AssignVolumed_Assign_To_Job_Skills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

/** aggregated selection of "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Aggregate = {
  __typename?: 'coassign_volumed_assign_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign>
}

export type Coassign_Volumed_Assign_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Coassign_Volumed_Assign_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Coassign_Volumed_Assign_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Coassign_Volumed_Assign_Aggregate_Bool_Exp_Count>
}

export type Coassign_Volumed_Assign_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coassign_Volumed_Assign_Select_Column_Coassign_Volumed_Assign_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Volumed_Assign_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coassign_Volumed_Assign_Select_Column_Coassign_Volumed_Assign_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Coassign_Volumed_Assign_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_Min_Fields>
}

/** aggregate fields of "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Volumed_Assign_Max_Order_By>
  min?: InputMaybe<Coassign_Volumed_Assign_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Volumed_Assign_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_Bool_Exp>>
  comment?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  icon?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_title?: InputMaybe<Coassign_Job_Title_Bool_Exp>
  job_title_id?: InputMaybe<String_Comparison_Exp>
  project?: InputMaybe<Coassign_Project_Bool_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  visible?: InputMaybe<Boolean_Comparison_Exp>
  volumed_assign_plans?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
  volumed_assign_plans_aggregate?: InputMaybe<Coassign_Volumed_Assign_Plan_Aggregate_Bool_Exp>
  volumed_assign_to_department?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
  volumed_assign_to_department_aggregate?: InputMaybe<Coassign_Volumed_Assign_To_Department_Aggregate_Bool_Exp>
  volumed_assign_to_job_skills?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
  volumed_assign_to_job_skills_aggregate?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.volumed_assign" */
export enum Coassign_Volumed_Assign_Constraint {
  /** unique or primary key constraint on columns "id" */
  VolumedAssignPkey = 'volumed_assign_pkey'
}

/** columns and relationships of "coassign.volumed_assign_full_view" */
export type Coassign_Volumed_Assign_Full_View = {
  __typename?: 'coassign_volumed_assign_full_view'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  visible?: Maybe<Scalars['Boolean']['output']>
}

/** aggregated selection of "coassign.volumed_assign_full_view" */
export type Coassign_Volumed_Assign_Full_View_Aggregate = {
  __typename?: 'coassign_volumed_assign_full_view_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_Full_View>
}

/** aggregate fields of "coassign.volumed_assign_full_view" */
export type Coassign_Volumed_Assign_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_full_view_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_Full_View_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_Full_View_Min_Fields>
}

/** aggregate fields of "coassign.volumed_assign_full_view" */
export type Coassign_Volumed_Assign_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Bool_Exp>>
  comment?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  icon?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_title_id?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  visible?: InputMaybe<Boolean_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_Full_View_Max_Fields = {
  __typename?: 'coassign_volumed_assign_full_view_max_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_Full_View_Min_Fields = {
  __typename?: 'coassign_volumed_assign_full_view_min_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** Ordering options when selecting data from "coassign.volumed_assign_full_view". */
export type Coassign_Volumed_Assign_Full_View_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  visible?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_full_view" */
export enum Coassign_Volumed_Assign_Full_View_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

/** Streaming cursor of the table "coassign_volumed_assign_full_view" */
export type Coassign_Volumed_Assign_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_Full_View_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** columns and relationships of "coassign.volumed_assign_history" */
export type Coassign_Volumed_Assign_History = {
  __typename?: 'coassign_volumed_assign_history'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  job_title_id: Scalars['String']['output']
  project_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  visible: Scalars['Boolean']['output']
}

/** aggregated selection of "coassign.volumed_assign_history" */
export type Coassign_Volumed_Assign_History_Aggregate = {
  __typename?: 'coassign_volumed_assign_history_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_History_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_History>
}

/** aggregate fields of "coassign.volumed_assign_history" */
export type Coassign_Volumed_Assign_History_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_History_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_History_Min_Fields>
}

/** aggregate fields of "coassign.volumed_assign_history" */
export type Coassign_Volumed_Assign_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_history". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_History_Bool_Exp>>
  comment?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  icon?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  job_title_id?: InputMaybe<String_Comparison_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  visible?: InputMaybe<Boolean_Comparison_Exp>
}

/** input type for inserting data into table "coassign.volumed_assign_history" */
export type Coassign_Volumed_Assign_History_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_History_Max_Fields = {
  __typename?: 'coassign_volumed_assign_history_max_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_History_Min_Fields = {
  __typename?: 'coassign_volumed_assign_history_min_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "coassign.volumed_assign_history" */
export type Coassign_Volumed_Assign_History_Mutation_Response = {
  __typename?: 'coassign_volumed_assign_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Volumed_Assign_History>
}

/** Ordering options when selecting data from "coassign.volumed_assign_history". */
export type Coassign_Volumed_Assign_History_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  visible?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_history" */
export enum Coassign_Volumed_Assign_History_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "coassign.volumed_assign_history" */
export type Coassign_Volumed_Assign_History_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** Streaming cursor of the table "coassign_volumed_assign_history" */
export type Coassign_Volumed_Assign_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_History_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

export type Coassign_Volumed_Assign_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Volumed_Assign_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Volumed_Assign_History_Bool_Exp
}

/** input type for inserting data into table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title?: InputMaybe<Coassign_Job_Title_Obj_Rel_Insert_Input>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project?: InputMaybe<Coassign_Project_Obj_Rel_Insert_Input>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
  volumed_assign_plans?: InputMaybe<Coassign_Volumed_Assign_Plan_Arr_Rel_Insert_Input>
  volumed_assign_to_department?: InputMaybe<Coassign_Volumed_Assign_To_Department_Arr_Rel_Insert_Input>
  volumed_assign_to_job_skills?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_Max_Fields = {
  __typename?: 'coassign_volumed_assign_max_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Max_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_Min_Fields = {
  __typename?: 'coassign_volumed_assign_min_fields'
  comment?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  job_title_id?: Maybe<Scalars['String']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Min_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title_id?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Mutation_Response = {
  __typename?: 'coassign_volumed_assign_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Volumed_Assign>
}

/** input type for inserting object relation for remote table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Obj_Rel_Insert_Input = {
  data: Coassign_Volumed_Assign_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_On_Conflict>
}

/** on_conflict condition type for table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_On_Conflict = {
  constraint: Coassign_Volumed_Assign_Constraint
  update_columns?: Array<Coassign_Volumed_Assign_Update_Column>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.volumed_assign". */
export type Coassign_Volumed_Assign_Order_By = {
  comment?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  icon?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_title?: InputMaybe<Coassign_Job_Title_Order_By>
  job_title_id?: InputMaybe<Order_By>
  project?: InputMaybe<Coassign_Project_Order_By>
  project_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  visible?: InputMaybe<Order_By>
  volumed_assign_plans_aggregate?: InputMaybe<Coassign_Volumed_Assign_Plan_Aggregate_Order_By>
  volumed_assign_to_department_aggregate?: InputMaybe<Coassign_Volumed_Assign_To_Department_Aggregate_Order_By>
  volumed_assign_to_job_skills_aggregate?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Order_By>
}

/** primary key columns input for table: coassign.volumed_assign */
export type Coassign_Volumed_Assign_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** columns and relationships of "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan = {
  __typename?: 'coassign_volumed_assign_plan'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset: Scalars['Int']['output']
  estimate: Scalars['Int']['output']
  id: Scalars['String']['output']
  start_offset: Scalars['Int']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  volumed_assign_id: Scalars['String']['output']
  /** An object relationship */
  volumed_assign_plan_assign: Coassign_Volumed_Assign
}

/** aggregated selection of "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Aggregate = {
  __typename?: 'coassign_volumed_assign_plan_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_Plan_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_Plan>
}

export type Coassign_Volumed_Assign_Plan_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Volumed_Assign_Plan_Aggregate_Bool_Exp_Count>
}

export type Coassign_Volumed_Assign_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_plan_aggregate_fields'
  avg?: Maybe<Coassign_Volumed_Assign_Plan_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_Plan_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_Plan_Min_Fields>
  stddev?: Maybe<Coassign_Volumed_Assign_Plan_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Volumed_Assign_Plan_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Volumed_Assign_Plan_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Volumed_Assign_Plan_Sum_Fields>
  var_pop?: Maybe<Coassign_Volumed_Assign_Plan_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Volumed_Assign_Plan_Var_Samp_Fields>
  variance?: Maybe<Coassign_Volumed_Assign_Plan_Variance_Fields>
}

/** aggregate fields of "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Aggregate_Order_By = {
  avg?: InputMaybe<Coassign_Volumed_Assign_Plan_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Volumed_Assign_Plan_Max_Order_By>
  min?: InputMaybe<Coassign_Volumed_Assign_Plan_Min_Order_By>
  stddev?: InputMaybe<Coassign_Volumed_Assign_Plan_Stddev_Order_By>
  stddev_pop?: InputMaybe<Coassign_Volumed_Assign_Plan_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Coassign_Volumed_Assign_Plan_Stddev_Samp_Order_By>
  sum?: InputMaybe<Coassign_Volumed_Assign_Plan_Sum_Order_By>
  var_pop?: InputMaybe<Coassign_Volumed_Assign_Plan_Var_Pop_Order_By>
  var_samp?: InputMaybe<Coassign_Volumed_Assign_Plan_Var_Samp_Order_By>
  variance?: InputMaybe<Coassign_Volumed_Assign_Plan_Variance_Order_By>
}

/** input type for inserting array relation for remote table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Volumed_Assign_Plan_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_Plan_On_Conflict>
}

/** aggregate avg on columns */
export type Coassign_Volumed_Assign_Plan_Avg_Fields = {
  __typename?: 'coassign_volumed_assign_plan_avg_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Avg_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_plan". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_Plan_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  end_offset?: InputMaybe<Int_Comparison_Exp>
  estimate?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  start_offset?: InputMaybe<Int_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assign_id?: InputMaybe<String_Comparison_Exp>
  volumed_assign_plan_assign?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

/** unique or primary key constraints on table "coassign.volumed_assign_plan" */
export enum Coassign_Volumed_Assign_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  VolumedAssignPlanPkey = 'volumed_assign_plan_pkey'
}

/** columns and relationships of "coassign.volumed_assign_plan_full_view" */
export type Coassign_Volumed_Assign_Plan_Full_View = {
  __typename?: 'coassign_volumed_assign_plan_full_view'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** aggregated selection of "coassign.volumed_assign_plan_full_view" */
export type Coassign_Volumed_Assign_Plan_Full_View_Aggregate = {
  __typename?: 'coassign_volumed_assign_plan_full_view_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_Plan_Full_View>
}

/** aggregate fields of "coassign.volumed_assign_plan_full_view" */
export type Coassign_Volumed_Assign_Plan_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_aggregate_fields'
  avg?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Min_Fields>
  stddev?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Sum_Fields>
  var_pop?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Var_Samp_Fields>
  variance?: Maybe<Coassign_Volumed_Assign_Plan_Full_View_Variance_Fields>
}

/** aggregate fields of "coassign.volumed_assign_plan_full_view" */
export type Coassign_Volumed_Assign_Plan_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Avg_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_avg_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_plan_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  end_offset?: InputMaybe<Int_Comparison_Exp>
  estimate?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  start_offset?: InputMaybe<Int_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assign_id?: InputMaybe<String_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Max_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Min_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** Ordering options when selecting data from "coassign.volumed_assign_plan_full_view". */
export type Coassign_Volumed_Assign_Plan_Full_View_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_plan_full_view" */
export enum Coassign_Volumed_Assign_Plan_Full_View_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndOffset = 'end_offset',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  Id = 'id',
  /** column name */
  StartOffset = 'start_offset',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

/** aggregate stddev on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Stddev_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_stddev_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Stddev_Pop_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_stddev_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Stddev_Samp_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_stddev_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "coassign_volumed_assign_plan_full_view" */
export type Coassign_Volumed_Assign_Plan_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_Plan_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_Plan_Full_View_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Sum_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_sum_fields'
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
}

/** aggregate var_pop on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Var_Pop_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_var_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Var_Samp_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_var_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Coassign_Volumed_Assign_Plan_Full_View_Variance_Fields = {
  __typename?: 'coassign_volumed_assign_plan_full_view_variance_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "coassign.volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History = {
  __typename?: 'coassign_volumed_assign_plan_history'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset: Scalars['Int']['output']
  estimate: Scalars['Int']['output']
  id: Scalars['String']['output']
  start_offset: Scalars['Int']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  volumed_assign_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History_Aggregate = {
  __typename?: 'coassign_volumed_assign_plan_history_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_Plan_History_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_Plan_History>
}

/** aggregate fields of "coassign.volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_aggregate_fields'
  avg?: Maybe<Coassign_Volumed_Assign_Plan_History_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_Plan_History_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_Plan_History_Min_Fields>
  stddev?: Maybe<Coassign_Volumed_Assign_Plan_History_Stddev_Fields>
  stddev_pop?: Maybe<Coassign_Volumed_Assign_Plan_History_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Coassign_Volumed_Assign_Plan_History_Stddev_Samp_Fields>
  sum?: Maybe<Coassign_Volumed_Assign_Plan_History_Sum_Fields>
  var_pop?: Maybe<Coassign_Volumed_Assign_Plan_History_Var_Pop_Fields>
  var_samp?: Maybe<Coassign_Volumed_Assign_Plan_History_Var_Samp_Fields>
  variance?: Maybe<Coassign_Volumed_Assign_Plan_History_Variance_Fields>
}

/** aggregate fields of "coassign.volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Coassign_Volumed_Assign_Plan_History_Avg_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_avg_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_plan_history". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_Plan_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  end_offset?: InputMaybe<Int_Comparison_Exp>
  estimate?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  start_offset?: InputMaybe<Int_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assign_id?: InputMaybe<String_Comparison_Exp>
}

/** input type for incrementing numeric columns in table "coassign.volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History_Inc_Input = {
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "coassign.volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_Plan_History_Max_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_Plan_History_Min_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "coassign.volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History_Mutation_Response = {
  __typename?: 'coassign_volumed_assign_plan_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Volumed_Assign_Plan_History>
}

/** Ordering options when selecting data from "coassign.volumed_assign_plan_history". */
export type Coassign_Volumed_Assign_Plan_History_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_plan_history" */
export enum Coassign_Volumed_Assign_Plan_History_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndOffset = 'end_offset',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  Id = 'id',
  /** column name */
  StartOffset = 'start_offset',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

/** input type for updating data in table "coassign.volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Volumed_Assign_Plan_History_Stddev_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_stddev_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Coassign_Volumed_Assign_Plan_History_Stddev_Pop_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_stddev_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Coassign_Volumed_Assign_Plan_History_Stddev_Samp_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_stddev_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "coassign_volumed_assign_plan_history" */
export type Coassign_Volumed_Assign_Plan_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_Plan_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_Plan_History_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Coassign_Volumed_Assign_Plan_History_Sum_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_sum_fields'
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
}

export type Coassign_Volumed_Assign_Plan_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Volumed_Assign_Plan_History_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Volumed_Assign_Plan_History_Var_Pop_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_var_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Coassign_Volumed_Assign_Plan_History_Var_Samp_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_var_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Coassign_Volumed_Assign_Plan_History_Variance_Fields = {
  __typename?: 'coassign_volumed_assign_plan_history_variance_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** input type for incrementing numeric columns in table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Inc_Input = {
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
  volumed_assign_plan_assign?: InputMaybe<Coassign_Volumed_Assign_Obj_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_Plan_Max_Fields = {
  __typename?: 'coassign_volumed_assign_plan_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_Plan_Min_Fields = {
  __typename?: 'coassign_volumed_assign_plan_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Mutation_Response = {
  __typename?: 'coassign_volumed_assign_plan_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Volumed_Assign_Plan>
}

/** on_conflict condition type for table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_On_Conflict = {
  constraint: Coassign_Volumed_Assign_Plan_Constraint
  update_columns?: Array<Coassign_Volumed_Assign_Plan_Update_Column>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.volumed_assign_plan". */
export type Coassign_Volumed_Assign_Plan_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
  volumed_assign_plan_assign?: InputMaybe<Coassign_Volumed_Assign_Order_By>
}

/** primary key columns input for table: coassign.volumed_assign_plan */
export type Coassign_Volumed_Assign_Plan_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.volumed_assign_plan" */
export enum Coassign_Volumed_Assign_Plan_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndOffset = 'end_offset',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  Id = 'id',
  /** column name */
  StartOffset = 'start_offset',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

/** input type for updating data in table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Coassign_Volumed_Assign_Plan_Stddev_Fields = {
  __typename?: 'coassign_volumed_assign_plan_stddev_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Stddev_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Coassign_Volumed_Assign_Plan_Stddev_Pop_Fields = {
  __typename?: 'coassign_volumed_assign_plan_stddev_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Stddev_Pop_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Coassign_Volumed_Assign_Plan_Stddev_Samp_Fields = {
  __typename?: 'coassign_volumed_assign_plan_stddev_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Stddev_Samp_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "coassign_volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_Plan_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_Plan_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_offset?: InputMaybe<Scalars['Int']['input']>
  estimate?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  start_offset?: InputMaybe<Scalars['Int']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Coassign_Volumed_Assign_Plan_Sum_Fields = {
  __typename?: 'coassign_volumed_assign_plan_sum_fields'
  end_offset?: Maybe<Scalars['Int']['output']>
  estimate?: Maybe<Scalars['Int']['output']>
  start_offset?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Sum_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** update columns of table "coassign.volumed_assign_plan" */
export enum Coassign_Volumed_Assign_Plan_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndOffset = 'end_offset',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  Id = 'id',
  /** column name */
  StartOffset = 'start_offset',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

export type Coassign_Volumed_Assign_Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coassign_Volumed_Assign_Plan_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Volumed_Assign_Plan_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Volumed_Assign_Plan_Bool_Exp
}

/** aggregate var_pop on columns */
export type Coassign_Volumed_Assign_Plan_Var_Pop_Fields = {
  __typename?: 'coassign_volumed_assign_plan_var_pop_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Var_Pop_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Coassign_Volumed_Assign_Plan_Var_Samp_Fields = {
  __typename?: 'coassign_volumed_assign_plan_var_samp_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Var_Samp_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Coassign_Volumed_Assign_Plan_Variance_Fields = {
  __typename?: 'coassign_volumed_assign_plan_variance_fields'
  end_offset?: Maybe<Scalars['Float']['output']>
  estimate?: Maybe<Scalars['Float']['output']>
  start_offset?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "coassign.volumed_assign_plan" */
export type Coassign_Volumed_Assign_Plan_Variance_Order_By = {
  end_offset?: InputMaybe<Order_By>
  estimate?: InputMaybe<Order_By>
  start_offset?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign" */
export enum Coassign_Volumed_Assign_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

/** select "coassign_volumed_assign_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coassign.volumed_assign" */
export enum Coassign_Volumed_Assign_Select_Column_Coassign_Volumed_Assign_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Visible = 'visible'
}

/** select "coassign_volumed_assign_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coassign.volumed_assign" */
export enum Coassign_Volumed_Assign_Select_Column_Coassign_Volumed_Assign_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "coassign.volumed_assign" */
export type Coassign_Volumed_Assign_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** Streaming cursor of the table "coassign_volumed_assign" */
export type Coassign_Volumed_Assign_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  job_title_id?: InputMaybe<Scalars['String']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

/** columns and relationships of "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department = {
  __typename?: 'coassign_volumed_assign_to_department'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  department: Coassign_Department
  department_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  volumed_assign: Coassign_Volumed_Assign
  volumed_assign_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Aggregate = {
  __typename?: 'coassign_volumed_assign_to_department_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_To_Department_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_To_Department>
}

export type Coassign_Volumed_Assign_To_Department_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Volumed_Assign_To_Department_Aggregate_Bool_Exp_Count>
}

export type Coassign_Volumed_Assign_To_Department_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_to_department_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_To_Department_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_To_Department_Min_Fields>
}

/** aggregate fields of "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Volumed_Assign_To_Department_Max_Order_By>
  min?: InputMaybe<Coassign_Volumed_Assign_To_Department_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Volumed_Assign_To_Department_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_To_Department_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_to_department". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_To_Department_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  department?: InputMaybe<Coassign_Department_Bool_Exp>
  department_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assign?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
  volumed_assign_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.volumed_assign_to_department" */
export enum Coassign_Volumed_Assign_To_Department_Constraint {
  /** unique or primary key constraint on columns "volumed_assign_id", "department_id" */
  VolumedAssignToDepartmentEnforceSingleNullDeletedAt = 'volumed_assign_to_department_enforce_single_null_deleted_at',
  /** unique or primary key constraint on columns "deleted_at", "volumed_assign_id", "department_id" */
  VolumedAssignToDepartmentUnique = 'volumed_assign_to_department_unique'
}

/** columns and relationships of "coassign.volumed_assign_to_department_history" */
export type Coassign_Volumed_Assign_To_Department_History = {
  __typename?: 'coassign_volumed_assign_to_department_history'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  volumed_assign_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.volumed_assign_to_department_history" */
export type Coassign_Volumed_Assign_To_Department_History_Aggregate = {
  __typename?: 'coassign_volumed_assign_to_department_history_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_To_Department_History_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_To_Department_History>
}

/** aggregate fields of "coassign.volumed_assign_to_department_history" */
export type Coassign_Volumed_Assign_To_Department_History_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_to_department_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_To_Department_History_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_To_Department_History_Min_Fields>
}

/** aggregate fields of "coassign.volumed_assign_to_department_history" */
export type Coassign_Volumed_Assign_To_Department_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_to_department_history". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_To_Department_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_To_Department_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  department_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assign_id?: InputMaybe<String_Comparison_Exp>
}

/** input type for inserting data into table "coassign.volumed_assign_to_department_history" */
export type Coassign_Volumed_Assign_To_Department_History_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_To_Department_History_Max_Fields = {
  __typename?: 'coassign_volumed_assign_to_department_history_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_To_Department_History_Min_Fields = {
  __typename?: 'coassign_volumed_assign_to_department_history_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "coassign.volumed_assign_to_department_history" */
export type Coassign_Volumed_Assign_To_Department_History_Mutation_Response = {
  __typename?: 'coassign_volumed_assign_to_department_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Volumed_Assign_To_Department_History>
}

/** Ordering options when selecting data from "coassign.volumed_assign_to_department_history". */
export type Coassign_Volumed_Assign_To_Department_History_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_to_department_history" */
export enum Coassign_Volumed_Assign_To_Department_History_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

/** input type for updating data in table "coassign.volumed_assign_to_department_history" */
export type Coassign_Volumed_Assign_To_Department_History_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_volumed_assign_to_department_history" */
export type Coassign_Volumed_Assign_To_Department_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_To_Department_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_To_Department_History_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

export type Coassign_Volumed_Assign_To_Department_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Volumed_Assign_To_Department_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Volumed_Assign_To_Department_History_Bool_Exp
}

/** input type for inserting data into table "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department?: InputMaybe<Coassign_Department_Obj_Rel_Insert_Input>
  department_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign?: InputMaybe<Coassign_Volumed_Assign_Obj_Rel_Insert_Input>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_To_Department_Max_Fields = {
  __typename?: 'coassign_volumed_assign_to_department_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_To_Department_Min_Fields = {
  __typename?: 'coassign_volumed_assign_to_department_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  department_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Mutation_Response = {
  __typename?: 'coassign_volumed_assign_to_department_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Volumed_Assign_To_Department>
}

/** on_conflict condition type for table "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_On_Conflict = {
  constraint: Coassign_Volumed_Assign_To_Department_Constraint
  update_columns?: Array<Coassign_Volumed_Assign_To_Department_Update_Column>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.volumed_assign_to_department". */
export type Coassign_Volumed_Assign_To_Department_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  department?: InputMaybe<Coassign_Department_Order_By>
  department_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign?: InputMaybe<Coassign_Volumed_Assign_Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_to_department" */
export enum Coassign_Volumed_Assign_To_Department_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

/** input type for updating data in table "coassign.volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_volumed_assign_to_department" */
export type Coassign_Volumed_Assign_To_Department_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_To_Department_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_To_Department_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  department_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.volumed_assign_to_department" */
export enum Coassign_Volumed_Assign_To_Department_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

export type Coassign_Volumed_Assign_To_Department_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Volumed_Assign_To_Department_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Volumed_Assign_To_Department_Bool_Exp
}

/** columns and relationships of "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill = {
  __typename?: 'coassign_volumed_assign_to_job_skill'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  job_skill: Coassign_Job_Skill
  job_skill_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  volumed_assign: Coassign_Volumed_Assign
  volumed_assign_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Aggregate = {
  __typename?: 'coassign_volumed_assign_to_job_skill_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_To_Job_Skill>
}

export type Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Bool_Exp_Count>
}

export type Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Min_Fields>
}

/** aggregate fields of "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Max_Order_By>
  min?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Volumed_Assign_To_Job_Skill_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_to_job_skill". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  job_skill?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
  job_skill_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assign?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
  volumed_assign_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.volumed_assign_to_job_skill" */
export enum Coassign_Volumed_Assign_To_Job_Skill_Constraint {
  /** unique or primary key constraint on columns "volumed_assign_id", "job_skill_id" */
  VolumedAssignToJobSkillEnforceSingleNullDeletedAt = 'volumed_assign_to_job_skill_enforce_single_null_deleted_at',
  /** unique or primary key constraint on columns "deleted_at", "volumed_assign_id", "job_skill_id" */
  VolumedAssignToJobSkillUnique = 'volumed_assign_to_job_skill_unique'
}

/** columns and relationships of "coassign.volumed_assign_to_job_skill_full_view" */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View = {
  __typename?: 'coassign_volumed_assign_to_job_skill_full_view'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  sys_period?: Maybe<Scalars['tstzrange']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** aggregated selection of "coassign.volumed_assign_to_job_skill_full_view" */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Aggregate = {
  __typename?: 'coassign_volumed_assign_to_job_skill_full_view_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View>
}

/** aggregate fields of "coassign.volumed_assign_to_job_skill_full_view" */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_full_view_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Min_Fields>
}

/** aggregate fields of "coassign.volumed_assign_to_job_skill_full_view" */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_to_job_skill_full_view". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  job_skill_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assign_id?: InputMaybe<String_Comparison_Exp>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Max_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_full_view_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Min_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_full_view_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** Ordering options when selecting data from "coassign.volumed_assign_to_job_skill_full_view". */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_skill_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_to_job_skill_full_view" */
export enum Coassign_Volumed_Assign_To_Job_Skill_Full_View_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  JobSkillId = 'job_skill_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

/** Streaming cursor of the table "coassign_volumed_assign_to_job_skill_full_view" */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_To_Job_Skill_Full_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_To_Job_Skill_Full_View_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.volumed_assign_to_job_skill_history" */
export type Coassign_Volumed_Assign_To_Job_Skill_History = {
  __typename?: 'coassign_volumed_assign_to_job_skill_history'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id: Scalars['String']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  volumed_assign_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.volumed_assign_to_job_skill_history" */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Aggregate = {
  __typename?: 'coassign_volumed_assign_to_job_skill_history_aggregate'
  aggregate?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_History_Aggregate_Fields>
  nodes: Array<Coassign_Volumed_Assign_To_Job_Skill_History>
}

/** aggregate fields of "coassign.volumed_assign_to_job_skill_history" */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Aggregate_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_History_Max_Fields>
  min?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_History_Min_Fields>
}

/** aggregate fields of "coassign.volumed_assign_to_job_skill_history" */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.volumed_assign_to_job_skill_history". All fields are combined with a logical 'AND'. */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp>>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  job_skill_id?: InputMaybe<String_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  volumed_assign_id?: InputMaybe<String_Comparison_Exp>
}

/** input type for inserting data into table "coassign.volumed_assign_to_job_skill_history" */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Max_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_history_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Min_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_history_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "coassign.volumed_assign_to_job_skill_history" */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Mutation_Response = {
  __typename?: 'coassign_volumed_assign_to_job_skill_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Volumed_Assign_To_Job_Skill_History>
}

/** Ordering options when selecting data from "coassign.volumed_assign_to_job_skill_history". */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_skill_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_to_job_skill_history" */
export enum Coassign_Volumed_Assign_To_Job_Skill_History_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  JobSkillId = 'job_skill_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

/** input type for updating data in table "coassign.volumed_assign_to_job_skill_history" */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_volumed_assign_to_job_skill_history" */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_To_Job_Skill_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_To_Job_Skill_History_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

export type Coassign_Volumed_Assign_To_Job_Skill_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp
}

/** input type for inserting data into table "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Insert_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill?: InputMaybe<Coassign_Job_Skill_Obj_Rel_Insert_Input>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign?: InputMaybe<Coassign_Volumed_Assign_Obj_Rel_Insert_Input>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Volumed_Assign_To_Job_Skill_Max_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_max_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Max_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_skill_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Volumed_Assign_To_Job_Skill_Min_Fields = {
  __typename?: 'coassign_volumed_assign_to_job_skill_min_fields'
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  job_skill_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  volumed_assign_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Min_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_skill_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Mutation_Response = {
  __typename?: 'coassign_volumed_assign_to_job_skill_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Volumed_Assign_To_Job_Skill>
}

/** on_conflict condition type for table "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_On_Conflict = {
  constraint: Coassign_Volumed_Assign_To_Job_Skill_Constraint
  update_columns?: Array<Coassign_Volumed_Assign_To_Job_Skill_Update_Column>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.volumed_assign_to_job_skill". */
export type Coassign_Volumed_Assign_To_Job_Skill_Order_By = {
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  job_skill?: InputMaybe<Coassign_Job_Skill_Order_By>
  job_skill_id?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  volumed_assign?: InputMaybe<Coassign_Volumed_Assign_Order_By>
  volumed_assign_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.volumed_assign_to_job_skill" */
export enum Coassign_Volumed_Assign_To_Job_Skill_Select_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  JobSkillId = 'job_skill_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

/** input type for updating data in table "coassign.volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Set_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_volumed_assign_to_job_skill" */
export type Coassign_Volumed_Assign_To_Job_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Volumed_Assign_To_Job_Skill_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Volumed_Assign_To_Job_Skill_Stream_Cursor_Value_Input = {
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  job_skill_id?: InputMaybe<Scalars['String']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  volumed_assign_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.volumed_assign_to_job_skill" */
export enum Coassign_Volumed_Assign_To_Job_Skill_Update_Column {
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  JobSkillId = 'job_skill_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumedAssignId = 'volumed_assign_id'
}

export type Coassign_Volumed_Assign_To_Job_Skill_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp
}

/** update columns of table "coassign.volumed_assign" */
export enum Coassign_Volumed_Assign_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitleId = 'job_title_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

export type Coassign_Volumed_Assign_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Volumed_Assign_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Volumed_Assign_Bool_Exp
}

/** columns and relationships of "coassign.work_on_project" */
export type Coassign_Work_On_Project = {
  __typename?: 'coassign_work_on_project'
  actuals: Scalars['jsonb']['output']
  /** An object relationship */
  assign: Coassign_Assign
  assign_id: Scalars['String']['output']
  comments: Scalars['jsonb']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  month: Scalars['date']['output']
  /** An object relationship */
  project: Coassign_Project
  project_id: Scalars['String']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Coassign_User
  user_id: Scalars['String']['output']
}

/** columns and relationships of "coassign.work_on_project" */
export type Coassign_Work_On_ProjectActualsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "coassign.work_on_project" */
export type Coassign_Work_On_ProjectCommentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "coassign.work_on_project" */
export type Coassign_Work_On_Project_Aggregate = {
  __typename?: 'coassign_work_on_project_aggregate'
  aggregate?: Maybe<Coassign_Work_On_Project_Aggregate_Fields>
  nodes: Array<Coassign_Work_On_Project>
}

export type Coassign_Work_On_Project_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Work_On_Project_Aggregate_Bool_Exp_Count>
}

export type Coassign_Work_On_Project_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.work_on_project" */
export type Coassign_Work_On_Project_Aggregate_Fields = {
  __typename?: 'coassign_work_on_project_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Work_On_Project_Max_Fields>
  min?: Maybe<Coassign_Work_On_Project_Min_Fields>
}

/** aggregate fields of "coassign.work_on_project" */
export type Coassign_Work_On_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.work_on_project" */
export type Coassign_Work_On_Project_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Work_On_Project_Max_Order_By>
  min?: InputMaybe<Coassign_Work_On_Project_Min_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Work_On_Project_Append_Input = {
  actuals?: InputMaybe<Scalars['jsonb']['input']>
  comments?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "coassign.work_on_project" */
export type Coassign_Work_On_Project_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Work_On_Project_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Work_On_Project_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.work_on_project". All fields are combined with a logical 'AND'. */
export type Coassign_Work_On_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Work_On_Project_Bool_Exp>>
  _not?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Work_On_Project_Bool_Exp>>
  actuals?: InputMaybe<Jsonb_Comparison_Exp>
  assign?: InputMaybe<Coassign_Assign_Bool_Exp>
  assign_id?: InputMaybe<String_Comparison_Exp>
  comments?: InputMaybe<Jsonb_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  month?: InputMaybe<Date_Comparison_Exp>
  project?: InputMaybe<Coassign_Project_Bool_Exp>
  project_id?: InputMaybe<String_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Coassign_User_Bool_Exp>
  user_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.work_on_project" */
export enum Coassign_Work_On_Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkOnProjectPkey = 'work_on_project_pkey',
  /** unique or primary key constraint on columns "user_id", "assign_id", "month" */
  WorkOnProjectUserIdAssignIdMonthDeletedAt = 'work_on_project_user_id_assign_id_month_deleted_at'
}

/** columns and relationships of "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract = {
  __typename?: 'coassign_work_on_project_contract'
  attendance_contract_id: Scalars['String']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  signer_id: Scalars['String']['output']
  state: Scalars['contract_states']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  work_on_project_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Aggregate = {
  __typename?: 'coassign_work_on_project_contract_aggregate'
  aggregate?: Maybe<Coassign_Work_On_Project_Contract_Aggregate_Fields>
  nodes: Array<Coassign_Work_On_Project_Contract>
}

export type Coassign_Work_On_Project_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coassign_Work_On_Project_Contract_Aggregate_Bool_Exp_Count>
}

export type Coassign_Work_On_Project_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Aggregate_Fields = {
  __typename?: 'coassign_work_on_project_contract_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Work_On_Project_Contract_Max_Fields>
  min?: Maybe<Coassign_Work_On_Project_Contract_Min_Fields>
}

/** aggregate fields of "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Coassign_Work_On_Project_Contract_Max_Order_By>
  min?: InputMaybe<Coassign_Work_On_Project_Contract_Min_Order_By>
}

/** input type for inserting array relation for remote table "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Arr_Rel_Insert_Input = {
  data: Array<Coassign_Work_On_Project_Contract_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Coassign_Work_On_Project_Contract_On_Conflict>
}

/** Boolean expression to filter rows from the table "coassign.work_on_project_contract". All fields are combined with a logical 'AND'. */
export type Coassign_Work_On_Project_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Bool_Exp>>
  _not?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Bool_Exp>>
  attendance_contract_id?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  signer_id?: InputMaybe<String_Comparison_Exp>
  state?: InputMaybe<Contract_States_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  work_on_project_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "coassign.work_on_project_contract" */
export enum Coassign_Work_On_Project_Contract_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkOnProjectContractPkey = 'work_on_project_contract_pkey',
  /** unique or primary key constraint on columns "work_on_project_id" */
  WorkOnProjectContractWorkOnProjectId = 'work_on_project_contract_work_on_project_id'
}

/** columns and relationships of "coassign.work_on_project_contract_history" */
export type Coassign_Work_On_Project_Contract_History = {
  __typename?: 'coassign_work_on_project_contract_history'
  attendance_contract_id: Scalars['String']['output']
  commit_id?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  signer_id: Scalars['String']['output']
  state: Scalars['contract_states']['output']
  sys_period: Scalars['tstzrange']['output']
  tenant_id: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  work_on_project_id: Scalars['String']['output']
}

/** aggregated selection of "coassign.work_on_project_contract_history" */
export type Coassign_Work_On_Project_Contract_History_Aggregate = {
  __typename?: 'coassign_work_on_project_contract_history_aggregate'
  aggregate?: Maybe<Coassign_Work_On_Project_Contract_History_Aggregate_Fields>
  nodes: Array<Coassign_Work_On_Project_Contract_History>
}

/** aggregate fields of "coassign.work_on_project_contract_history" */
export type Coassign_Work_On_Project_Contract_History_Aggregate_Fields = {
  __typename?: 'coassign_work_on_project_contract_history_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Coassign_Work_On_Project_Contract_History_Max_Fields>
  min?: Maybe<Coassign_Work_On_Project_Contract_History_Min_Fields>
}

/** aggregate fields of "coassign.work_on_project_contract_history" */
export type Coassign_Work_On_Project_Contract_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "coassign.work_on_project_contract_history". All fields are combined with a logical 'AND'. */
export type Coassign_Work_On_Project_Contract_History_Bool_Exp = {
  _and?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Bool_Exp>>
  _not?: InputMaybe<Coassign_Work_On_Project_Contract_History_Bool_Exp>
  _or?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Bool_Exp>>
  attendance_contract_id?: InputMaybe<String_Comparison_Exp>
  commit_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  signer_id?: InputMaybe<String_Comparison_Exp>
  state?: InputMaybe<Contract_States_Comparison_Exp>
  sys_period?: InputMaybe<Tstzrange_Comparison_Exp>
  tenant_id?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  work_on_project_id?: InputMaybe<String_Comparison_Exp>
}

/** input type for inserting data into table "coassign.work_on_project_contract_history" */
export type Coassign_Work_On_Project_Contract_History_Insert_Input = {
  attendance_contract_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  work_on_project_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Work_On_Project_Contract_History_Max_Fields = {
  __typename?: 'coassign_work_on_project_contract_history_max_fields'
  attendance_contract_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  signer_id?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  work_on_project_id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Coassign_Work_On_Project_Contract_History_Min_Fields = {
  __typename?: 'coassign_work_on_project_contract_history_min_fields'
  attendance_contract_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  signer_id?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  work_on_project_id?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "coassign.work_on_project_contract_history" */
export type Coassign_Work_On_Project_Contract_History_Mutation_Response = {
  __typename?: 'coassign_work_on_project_contract_history_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Work_On_Project_Contract_History>
}

/** Ordering options when selecting data from "coassign.work_on_project_contract_history". */
export type Coassign_Work_On_Project_Contract_History_Order_By = {
  attendance_contract_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  signer_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  work_on_project_id?: InputMaybe<Order_By>
}

/** select columns of table "coassign.work_on_project_contract_history" */
export enum Coassign_Work_On_Project_Contract_History_Select_Column {
  /** column name */
  AttendanceContractId = 'attendance_contract_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SignerId = 'signer_id',
  /** column name */
  State = 'state',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOnProjectId = 'work_on_project_id'
}

/** input type for updating data in table "coassign.work_on_project_contract_history" */
export type Coassign_Work_On_Project_Contract_History_Set_Input = {
  attendance_contract_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  work_on_project_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_work_on_project_contract_history" */
export type Coassign_Work_On_Project_Contract_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Work_On_Project_Contract_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Work_On_Project_Contract_History_Stream_Cursor_Value_Input = {
  attendance_contract_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  work_on_project_id?: InputMaybe<Scalars['String']['input']>
}

export type Coassign_Work_On_Project_Contract_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Work_On_Project_Contract_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Work_On_Project_Contract_History_Bool_Exp
}

/** input type for inserting data into table "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Insert_Input = {
  attendance_contract_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  work_on_project_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Work_On_Project_Contract_Max_Fields = {
  __typename?: 'coassign_work_on_project_contract_max_fields'
  attendance_contract_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  signer_id?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  work_on_project_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Max_Order_By = {
  attendance_contract_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  signer_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  work_on_project_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Work_On_Project_Contract_Min_Fields = {
  __typename?: 'coassign_work_on_project_contract_min_fields'
  attendance_contract_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  signer_id?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['contract_states']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  work_on_project_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Min_Order_By = {
  attendance_contract_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  signer_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  work_on_project_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Mutation_Response = {
  __typename?: 'coassign_work_on_project_contract_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Work_On_Project_Contract>
}

/** on_conflict condition type for table "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_On_Conflict = {
  constraint: Coassign_Work_On_Project_Contract_Constraint
  update_columns?: Array<Coassign_Work_On_Project_Contract_Update_Column>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.work_on_project_contract". */
export type Coassign_Work_On_Project_Contract_Order_By = {
  attendance_contract_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  signer_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  sys_period?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  work_on_project_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.work_on_project_contract */
export type Coassign_Work_On_Project_Contract_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "coassign.work_on_project_contract" */
export enum Coassign_Work_On_Project_Contract_Select_Column {
  /** column name */
  AttendanceContractId = 'attendance_contract_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SignerId = 'signer_id',
  /** column name */
  State = 'state',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOnProjectId = 'work_on_project_id'
}

/** input type for updating data in table "coassign.work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Set_Input = {
  attendance_contract_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  work_on_project_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_work_on_project_contract" */
export type Coassign_Work_On_Project_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Work_On_Project_Contract_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Work_On_Project_Contract_Stream_Cursor_Value_Input = {
  attendance_contract_id?: InputMaybe<Scalars['String']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  signer_id?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['contract_states']['input']>
  sys_period?: InputMaybe<Scalars['tstzrange']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  work_on_project_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.work_on_project_contract" */
export enum Coassign_Work_On_Project_Contract_Update_Column {
  /** column name */
  AttendanceContractId = 'attendance_contract_id',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  SignerId = 'signer_id',
  /** column name */
  State = 'state',
  /** column name */
  SysPeriod = 'sys_period',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkOnProjectId = 'work_on_project_id'
}

export type Coassign_Work_On_Project_Contract_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Work_On_Project_Contract_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Work_On_Project_Contract_Bool_Exp
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Coassign_Work_On_Project_Delete_At_Path_Input = {
  actuals?: InputMaybe<Array<Scalars['String']['input']>>
  comments?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Coassign_Work_On_Project_Delete_Elem_Input = {
  actuals?: InputMaybe<Scalars['Int']['input']>
  comments?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Coassign_Work_On_Project_Delete_Key_Input = {
  actuals?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "coassign.work_on_project" */
export type Coassign_Work_On_Project_Insert_Input = {
  actuals?: InputMaybe<Scalars['jsonb']['input']>
  assign?: InputMaybe<Coassign_Assign_Obj_Rel_Insert_Input>
  assign_id?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['jsonb']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  project?: InputMaybe<Coassign_Project_Obj_Rel_Insert_Input>
  project_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Coassign_User_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Coassign_Work_On_Project_Max_Fields = {
  __typename?: 'coassign_work_on_project_max_fields'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  month?: Maybe<Scalars['date']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "coassign.work_on_project" */
export type Coassign_Work_On_Project_Max_Order_By = {
  assign_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Coassign_Work_On_Project_Min_Fields = {
  __typename?: 'coassign_work_on_project_min_fields'
  assign_id?: Maybe<Scalars['String']['output']>
  commit_id?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  deleted_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['String']['output']>
  month?: Maybe<Scalars['date']['output']>
  project_id?: Maybe<Scalars['String']['output']>
  tenant_id?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "coassign.work_on_project" */
export type Coassign_Work_On_Project_Min_Order_By = {
  assign_id?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "coassign.work_on_project" */
export type Coassign_Work_On_Project_Mutation_Response = {
  __typename?: 'coassign_work_on_project_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Coassign_Work_On_Project>
}

/** on_conflict condition type for table "coassign.work_on_project" */
export type Coassign_Work_On_Project_On_Conflict = {
  constraint: Coassign_Work_On_Project_Constraint
  update_columns?: Array<Coassign_Work_On_Project_Update_Column>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

/** Ordering options when selecting data from "coassign.work_on_project". */
export type Coassign_Work_On_Project_Order_By = {
  actuals?: InputMaybe<Order_By>
  assign?: InputMaybe<Coassign_Assign_Order_By>
  assign_id?: InputMaybe<Order_By>
  comments?: InputMaybe<Order_By>
  commit_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  project?: InputMaybe<Coassign_Project_Order_By>
  project_id?: InputMaybe<Order_By>
  tenant_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Coassign_User_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: coassign.work_on_project */
export type Coassign_Work_On_Project_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Coassign_Work_On_Project_Prepend_Input = {
  actuals?: InputMaybe<Scalars['jsonb']['input']>
  comments?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "coassign.work_on_project" */
export enum Coassign_Work_On_Project_Select_Column {
  /** column name */
  Actuals = 'actuals',
  /** column name */
  AssignId = 'assign_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coassign.work_on_project" */
export type Coassign_Work_On_Project_Set_Input = {
  actuals?: InputMaybe<Scalars['jsonb']['input']>
  assign_id?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['jsonb']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "coassign_work_on_project" */
export type Coassign_Work_On_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coassign_Work_On_Project_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Coassign_Work_On_Project_Stream_Cursor_Value_Input = {
  actuals?: InputMaybe<Scalars['jsonb']['input']>
  assign_id?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['jsonb']['input']>
  commit_id?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  month?: InputMaybe<Scalars['date']['input']>
  project_id?: InputMaybe<Scalars['String']['input']>
  tenant_id?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "coassign.work_on_project" */
export enum Coassign_Work_On_Project_Update_Column {
  /** column name */
  Actuals = 'actuals',
  /** column name */
  AssignId = 'assign_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommitId = 'commit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Coassign_Work_On_Project_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Coassign_Work_On_Project_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Coassign_Work_On_Project_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Coassign_Work_On_Project_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Coassign_Work_On_Project_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Coassign_Work_On_Project_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coassign_Work_On_Project_Set_Input>
  /** filter the rows which have to be updated */
  where: Coassign_Work_On_Project_Bool_Exp
}

/** Boolean expression to compare columns of type "contract_locks". All fields are combined with logical 'AND'. */
export type Contract_Locks_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['contract_locks']['input']>
  _gt?: InputMaybe<Scalars['contract_locks']['input']>
  _gte?: InputMaybe<Scalars['contract_locks']['input']>
  _in?: InputMaybe<Array<Scalars['contract_locks']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['contract_locks']['input']>
  _lte?: InputMaybe<Scalars['contract_locks']['input']>
  _neq?: InputMaybe<Scalars['contract_locks']['input']>
  _nin?: InputMaybe<Array<Scalars['contract_locks']['input']>>
}

/** Boolean expression to compare columns of type "contract_states". All fields are combined with logical 'AND'. */
export type Contract_States_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['contract_states']['input']>
  _gt?: InputMaybe<Scalars['contract_states']['input']>
  _gte?: InputMaybe<Scalars['contract_states']['input']>
  _in?: InputMaybe<Array<Scalars['contract_states']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['contract_states']['input']>
  _lte?: InputMaybe<Scalars['contract_states']['input']>
  _neq?: InputMaybe<Scalars['contract_states']['input']>
  _nin?: InputMaybe<Array<Scalars['contract_states']['input']>>
}

/** Boolean expression to compare columns of type "cost_periods". All fields are combined with logical 'AND'. */
export type Cost_Periods_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['cost_periods']['input']>
  _gt?: InputMaybe<Scalars['cost_periods']['input']>
  _gte?: InputMaybe<Scalars['cost_periods']['input']>
  _in?: InputMaybe<Array<Scalars['cost_periods']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['cost_periods']['input']>
  _lte?: InputMaybe<Scalars['cost_periods']['input']>
  _neq?: InputMaybe<Scalars['cost_periods']['input']>
  _nin?: InputMaybe<Array<Scalars['cost_periods']['input']>>
}

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "custom_field_value_types". All fields are combined with logical 'AND'. */
export type Custom_Field_Value_Types_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['custom_field_value_types']['input']>
  _gt?: InputMaybe<Scalars['custom_field_value_types']['input']>
  _gte?: InputMaybe<Scalars['custom_field_value_types']['input']>
  _in?: InputMaybe<Array<Scalars['custom_field_value_types']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['custom_field_value_types']['input']>
  _lte?: InputMaybe<Scalars['custom_field_value_types']['input']>
  _neq?: InputMaybe<Scalars['custom_field_value_types']['input']>
  _nin?: InputMaybe<Array<Scalars['custom_field_value_types']['input']>>
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>
  _gt?: InputMaybe<Scalars['date']['input']>
  _gte?: InputMaybe<Scalars['date']['input']>
  _in?: InputMaybe<Array<Scalars['date']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['date']['input']>
  _lte?: InputMaybe<Scalars['date']['input']>
  _neq?: InputMaybe<Scalars['date']['input']>
  _nin?: InputMaybe<Array<Scalars['date']['input']>>
}

/** Boolean expression to compare columns of type "day_of_week". All fields are combined with logical 'AND'. */
export type Day_Of_Week_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['day_of_week']['input']>
  _gt?: InputMaybe<Scalars['day_of_week']['input']>
  _gte?: InputMaybe<Scalars['day_of_week']['input']>
  _in?: InputMaybe<Array<Scalars['day_of_week']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['day_of_week']['input']>
  _lte?: InputMaybe<Scalars['day_of_week']['input']>
  _neq?: InputMaybe<Scalars['day_of_week']['input']>
  _nin?: InputMaybe<Array<Scalars['day_of_week']['input']>>
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>
  _gt?: InputMaybe<Scalars['float8']['input']>
  _gte?: InputMaybe<Scalars['float8']['input']>
  _in?: InputMaybe<Array<Scalars['float8']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['float8']['input']>
  _lte?: InputMaybe<Scalars['float8']['input']>
  _neq?: InputMaybe<Scalars['float8']['input']>
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>
}

/** Boolean expression to compare columns of type "job_runtime_types". All fields are combined with logical 'AND'. */
export type Job_Runtime_Types_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['job_runtime_types']['input']>
  _gt?: InputMaybe<Scalars['job_runtime_types']['input']>
  _gte?: InputMaybe<Scalars['job_runtime_types']['input']>
  _in?: InputMaybe<Array<Scalars['job_runtime_types']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['job_runtime_types']['input']>
  _lte?: InputMaybe<Scalars['job_runtime_types']['input']>
  _neq?: InputMaybe<Scalars['job_runtime_types']['input']>
  _nin?: InputMaybe<Array<Scalars['job_runtime_types']['input']>>
}

/** Boolean expression to compare columns of type "job_state". All fields are combined with logical 'AND'. */
export type Job_State_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['job_state']['input']>
  _gt?: InputMaybe<Scalars['job_state']['input']>
  _gte?: InputMaybe<Scalars['job_state']['input']>
  _in?: InputMaybe<Array<Scalars['job_state']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['job_state']['input']>
  _lte?: InputMaybe<Scalars['job_state']['input']>
  _neq?: InputMaybe<Scalars['job_state']['input']>
  _nin?: InputMaybe<Array<Scalars['job_state']['input']>>
}

/** Boolean expression to compare columns of type "job_trigger_types". All fields are combined with logical 'AND'. */
export type Job_Trigger_Types_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['job_trigger_types']['input']>
  _gt?: InputMaybe<Scalars['job_trigger_types']['input']>
  _gte?: InputMaybe<Scalars['job_trigger_types']['input']>
  _in?: InputMaybe<Array<Scalars['job_trigger_types']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['job_trigger_types']['input']>
  _lte?: InputMaybe<Scalars['job_trigger_types']['input']>
  _neq?: InputMaybe<Scalars['job_trigger_types']['input']>
  _nin?: InputMaybe<Array<Scalars['job_trigger_types']['input']>>
}

/** Boolean expression to compare columns of type "job_types". All fields are combined with logical 'AND'. */
export type Job_Types_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['job_types']['input']>
  _gt?: InputMaybe<Scalars['job_types']['input']>
  _gte?: InputMaybe<Scalars['job_types']['input']>
  _in?: InputMaybe<Array<Scalars['job_types']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['job_types']['input']>
  _lte?: InputMaybe<Scalars['job_types']['input']>
  _neq?: InputMaybe<Scalars['job_types']['input']>
  _nin?: InputMaybe<Array<Scalars['job_types']['input']>>
}

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>
  _gt?: InputMaybe<Scalars['json']['input']>
  _gte?: InputMaybe<Scalars['json']['input']>
  _in?: InputMaybe<Array<Scalars['json']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['json']['input']>
  _lte?: InputMaybe<Scalars['json']['input']>
  _neq?: InputMaybe<Scalars['json']['input']>
  _nin?: InputMaybe<Array<Scalars['json']['input']>>
}

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>
}

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>
  _eq?: InputMaybe<Scalars['jsonb']['input']>
  _gt?: InputMaybe<Scalars['jsonb']['input']>
  _gte?: InputMaybe<Scalars['jsonb']['input']>
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['jsonb']['input']>
  _lte?: InputMaybe<Scalars['jsonb']['input']>
  _neq?: InputMaybe<Scalars['jsonb']['input']>
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root'
  /** CreateFirebaseUser */
  CreateFirebaseUser?: Maybe<Output>
  /** GenerateJobResultS3Url */
  GenerateJobResultS3Url?: Maybe<GenerateJobResultS3UrlOutput>
  /** GenerateS3UrlForUpload */
  GenerateS3UrlForUpload?: Maybe<GenerateS3UrlForUploadOutput>
  /** ResetMfaUserStatus */
  ResetMfaUserStatus?: Maybe<ResetMfaUserStatusOutput>
  /** TriggerJobById */
  TriggerJobById?: Maybe<TriggerJobByIdOutput>
  /** TriggerJobByName */
  TriggerJobByName?: Maybe<TriggerJobByNameOutput>
  /** UpdateEmailFirebaseUser */
  UpdateEmailFirebaseUser?: Maybe<Output>
  /** UpdateMfaStatus */
  UpdateMfaStatus: Scalars['uuid']['output']
  /** delete data from the table: "coassign.assign" */
  delete_coassign_assign?: Maybe<Coassign_Assign_Mutation_Response>
  /** delete single row from the table: "coassign.assign" */
  delete_coassign_assign_by_pk?: Maybe<Coassign_Assign>
  /** delete data from the table: "coassign.assign_history" */
  delete_coassign_assign_history?: Maybe<Coassign_Assign_History_Mutation_Response>
  /** delete data from the table: "coassign.assign_plan" */
  delete_coassign_assign_plan?: Maybe<Coassign_Assign_Plan_Mutation_Response>
  /** delete single row from the table: "coassign.assign_plan" */
  delete_coassign_assign_plan_by_pk?: Maybe<Coassign_Assign_Plan>
  /** delete data from the table: "coassign.assign_plan_history" */
  delete_coassign_assign_plan_history?: Maybe<Coassign_Assign_Plan_History_Mutation_Response>
  /** delete data from the table: "coassign.attendance" */
  delete_coassign_attendance?: Maybe<Coassign_Attendance_Mutation_Response>
  /** delete single row from the table: "coassign.attendance" */
  delete_coassign_attendance_by_pk?: Maybe<Coassign_Attendance>
  /** delete data from the table: "coassign.attendance_contract" */
  delete_coassign_attendance_contract?: Maybe<Coassign_Attendance_Contract_Mutation_Response>
  /** delete single row from the table: "coassign.attendance_contract" */
  delete_coassign_attendance_contract_by_pk?: Maybe<Coassign_Attendance_Contract>
  /** delete data from the table: "coassign.attendance_contract_history" */
  delete_coassign_attendance_contract_history?: Maybe<Coassign_Attendance_Contract_History_Mutation_Response>
  /** delete data from the table: "coassign.client" */
  delete_coassign_client?: Maybe<Coassign_Client_Mutation_Response>
  /** delete single row from the table: "coassign.client" */
  delete_coassign_client_by_pk?: Maybe<Coassign_Client>
  /** delete data from the table: "coassign.commit" */
  delete_coassign_commit?: Maybe<Coassign_Commit_Mutation_Response>
  /** delete single row from the table: "coassign.commit" */
  delete_coassign_commit_by_pk?: Maybe<Coassign_Commit>
  /** delete data from the table: "coassign.custom_field" */
  delete_coassign_custom_field?: Maybe<Coassign_Custom_Field_Mutation_Response>
  /** delete single row from the table: "coassign.custom_field" */
  delete_coassign_custom_field_by_pk?: Maybe<Coassign_Custom_Field>
  /** delete data from the table: "coassign.custom_field_choice" */
  delete_coassign_custom_field_choice?: Maybe<Coassign_Custom_Field_Choice_Mutation_Response>
  /** delete single row from the table: "coassign.custom_field_choice" */
  delete_coassign_custom_field_choice_by_pk?: Maybe<Coassign_Custom_Field_Choice>
  /** delete data from the table: "coassign.department" */
  delete_coassign_department?: Maybe<Coassign_Department_Mutation_Response>
  /** delete single row from the table: "coassign.department" */
  delete_coassign_department_by_pk?: Maybe<Coassign_Department>
  /** delete data from the table: "coassign.employment" */
  delete_coassign_employment?: Maybe<Coassign_Employment_Mutation_Response>
  /** delete single row from the table: "coassign.employment" */
  delete_coassign_employment_by_pk?: Maybe<Coassign_Employment>
  /** delete data from the table: "coassign.employment_contract" */
  delete_coassign_employment_contract?: Maybe<Coassign_Employment_Contract_Mutation_Response>
  /** delete single row from the table: "coassign.employment_contract" */
  delete_coassign_employment_contract_by_pk?: Maybe<Coassign_Employment_Contract>
  /** delete data from the table: "coassign.holiday" */
  delete_coassign_holiday?: Maybe<Coassign_Holiday_Mutation_Response>
  /** delete single row from the table: "coassign.holiday" */
  delete_coassign_holiday_by_pk?: Maybe<Coassign_Holiday>
  /** delete data from the table: "coassign.job" */
  delete_coassign_job?: Maybe<Coassign_Job_Mutation_Response>
  /** delete single row from the table: "coassign.job" */
  delete_coassign_job_by_pk?: Maybe<Coassign_Job>
  /** delete data from the table: "coassign.job_definition" */
  delete_coassign_job_definition?: Maybe<Coassign_Job_Definition_Mutation_Response>
  /** delete single row from the table: "coassign.job_definition" */
  delete_coassign_job_definition_by_pk?: Maybe<Coassign_Job_Definition>
  /** delete data from the table: "coassign.job_result" */
  delete_coassign_job_result?: Maybe<Coassign_Job_Result_Mutation_Response>
  /** delete single row from the table: "coassign.job_result" */
  delete_coassign_job_result_by_pk?: Maybe<Coassign_Job_Result>
  /** delete data from the table: "coassign.job_skill" */
  delete_coassign_job_skill?: Maybe<Coassign_Job_Skill_Mutation_Response>
  /** delete single row from the table: "coassign.job_skill" */
  delete_coassign_job_skill_by_pk?: Maybe<Coassign_Job_Skill>
  /** delete data from the table: "coassign.job_title" */
  delete_coassign_job_title?: Maybe<Coassign_Job_Title_Mutation_Response>
  /** delete single row from the table: "coassign.job_title" */
  delete_coassign_job_title_by_pk?: Maybe<Coassign_Job_Title>
  /** delete data from the table: "coassign.job_trigger" */
  delete_coassign_job_trigger?: Maybe<Coassign_Job_Trigger_Mutation_Response>
  /** delete single row from the table: "coassign.job_trigger" */
  delete_coassign_job_trigger_by_pk?: Maybe<Coassign_Job_Trigger>
  /** delete data from the table: "coassign.partner" */
  delete_coassign_partner?: Maybe<Coassign_Partner_Mutation_Response>
  /** delete single row from the table: "coassign.partner" */
  delete_coassign_partner_by_pk?: Maybe<Coassign_Partner>
  /** delete data from the table: "coassign.project" */
  delete_coassign_project?: Maybe<Coassign_Project_Mutation_Response>
  /** delete single row from the table: "coassign.project" */
  delete_coassign_project_by_pk?: Maybe<Coassign_Project>
  /** delete data from the table: "coassign.project_history" */
  delete_coassign_project_history?: Maybe<Coassign_Project_History_Mutation_Response>
  /** delete data from the table: "coassign.project_to_department" */
  delete_coassign_project_to_department?: Maybe<Coassign_Project_To_Department_Mutation_Response>
  /** delete data from the table: "coassign.project_to_department_history" */
  delete_coassign_project_to_department_history?: Maybe<Coassign_Project_To_Department_History_Mutation_Response>
  /** delete data from the table: "coassign.project_to_user" */
  delete_coassign_project_to_user?: Maybe<Coassign_Project_To_User_Mutation_Response>
  /** delete data from the table: "coassign.project_to_user_history" */
  delete_coassign_project_to_user_history?: Maybe<Coassign_Project_To_User_History_Mutation_Response>
  /** delete data from the table: "coassign.regular_holiday" */
  delete_coassign_regular_holiday?: Maybe<Coassign_Regular_Holiday_Mutation_Response>
  /** delete single row from the table: "coassign.regular_holiday" */
  delete_coassign_regular_holiday_by_pk?: Maybe<Coassign_Regular_Holiday>
  /** delete data from the table: "coassign.target_cost_other" */
  delete_coassign_target_cost_other?: Maybe<Coassign_Target_Cost_Other_Mutation_Response>
  /** delete data from the table: "coassign.target_cost_other_actual" */
  delete_coassign_target_cost_other_actual?: Maybe<Coassign_Target_Cost_Other_Actual_Mutation_Response>
  /** delete single row from the table: "coassign.target_cost_other_actual" */
  delete_coassign_target_cost_other_actual_by_pk?: Maybe<Coassign_Target_Cost_Other_Actual>
  /** delete single row from the table: "coassign.target_cost_other" */
  delete_coassign_target_cost_other_by_pk?: Maybe<Coassign_Target_Cost_Other>
  /** delete data from the table: "coassign.target_cost_other_history" */
  delete_coassign_target_cost_other_history?: Maybe<Coassign_Target_Cost_Other_History_Mutation_Response>
  /** delete data from the table: "coassign.tenant" */
  delete_coassign_tenant?: Maybe<Coassign_Tenant_Mutation_Response>
  /** delete single row from the table: "coassign.tenant" */
  delete_coassign_tenant_by_pk?: Maybe<Coassign_Tenant>
  /** delete data from the table: "coassign.user" */
  delete_coassign_user?: Maybe<Coassign_User_Mutation_Response>
  /** delete single row from the table: "coassign.user" */
  delete_coassign_user_by_pk?: Maybe<Coassign_User>
  /** delete data from the table: "coassign.user_to_department" */
  delete_coassign_user_to_department?: Maybe<Coassign_User_To_Department_Mutation_Response>
  /** delete data from the table: "coassign.user_to_job_skill" */
  delete_coassign_user_to_job_skill?: Maybe<Coassign_User_To_Job_Skill_Mutation_Response>
  /** delete data from the table: "coassign.user_to_job_title" */
  delete_coassign_user_to_job_title?: Maybe<Coassign_User_To_Job_Title_Mutation_Response>
  /** delete data from the table: "coassign.volumed_assign" */
  delete_coassign_volumed_assign?: Maybe<Coassign_Volumed_Assign_Mutation_Response>
  /** delete single row from the table: "coassign.volumed_assign" */
  delete_coassign_volumed_assign_by_pk?: Maybe<Coassign_Volumed_Assign>
  /** delete data from the table: "coassign.volumed_assign_history" */
  delete_coassign_volumed_assign_history?: Maybe<Coassign_Volumed_Assign_History_Mutation_Response>
  /** delete data from the table: "coassign.volumed_assign_plan" */
  delete_coassign_volumed_assign_plan?: Maybe<Coassign_Volumed_Assign_Plan_Mutation_Response>
  /** delete single row from the table: "coassign.volumed_assign_plan" */
  delete_coassign_volumed_assign_plan_by_pk?: Maybe<Coassign_Volumed_Assign_Plan>
  /** delete data from the table: "coassign.volumed_assign_plan_history" */
  delete_coassign_volumed_assign_plan_history?: Maybe<Coassign_Volumed_Assign_Plan_History_Mutation_Response>
  /** delete data from the table: "coassign.volumed_assign_to_department" */
  delete_coassign_volumed_assign_to_department?: Maybe<Coassign_Volumed_Assign_To_Department_Mutation_Response>
  /** delete data from the table: "coassign.volumed_assign_to_department_history" */
  delete_coassign_volumed_assign_to_department_history?: Maybe<Coassign_Volumed_Assign_To_Department_History_Mutation_Response>
  /** delete data from the table: "coassign.volumed_assign_to_job_skill" */
  delete_coassign_volumed_assign_to_job_skill?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Mutation_Response>
  /** delete data from the table: "coassign.volumed_assign_to_job_skill_history" */
  delete_coassign_volumed_assign_to_job_skill_history?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_History_Mutation_Response>
  /** delete data from the table: "coassign.work_on_project" */
  delete_coassign_work_on_project?: Maybe<Coassign_Work_On_Project_Mutation_Response>
  /** delete single row from the table: "coassign.work_on_project" */
  delete_coassign_work_on_project_by_pk?: Maybe<Coassign_Work_On_Project>
  /** delete data from the table: "coassign.work_on_project_contract" */
  delete_coassign_work_on_project_contract?: Maybe<Coassign_Work_On_Project_Contract_Mutation_Response>
  /** delete single row from the table: "coassign.work_on_project_contract" */
  delete_coassign_work_on_project_contract_by_pk?: Maybe<Coassign_Work_On_Project_Contract>
  /** delete data from the table: "coassign.work_on_project_contract_history" */
  delete_coassign_work_on_project_contract_history?: Maybe<Coassign_Work_On_Project_Contract_History_Mutation_Response>
  /** insert data into the table: "coassign.assign" */
  insert_coassign_assign?: Maybe<Coassign_Assign_Mutation_Response>
  /** insert data into the table: "coassign.assign_history" */
  insert_coassign_assign_history?: Maybe<Coassign_Assign_History_Mutation_Response>
  /** insert a single row into the table: "coassign.assign_history" */
  insert_coassign_assign_history_one?: Maybe<Coassign_Assign_History>
  /** insert a single row into the table: "coassign.assign" */
  insert_coassign_assign_one?: Maybe<Coassign_Assign>
  /** insert data into the table: "coassign.assign_plan" */
  insert_coassign_assign_plan?: Maybe<Coassign_Assign_Plan_Mutation_Response>
  /** insert data into the table: "coassign.assign_plan_history" */
  insert_coassign_assign_plan_history?: Maybe<Coassign_Assign_Plan_History_Mutation_Response>
  /** insert a single row into the table: "coassign.assign_plan_history" */
  insert_coassign_assign_plan_history_one?: Maybe<Coassign_Assign_Plan_History>
  /** insert a single row into the table: "coassign.assign_plan" */
  insert_coassign_assign_plan_one?: Maybe<Coassign_Assign_Plan>
  /** insert data into the table: "coassign.attendance" */
  insert_coassign_attendance?: Maybe<Coassign_Attendance_Mutation_Response>
  /** insert data into the table: "coassign.attendance_contract" */
  insert_coassign_attendance_contract?: Maybe<Coassign_Attendance_Contract_Mutation_Response>
  /** insert data into the table: "coassign.attendance_contract_history" */
  insert_coassign_attendance_contract_history?: Maybe<Coassign_Attendance_Contract_History_Mutation_Response>
  /** insert a single row into the table: "coassign.attendance_contract_history" */
  insert_coassign_attendance_contract_history_one?: Maybe<Coassign_Attendance_Contract_History>
  /** insert a single row into the table: "coassign.attendance_contract" */
  insert_coassign_attendance_contract_one?: Maybe<Coassign_Attendance_Contract>
  /** insert a single row into the table: "coassign.attendance" */
  insert_coassign_attendance_one?: Maybe<Coassign_Attendance>
  /** insert data into the table: "coassign.client" */
  insert_coassign_client?: Maybe<Coassign_Client_Mutation_Response>
  /** insert a single row into the table: "coassign.client" */
  insert_coassign_client_one?: Maybe<Coassign_Client>
  /** insert data into the table: "coassign.commit" */
  insert_coassign_commit?: Maybe<Coassign_Commit_Mutation_Response>
  /** insert a single row into the table: "coassign.commit" */
  insert_coassign_commit_one?: Maybe<Coassign_Commit>
  /** insert data into the table: "coassign.custom_field" */
  insert_coassign_custom_field?: Maybe<Coassign_Custom_Field_Mutation_Response>
  /** insert data into the table: "coassign.custom_field_choice" */
  insert_coassign_custom_field_choice?: Maybe<Coassign_Custom_Field_Choice_Mutation_Response>
  /** insert a single row into the table: "coassign.custom_field_choice" */
  insert_coassign_custom_field_choice_one?: Maybe<Coassign_Custom_Field_Choice>
  /** insert a single row into the table: "coassign.custom_field" */
  insert_coassign_custom_field_one?: Maybe<Coassign_Custom_Field>
  /** insert data into the table: "coassign.department" */
  insert_coassign_department?: Maybe<Coassign_Department_Mutation_Response>
  /** insert a single row into the table: "coassign.department" */
  insert_coassign_department_one?: Maybe<Coassign_Department>
  /** insert data into the table: "coassign.employment" */
  insert_coassign_employment?: Maybe<Coassign_Employment_Mutation_Response>
  /** insert data into the table: "coassign.employment_contract" */
  insert_coassign_employment_contract?: Maybe<Coassign_Employment_Contract_Mutation_Response>
  /** insert a single row into the table: "coassign.employment_contract" */
  insert_coassign_employment_contract_one?: Maybe<Coassign_Employment_Contract>
  /** insert a single row into the table: "coassign.employment" */
  insert_coassign_employment_one?: Maybe<Coassign_Employment>
  /** insert data into the table: "coassign.holiday" */
  insert_coassign_holiday?: Maybe<Coassign_Holiday_Mutation_Response>
  /** insert a single row into the table: "coassign.holiday" */
  insert_coassign_holiday_one?: Maybe<Coassign_Holiday>
  /** insert data into the table: "coassign.job" */
  insert_coassign_job?: Maybe<Coassign_Job_Mutation_Response>
  /** insert data into the table: "coassign.job_definition" */
  insert_coassign_job_definition?: Maybe<Coassign_Job_Definition_Mutation_Response>
  /** insert a single row into the table: "coassign.job_definition" */
  insert_coassign_job_definition_one?: Maybe<Coassign_Job_Definition>
  /** insert a single row into the table: "coassign.job" */
  insert_coassign_job_one?: Maybe<Coassign_Job>
  /** insert data into the table: "coassign.job_result" */
  insert_coassign_job_result?: Maybe<Coassign_Job_Result_Mutation_Response>
  /** insert a single row into the table: "coassign.job_result" */
  insert_coassign_job_result_one?: Maybe<Coassign_Job_Result>
  /** insert data into the table: "coassign.job_skill" */
  insert_coassign_job_skill?: Maybe<Coassign_Job_Skill_Mutation_Response>
  /** insert a single row into the table: "coassign.job_skill" */
  insert_coassign_job_skill_one?: Maybe<Coassign_Job_Skill>
  /** insert data into the table: "coassign.job_title" */
  insert_coassign_job_title?: Maybe<Coassign_Job_Title_Mutation_Response>
  /** insert a single row into the table: "coassign.job_title" */
  insert_coassign_job_title_one?: Maybe<Coassign_Job_Title>
  /** insert data into the table: "coassign.job_trigger" */
  insert_coassign_job_trigger?: Maybe<Coassign_Job_Trigger_Mutation_Response>
  /** insert a single row into the table: "coassign.job_trigger" */
  insert_coassign_job_trigger_one?: Maybe<Coassign_Job_Trigger>
  /** insert data into the table: "coassign.partner" */
  insert_coassign_partner?: Maybe<Coassign_Partner_Mutation_Response>
  /** insert a single row into the table: "coassign.partner" */
  insert_coassign_partner_one?: Maybe<Coassign_Partner>
  /** insert data into the table: "coassign.project" */
  insert_coassign_project?: Maybe<Coassign_Project_Mutation_Response>
  /** insert data into the table: "coassign.project_history" */
  insert_coassign_project_history?: Maybe<Coassign_Project_History_Mutation_Response>
  /** insert a single row into the table: "coassign.project_history" */
  insert_coassign_project_history_one?: Maybe<Coassign_Project_History>
  /** insert a single row into the table: "coassign.project" */
  insert_coassign_project_one?: Maybe<Coassign_Project>
  /** insert data into the table: "coassign.project_to_department" */
  insert_coassign_project_to_department?: Maybe<Coassign_Project_To_Department_Mutation_Response>
  /** insert data into the table: "coassign.project_to_department_history" */
  insert_coassign_project_to_department_history?: Maybe<Coassign_Project_To_Department_History_Mutation_Response>
  /** insert a single row into the table: "coassign.project_to_department_history" */
  insert_coassign_project_to_department_history_one?: Maybe<Coassign_Project_To_Department_History>
  /** insert a single row into the table: "coassign.project_to_department" */
  insert_coassign_project_to_department_one?: Maybe<Coassign_Project_To_Department>
  /** insert data into the table: "coassign.project_to_user" */
  insert_coassign_project_to_user?: Maybe<Coassign_Project_To_User_Mutation_Response>
  /** insert data into the table: "coassign.project_to_user_history" */
  insert_coassign_project_to_user_history?: Maybe<Coassign_Project_To_User_History_Mutation_Response>
  /** insert a single row into the table: "coassign.project_to_user_history" */
  insert_coassign_project_to_user_history_one?: Maybe<Coassign_Project_To_User_History>
  /** insert a single row into the table: "coassign.project_to_user" */
  insert_coassign_project_to_user_one?: Maybe<Coassign_Project_To_User>
  /** insert data into the table: "coassign.regular_holiday" */
  insert_coassign_regular_holiday?: Maybe<Coassign_Regular_Holiday_Mutation_Response>
  /** insert a single row into the table: "coassign.regular_holiday" */
  insert_coassign_regular_holiday_one?: Maybe<Coassign_Regular_Holiday>
  /** insert data into the table: "coassign.target_cost_other" */
  insert_coassign_target_cost_other?: Maybe<Coassign_Target_Cost_Other_Mutation_Response>
  /** insert data into the table: "coassign.target_cost_other_actual" */
  insert_coassign_target_cost_other_actual?: Maybe<Coassign_Target_Cost_Other_Actual_Mutation_Response>
  /** insert a single row into the table: "coassign.target_cost_other_actual" */
  insert_coassign_target_cost_other_actual_one?: Maybe<Coassign_Target_Cost_Other_Actual>
  /** insert data into the table: "coassign.target_cost_other_history" */
  insert_coassign_target_cost_other_history?: Maybe<Coassign_Target_Cost_Other_History_Mutation_Response>
  /** insert a single row into the table: "coassign.target_cost_other_history" */
  insert_coassign_target_cost_other_history_one?: Maybe<Coassign_Target_Cost_Other_History>
  /** insert a single row into the table: "coassign.target_cost_other" */
  insert_coassign_target_cost_other_one?: Maybe<Coassign_Target_Cost_Other>
  /** insert data into the table: "coassign.tenant" */
  insert_coassign_tenant?: Maybe<Coassign_Tenant_Mutation_Response>
  /** insert a single row into the table: "coassign.tenant" */
  insert_coassign_tenant_one?: Maybe<Coassign_Tenant>
  /** insert data into the table: "coassign.user" */
  insert_coassign_user?: Maybe<Coassign_User_Mutation_Response>
  /** insert a single row into the table: "coassign.user" */
  insert_coassign_user_one?: Maybe<Coassign_User>
  /** insert data into the table: "coassign.user_to_department" */
  insert_coassign_user_to_department?: Maybe<Coassign_User_To_Department_Mutation_Response>
  /** insert a single row into the table: "coassign.user_to_department" */
  insert_coassign_user_to_department_one?: Maybe<Coassign_User_To_Department>
  /** insert data into the table: "coassign.user_to_job_skill" */
  insert_coassign_user_to_job_skill?: Maybe<Coassign_User_To_Job_Skill_Mutation_Response>
  /** insert a single row into the table: "coassign.user_to_job_skill" */
  insert_coassign_user_to_job_skill_one?: Maybe<Coassign_User_To_Job_Skill>
  /** insert data into the table: "coassign.user_to_job_title" */
  insert_coassign_user_to_job_title?: Maybe<Coassign_User_To_Job_Title_Mutation_Response>
  /** insert a single row into the table: "coassign.user_to_job_title" */
  insert_coassign_user_to_job_title_one?: Maybe<Coassign_User_To_Job_Title>
  /** insert data into the table: "coassign.volumed_assign" */
  insert_coassign_volumed_assign?: Maybe<Coassign_Volumed_Assign_Mutation_Response>
  /** insert data into the table: "coassign.volumed_assign_history" */
  insert_coassign_volumed_assign_history?: Maybe<Coassign_Volumed_Assign_History_Mutation_Response>
  /** insert a single row into the table: "coassign.volumed_assign_history" */
  insert_coassign_volumed_assign_history_one?: Maybe<Coassign_Volumed_Assign_History>
  /** insert a single row into the table: "coassign.volumed_assign" */
  insert_coassign_volumed_assign_one?: Maybe<Coassign_Volumed_Assign>
  /** insert data into the table: "coassign.volumed_assign_plan" */
  insert_coassign_volumed_assign_plan?: Maybe<Coassign_Volumed_Assign_Plan_Mutation_Response>
  /** insert data into the table: "coassign.volumed_assign_plan_history" */
  insert_coassign_volumed_assign_plan_history?: Maybe<Coassign_Volumed_Assign_Plan_History_Mutation_Response>
  /** insert a single row into the table: "coassign.volumed_assign_plan_history" */
  insert_coassign_volumed_assign_plan_history_one?: Maybe<Coassign_Volumed_Assign_Plan_History>
  /** insert a single row into the table: "coassign.volumed_assign_plan" */
  insert_coassign_volumed_assign_plan_one?: Maybe<Coassign_Volumed_Assign_Plan>
  /** insert data into the table: "coassign.volumed_assign_to_department" */
  insert_coassign_volumed_assign_to_department?: Maybe<Coassign_Volumed_Assign_To_Department_Mutation_Response>
  /** insert data into the table: "coassign.volumed_assign_to_department_history" */
  insert_coassign_volumed_assign_to_department_history?: Maybe<Coassign_Volumed_Assign_To_Department_History_Mutation_Response>
  /** insert a single row into the table: "coassign.volumed_assign_to_department_history" */
  insert_coassign_volumed_assign_to_department_history_one?: Maybe<Coassign_Volumed_Assign_To_Department_History>
  /** insert a single row into the table: "coassign.volumed_assign_to_department" */
  insert_coassign_volumed_assign_to_department_one?: Maybe<Coassign_Volumed_Assign_To_Department>
  /** insert data into the table: "coassign.volumed_assign_to_job_skill" */
  insert_coassign_volumed_assign_to_job_skill?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Mutation_Response>
  /** insert data into the table: "coassign.volumed_assign_to_job_skill_history" */
  insert_coassign_volumed_assign_to_job_skill_history?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_History_Mutation_Response>
  /** insert a single row into the table: "coassign.volumed_assign_to_job_skill_history" */
  insert_coassign_volumed_assign_to_job_skill_history_one?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_History>
  /** insert a single row into the table: "coassign.volumed_assign_to_job_skill" */
  insert_coassign_volumed_assign_to_job_skill_one?: Maybe<Coassign_Volumed_Assign_To_Job_Skill>
  /** insert data into the table: "coassign.work_on_project" */
  insert_coassign_work_on_project?: Maybe<Coassign_Work_On_Project_Mutation_Response>
  /** insert data into the table: "coassign.work_on_project_contract" */
  insert_coassign_work_on_project_contract?: Maybe<Coassign_Work_On_Project_Contract_Mutation_Response>
  /** insert data into the table: "coassign.work_on_project_contract_history" */
  insert_coassign_work_on_project_contract_history?: Maybe<Coassign_Work_On_Project_Contract_History_Mutation_Response>
  /** insert a single row into the table: "coassign.work_on_project_contract_history" */
  insert_coassign_work_on_project_contract_history_one?: Maybe<Coassign_Work_On_Project_Contract_History>
  /** insert a single row into the table: "coassign.work_on_project_contract" */
  insert_coassign_work_on_project_contract_one?: Maybe<Coassign_Work_On_Project_Contract>
  /** insert a single row into the table: "coassign.work_on_project" */
  insert_coassign_work_on_project_one?: Maybe<Coassign_Work_On_Project>
  /** update data of the table: "coassign.assign" */
  update_coassign_assign?: Maybe<Coassign_Assign_Mutation_Response>
  /** update single row of the table: "coassign.assign" */
  update_coassign_assign_by_pk?: Maybe<Coassign_Assign>
  /** update data of the table: "coassign.assign_history" */
  update_coassign_assign_history?: Maybe<Coassign_Assign_History_Mutation_Response>
  /** update multiples rows of table: "coassign.assign_history" */
  update_coassign_assign_history_many?: Maybe<
    Array<Maybe<Coassign_Assign_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.assign" */
  update_coassign_assign_many?: Maybe<Array<Maybe<Coassign_Assign_Mutation_Response>>>
  /** update data of the table: "coassign.assign_plan" */
  update_coassign_assign_plan?: Maybe<Coassign_Assign_Plan_Mutation_Response>
  /** update single row of the table: "coassign.assign_plan" */
  update_coassign_assign_plan_by_pk?: Maybe<Coassign_Assign_Plan>
  /** update data of the table: "coassign.assign_plan_history" */
  update_coassign_assign_plan_history?: Maybe<Coassign_Assign_Plan_History_Mutation_Response>
  /** update multiples rows of table: "coassign.assign_plan_history" */
  update_coassign_assign_plan_history_many?: Maybe<
    Array<Maybe<Coassign_Assign_Plan_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.assign_plan" */
  update_coassign_assign_plan_many?: Maybe<Array<Maybe<Coassign_Assign_Plan_Mutation_Response>>>
  /** update data of the table: "coassign.attendance" */
  update_coassign_attendance?: Maybe<Coassign_Attendance_Mutation_Response>
  /** update single row of the table: "coassign.attendance" */
  update_coassign_attendance_by_pk?: Maybe<Coassign_Attendance>
  /** update data of the table: "coassign.attendance_contract" */
  update_coassign_attendance_contract?: Maybe<Coassign_Attendance_Contract_Mutation_Response>
  /** update single row of the table: "coassign.attendance_contract" */
  update_coassign_attendance_contract_by_pk?: Maybe<Coassign_Attendance_Contract>
  /** update data of the table: "coassign.attendance_contract_history" */
  update_coassign_attendance_contract_history?: Maybe<Coassign_Attendance_Contract_History_Mutation_Response>
  /** update multiples rows of table: "coassign.attendance_contract_history" */
  update_coassign_attendance_contract_history_many?: Maybe<
    Array<Maybe<Coassign_Attendance_Contract_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.attendance_contract" */
  update_coassign_attendance_contract_many?: Maybe<
    Array<Maybe<Coassign_Attendance_Contract_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.attendance" */
  update_coassign_attendance_many?: Maybe<Array<Maybe<Coassign_Attendance_Mutation_Response>>>
  /** update data of the table: "coassign.client" */
  update_coassign_client?: Maybe<Coassign_Client_Mutation_Response>
  /** update single row of the table: "coassign.client" */
  update_coassign_client_by_pk?: Maybe<Coassign_Client>
  /** update multiples rows of table: "coassign.client" */
  update_coassign_client_many?: Maybe<Array<Maybe<Coassign_Client_Mutation_Response>>>
  /** update data of the table: "coassign.commit" */
  update_coassign_commit?: Maybe<Coassign_Commit_Mutation_Response>
  /** update single row of the table: "coassign.commit" */
  update_coassign_commit_by_pk?: Maybe<Coassign_Commit>
  /** update multiples rows of table: "coassign.commit" */
  update_coassign_commit_many?: Maybe<Array<Maybe<Coassign_Commit_Mutation_Response>>>
  /** update data of the table: "coassign.custom_field" */
  update_coassign_custom_field?: Maybe<Coassign_Custom_Field_Mutation_Response>
  /** update single row of the table: "coassign.custom_field" */
  update_coassign_custom_field_by_pk?: Maybe<Coassign_Custom_Field>
  /** update data of the table: "coassign.custom_field_choice" */
  update_coassign_custom_field_choice?: Maybe<Coassign_Custom_Field_Choice_Mutation_Response>
  /** update single row of the table: "coassign.custom_field_choice" */
  update_coassign_custom_field_choice_by_pk?: Maybe<Coassign_Custom_Field_Choice>
  /** update multiples rows of table: "coassign.custom_field_choice" */
  update_coassign_custom_field_choice_many?: Maybe<
    Array<Maybe<Coassign_Custom_Field_Choice_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.custom_field" */
  update_coassign_custom_field_many?: Maybe<Array<Maybe<Coassign_Custom_Field_Mutation_Response>>>
  /** update data of the table: "coassign.department" */
  update_coassign_department?: Maybe<Coassign_Department_Mutation_Response>
  /** update single row of the table: "coassign.department" */
  update_coassign_department_by_pk?: Maybe<Coassign_Department>
  /** update multiples rows of table: "coassign.department" */
  update_coassign_department_many?: Maybe<Array<Maybe<Coassign_Department_Mutation_Response>>>
  /** update data of the table: "coassign.employment" */
  update_coassign_employment?: Maybe<Coassign_Employment_Mutation_Response>
  /** update single row of the table: "coassign.employment" */
  update_coassign_employment_by_pk?: Maybe<Coassign_Employment>
  /** update data of the table: "coassign.employment_contract" */
  update_coassign_employment_contract?: Maybe<Coassign_Employment_Contract_Mutation_Response>
  /** update single row of the table: "coassign.employment_contract" */
  update_coassign_employment_contract_by_pk?: Maybe<Coassign_Employment_Contract>
  /** update multiples rows of table: "coassign.employment_contract" */
  update_coassign_employment_contract_many?: Maybe<
    Array<Maybe<Coassign_Employment_Contract_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.employment" */
  update_coassign_employment_many?: Maybe<Array<Maybe<Coassign_Employment_Mutation_Response>>>
  /** update data of the table: "coassign.holiday" */
  update_coassign_holiday?: Maybe<Coassign_Holiday_Mutation_Response>
  /** update single row of the table: "coassign.holiday" */
  update_coassign_holiday_by_pk?: Maybe<Coassign_Holiday>
  /** update multiples rows of table: "coassign.holiday" */
  update_coassign_holiday_many?: Maybe<Array<Maybe<Coassign_Holiday_Mutation_Response>>>
  /** update data of the table: "coassign.job" */
  update_coassign_job?: Maybe<Coassign_Job_Mutation_Response>
  /** update single row of the table: "coassign.job" */
  update_coassign_job_by_pk?: Maybe<Coassign_Job>
  /** update data of the table: "coassign.job_definition" */
  update_coassign_job_definition?: Maybe<Coassign_Job_Definition_Mutation_Response>
  /** update single row of the table: "coassign.job_definition" */
  update_coassign_job_definition_by_pk?: Maybe<Coassign_Job_Definition>
  /** update multiples rows of table: "coassign.job_definition" */
  update_coassign_job_definition_many?: Maybe<
    Array<Maybe<Coassign_Job_Definition_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.job" */
  update_coassign_job_many?: Maybe<Array<Maybe<Coassign_Job_Mutation_Response>>>
  /** update data of the table: "coassign.job_result" */
  update_coassign_job_result?: Maybe<Coassign_Job_Result_Mutation_Response>
  /** update single row of the table: "coassign.job_result" */
  update_coassign_job_result_by_pk?: Maybe<Coassign_Job_Result>
  /** update multiples rows of table: "coassign.job_result" */
  update_coassign_job_result_many?: Maybe<Array<Maybe<Coassign_Job_Result_Mutation_Response>>>
  /** update data of the table: "coassign.job_skill" */
  update_coassign_job_skill?: Maybe<Coassign_Job_Skill_Mutation_Response>
  /** update single row of the table: "coassign.job_skill" */
  update_coassign_job_skill_by_pk?: Maybe<Coassign_Job_Skill>
  /** update multiples rows of table: "coassign.job_skill" */
  update_coassign_job_skill_many?: Maybe<Array<Maybe<Coassign_Job_Skill_Mutation_Response>>>
  /** update data of the table: "coassign.job_title" */
  update_coassign_job_title?: Maybe<Coassign_Job_Title_Mutation_Response>
  /** update single row of the table: "coassign.job_title" */
  update_coassign_job_title_by_pk?: Maybe<Coassign_Job_Title>
  /** update multiples rows of table: "coassign.job_title" */
  update_coassign_job_title_many?: Maybe<Array<Maybe<Coassign_Job_Title_Mutation_Response>>>
  /** update data of the table: "coassign.job_trigger" */
  update_coassign_job_trigger?: Maybe<Coassign_Job_Trigger_Mutation_Response>
  /** update single row of the table: "coassign.job_trigger" */
  update_coassign_job_trigger_by_pk?: Maybe<Coassign_Job_Trigger>
  /** update multiples rows of table: "coassign.job_trigger" */
  update_coassign_job_trigger_many?: Maybe<Array<Maybe<Coassign_Job_Trigger_Mutation_Response>>>
  /** update data of the table: "coassign.partner" */
  update_coassign_partner?: Maybe<Coassign_Partner_Mutation_Response>
  /** update single row of the table: "coassign.partner" */
  update_coassign_partner_by_pk?: Maybe<Coassign_Partner>
  /** update multiples rows of table: "coassign.partner" */
  update_coassign_partner_many?: Maybe<Array<Maybe<Coassign_Partner_Mutation_Response>>>
  /** update data of the table: "coassign.project" */
  update_coassign_project?: Maybe<Coassign_Project_Mutation_Response>
  /** update single row of the table: "coassign.project" */
  update_coassign_project_by_pk?: Maybe<Coassign_Project>
  /** update data of the table: "coassign.project_history" */
  update_coassign_project_history?: Maybe<Coassign_Project_History_Mutation_Response>
  /** update multiples rows of table: "coassign.project_history" */
  update_coassign_project_history_many?: Maybe<
    Array<Maybe<Coassign_Project_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.project" */
  update_coassign_project_many?: Maybe<Array<Maybe<Coassign_Project_Mutation_Response>>>
  /** update data of the table: "coassign.project_to_department" */
  update_coassign_project_to_department?: Maybe<Coassign_Project_To_Department_Mutation_Response>
  /** update data of the table: "coassign.project_to_department_history" */
  update_coassign_project_to_department_history?: Maybe<Coassign_Project_To_Department_History_Mutation_Response>
  /** update multiples rows of table: "coassign.project_to_department_history" */
  update_coassign_project_to_department_history_many?: Maybe<
    Array<Maybe<Coassign_Project_To_Department_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.project_to_department" */
  update_coassign_project_to_department_many?: Maybe<
    Array<Maybe<Coassign_Project_To_Department_Mutation_Response>>
  >
  /** update data of the table: "coassign.project_to_user" */
  update_coassign_project_to_user?: Maybe<Coassign_Project_To_User_Mutation_Response>
  /** update data of the table: "coassign.project_to_user_history" */
  update_coassign_project_to_user_history?: Maybe<Coassign_Project_To_User_History_Mutation_Response>
  /** update multiples rows of table: "coassign.project_to_user_history" */
  update_coassign_project_to_user_history_many?: Maybe<
    Array<Maybe<Coassign_Project_To_User_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.project_to_user" */
  update_coassign_project_to_user_many?: Maybe<
    Array<Maybe<Coassign_Project_To_User_Mutation_Response>>
  >
  /** update data of the table: "coassign.regular_holiday" */
  update_coassign_regular_holiday?: Maybe<Coassign_Regular_Holiday_Mutation_Response>
  /** update single row of the table: "coassign.regular_holiday" */
  update_coassign_regular_holiday_by_pk?: Maybe<Coassign_Regular_Holiday>
  /** update multiples rows of table: "coassign.regular_holiday" */
  update_coassign_regular_holiday_many?: Maybe<
    Array<Maybe<Coassign_Regular_Holiday_Mutation_Response>>
  >
  /** update data of the table: "coassign.target_cost_other" */
  update_coassign_target_cost_other?: Maybe<Coassign_Target_Cost_Other_Mutation_Response>
  /** update data of the table: "coassign.target_cost_other_actual" */
  update_coassign_target_cost_other_actual?: Maybe<Coassign_Target_Cost_Other_Actual_Mutation_Response>
  /** update single row of the table: "coassign.target_cost_other_actual" */
  update_coassign_target_cost_other_actual_by_pk?: Maybe<Coassign_Target_Cost_Other_Actual>
  /** update multiples rows of table: "coassign.target_cost_other_actual" */
  update_coassign_target_cost_other_actual_many?: Maybe<
    Array<Maybe<Coassign_Target_Cost_Other_Actual_Mutation_Response>>
  >
  /** update single row of the table: "coassign.target_cost_other" */
  update_coassign_target_cost_other_by_pk?: Maybe<Coassign_Target_Cost_Other>
  /** update data of the table: "coassign.target_cost_other_history" */
  update_coassign_target_cost_other_history?: Maybe<Coassign_Target_Cost_Other_History_Mutation_Response>
  /** update multiples rows of table: "coassign.target_cost_other_history" */
  update_coassign_target_cost_other_history_many?: Maybe<
    Array<Maybe<Coassign_Target_Cost_Other_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.target_cost_other" */
  update_coassign_target_cost_other_many?: Maybe<
    Array<Maybe<Coassign_Target_Cost_Other_Mutation_Response>>
  >
  /** update data of the table: "coassign.tenant" */
  update_coassign_tenant?: Maybe<Coassign_Tenant_Mutation_Response>
  /** update single row of the table: "coassign.tenant" */
  update_coassign_tenant_by_pk?: Maybe<Coassign_Tenant>
  /** update multiples rows of table: "coassign.tenant" */
  update_coassign_tenant_many?: Maybe<Array<Maybe<Coassign_Tenant_Mutation_Response>>>
  /** update data of the table: "coassign.user" */
  update_coassign_user?: Maybe<Coassign_User_Mutation_Response>
  /** update single row of the table: "coassign.user" */
  update_coassign_user_by_pk?: Maybe<Coassign_User>
  /** update multiples rows of table: "coassign.user" */
  update_coassign_user_many?: Maybe<Array<Maybe<Coassign_User_Mutation_Response>>>
  /** update data of the table: "coassign.user_to_department" */
  update_coassign_user_to_department?: Maybe<Coassign_User_To_Department_Mutation_Response>
  /** update multiples rows of table: "coassign.user_to_department" */
  update_coassign_user_to_department_many?: Maybe<
    Array<Maybe<Coassign_User_To_Department_Mutation_Response>>
  >
  /** update data of the table: "coassign.user_to_job_skill" */
  update_coassign_user_to_job_skill?: Maybe<Coassign_User_To_Job_Skill_Mutation_Response>
  /** update multiples rows of table: "coassign.user_to_job_skill" */
  update_coassign_user_to_job_skill_many?: Maybe<
    Array<Maybe<Coassign_User_To_Job_Skill_Mutation_Response>>
  >
  /** update data of the table: "coassign.user_to_job_title" */
  update_coassign_user_to_job_title?: Maybe<Coassign_User_To_Job_Title_Mutation_Response>
  /** update multiples rows of table: "coassign.user_to_job_title" */
  update_coassign_user_to_job_title_many?: Maybe<
    Array<Maybe<Coassign_User_To_Job_Title_Mutation_Response>>
  >
  /** update data of the table: "coassign.volumed_assign" */
  update_coassign_volumed_assign?: Maybe<Coassign_Volumed_Assign_Mutation_Response>
  /** update single row of the table: "coassign.volumed_assign" */
  update_coassign_volumed_assign_by_pk?: Maybe<Coassign_Volumed_Assign>
  /** update data of the table: "coassign.volumed_assign_history" */
  update_coassign_volumed_assign_history?: Maybe<Coassign_Volumed_Assign_History_Mutation_Response>
  /** update multiples rows of table: "coassign.volumed_assign_history" */
  update_coassign_volumed_assign_history_many?: Maybe<
    Array<Maybe<Coassign_Volumed_Assign_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.volumed_assign" */
  update_coassign_volumed_assign_many?: Maybe<
    Array<Maybe<Coassign_Volumed_Assign_Mutation_Response>>
  >
  /** update data of the table: "coassign.volumed_assign_plan" */
  update_coassign_volumed_assign_plan?: Maybe<Coassign_Volumed_Assign_Plan_Mutation_Response>
  /** update single row of the table: "coassign.volumed_assign_plan" */
  update_coassign_volumed_assign_plan_by_pk?: Maybe<Coassign_Volumed_Assign_Plan>
  /** update data of the table: "coassign.volumed_assign_plan_history" */
  update_coassign_volumed_assign_plan_history?: Maybe<Coassign_Volumed_Assign_Plan_History_Mutation_Response>
  /** update multiples rows of table: "coassign.volumed_assign_plan_history" */
  update_coassign_volumed_assign_plan_history_many?: Maybe<
    Array<Maybe<Coassign_Volumed_Assign_Plan_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.volumed_assign_plan" */
  update_coassign_volumed_assign_plan_many?: Maybe<
    Array<Maybe<Coassign_Volumed_Assign_Plan_Mutation_Response>>
  >
  /** update data of the table: "coassign.volumed_assign_to_department" */
  update_coassign_volumed_assign_to_department?: Maybe<Coassign_Volumed_Assign_To_Department_Mutation_Response>
  /** update data of the table: "coassign.volumed_assign_to_department_history" */
  update_coassign_volumed_assign_to_department_history?: Maybe<Coassign_Volumed_Assign_To_Department_History_Mutation_Response>
  /** update multiples rows of table: "coassign.volumed_assign_to_department_history" */
  update_coassign_volumed_assign_to_department_history_many?: Maybe<
    Array<Maybe<Coassign_Volumed_Assign_To_Department_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.volumed_assign_to_department" */
  update_coassign_volumed_assign_to_department_many?: Maybe<
    Array<Maybe<Coassign_Volumed_Assign_To_Department_Mutation_Response>>
  >
  /** update data of the table: "coassign.volumed_assign_to_job_skill" */
  update_coassign_volumed_assign_to_job_skill?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_Mutation_Response>
  /** update data of the table: "coassign.volumed_assign_to_job_skill_history" */
  update_coassign_volumed_assign_to_job_skill_history?: Maybe<Coassign_Volumed_Assign_To_Job_Skill_History_Mutation_Response>
  /** update multiples rows of table: "coassign.volumed_assign_to_job_skill_history" */
  update_coassign_volumed_assign_to_job_skill_history_many?: Maybe<
    Array<Maybe<Coassign_Volumed_Assign_To_Job_Skill_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.volumed_assign_to_job_skill" */
  update_coassign_volumed_assign_to_job_skill_many?: Maybe<
    Array<Maybe<Coassign_Volumed_Assign_To_Job_Skill_Mutation_Response>>
  >
  /** update data of the table: "coassign.work_on_project" */
  update_coassign_work_on_project?: Maybe<Coassign_Work_On_Project_Mutation_Response>
  /** update single row of the table: "coassign.work_on_project" */
  update_coassign_work_on_project_by_pk?: Maybe<Coassign_Work_On_Project>
  /** update data of the table: "coassign.work_on_project_contract" */
  update_coassign_work_on_project_contract?: Maybe<Coassign_Work_On_Project_Contract_Mutation_Response>
  /** update single row of the table: "coassign.work_on_project_contract" */
  update_coassign_work_on_project_contract_by_pk?: Maybe<Coassign_Work_On_Project_Contract>
  /** update data of the table: "coassign.work_on_project_contract_history" */
  update_coassign_work_on_project_contract_history?: Maybe<Coassign_Work_On_Project_Contract_History_Mutation_Response>
  /** update multiples rows of table: "coassign.work_on_project_contract_history" */
  update_coassign_work_on_project_contract_history_many?: Maybe<
    Array<Maybe<Coassign_Work_On_Project_Contract_History_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.work_on_project_contract" */
  update_coassign_work_on_project_contract_many?: Maybe<
    Array<Maybe<Coassign_Work_On_Project_Contract_Mutation_Response>>
  >
  /** update multiples rows of table: "coassign.work_on_project" */
  update_coassign_work_on_project_many?: Maybe<
    Array<Maybe<Coassign_Work_On_Project_Mutation_Response>>
  >
}

/** mutation root */
export type Mutation_RootCreateFirebaseUserArgs = {
  email: Scalars['String']['input']
  firebase_tenant_id: Scalars['String']['input']
  subdomain: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootGenerateJobResultS3UrlArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootGenerateS3UrlForUploadArgs = {
  job_id: Scalars['String']['input']
  result_id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootResetMfaUserStatusArgs = {
  uuid: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootTriggerJobByIdArgs = {
  id: Scalars['String']['input']
  jobResultId: Scalars['String']['input']
  params: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootTriggerJobByNameArgs = {
  name: Scalars['String']['input']
  params: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootUpdateEmailFirebaseUserArgs = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firebase_tenant_id: Scalars['String']['input']
  firebase_uid: Scalars['String']['input']
  password?: InputMaybe<Scalars['String']['input']>
}

/** mutation root */
export type Mutation_RootUpdateMfaStatusArgs = {
  status: Scalars['Boolean']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_AssignArgs = {
  where: Coassign_Assign_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Assign_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Assign_HistoryArgs = {
  where: Coassign_Assign_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Assign_PlanArgs = {
  where: Coassign_Assign_Plan_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Assign_Plan_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Assign_Plan_HistoryArgs = {
  where: Coassign_Assign_Plan_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_AttendanceArgs = {
  where: Coassign_Attendance_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Attendance_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Attendance_ContractArgs = {
  where: Coassign_Attendance_Contract_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Attendance_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Attendance_Contract_HistoryArgs = {
  where: Coassign_Attendance_Contract_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_ClientArgs = {
  where: Coassign_Client_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Client_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_CommitArgs = {
  where: Coassign_Commit_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Commit_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Custom_FieldArgs = {
  where: Coassign_Custom_Field_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Custom_Field_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Custom_Field_ChoiceArgs = {
  where: Coassign_Custom_Field_Choice_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Custom_Field_Choice_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_DepartmentArgs = {
  where: Coassign_Department_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Department_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_EmploymentArgs = {
  where: Coassign_Employment_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Employment_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Employment_ContractArgs = {
  where: Coassign_Employment_Contract_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Employment_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_HolidayArgs = {
  where: Coassign_Holiday_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Holiday_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_JobArgs = {
  where: Coassign_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_DefinitionArgs = {
  where: Coassign_Job_Definition_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_Definition_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_ResultArgs = {
  where: Coassign_Job_Result_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_Result_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_SkillArgs = {
  where: Coassign_Job_Skill_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_Skill_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_TitleArgs = {
  where: Coassign_Job_Title_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_Title_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_TriggerArgs = {
  where: Coassign_Job_Trigger_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Job_Trigger_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_PartnerArgs = {
  where: Coassign_Partner_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Partner_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_ProjectArgs = {
  where: Coassign_Project_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Project_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Project_HistoryArgs = {
  where: Coassign_Project_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Project_To_DepartmentArgs = {
  where: Coassign_Project_To_Department_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Project_To_Department_HistoryArgs = {
  where: Coassign_Project_To_Department_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Project_To_UserArgs = {
  where: Coassign_Project_To_User_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Project_To_User_HistoryArgs = {
  where: Coassign_Project_To_User_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Regular_HolidayArgs = {
  where: Coassign_Regular_Holiday_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Regular_Holiday_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Target_Cost_OtherArgs = {
  where: Coassign_Target_Cost_Other_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Target_Cost_Other_ActualArgs = {
  where: Coassign_Target_Cost_Other_Actual_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Target_Cost_Other_Actual_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Target_Cost_Other_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Target_Cost_Other_HistoryArgs = {
  where: Coassign_Target_Cost_Other_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_TenantArgs = {
  where: Coassign_Tenant_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Tenant_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_UserArgs = {
  where: Coassign_User_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_User_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_User_To_DepartmentArgs = {
  where: Coassign_User_To_Department_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_User_To_Job_SkillArgs = {
  where: Coassign_User_To_Job_Skill_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_User_To_Job_TitleArgs = {
  where: Coassign_User_To_Job_Title_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_AssignArgs = {
  where: Coassign_Volumed_Assign_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_HistoryArgs = {
  where: Coassign_Volumed_Assign_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_PlanArgs = {
  where: Coassign_Volumed_Assign_Plan_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_Plan_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_Plan_HistoryArgs = {
  where: Coassign_Volumed_Assign_Plan_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_To_DepartmentArgs = {
  where: Coassign_Volumed_Assign_To_Department_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_To_Department_HistoryArgs = {
  where: Coassign_Volumed_Assign_To_Department_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_To_Job_SkillArgs = {
  where: Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Volumed_Assign_To_Job_Skill_HistoryArgs = {
  where: Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Work_On_ProjectArgs = {
  where: Coassign_Work_On_Project_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Work_On_Project_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Work_On_Project_ContractArgs = {
  where: Coassign_Work_On_Project_Contract_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Work_On_Project_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Coassign_Work_On_Project_Contract_HistoryArgs = {
  where: Coassign_Work_On_Project_Contract_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootInsert_Coassign_AssignArgs = {
  objects: Array<Coassign_Assign_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Assign_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Assign_HistoryArgs = {
  objects: Array<Coassign_Assign_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Assign_History_OneArgs = {
  object: Coassign_Assign_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Assign_OneArgs = {
  object: Coassign_Assign_Insert_Input
  on_conflict?: InputMaybe<Coassign_Assign_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Assign_PlanArgs = {
  objects: Array<Coassign_Assign_Plan_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Assign_Plan_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Assign_Plan_HistoryArgs = {
  objects: Array<Coassign_Assign_Plan_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Assign_Plan_History_OneArgs = {
  object: Coassign_Assign_Plan_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Assign_Plan_OneArgs = {
  object: Coassign_Assign_Plan_Insert_Input
  on_conflict?: InputMaybe<Coassign_Assign_Plan_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_AttendanceArgs = {
  objects: Array<Coassign_Attendance_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Attendance_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Attendance_ContractArgs = {
  objects: Array<Coassign_Attendance_Contract_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Attendance_Contract_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Attendance_Contract_HistoryArgs = {
  objects: Array<Coassign_Attendance_Contract_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Attendance_Contract_History_OneArgs = {
  object: Coassign_Attendance_Contract_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Attendance_Contract_OneArgs = {
  object: Coassign_Attendance_Contract_Insert_Input
  on_conflict?: InputMaybe<Coassign_Attendance_Contract_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Attendance_OneArgs = {
  object: Coassign_Attendance_Insert_Input
  on_conflict?: InputMaybe<Coassign_Attendance_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_ClientArgs = {
  objects: Array<Coassign_Client_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Client_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Client_OneArgs = {
  object: Coassign_Client_Insert_Input
  on_conflict?: InputMaybe<Coassign_Client_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_CommitArgs = {
  objects: Array<Coassign_Commit_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Commit_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Commit_OneArgs = {
  object: Coassign_Commit_Insert_Input
  on_conflict?: InputMaybe<Coassign_Commit_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Custom_FieldArgs = {
  objects: Array<Coassign_Custom_Field_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Custom_Field_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Custom_Field_ChoiceArgs = {
  objects: Array<Coassign_Custom_Field_Choice_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Custom_Field_Choice_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Custom_Field_Choice_OneArgs = {
  object: Coassign_Custom_Field_Choice_Insert_Input
  on_conflict?: InputMaybe<Coassign_Custom_Field_Choice_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Custom_Field_OneArgs = {
  object: Coassign_Custom_Field_Insert_Input
  on_conflict?: InputMaybe<Coassign_Custom_Field_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_DepartmentArgs = {
  objects: Array<Coassign_Department_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Department_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Department_OneArgs = {
  object: Coassign_Department_Insert_Input
  on_conflict?: InputMaybe<Coassign_Department_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_EmploymentArgs = {
  objects: Array<Coassign_Employment_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Employment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Employment_ContractArgs = {
  objects: Array<Coassign_Employment_Contract_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Employment_Contract_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Employment_Contract_OneArgs = {
  object: Coassign_Employment_Contract_Insert_Input
  on_conflict?: InputMaybe<Coassign_Employment_Contract_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Employment_OneArgs = {
  object: Coassign_Employment_Insert_Input
  on_conflict?: InputMaybe<Coassign_Employment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_HolidayArgs = {
  objects: Array<Coassign_Holiday_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Holiday_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Holiday_OneArgs = {
  object: Coassign_Holiday_Insert_Input
  on_conflict?: InputMaybe<Coassign_Holiday_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_JobArgs = {
  objects: Array<Coassign_Job_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_DefinitionArgs = {
  objects: Array<Coassign_Job_Definition_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Job_Definition_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_Definition_OneArgs = {
  object: Coassign_Job_Definition_Insert_Input
  on_conflict?: InputMaybe<Coassign_Job_Definition_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_OneArgs = {
  object: Coassign_Job_Insert_Input
  on_conflict?: InputMaybe<Coassign_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_ResultArgs = {
  objects: Array<Coassign_Job_Result_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Job_Result_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_Result_OneArgs = {
  object: Coassign_Job_Result_Insert_Input
  on_conflict?: InputMaybe<Coassign_Job_Result_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_SkillArgs = {
  objects: Array<Coassign_Job_Skill_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Job_Skill_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_Skill_OneArgs = {
  object: Coassign_Job_Skill_Insert_Input
  on_conflict?: InputMaybe<Coassign_Job_Skill_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_TitleArgs = {
  objects: Array<Coassign_Job_Title_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Job_Title_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_Title_OneArgs = {
  object: Coassign_Job_Title_Insert_Input
  on_conflict?: InputMaybe<Coassign_Job_Title_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_TriggerArgs = {
  objects: Array<Coassign_Job_Trigger_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Job_Trigger_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Job_Trigger_OneArgs = {
  object: Coassign_Job_Trigger_Insert_Input
  on_conflict?: InputMaybe<Coassign_Job_Trigger_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_PartnerArgs = {
  objects: Array<Coassign_Partner_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Partner_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Partner_OneArgs = {
  object: Coassign_Partner_Insert_Input
  on_conflict?: InputMaybe<Coassign_Partner_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_ProjectArgs = {
  objects: Array<Coassign_Project_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Project_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_HistoryArgs = {
  objects: Array<Coassign_Project_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_History_OneArgs = {
  object: Coassign_Project_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_OneArgs = {
  object: Coassign_Project_Insert_Input
  on_conflict?: InputMaybe<Coassign_Project_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_To_DepartmentArgs = {
  objects: Array<Coassign_Project_To_Department_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Project_To_Department_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_To_Department_HistoryArgs = {
  objects: Array<Coassign_Project_To_Department_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_To_Department_History_OneArgs = {
  object: Coassign_Project_To_Department_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_To_Department_OneArgs = {
  object: Coassign_Project_To_Department_Insert_Input
  on_conflict?: InputMaybe<Coassign_Project_To_Department_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_To_UserArgs = {
  objects: Array<Coassign_Project_To_User_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Project_To_User_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_To_User_HistoryArgs = {
  objects: Array<Coassign_Project_To_User_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_To_User_History_OneArgs = {
  object: Coassign_Project_To_User_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Project_To_User_OneArgs = {
  object: Coassign_Project_To_User_Insert_Input
  on_conflict?: InputMaybe<Coassign_Project_To_User_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Regular_HolidayArgs = {
  objects: Array<Coassign_Regular_Holiday_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Regular_Holiday_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Regular_Holiday_OneArgs = {
  object: Coassign_Regular_Holiday_Insert_Input
  on_conflict?: InputMaybe<Coassign_Regular_Holiday_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Target_Cost_OtherArgs = {
  objects: Array<Coassign_Target_Cost_Other_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Target_Cost_Other_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Target_Cost_Other_ActualArgs = {
  objects: Array<Coassign_Target_Cost_Other_Actual_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Target_Cost_Other_Actual_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Target_Cost_Other_Actual_OneArgs = {
  object: Coassign_Target_Cost_Other_Actual_Insert_Input
  on_conflict?: InputMaybe<Coassign_Target_Cost_Other_Actual_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Target_Cost_Other_HistoryArgs = {
  objects: Array<Coassign_Target_Cost_Other_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Target_Cost_Other_History_OneArgs = {
  object: Coassign_Target_Cost_Other_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Target_Cost_Other_OneArgs = {
  object: Coassign_Target_Cost_Other_Insert_Input
  on_conflict?: InputMaybe<Coassign_Target_Cost_Other_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_TenantArgs = {
  objects: Array<Coassign_Tenant_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Tenant_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Tenant_OneArgs = {
  object: Coassign_Tenant_Insert_Input
  on_conflict?: InputMaybe<Coassign_Tenant_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_UserArgs = {
  objects: Array<Coassign_User_Insert_Input>
  on_conflict?: InputMaybe<Coassign_User_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_User_OneArgs = {
  object: Coassign_User_Insert_Input
  on_conflict?: InputMaybe<Coassign_User_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_User_To_DepartmentArgs = {
  objects: Array<Coassign_User_To_Department_Insert_Input>
  on_conflict?: InputMaybe<Coassign_User_To_Department_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_User_To_Department_OneArgs = {
  object: Coassign_User_To_Department_Insert_Input
  on_conflict?: InputMaybe<Coassign_User_To_Department_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_User_To_Job_SkillArgs = {
  objects: Array<Coassign_User_To_Job_Skill_Insert_Input>
  on_conflict?: InputMaybe<Coassign_User_To_Job_Skill_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_User_To_Job_Skill_OneArgs = {
  object: Coassign_User_To_Job_Skill_Insert_Input
  on_conflict?: InputMaybe<Coassign_User_To_Job_Skill_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_User_To_Job_TitleArgs = {
  objects: Array<Coassign_User_To_Job_Title_Insert_Input>
  on_conflict?: InputMaybe<Coassign_User_To_Job_Title_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_User_To_Job_Title_OneArgs = {
  object: Coassign_User_To_Job_Title_Insert_Input
  on_conflict?: InputMaybe<Coassign_User_To_Job_Title_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_AssignArgs = {
  objects: Array<Coassign_Volumed_Assign_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_HistoryArgs = {
  objects: Array<Coassign_Volumed_Assign_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_History_OneArgs = {
  object: Coassign_Volumed_Assign_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_OneArgs = {
  object: Coassign_Volumed_Assign_Insert_Input
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_PlanArgs = {
  objects: Array<Coassign_Volumed_Assign_Plan_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_Plan_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_Plan_HistoryArgs = {
  objects: Array<Coassign_Volumed_Assign_Plan_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_Plan_History_OneArgs = {
  object: Coassign_Volumed_Assign_Plan_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_Plan_OneArgs = {
  object: Coassign_Volumed_Assign_Plan_Insert_Input
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_Plan_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_To_DepartmentArgs = {
  objects: Array<Coassign_Volumed_Assign_To_Department_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_To_Department_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_To_Department_HistoryArgs = {
  objects: Array<Coassign_Volumed_Assign_To_Department_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_To_Department_History_OneArgs = {
  object: Coassign_Volumed_Assign_To_Department_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_To_Department_OneArgs = {
  object: Coassign_Volumed_Assign_To_Department_Insert_Input
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_To_Department_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_To_Job_SkillArgs = {
  objects: Array<Coassign_Volumed_Assign_To_Job_Skill_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_To_Job_Skill_HistoryArgs = {
  objects: Array<Coassign_Volumed_Assign_To_Job_Skill_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_To_Job_Skill_History_OneArgs = {
  object: Coassign_Volumed_Assign_To_Job_Skill_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Volumed_Assign_To_Job_Skill_OneArgs = {
  object: Coassign_Volumed_Assign_To_Job_Skill_Insert_Input
  on_conflict?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Work_On_ProjectArgs = {
  objects: Array<Coassign_Work_On_Project_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Work_On_Project_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Work_On_Project_ContractArgs = {
  objects: Array<Coassign_Work_On_Project_Contract_Insert_Input>
  on_conflict?: InputMaybe<Coassign_Work_On_Project_Contract_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Work_On_Project_Contract_HistoryArgs = {
  objects: Array<Coassign_Work_On_Project_Contract_History_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Work_On_Project_Contract_History_OneArgs = {
  object: Coassign_Work_On_Project_Contract_History_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Work_On_Project_Contract_OneArgs = {
  object: Coassign_Work_On_Project_Contract_Insert_Input
  on_conflict?: InputMaybe<Coassign_Work_On_Project_Contract_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Coassign_Work_On_Project_OneArgs = {
  object: Coassign_Work_On_Project_Insert_Input
  on_conflict?: InputMaybe<Coassign_Work_On_Project_On_Conflict>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_AssignArgs = {
  _set?: InputMaybe<Coassign_Assign_Set_Input>
  where: Coassign_Assign_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_By_PkArgs = {
  _set?: InputMaybe<Coassign_Assign_Set_Input>
  pk_columns: Coassign_Assign_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_HistoryArgs = {
  _set?: InputMaybe<Coassign_Assign_History_Set_Input>
  where: Coassign_Assign_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_History_ManyArgs = {
  updates: Array<Coassign_Assign_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_ManyArgs = {
  updates: Array<Coassign_Assign_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_PlanArgs = {
  _inc?: InputMaybe<Coassign_Assign_Plan_Inc_Input>
  _set?: InputMaybe<Coassign_Assign_Plan_Set_Input>
  where: Coassign_Assign_Plan_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_Plan_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Assign_Plan_Inc_Input>
  _set?: InputMaybe<Coassign_Assign_Plan_Set_Input>
  pk_columns: Coassign_Assign_Plan_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_Plan_HistoryArgs = {
  _inc?: InputMaybe<Coassign_Assign_Plan_History_Inc_Input>
  _set?: InputMaybe<Coassign_Assign_Plan_History_Set_Input>
  where: Coassign_Assign_Plan_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_Plan_History_ManyArgs = {
  updates: Array<Coassign_Assign_Plan_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Assign_Plan_ManyArgs = {
  updates: Array<Coassign_Assign_Plan_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_AttendanceArgs = {
  _append?: InputMaybe<Coassign_Attendance_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Attendance_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Attendance_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Attendance_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Attendance_Prepend_Input>
  _set?: InputMaybe<Coassign_Attendance_Set_Input>
  where: Coassign_Attendance_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Attendance_By_PkArgs = {
  _append?: InputMaybe<Coassign_Attendance_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Attendance_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Attendance_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Attendance_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Attendance_Prepend_Input>
  _set?: InputMaybe<Coassign_Attendance_Set_Input>
  pk_columns: Coassign_Attendance_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Attendance_ContractArgs = {
  _set?: InputMaybe<Coassign_Attendance_Contract_Set_Input>
  where: Coassign_Attendance_Contract_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Attendance_Contract_By_PkArgs = {
  _set?: InputMaybe<Coassign_Attendance_Contract_Set_Input>
  pk_columns: Coassign_Attendance_Contract_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Attendance_Contract_HistoryArgs = {
  _set?: InputMaybe<Coassign_Attendance_Contract_History_Set_Input>
  where: Coassign_Attendance_Contract_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Attendance_Contract_History_ManyArgs = {
  updates: Array<Coassign_Attendance_Contract_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Attendance_Contract_ManyArgs = {
  updates: Array<Coassign_Attendance_Contract_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Attendance_ManyArgs = {
  updates: Array<Coassign_Attendance_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_ClientArgs = {
  _inc?: InputMaybe<Coassign_Client_Inc_Input>
  _set?: InputMaybe<Coassign_Client_Set_Input>
  where: Coassign_Client_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Client_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Client_Inc_Input>
  _set?: InputMaybe<Coassign_Client_Set_Input>
  pk_columns: Coassign_Client_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Client_ManyArgs = {
  updates: Array<Coassign_Client_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_CommitArgs = {
  _set?: InputMaybe<Coassign_Commit_Set_Input>
  where: Coassign_Commit_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Commit_By_PkArgs = {
  _set?: InputMaybe<Coassign_Commit_Set_Input>
  pk_columns: Coassign_Commit_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Commit_ManyArgs = {
  updates: Array<Coassign_Commit_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Custom_FieldArgs = {
  _inc?: InputMaybe<Coassign_Custom_Field_Inc_Input>
  _set?: InputMaybe<Coassign_Custom_Field_Set_Input>
  where: Coassign_Custom_Field_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Custom_Field_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Custom_Field_Inc_Input>
  _set?: InputMaybe<Coassign_Custom_Field_Set_Input>
  pk_columns: Coassign_Custom_Field_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Custom_Field_ChoiceArgs = {
  _inc?: InputMaybe<Coassign_Custom_Field_Choice_Inc_Input>
  _set?: InputMaybe<Coassign_Custom_Field_Choice_Set_Input>
  where: Coassign_Custom_Field_Choice_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Custom_Field_Choice_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Custom_Field_Choice_Inc_Input>
  _set?: InputMaybe<Coassign_Custom_Field_Choice_Set_Input>
  pk_columns: Coassign_Custom_Field_Choice_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Custom_Field_Choice_ManyArgs = {
  updates: Array<Coassign_Custom_Field_Choice_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Custom_Field_ManyArgs = {
  updates: Array<Coassign_Custom_Field_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_DepartmentArgs = {
  _inc?: InputMaybe<Coassign_Department_Inc_Input>
  _set?: InputMaybe<Coassign_Department_Set_Input>
  where: Coassign_Department_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Department_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Department_Inc_Input>
  _set?: InputMaybe<Coassign_Department_Set_Input>
  pk_columns: Coassign_Department_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Department_ManyArgs = {
  updates: Array<Coassign_Department_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_EmploymentArgs = {
  _inc?: InputMaybe<Coassign_Employment_Inc_Input>
  _set?: InputMaybe<Coassign_Employment_Set_Input>
  where: Coassign_Employment_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Employment_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Employment_Inc_Input>
  _set?: InputMaybe<Coassign_Employment_Set_Input>
  pk_columns: Coassign_Employment_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Employment_ContractArgs = {
  _set?: InputMaybe<Coassign_Employment_Contract_Set_Input>
  where: Coassign_Employment_Contract_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Employment_Contract_By_PkArgs = {
  _set?: InputMaybe<Coassign_Employment_Contract_Set_Input>
  pk_columns: Coassign_Employment_Contract_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Employment_Contract_ManyArgs = {
  updates: Array<Coassign_Employment_Contract_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Employment_ManyArgs = {
  updates: Array<Coassign_Employment_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_HolidayArgs = {
  _set?: InputMaybe<Coassign_Holiday_Set_Input>
  where: Coassign_Holiday_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Holiday_By_PkArgs = {
  _set?: InputMaybe<Coassign_Holiday_Set_Input>
  pk_columns: Coassign_Holiday_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Holiday_ManyArgs = {
  updates: Array<Coassign_Holiday_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_JobArgs = {
  _append?: InputMaybe<Coassign_Job_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Job_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Job_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Job_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Job_Prepend_Input>
  _set?: InputMaybe<Coassign_Job_Set_Input>
  where: Coassign_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_By_PkArgs = {
  _append?: InputMaybe<Coassign_Job_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Job_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Job_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Job_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Job_Prepend_Input>
  _set?: InputMaybe<Coassign_Job_Set_Input>
  pk_columns: Coassign_Job_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_DefinitionArgs = {
  _append?: InputMaybe<Coassign_Job_Definition_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Job_Definition_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Job_Definition_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Job_Definition_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Job_Definition_Prepend_Input>
  _set?: InputMaybe<Coassign_Job_Definition_Set_Input>
  where: Coassign_Job_Definition_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Definition_By_PkArgs = {
  _append?: InputMaybe<Coassign_Job_Definition_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Job_Definition_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Job_Definition_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Job_Definition_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Job_Definition_Prepend_Input>
  _set?: InputMaybe<Coassign_Job_Definition_Set_Input>
  pk_columns: Coassign_Job_Definition_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Definition_ManyArgs = {
  updates: Array<Coassign_Job_Definition_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_ManyArgs = {
  updates: Array<Coassign_Job_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_ResultArgs = {
  _set?: InputMaybe<Coassign_Job_Result_Set_Input>
  where: Coassign_Job_Result_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Result_By_PkArgs = {
  _set?: InputMaybe<Coassign_Job_Result_Set_Input>
  pk_columns: Coassign_Job_Result_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Result_ManyArgs = {
  updates: Array<Coassign_Job_Result_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_SkillArgs = {
  _inc?: InputMaybe<Coassign_Job_Skill_Inc_Input>
  _set?: InputMaybe<Coassign_Job_Skill_Set_Input>
  where: Coassign_Job_Skill_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Skill_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Job_Skill_Inc_Input>
  _set?: InputMaybe<Coassign_Job_Skill_Set_Input>
  pk_columns: Coassign_Job_Skill_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Skill_ManyArgs = {
  updates: Array<Coassign_Job_Skill_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_TitleArgs = {
  _inc?: InputMaybe<Coassign_Job_Title_Inc_Input>
  _set?: InputMaybe<Coassign_Job_Title_Set_Input>
  where: Coassign_Job_Title_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Title_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Job_Title_Inc_Input>
  _set?: InputMaybe<Coassign_Job_Title_Set_Input>
  pk_columns: Coassign_Job_Title_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Title_ManyArgs = {
  updates: Array<Coassign_Job_Title_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_TriggerArgs = {
  _append?: InputMaybe<Coassign_Job_Trigger_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Job_Trigger_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Job_Trigger_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Job_Trigger_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Job_Trigger_Prepend_Input>
  _set?: InputMaybe<Coassign_Job_Trigger_Set_Input>
  where: Coassign_Job_Trigger_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Trigger_By_PkArgs = {
  _append?: InputMaybe<Coassign_Job_Trigger_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Job_Trigger_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Job_Trigger_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Job_Trigger_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Job_Trigger_Prepend_Input>
  _set?: InputMaybe<Coassign_Job_Trigger_Set_Input>
  pk_columns: Coassign_Job_Trigger_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Job_Trigger_ManyArgs = {
  updates: Array<Coassign_Job_Trigger_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_PartnerArgs = {
  _inc?: InputMaybe<Coassign_Partner_Inc_Input>
  _set?: InputMaybe<Coassign_Partner_Set_Input>
  where: Coassign_Partner_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Partner_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Partner_Inc_Input>
  _set?: InputMaybe<Coassign_Partner_Set_Input>
  pk_columns: Coassign_Partner_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Partner_ManyArgs = {
  updates: Array<Coassign_Partner_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_ProjectArgs = {
  _append?: InputMaybe<Coassign_Project_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Project_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Project_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Project_Delete_Key_Input>
  _inc?: InputMaybe<Coassign_Project_Inc_Input>
  _prepend?: InputMaybe<Coassign_Project_Prepend_Input>
  _set?: InputMaybe<Coassign_Project_Set_Input>
  where: Coassign_Project_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_By_PkArgs = {
  _append?: InputMaybe<Coassign_Project_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Project_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Project_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Project_Delete_Key_Input>
  _inc?: InputMaybe<Coassign_Project_Inc_Input>
  _prepend?: InputMaybe<Coassign_Project_Prepend_Input>
  _set?: InputMaybe<Coassign_Project_Set_Input>
  pk_columns: Coassign_Project_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_HistoryArgs = {
  _append?: InputMaybe<Coassign_Project_History_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Project_History_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Project_History_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Project_History_Delete_Key_Input>
  _inc?: InputMaybe<Coassign_Project_History_Inc_Input>
  _prepend?: InputMaybe<Coassign_Project_History_Prepend_Input>
  _set?: InputMaybe<Coassign_Project_History_Set_Input>
  where: Coassign_Project_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_History_ManyArgs = {
  updates: Array<Coassign_Project_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_ManyArgs = {
  updates: Array<Coassign_Project_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_To_DepartmentArgs = {
  _set?: InputMaybe<Coassign_Project_To_Department_Set_Input>
  where: Coassign_Project_To_Department_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_To_Department_HistoryArgs = {
  _set?: InputMaybe<Coassign_Project_To_Department_History_Set_Input>
  where: Coassign_Project_To_Department_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_To_Department_History_ManyArgs = {
  updates: Array<Coassign_Project_To_Department_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_To_Department_ManyArgs = {
  updates: Array<Coassign_Project_To_Department_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_To_UserArgs = {
  _set?: InputMaybe<Coassign_Project_To_User_Set_Input>
  where: Coassign_Project_To_User_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_To_User_HistoryArgs = {
  _set?: InputMaybe<Coassign_Project_To_User_History_Set_Input>
  where: Coassign_Project_To_User_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_To_User_History_ManyArgs = {
  updates: Array<Coassign_Project_To_User_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Project_To_User_ManyArgs = {
  updates: Array<Coassign_Project_To_User_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Regular_HolidayArgs = {
  _inc?: InputMaybe<Coassign_Regular_Holiday_Inc_Input>
  _set?: InputMaybe<Coassign_Regular_Holiday_Set_Input>
  where: Coassign_Regular_Holiday_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Regular_Holiday_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Regular_Holiday_Inc_Input>
  _set?: InputMaybe<Coassign_Regular_Holiday_Set_Input>
  pk_columns: Coassign_Regular_Holiday_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Regular_Holiday_ManyArgs = {
  updates: Array<Coassign_Regular_Holiday_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Target_Cost_OtherArgs = {
  _append?: InputMaybe<Coassign_Target_Cost_Other_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Target_Cost_Other_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Target_Cost_Other_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Target_Cost_Other_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Target_Cost_Other_Prepend_Input>
  _set?: InputMaybe<Coassign_Target_Cost_Other_Set_Input>
  where: Coassign_Target_Cost_Other_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Target_Cost_Other_ActualArgs = {
  _inc?: InputMaybe<Coassign_Target_Cost_Other_Actual_Inc_Input>
  _set?: InputMaybe<Coassign_Target_Cost_Other_Actual_Set_Input>
  where: Coassign_Target_Cost_Other_Actual_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Target_Cost_Other_Actual_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Target_Cost_Other_Actual_Inc_Input>
  _set?: InputMaybe<Coassign_Target_Cost_Other_Actual_Set_Input>
  pk_columns: Coassign_Target_Cost_Other_Actual_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Target_Cost_Other_Actual_ManyArgs = {
  updates: Array<Coassign_Target_Cost_Other_Actual_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Target_Cost_Other_By_PkArgs = {
  _append?: InputMaybe<Coassign_Target_Cost_Other_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Target_Cost_Other_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Target_Cost_Other_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Target_Cost_Other_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Target_Cost_Other_Prepend_Input>
  _set?: InputMaybe<Coassign_Target_Cost_Other_Set_Input>
  pk_columns: Coassign_Target_Cost_Other_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Target_Cost_Other_HistoryArgs = {
  _append?: InputMaybe<Coassign_Target_Cost_Other_History_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Target_Cost_Other_History_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Target_Cost_Other_History_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Target_Cost_Other_History_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Target_Cost_Other_History_Prepend_Input>
  _set?: InputMaybe<Coassign_Target_Cost_Other_History_Set_Input>
  where: Coassign_Target_Cost_Other_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Target_Cost_Other_History_ManyArgs = {
  updates: Array<Coassign_Target_Cost_Other_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Target_Cost_Other_ManyArgs = {
  updates: Array<Coassign_Target_Cost_Other_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_TenantArgs = {
  _set?: InputMaybe<Coassign_Tenant_Set_Input>
  where: Coassign_Tenant_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Tenant_By_PkArgs = {
  _set?: InputMaybe<Coassign_Tenant_Set_Input>
  pk_columns: Coassign_Tenant_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Tenant_ManyArgs = {
  updates: Array<Coassign_Tenant_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_UserArgs = {
  _inc?: InputMaybe<Coassign_User_Inc_Input>
  _set?: InputMaybe<Coassign_User_Set_Input>
  where: Coassign_User_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_User_By_PkArgs = {
  _inc?: InputMaybe<Coassign_User_Inc_Input>
  _set?: InputMaybe<Coassign_User_Set_Input>
  pk_columns: Coassign_User_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_User_ManyArgs = {
  updates: Array<Coassign_User_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_User_To_DepartmentArgs = {
  _set?: InputMaybe<Coassign_User_To_Department_Set_Input>
  where: Coassign_User_To_Department_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_User_To_Department_ManyArgs = {
  updates: Array<Coassign_User_To_Department_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_User_To_Job_SkillArgs = {
  _set?: InputMaybe<Coassign_User_To_Job_Skill_Set_Input>
  where: Coassign_User_To_Job_Skill_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_User_To_Job_Skill_ManyArgs = {
  updates: Array<Coassign_User_To_Job_Skill_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_User_To_Job_TitleArgs = {
  _set?: InputMaybe<Coassign_User_To_Job_Title_Set_Input>
  where: Coassign_User_To_Job_Title_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_User_To_Job_Title_ManyArgs = {
  updates: Array<Coassign_User_To_Job_Title_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_AssignArgs = {
  _set?: InputMaybe<Coassign_Volumed_Assign_Set_Input>
  where: Coassign_Volumed_Assign_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_By_PkArgs = {
  _set?: InputMaybe<Coassign_Volumed_Assign_Set_Input>
  pk_columns: Coassign_Volumed_Assign_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_HistoryArgs = {
  _set?: InputMaybe<Coassign_Volumed_Assign_History_Set_Input>
  where: Coassign_Volumed_Assign_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_History_ManyArgs = {
  updates: Array<Coassign_Volumed_Assign_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_ManyArgs = {
  updates: Array<Coassign_Volumed_Assign_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_PlanArgs = {
  _inc?: InputMaybe<Coassign_Volumed_Assign_Plan_Inc_Input>
  _set?: InputMaybe<Coassign_Volumed_Assign_Plan_Set_Input>
  where: Coassign_Volumed_Assign_Plan_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_Plan_By_PkArgs = {
  _inc?: InputMaybe<Coassign_Volumed_Assign_Plan_Inc_Input>
  _set?: InputMaybe<Coassign_Volumed_Assign_Plan_Set_Input>
  pk_columns: Coassign_Volumed_Assign_Plan_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_Plan_HistoryArgs = {
  _inc?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Inc_Input>
  _set?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Set_Input>
  where: Coassign_Volumed_Assign_Plan_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_Plan_History_ManyArgs = {
  updates: Array<Coassign_Volumed_Assign_Plan_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_Plan_ManyArgs = {
  updates: Array<Coassign_Volumed_Assign_Plan_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_To_DepartmentArgs = {
  _set?: InputMaybe<Coassign_Volumed_Assign_To_Department_Set_Input>
  where: Coassign_Volumed_Assign_To_Department_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_To_Department_HistoryArgs = {
  _set?: InputMaybe<Coassign_Volumed_Assign_To_Department_History_Set_Input>
  where: Coassign_Volumed_Assign_To_Department_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_To_Department_History_ManyArgs = {
  updates: Array<Coassign_Volumed_Assign_To_Department_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_To_Department_ManyArgs = {
  updates: Array<Coassign_Volumed_Assign_To_Department_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_To_Job_SkillArgs = {
  _set?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Set_Input>
  where: Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_To_Job_Skill_HistoryArgs = {
  _set?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Set_Input>
  where: Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_To_Job_Skill_History_ManyArgs = {
  updates: Array<Coassign_Volumed_Assign_To_Job_Skill_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Volumed_Assign_To_Job_Skill_ManyArgs = {
  updates: Array<Coassign_Volumed_Assign_To_Job_Skill_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Work_On_ProjectArgs = {
  _append?: InputMaybe<Coassign_Work_On_Project_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Work_On_Project_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Work_On_Project_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Work_On_Project_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Work_On_Project_Prepend_Input>
  _set?: InputMaybe<Coassign_Work_On_Project_Set_Input>
  where: Coassign_Work_On_Project_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Work_On_Project_By_PkArgs = {
  _append?: InputMaybe<Coassign_Work_On_Project_Append_Input>
  _delete_at_path?: InputMaybe<Coassign_Work_On_Project_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Coassign_Work_On_Project_Delete_Elem_Input>
  _delete_key?: InputMaybe<Coassign_Work_On_Project_Delete_Key_Input>
  _prepend?: InputMaybe<Coassign_Work_On_Project_Prepend_Input>
  _set?: InputMaybe<Coassign_Work_On_Project_Set_Input>
  pk_columns: Coassign_Work_On_Project_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Work_On_Project_ContractArgs = {
  _set?: InputMaybe<Coassign_Work_On_Project_Contract_Set_Input>
  where: Coassign_Work_On_Project_Contract_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Work_On_Project_Contract_By_PkArgs = {
  _set?: InputMaybe<Coassign_Work_On_Project_Contract_Set_Input>
  pk_columns: Coassign_Work_On_Project_Contract_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Work_On_Project_Contract_HistoryArgs = {
  _set?: InputMaybe<Coassign_Work_On_Project_Contract_History_Set_Input>
  where: Coassign_Work_On_Project_Contract_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Work_On_Project_Contract_History_ManyArgs = {
  updates: Array<Coassign_Work_On_Project_Contract_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Work_On_Project_Contract_ManyArgs = {
  updates: Array<Coassign_Work_On_Project_Contract_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Coassign_Work_On_Project_ManyArgs = {
  updates: Array<Coassign_Work_On_Project_Updates>
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root'
  /** UpdateMfaStatus */
  UpdateMfaStatus?: Maybe<UpdateMfaStatus>
  /** fetch data from the table: "coassign.assign" */
  coassign_assign: Array<Coassign_Assign>
  /** fetch aggregated fields from the table: "coassign.assign" */
  coassign_assign_aggregate: Coassign_Assign_Aggregate
  /** fetch data from the table: "coassign.assign" using primary key columns */
  coassign_assign_by_pk?: Maybe<Coassign_Assign>
  /** fetch data from the table: "coassign.assign_full_view" */
  coassign_assign_full_view: Array<Coassign_Assign_Full_View>
  /** fetch aggregated fields from the table: "coassign.assign_full_view" */
  coassign_assign_full_view_aggregate: Coassign_Assign_Full_View_Aggregate
  /** fetch data from the table: "coassign.assign_history" */
  coassign_assign_history: Array<Coassign_Assign_History>
  /** fetch aggregated fields from the table: "coassign.assign_history" */
  coassign_assign_history_aggregate: Coassign_Assign_History_Aggregate
  /** fetch data from the table: "coassign.assign_plan" */
  coassign_assign_plan: Array<Coassign_Assign_Plan>
  /** fetch aggregated fields from the table: "coassign.assign_plan" */
  coassign_assign_plan_aggregate: Coassign_Assign_Plan_Aggregate
  /** fetch data from the table: "coassign.assign_plan" using primary key columns */
  coassign_assign_plan_by_pk?: Maybe<Coassign_Assign_Plan>
  /** fetch data from the table: "coassign.assign_plan_full_view" */
  coassign_assign_plan_full_view: Array<Coassign_Assign_Plan_Full_View>
  /** fetch aggregated fields from the table: "coassign.assign_plan_full_view" */
  coassign_assign_plan_full_view_aggregate: Coassign_Assign_Plan_Full_View_Aggregate
  /** fetch data from the table: "coassign.assign_plan_history" */
  coassign_assign_plan_history: Array<Coassign_Assign_Plan_History>
  /** fetch aggregated fields from the table: "coassign.assign_plan_history" */
  coassign_assign_plan_history_aggregate: Coassign_Assign_Plan_History_Aggregate
  /** fetch data from the table: "coassign.attendance" */
  coassign_attendance: Array<Coassign_Attendance>
  /** fetch aggregated fields from the table: "coassign.attendance" */
  coassign_attendance_aggregate: Coassign_Attendance_Aggregate
  /** fetch data from the table: "coassign.attendance" using primary key columns */
  coassign_attendance_by_pk?: Maybe<Coassign_Attendance>
  /** fetch data from the table: "coassign.attendance_contract" */
  coassign_attendance_contract: Array<Coassign_Attendance_Contract>
  /** fetch aggregated fields from the table: "coassign.attendance_contract" */
  coassign_attendance_contract_aggregate: Coassign_Attendance_Contract_Aggregate
  /** fetch data from the table: "coassign.attendance_contract" using primary key columns */
  coassign_attendance_contract_by_pk?: Maybe<Coassign_Attendance_Contract>
  /** fetch data from the table: "coassign.attendance_contract_history" */
  coassign_attendance_contract_history: Array<Coassign_Attendance_Contract_History>
  /** fetch aggregated fields from the table: "coassign.attendance_contract_history" */
  coassign_attendance_contract_history_aggregate: Coassign_Attendance_Contract_History_Aggregate
  /** fetch data from the table: "coassign.client" */
  coassign_client: Array<Coassign_Client>
  /** fetch aggregated fields from the table: "coassign.client" */
  coassign_client_aggregate: Coassign_Client_Aggregate
  /** fetch data from the table: "coassign.client" using primary key columns */
  coassign_client_by_pk?: Maybe<Coassign_Client>
  /** fetch data from the table: "coassign.commit" */
  coassign_commit: Array<Coassign_Commit>
  /** fetch aggregated fields from the table: "coassign.commit" */
  coassign_commit_aggregate: Coassign_Commit_Aggregate
  /** fetch data from the table: "coassign.commit" using primary key columns */
  coassign_commit_by_pk?: Maybe<Coassign_Commit>
  /** fetch data from the table: "coassign.commit_with_project_view" */
  coassign_commit_with_project_view: Array<Coassign_Commit_With_Project_View>
  /** fetch aggregated fields from the table: "coassign.commit_with_project_view" */
  coassign_commit_with_project_view_aggregate: Coassign_Commit_With_Project_View_Aggregate
  /** fetch data from the table: "coassign.custom_field" */
  coassign_custom_field: Array<Coassign_Custom_Field>
  /** fetch aggregated fields from the table: "coassign.custom_field" */
  coassign_custom_field_aggregate: Coassign_Custom_Field_Aggregate
  /** fetch data from the table: "coassign.custom_field" using primary key columns */
  coassign_custom_field_by_pk?: Maybe<Coassign_Custom_Field>
  /** fetch data from the table: "coassign.custom_field_choice" */
  coassign_custom_field_choice: Array<Coassign_Custom_Field_Choice>
  /** fetch aggregated fields from the table: "coassign.custom_field_choice" */
  coassign_custom_field_choice_aggregate: Coassign_Custom_Field_Choice_Aggregate
  /** fetch data from the table: "coassign.custom_field_choice" using primary key columns */
  coassign_custom_field_choice_by_pk?: Maybe<Coassign_Custom_Field_Choice>
  /** fetch data from the table: "coassign.department" */
  coassign_department: Array<Coassign_Department>
  /** fetch aggregated fields from the table: "coassign.department" */
  coassign_department_aggregate: Coassign_Department_Aggregate
  /** fetch data from the table: "coassign.department" using primary key columns */
  coassign_department_by_pk?: Maybe<Coassign_Department>
  /** fetch data from the table: "coassign.employment" */
  coassign_employment: Array<Coassign_Employment>
  /** fetch aggregated fields from the table: "coassign.employment" */
  coassign_employment_aggregate: Coassign_Employment_Aggregate
  /** fetch data from the table: "coassign.employment" using primary key columns */
  coassign_employment_by_pk?: Maybe<Coassign_Employment>
  /** fetch data from the table: "coassign.employment_contract" */
  coassign_employment_contract: Array<Coassign_Employment_Contract>
  /** fetch aggregated fields from the table: "coassign.employment_contract" */
  coassign_employment_contract_aggregate: Coassign_Employment_Contract_Aggregate
  /** fetch data from the table: "coassign.employment_contract" using primary key columns */
  coassign_employment_contract_by_pk?: Maybe<Coassign_Employment_Contract>
  /** fetch data from the table: "coassign.holiday" */
  coassign_holiday: Array<Coassign_Holiday>
  /** fetch aggregated fields from the table: "coassign.holiday" */
  coassign_holiday_aggregate: Coassign_Holiday_Aggregate
  /** fetch data from the table: "coassign.holiday" using primary key columns */
  coassign_holiday_by_pk?: Maybe<Coassign_Holiday>
  /** fetch data from the table: "coassign.job" */
  coassign_job: Array<Coassign_Job>
  /** fetch aggregated fields from the table: "coassign.job" */
  coassign_job_aggregate: Coassign_Job_Aggregate
  /** fetch data from the table: "coassign.job" using primary key columns */
  coassign_job_by_pk?: Maybe<Coassign_Job>
  /** fetch data from the table: "coassign.job_definition" */
  coassign_job_definition: Array<Coassign_Job_Definition>
  /** fetch aggregated fields from the table: "coassign.job_definition" */
  coassign_job_definition_aggregate: Coassign_Job_Definition_Aggregate
  /** fetch data from the table: "coassign.job_definition" using primary key columns */
  coassign_job_definition_by_pk?: Maybe<Coassign_Job_Definition>
  /** fetch data from the table: "coassign.job_result" */
  coassign_job_result: Array<Coassign_Job_Result>
  /** fetch aggregated fields from the table: "coassign.job_result" */
  coassign_job_result_aggregate: Coassign_Job_Result_Aggregate
  /** fetch data from the table: "coassign.job_result" using primary key columns */
  coassign_job_result_by_pk?: Maybe<Coassign_Job_Result>
  /** fetch data from the table: "coassign.job_skill" */
  coassign_job_skill: Array<Coassign_Job_Skill>
  /** fetch aggregated fields from the table: "coassign.job_skill" */
  coassign_job_skill_aggregate: Coassign_Job_Skill_Aggregate
  /** fetch data from the table: "coassign.job_skill" using primary key columns */
  coassign_job_skill_by_pk?: Maybe<Coassign_Job_Skill>
  /** fetch data from the table: "coassign.job_title" */
  coassign_job_title: Array<Coassign_Job_Title>
  /** fetch aggregated fields from the table: "coassign.job_title" */
  coassign_job_title_aggregate: Coassign_Job_Title_Aggregate
  /** fetch data from the table: "coassign.job_title" using primary key columns */
  coassign_job_title_by_pk?: Maybe<Coassign_Job_Title>
  /** fetch data from the table: "coassign.job_trigger" */
  coassign_job_trigger: Array<Coassign_Job_Trigger>
  /** fetch aggregated fields from the table: "coassign.job_trigger" */
  coassign_job_trigger_aggregate: Coassign_Job_Trigger_Aggregate
  /** fetch data from the table: "coassign.job_trigger" using primary key columns */
  coassign_job_trigger_by_pk?: Maybe<Coassign_Job_Trigger>
  /** fetch data from the table: "coassign.partner" */
  coassign_partner: Array<Coassign_Partner>
  /** fetch aggregated fields from the table: "coassign.partner" */
  coassign_partner_aggregate: Coassign_Partner_Aggregate
  /** fetch data from the table: "coassign.partner" using primary key columns */
  coassign_partner_by_pk?: Maybe<Coassign_Partner>
  /** fetch data from the table: "coassign.project" */
  coassign_project: Array<Coassign_Project>
  /** fetch aggregated fields from the table: "coassign.project" */
  coassign_project_aggregate: Coassign_Project_Aggregate
  /** fetch data from the table: "coassign.project" using primary key columns */
  coassign_project_by_pk?: Maybe<Coassign_Project>
  /** fetch data from the table: "coassign.project_full_view" */
  coassign_project_full_view: Array<Coassign_Project_Full_View>
  /** fetch aggregated fields from the table: "coassign.project_full_view" */
  coassign_project_full_view_aggregate: Coassign_Project_Full_View_Aggregate
  /** fetch data from the table: "coassign.project_history" */
  coassign_project_history: Array<Coassign_Project_History>
  /** fetch aggregated fields from the table: "coassign.project_history" */
  coassign_project_history_aggregate: Coassign_Project_History_Aggregate
  /** fetch data from the table: "coassign.project_to_department" */
  coassign_project_to_department: Array<Coassign_Project_To_Department>
  /** fetch aggregated fields from the table: "coassign.project_to_department" */
  coassign_project_to_department_aggregate: Coassign_Project_To_Department_Aggregate
  /** fetch data from the table: "coassign.project_to_department_full_view" */
  coassign_project_to_department_full_view: Array<Coassign_Project_To_Department_Full_View>
  /** fetch aggregated fields from the table: "coassign.project_to_department_full_view" */
  coassign_project_to_department_full_view_aggregate: Coassign_Project_To_Department_Full_View_Aggregate
  /** fetch data from the table: "coassign.project_to_department_history" */
  coassign_project_to_department_history: Array<Coassign_Project_To_Department_History>
  /** fetch aggregated fields from the table: "coassign.project_to_department_history" */
  coassign_project_to_department_history_aggregate: Coassign_Project_To_Department_History_Aggregate
  /** fetch data from the table: "coassign.project_to_user" */
  coassign_project_to_user: Array<Coassign_Project_To_User>
  /** fetch aggregated fields from the table: "coassign.project_to_user" */
  coassign_project_to_user_aggregate: Coassign_Project_To_User_Aggregate
  /** fetch data from the table: "coassign.project_to_user_full_view" */
  coassign_project_to_user_full_view: Array<Coassign_Project_To_User_Full_View>
  /** fetch aggregated fields from the table: "coassign.project_to_user_full_view" */
  coassign_project_to_user_full_view_aggregate: Coassign_Project_To_User_Full_View_Aggregate
  /** fetch data from the table: "coassign.project_to_user_history" */
  coassign_project_to_user_history: Array<Coassign_Project_To_User_History>
  /** fetch aggregated fields from the table: "coassign.project_to_user_history" */
  coassign_project_to_user_history_aggregate: Coassign_Project_To_User_History_Aggregate
  /** fetch data from the table: "coassign.regular_holiday" */
  coassign_regular_holiday: Array<Coassign_Regular_Holiday>
  /** fetch aggregated fields from the table: "coassign.regular_holiday" */
  coassign_regular_holiday_aggregate: Coassign_Regular_Holiday_Aggregate
  /** fetch data from the table: "coassign.regular_holiday" using primary key columns */
  coassign_regular_holiday_by_pk?: Maybe<Coassign_Regular_Holiday>
  /** fetch data from the table: "coassign.target_cost_other" */
  coassign_target_cost_other: Array<Coassign_Target_Cost_Other>
  /** fetch data from the table: "coassign.target_cost_other_actual" */
  coassign_target_cost_other_actual: Array<Coassign_Target_Cost_Other_Actual>
  /** fetch aggregated fields from the table: "coassign.target_cost_other_actual" */
  coassign_target_cost_other_actual_aggregate: Coassign_Target_Cost_Other_Actual_Aggregate
  /** fetch data from the table: "coassign.target_cost_other_actual" using primary key columns */
  coassign_target_cost_other_actual_by_pk?: Maybe<Coassign_Target_Cost_Other_Actual>
  /** fetch aggregated fields from the table: "coassign.target_cost_other" */
  coassign_target_cost_other_aggregate: Coassign_Target_Cost_Other_Aggregate
  /** fetch data from the table: "coassign.target_cost_other" using primary key columns */
  coassign_target_cost_other_by_pk?: Maybe<Coassign_Target_Cost_Other>
  /** fetch data from the table: "coassign.target_cost_other_full_view" */
  coassign_target_cost_other_full_view: Array<Coassign_Target_Cost_Other_Full_View>
  /** fetch aggregated fields from the table: "coassign.target_cost_other_full_view" */
  coassign_target_cost_other_full_view_aggregate: Coassign_Target_Cost_Other_Full_View_Aggregate
  /** fetch data from the table: "coassign.target_cost_other_history" */
  coassign_target_cost_other_history: Array<Coassign_Target_Cost_Other_History>
  /** fetch aggregated fields from the table: "coassign.target_cost_other_history" */
  coassign_target_cost_other_history_aggregate: Coassign_Target_Cost_Other_History_Aggregate
  /** fetch data from the table: "coassign.tenant" */
  coassign_tenant: Array<Coassign_Tenant>
  /** fetch aggregated fields from the table: "coassign.tenant" */
  coassign_tenant_aggregate: Coassign_Tenant_Aggregate
  /** fetch data from the table: "coassign.tenant" using primary key columns */
  coassign_tenant_by_pk?: Maybe<Coassign_Tenant>
  /** fetch data from the table: "coassign.user" */
  coassign_user: Array<Coassign_User>
  /** fetch aggregated fields from the table: "coassign.user" */
  coassign_user_aggregate: Coassign_User_Aggregate
  /** fetch data from the table: "coassign.user" using primary key columns */
  coassign_user_by_pk?: Maybe<Coassign_User>
  /** fetch data from the table: "coassign.user_to_department" */
  coassign_user_to_department: Array<Coassign_User_To_Department>
  /** fetch aggregated fields from the table: "coassign.user_to_department" */
  coassign_user_to_department_aggregate: Coassign_User_To_Department_Aggregate
  /** fetch data from the table: "coassign.user_to_job_skill" */
  coassign_user_to_job_skill: Array<Coassign_User_To_Job_Skill>
  /** fetch aggregated fields from the table: "coassign.user_to_job_skill" */
  coassign_user_to_job_skill_aggregate: Coassign_User_To_Job_Skill_Aggregate
  /** fetch data from the table: "coassign.user_to_job_title" */
  coassign_user_to_job_title: Array<Coassign_User_To_Job_Title>
  /** fetch aggregated fields from the table: "coassign.user_to_job_title" */
  coassign_user_to_job_title_aggregate: Coassign_User_To_Job_Title_Aggregate
  /** fetch data from the table: "coassign.volumed_assign" */
  coassign_volumed_assign: Array<Coassign_Volumed_Assign>
  /** fetch aggregated fields from the table: "coassign.volumed_assign" */
  coassign_volumed_assign_aggregate: Coassign_Volumed_Assign_Aggregate
  /** fetch data from the table: "coassign.volumed_assign" using primary key columns */
  coassign_volumed_assign_by_pk?: Maybe<Coassign_Volumed_Assign>
  /** fetch data from the table: "coassign.volumed_assign_full_view" */
  coassign_volumed_assign_full_view: Array<Coassign_Volumed_Assign_Full_View>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_full_view" */
  coassign_volumed_assign_full_view_aggregate: Coassign_Volumed_Assign_Full_View_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_history" */
  coassign_volumed_assign_history: Array<Coassign_Volumed_Assign_History>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_history" */
  coassign_volumed_assign_history_aggregate: Coassign_Volumed_Assign_History_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_plan" */
  coassign_volumed_assign_plan: Array<Coassign_Volumed_Assign_Plan>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_plan" */
  coassign_volumed_assign_plan_aggregate: Coassign_Volumed_Assign_Plan_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_plan" using primary key columns */
  coassign_volumed_assign_plan_by_pk?: Maybe<Coassign_Volumed_Assign_Plan>
  /** fetch data from the table: "coassign.volumed_assign_plan_full_view" */
  coassign_volumed_assign_plan_full_view: Array<Coassign_Volumed_Assign_Plan_Full_View>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_plan_full_view" */
  coassign_volumed_assign_plan_full_view_aggregate: Coassign_Volumed_Assign_Plan_Full_View_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_plan_history" */
  coassign_volumed_assign_plan_history: Array<Coassign_Volumed_Assign_Plan_History>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_plan_history" */
  coassign_volumed_assign_plan_history_aggregate: Coassign_Volumed_Assign_Plan_History_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_to_department" */
  coassign_volumed_assign_to_department: Array<Coassign_Volumed_Assign_To_Department>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_department" */
  coassign_volumed_assign_to_department_aggregate: Coassign_Volumed_Assign_To_Department_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_to_department_history" */
  coassign_volumed_assign_to_department_history: Array<Coassign_Volumed_Assign_To_Department_History>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_department_history" */
  coassign_volumed_assign_to_department_history_aggregate: Coassign_Volumed_Assign_To_Department_History_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_to_job_skill" */
  coassign_volumed_assign_to_job_skill: Array<Coassign_Volumed_Assign_To_Job_Skill>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_job_skill" */
  coassign_volumed_assign_to_job_skill_aggregate: Coassign_Volumed_Assign_To_Job_Skill_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_to_job_skill_full_view" */
  coassign_volumed_assign_to_job_skill_full_view: Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_job_skill_full_view" */
  coassign_volumed_assign_to_job_skill_full_view_aggregate: Coassign_Volumed_Assign_To_Job_Skill_Full_View_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_to_job_skill_history" */
  coassign_volumed_assign_to_job_skill_history: Array<Coassign_Volumed_Assign_To_Job_Skill_History>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_job_skill_history" */
  coassign_volumed_assign_to_job_skill_history_aggregate: Coassign_Volumed_Assign_To_Job_Skill_History_Aggregate
  /** fetch data from the table: "coassign.work_on_project" */
  coassign_work_on_project: Array<Coassign_Work_On_Project>
  /** fetch aggregated fields from the table: "coassign.work_on_project" */
  coassign_work_on_project_aggregate: Coassign_Work_On_Project_Aggregate
  /** fetch data from the table: "coassign.work_on_project" using primary key columns */
  coassign_work_on_project_by_pk?: Maybe<Coassign_Work_On_Project>
  /** fetch data from the table: "coassign.work_on_project_contract" */
  coassign_work_on_project_contract: Array<Coassign_Work_On_Project_Contract>
  /** fetch aggregated fields from the table: "coassign.work_on_project_contract" */
  coassign_work_on_project_contract_aggregate: Coassign_Work_On_Project_Contract_Aggregate
  /** fetch data from the table: "coassign.work_on_project_contract" using primary key columns */
  coassign_work_on_project_contract_by_pk?: Maybe<Coassign_Work_On_Project_Contract>
  /** fetch data from the table: "coassign.work_on_project_contract_history" */
  coassign_work_on_project_contract_history: Array<Coassign_Work_On_Project_Contract_History>
  /** fetch aggregated fields from the table: "coassign.work_on_project_contract_history" */
  coassign_work_on_project_contract_history_aggregate: Coassign_Work_On_Project_Contract_History_Aggregate
}

export type Query_RootUpdateMfaStatusArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootCoassign_AssignArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Order_By>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

export type Query_RootCoassign_Assign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Order_By>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

export type Query_RootCoassign_Assign_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Assign_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Assign_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Assign_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Assign_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Assign_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_History_Order_By>>
  where?: InputMaybe<Coassign_Assign_History_Bool_Exp>
}

export type Query_RootCoassign_Assign_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_History_Order_By>>
  where?: InputMaybe<Coassign_Assign_History_Bool_Exp>
}

export type Query_RootCoassign_Assign_PlanArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

export type Query_RootCoassign_Assign_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

export type Query_RootCoassign_Assign_Plan_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Assign_Plan_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Assign_Plan_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Assign_Plan_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_History_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_History_Bool_Exp>
}

export type Query_RootCoassign_Assign_Plan_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_History_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_History_Bool_Exp>
}

export type Query_RootCoassign_AttendanceArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Bool_Exp>
}

export type Query_RootCoassign_Attendance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Bool_Exp>
}

export type Query_RootCoassign_Attendance_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Attendance_ContractArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
}

export type Query_RootCoassign_Attendance_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
}

export type Query_RootCoassign_Attendance_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Attendance_Contract_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_History_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_History_Bool_Exp>
}

export type Query_RootCoassign_Attendance_Contract_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_History_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_History_Bool_Exp>
}

export type Query_RootCoassign_ClientArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Client_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Client_Order_By>>
  where?: InputMaybe<Coassign_Client_Bool_Exp>
}

export type Query_RootCoassign_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Client_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Client_Order_By>>
  where?: InputMaybe<Coassign_Client_Bool_Exp>
}

export type Query_RootCoassign_Client_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_CommitArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_Order_By>>
  where?: InputMaybe<Coassign_Commit_Bool_Exp>
}

export type Query_RootCoassign_Commit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_Order_By>>
  where?: InputMaybe<Coassign_Commit_Bool_Exp>
}

export type Query_RootCoassign_Commit_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Commit_With_Project_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_With_Project_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_With_Project_View_Order_By>>
  where?: InputMaybe<Coassign_Commit_With_Project_View_Bool_Exp>
}

export type Query_RootCoassign_Commit_With_Project_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_With_Project_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_With_Project_View_Order_By>>
  where?: InputMaybe<Coassign_Commit_With_Project_View_Bool_Exp>
}

export type Query_RootCoassign_Custom_FieldArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
}

export type Query_RootCoassign_Custom_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
}

export type Query_RootCoassign_Custom_Field_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Custom_Field_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Choice_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

export type Query_RootCoassign_Custom_Field_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Choice_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

export type Query_RootCoassign_Custom_Field_Choice_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Department_Order_By>>
  where?: InputMaybe<Coassign_Department_Bool_Exp>
}

export type Query_RootCoassign_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Department_Order_By>>
  where?: InputMaybe<Coassign_Department_Bool_Exp>
}

export type Query_RootCoassign_Department_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_EmploymentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

export type Query_RootCoassign_Employment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

export type Query_RootCoassign_Employment_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Employment_ContractArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Contract_Order_By>>
  where?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
}

export type Query_RootCoassign_Employment_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Contract_Order_By>>
  where?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
}

export type Query_RootCoassign_Employment_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_HolidayArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Holiday_Bool_Exp>
}

export type Query_RootCoassign_Holiday_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Holiday_Bool_Exp>
}

export type Query_RootCoassign_Holiday_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_JobArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Order_By>>
  where?: InputMaybe<Coassign_Job_Bool_Exp>
}

export type Query_RootCoassign_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Order_By>>
  where?: InputMaybe<Coassign_Job_Bool_Exp>
}

export type Query_RootCoassign_Job_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Job_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Definition_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Definition_Order_By>>
  where?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
}

export type Query_RootCoassign_Job_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Definition_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Definition_Order_By>>
  where?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
}

export type Query_RootCoassign_Job_Definition_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Job_ResultArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Result_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Result_Order_By>>
  where?: InputMaybe<Coassign_Job_Result_Bool_Exp>
}

export type Query_RootCoassign_Job_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Result_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Result_Order_By>>
  where?: InputMaybe<Coassign_Job_Result_Bool_Exp>
}

export type Query_RootCoassign_Job_Result_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Job_SkillArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
}

export type Query_RootCoassign_Job_Skill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
}

export type Query_RootCoassign_Job_Skill_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Job_TitleArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_Job_Title_Bool_Exp>
}

export type Query_RootCoassign_Job_Title_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_Job_Title_Bool_Exp>
}

export type Query_RootCoassign_Job_Title_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Job_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Trigger_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Trigger_Order_By>>
  where?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
}

export type Query_RootCoassign_Job_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Trigger_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Trigger_Order_By>>
  where?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
}

export type Query_RootCoassign_Job_Trigger_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_PartnerArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Partner_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Partner_Order_By>>
  where?: InputMaybe<Coassign_Partner_Bool_Exp>
}

export type Query_RootCoassign_Partner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Partner_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Partner_Order_By>>
  where?: InputMaybe<Coassign_Partner_Bool_Exp>
}

export type Query_RootCoassign_Partner_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Order_By>>
  where?: InputMaybe<Coassign_Project_Bool_Exp>
}

export type Query_RootCoassign_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Order_By>>
  where?: InputMaybe<Coassign_Project_Bool_Exp>
}

export type Query_RootCoassign_Project_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Project_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Project_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Project_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_History_Order_By>>
  where?: InputMaybe<Coassign_Project_History_Bool_Exp>
}

export type Query_RootCoassign_Project_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_History_Order_By>>
  where?: InputMaybe<Coassign_Project_History_Bool_Exp>
}

export type Query_RootCoassign_Project_To_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

export type Query_RootCoassign_Project_To_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

export type Query_RootCoassign_Project_To_Department_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Project_To_Department_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Project_To_Department_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_History_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_History_Bool_Exp>
}

export type Query_RootCoassign_Project_To_Department_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_History_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_History_Bool_Exp>
}

export type Query_RootCoassign_Project_To_UserArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

export type Query_RootCoassign_Project_To_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

export type Query_RootCoassign_Project_To_User_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Project_To_User_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Project_To_User_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_History_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_History_Bool_Exp>
}

export type Query_RootCoassign_Project_To_User_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_History_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_History_Bool_Exp>
}

export type Query_RootCoassign_Regular_HolidayArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Regular_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Regular_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
}

export type Query_RootCoassign_Regular_Holiday_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Regular_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Regular_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
}

export type Query_RootCoassign_Regular_Holiday_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Target_Cost_OtherArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

export type Query_RootCoassign_Target_Cost_Other_ActualArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
}

export type Query_RootCoassign_Target_Cost_Other_Actual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
}

export type Query_RootCoassign_Target_Cost_Other_Actual_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Target_Cost_Other_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

export type Query_RootCoassign_Target_Cost_Other_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Target_Cost_Other_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Target_Cost_Other_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Target_Cost_Other_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_History_Bool_Exp>
}

export type Query_RootCoassign_Target_Cost_Other_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_History_Bool_Exp>
}

export type Query_RootCoassign_TenantArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Tenant_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Tenant_Order_By>>
  where?: InputMaybe<Coassign_Tenant_Bool_Exp>
}

export type Query_RootCoassign_Tenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Tenant_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Tenant_Order_By>>
  where?: InputMaybe<Coassign_Tenant_Bool_Exp>
}

export type Query_RootCoassign_Tenant_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_UserArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_Order_By>>
  where?: InputMaybe<Coassign_User_Bool_Exp>
}

export type Query_RootCoassign_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_Order_By>>
  where?: InputMaybe<Coassign_User_Bool_Exp>
}

export type Query_RootCoassign_User_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_User_To_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

export type Query_RootCoassign_User_To_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

export type Query_RootCoassign_User_To_Job_SkillArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

export type Query_RootCoassign_User_To_Job_Skill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

export type Query_RootCoassign_User_To_Job_TitleArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

export type Query_RootCoassign_User_To_Job_Title_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

export type Query_RootCoassign_Volumed_AssignArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Volumed_Assign_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_History_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_History_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_PlanArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_Plan_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Volumed_Assign_Plan_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_Plan_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_Plan_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_Plan_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Department_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_History_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Department_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_History_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Job_SkillArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Job_Skill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Job_Skill_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Job_Skill_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Job_Skill_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp>
}

export type Query_RootCoassign_Volumed_Assign_To_Job_Skill_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp>
}

export type Query_RootCoassign_Work_On_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

export type Query_RootCoassign_Work_On_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

export type Query_RootCoassign_Work_On_Project_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Work_On_Project_ContractArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
}

export type Query_RootCoassign_Work_On_Project_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
}

export type Query_RootCoassign_Work_On_Project_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootCoassign_Work_On_Project_Contract_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_History_Bool_Exp>
}

export type Query_RootCoassign_Work_On_Project_Contract_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_History_Bool_Exp>
}

/** Boolean expression to compare columns of type "roles". All fields are combined with logical 'AND'. */
export type Roles_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['roles']['input']>
  _gt?: InputMaybe<Scalars['roles']['input']>
  _gte?: InputMaybe<Scalars['roles']['input']>
  _in?: InputMaybe<Array<Scalars['roles']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['roles']['input']>
  _lte?: InputMaybe<Scalars['roles']['input']>
  _neq?: InputMaybe<Scalars['roles']['input']>
  _nin?: InputMaybe<Array<Scalars['roles']['input']>>
}

export type Subscription_Root = {
  __typename?: 'subscription_root'
  /** UpdateMfaStatus */
  UpdateMfaStatus?: Maybe<UpdateMfaStatus>
  /** fetch data from the table: "coassign.assign" */
  coassign_assign: Array<Coassign_Assign>
  /** fetch aggregated fields from the table: "coassign.assign" */
  coassign_assign_aggregate: Coassign_Assign_Aggregate
  /** fetch data from the table: "coassign.assign" using primary key columns */
  coassign_assign_by_pk?: Maybe<Coassign_Assign>
  /** fetch data from the table: "coassign.assign_full_view" */
  coassign_assign_full_view: Array<Coassign_Assign_Full_View>
  /** fetch aggregated fields from the table: "coassign.assign_full_view" */
  coassign_assign_full_view_aggregate: Coassign_Assign_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.assign_full_view" */
  coassign_assign_full_view_stream: Array<Coassign_Assign_Full_View>
  /** fetch data from the table: "coassign.assign_history" */
  coassign_assign_history: Array<Coassign_Assign_History>
  /** fetch aggregated fields from the table: "coassign.assign_history" */
  coassign_assign_history_aggregate: Coassign_Assign_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.assign_history" */
  coassign_assign_history_stream: Array<Coassign_Assign_History>
  /** fetch data from the table: "coassign.assign_plan" */
  coassign_assign_plan: Array<Coassign_Assign_Plan>
  /** fetch aggregated fields from the table: "coassign.assign_plan" */
  coassign_assign_plan_aggregate: Coassign_Assign_Plan_Aggregate
  /** fetch data from the table: "coassign.assign_plan" using primary key columns */
  coassign_assign_plan_by_pk?: Maybe<Coassign_Assign_Plan>
  /** fetch data from the table: "coassign.assign_plan_full_view" */
  coassign_assign_plan_full_view: Array<Coassign_Assign_Plan_Full_View>
  /** fetch aggregated fields from the table: "coassign.assign_plan_full_view" */
  coassign_assign_plan_full_view_aggregate: Coassign_Assign_Plan_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.assign_plan_full_view" */
  coassign_assign_plan_full_view_stream: Array<Coassign_Assign_Plan_Full_View>
  /** fetch data from the table: "coassign.assign_plan_history" */
  coassign_assign_plan_history: Array<Coassign_Assign_Plan_History>
  /** fetch aggregated fields from the table: "coassign.assign_plan_history" */
  coassign_assign_plan_history_aggregate: Coassign_Assign_Plan_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.assign_plan_history" */
  coassign_assign_plan_history_stream: Array<Coassign_Assign_Plan_History>
  /** fetch data from the table in a streaming manner: "coassign.assign_plan" */
  coassign_assign_plan_stream: Array<Coassign_Assign_Plan>
  /** fetch data from the table in a streaming manner: "coassign.assign" */
  coassign_assign_stream: Array<Coassign_Assign>
  /** fetch data from the table: "coassign.attendance" */
  coassign_attendance: Array<Coassign_Attendance>
  /** fetch aggregated fields from the table: "coassign.attendance" */
  coassign_attendance_aggregate: Coassign_Attendance_Aggregate
  /** fetch data from the table: "coassign.attendance" using primary key columns */
  coassign_attendance_by_pk?: Maybe<Coassign_Attendance>
  /** fetch data from the table: "coassign.attendance_contract" */
  coassign_attendance_contract: Array<Coassign_Attendance_Contract>
  /** fetch aggregated fields from the table: "coassign.attendance_contract" */
  coassign_attendance_contract_aggregate: Coassign_Attendance_Contract_Aggregate
  /** fetch data from the table: "coassign.attendance_contract" using primary key columns */
  coassign_attendance_contract_by_pk?: Maybe<Coassign_Attendance_Contract>
  /** fetch data from the table: "coassign.attendance_contract_history" */
  coassign_attendance_contract_history: Array<Coassign_Attendance_Contract_History>
  /** fetch aggregated fields from the table: "coassign.attendance_contract_history" */
  coassign_attendance_contract_history_aggregate: Coassign_Attendance_Contract_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.attendance_contract_history" */
  coassign_attendance_contract_history_stream: Array<Coassign_Attendance_Contract_History>
  /** fetch data from the table in a streaming manner: "coassign.attendance_contract" */
  coassign_attendance_contract_stream: Array<Coassign_Attendance_Contract>
  /** fetch data from the table in a streaming manner: "coassign.attendance" */
  coassign_attendance_stream: Array<Coassign_Attendance>
  /** fetch data from the table: "coassign.client" */
  coassign_client: Array<Coassign_Client>
  /** fetch aggregated fields from the table: "coassign.client" */
  coassign_client_aggregate: Coassign_Client_Aggregate
  /** fetch data from the table: "coassign.client" using primary key columns */
  coassign_client_by_pk?: Maybe<Coassign_Client>
  /** fetch data from the table in a streaming manner: "coassign.client" */
  coassign_client_stream: Array<Coassign_Client>
  /** fetch data from the table: "coassign.commit" */
  coassign_commit: Array<Coassign_Commit>
  /** fetch aggregated fields from the table: "coassign.commit" */
  coassign_commit_aggregate: Coassign_Commit_Aggregate
  /** fetch data from the table: "coassign.commit" using primary key columns */
  coassign_commit_by_pk?: Maybe<Coassign_Commit>
  /** fetch data from the table in a streaming manner: "coassign.commit" */
  coassign_commit_stream: Array<Coassign_Commit>
  /** fetch data from the table: "coassign.commit_with_project_view" */
  coassign_commit_with_project_view: Array<Coassign_Commit_With_Project_View>
  /** fetch aggregated fields from the table: "coassign.commit_with_project_view" */
  coassign_commit_with_project_view_aggregate: Coassign_Commit_With_Project_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.commit_with_project_view" */
  coassign_commit_with_project_view_stream: Array<Coassign_Commit_With_Project_View>
  /** fetch data from the table: "coassign.custom_field" */
  coassign_custom_field: Array<Coassign_Custom_Field>
  /** fetch aggregated fields from the table: "coassign.custom_field" */
  coassign_custom_field_aggregate: Coassign_Custom_Field_Aggregate
  /** fetch data from the table: "coassign.custom_field" using primary key columns */
  coassign_custom_field_by_pk?: Maybe<Coassign_Custom_Field>
  /** fetch data from the table: "coassign.custom_field_choice" */
  coassign_custom_field_choice: Array<Coassign_Custom_Field_Choice>
  /** fetch aggregated fields from the table: "coassign.custom_field_choice" */
  coassign_custom_field_choice_aggregate: Coassign_Custom_Field_Choice_Aggregate
  /** fetch data from the table: "coassign.custom_field_choice" using primary key columns */
  coassign_custom_field_choice_by_pk?: Maybe<Coassign_Custom_Field_Choice>
  /** fetch data from the table in a streaming manner: "coassign.custom_field_choice" */
  coassign_custom_field_choice_stream: Array<Coassign_Custom_Field_Choice>
  /** fetch data from the table in a streaming manner: "coassign.custom_field" */
  coassign_custom_field_stream: Array<Coassign_Custom_Field>
  /** fetch data from the table: "coassign.department" */
  coassign_department: Array<Coassign_Department>
  /** fetch aggregated fields from the table: "coassign.department" */
  coassign_department_aggregate: Coassign_Department_Aggregate
  /** fetch data from the table: "coassign.department" using primary key columns */
  coassign_department_by_pk?: Maybe<Coassign_Department>
  /** fetch data from the table in a streaming manner: "coassign.department" */
  coassign_department_stream: Array<Coassign_Department>
  /** fetch data from the table: "coassign.employment" */
  coassign_employment: Array<Coassign_Employment>
  /** fetch aggregated fields from the table: "coassign.employment" */
  coassign_employment_aggregate: Coassign_Employment_Aggregate
  /** fetch data from the table: "coassign.employment" using primary key columns */
  coassign_employment_by_pk?: Maybe<Coassign_Employment>
  /** fetch data from the table: "coassign.employment_contract" */
  coassign_employment_contract: Array<Coassign_Employment_Contract>
  /** fetch aggregated fields from the table: "coassign.employment_contract" */
  coassign_employment_contract_aggregate: Coassign_Employment_Contract_Aggregate
  /** fetch data from the table: "coassign.employment_contract" using primary key columns */
  coassign_employment_contract_by_pk?: Maybe<Coassign_Employment_Contract>
  /** fetch data from the table in a streaming manner: "coassign.employment_contract" */
  coassign_employment_contract_stream: Array<Coassign_Employment_Contract>
  /** fetch data from the table in a streaming manner: "coassign.employment" */
  coassign_employment_stream: Array<Coassign_Employment>
  /** fetch data from the table: "coassign.holiday" */
  coassign_holiday: Array<Coassign_Holiday>
  /** fetch aggregated fields from the table: "coassign.holiday" */
  coassign_holiday_aggregate: Coassign_Holiday_Aggregate
  /** fetch data from the table: "coassign.holiday" using primary key columns */
  coassign_holiday_by_pk?: Maybe<Coassign_Holiday>
  /** fetch data from the table in a streaming manner: "coassign.holiday" */
  coassign_holiday_stream: Array<Coassign_Holiday>
  /** fetch data from the table: "coassign.job" */
  coassign_job: Array<Coassign_Job>
  /** fetch aggregated fields from the table: "coassign.job" */
  coassign_job_aggregate: Coassign_Job_Aggregate
  /** fetch data from the table: "coassign.job" using primary key columns */
  coassign_job_by_pk?: Maybe<Coassign_Job>
  /** fetch data from the table: "coassign.job_definition" */
  coassign_job_definition: Array<Coassign_Job_Definition>
  /** fetch aggregated fields from the table: "coassign.job_definition" */
  coassign_job_definition_aggregate: Coassign_Job_Definition_Aggregate
  /** fetch data from the table: "coassign.job_definition" using primary key columns */
  coassign_job_definition_by_pk?: Maybe<Coassign_Job_Definition>
  /** fetch data from the table in a streaming manner: "coassign.job_definition" */
  coassign_job_definition_stream: Array<Coassign_Job_Definition>
  /** fetch data from the table: "coassign.job_result" */
  coassign_job_result: Array<Coassign_Job_Result>
  /** fetch aggregated fields from the table: "coassign.job_result" */
  coassign_job_result_aggregate: Coassign_Job_Result_Aggregate
  /** fetch data from the table: "coassign.job_result" using primary key columns */
  coassign_job_result_by_pk?: Maybe<Coassign_Job_Result>
  /** fetch data from the table in a streaming manner: "coassign.job_result" */
  coassign_job_result_stream: Array<Coassign_Job_Result>
  /** fetch data from the table: "coassign.job_skill" */
  coassign_job_skill: Array<Coassign_Job_Skill>
  /** fetch aggregated fields from the table: "coassign.job_skill" */
  coassign_job_skill_aggregate: Coassign_Job_Skill_Aggregate
  /** fetch data from the table: "coassign.job_skill" using primary key columns */
  coassign_job_skill_by_pk?: Maybe<Coassign_Job_Skill>
  /** fetch data from the table in a streaming manner: "coassign.job_skill" */
  coassign_job_skill_stream: Array<Coassign_Job_Skill>
  /** fetch data from the table in a streaming manner: "coassign.job" */
  coassign_job_stream: Array<Coassign_Job>
  /** fetch data from the table: "coassign.job_title" */
  coassign_job_title: Array<Coassign_Job_Title>
  /** fetch aggregated fields from the table: "coassign.job_title" */
  coassign_job_title_aggregate: Coassign_Job_Title_Aggregate
  /** fetch data from the table: "coassign.job_title" using primary key columns */
  coassign_job_title_by_pk?: Maybe<Coassign_Job_Title>
  /** fetch data from the table in a streaming manner: "coassign.job_title" */
  coassign_job_title_stream: Array<Coassign_Job_Title>
  /** fetch data from the table: "coassign.job_trigger" */
  coassign_job_trigger: Array<Coassign_Job_Trigger>
  /** fetch aggregated fields from the table: "coassign.job_trigger" */
  coassign_job_trigger_aggregate: Coassign_Job_Trigger_Aggregate
  /** fetch data from the table: "coassign.job_trigger" using primary key columns */
  coassign_job_trigger_by_pk?: Maybe<Coassign_Job_Trigger>
  /** fetch data from the table in a streaming manner: "coassign.job_trigger" */
  coassign_job_trigger_stream: Array<Coassign_Job_Trigger>
  /** fetch data from the table: "coassign.partner" */
  coassign_partner: Array<Coassign_Partner>
  /** fetch aggregated fields from the table: "coassign.partner" */
  coassign_partner_aggregate: Coassign_Partner_Aggregate
  /** fetch data from the table: "coassign.partner" using primary key columns */
  coassign_partner_by_pk?: Maybe<Coassign_Partner>
  /** fetch data from the table in a streaming manner: "coassign.partner" */
  coassign_partner_stream: Array<Coassign_Partner>
  /** fetch data from the table: "coassign.project" */
  coassign_project: Array<Coassign_Project>
  /** fetch aggregated fields from the table: "coassign.project" */
  coassign_project_aggregate: Coassign_Project_Aggregate
  /** fetch data from the table: "coassign.project" using primary key columns */
  coassign_project_by_pk?: Maybe<Coassign_Project>
  /** fetch data from the table: "coassign.project_full_view" */
  coassign_project_full_view: Array<Coassign_Project_Full_View>
  /** fetch aggregated fields from the table: "coassign.project_full_view" */
  coassign_project_full_view_aggregate: Coassign_Project_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.project_full_view" */
  coassign_project_full_view_stream: Array<Coassign_Project_Full_View>
  /** fetch data from the table: "coassign.project_history" */
  coassign_project_history: Array<Coassign_Project_History>
  /** fetch aggregated fields from the table: "coassign.project_history" */
  coassign_project_history_aggregate: Coassign_Project_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.project_history" */
  coassign_project_history_stream: Array<Coassign_Project_History>
  /** fetch data from the table in a streaming manner: "coassign.project" */
  coassign_project_stream: Array<Coassign_Project>
  /** fetch data from the table: "coassign.project_to_department" */
  coassign_project_to_department: Array<Coassign_Project_To_Department>
  /** fetch aggregated fields from the table: "coassign.project_to_department" */
  coassign_project_to_department_aggregate: Coassign_Project_To_Department_Aggregate
  /** fetch data from the table: "coassign.project_to_department_full_view" */
  coassign_project_to_department_full_view: Array<Coassign_Project_To_Department_Full_View>
  /** fetch aggregated fields from the table: "coassign.project_to_department_full_view" */
  coassign_project_to_department_full_view_aggregate: Coassign_Project_To_Department_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.project_to_department_full_view" */
  coassign_project_to_department_full_view_stream: Array<Coassign_Project_To_Department_Full_View>
  /** fetch data from the table: "coassign.project_to_department_history" */
  coassign_project_to_department_history: Array<Coassign_Project_To_Department_History>
  /** fetch aggregated fields from the table: "coassign.project_to_department_history" */
  coassign_project_to_department_history_aggregate: Coassign_Project_To_Department_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.project_to_department_history" */
  coassign_project_to_department_history_stream: Array<Coassign_Project_To_Department_History>
  /** fetch data from the table in a streaming manner: "coassign.project_to_department" */
  coassign_project_to_department_stream: Array<Coassign_Project_To_Department>
  /** fetch data from the table: "coassign.project_to_user" */
  coassign_project_to_user: Array<Coassign_Project_To_User>
  /** fetch aggregated fields from the table: "coassign.project_to_user" */
  coassign_project_to_user_aggregate: Coassign_Project_To_User_Aggregate
  /** fetch data from the table: "coassign.project_to_user_full_view" */
  coassign_project_to_user_full_view: Array<Coassign_Project_To_User_Full_View>
  /** fetch aggregated fields from the table: "coassign.project_to_user_full_view" */
  coassign_project_to_user_full_view_aggregate: Coassign_Project_To_User_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.project_to_user_full_view" */
  coassign_project_to_user_full_view_stream: Array<Coassign_Project_To_User_Full_View>
  /** fetch data from the table: "coassign.project_to_user_history" */
  coassign_project_to_user_history: Array<Coassign_Project_To_User_History>
  /** fetch aggregated fields from the table: "coassign.project_to_user_history" */
  coassign_project_to_user_history_aggregate: Coassign_Project_To_User_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.project_to_user_history" */
  coassign_project_to_user_history_stream: Array<Coassign_Project_To_User_History>
  /** fetch data from the table in a streaming manner: "coassign.project_to_user" */
  coassign_project_to_user_stream: Array<Coassign_Project_To_User>
  /** fetch data from the table: "coassign.regular_holiday" */
  coassign_regular_holiday: Array<Coassign_Regular_Holiday>
  /** fetch aggregated fields from the table: "coassign.regular_holiday" */
  coassign_regular_holiday_aggregate: Coassign_Regular_Holiday_Aggregate
  /** fetch data from the table: "coassign.regular_holiday" using primary key columns */
  coassign_regular_holiday_by_pk?: Maybe<Coassign_Regular_Holiday>
  /** fetch data from the table in a streaming manner: "coassign.regular_holiday" */
  coassign_regular_holiday_stream: Array<Coassign_Regular_Holiday>
  /** fetch data from the table: "coassign.target_cost_other" */
  coassign_target_cost_other: Array<Coassign_Target_Cost_Other>
  /** fetch data from the table: "coassign.target_cost_other_actual" */
  coassign_target_cost_other_actual: Array<Coassign_Target_Cost_Other_Actual>
  /** fetch aggregated fields from the table: "coassign.target_cost_other_actual" */
  coassign_target_cost_other_actual_aggregate: Coassign_Target_Cost_Other_Actual_Aggregate
  /** fetch data from the table: "coassign.target_cost_other_actual" using primary key columns */
  coassign_target_cost_other_actual_by_pk?: Maybe<Coassign_Target_Cost_Other_Actual>
  /** fetch data from the table in a streaming manner: "coassign.target_cost_other_actual" */
  coassign_target_cost_other_actual_stream: Array<Coassign_Target_Cost_Other_Actual>
  /** fetch aggregated fields from the table: "coassign.target_cost_other" */
  coassign_target_cost_other_aggregate: Coassign_Target_Cost_Other_Aggregate
  /** fetch data from the table: "coassign.target_cost_other" using primary key columns */
  coassign_target_cost_other_by_pk?: Maybe<Coassign_Target_Cost_Other>
  /** fetch data from the table: "coassign.target_cost_other_full_view" */
  coassign_target_cost_other_full_view: Array<Coassign_Target_Cost_Other_Full_View>
  /** fetch aggregated fields from the table: "coassign.target_cost_other_full_view" */
  coassign_target_cost_other_full_view_aggregate: Coassign_Target_Cost_Other_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.target_cost_other_full_view" */
  coassign_target_cost_other_full_view_stream: Array<Coassign_Target_Cost_Other_Full_View>
  /** fetch data from the table: "coassign.target_cost_other_history" */
  coassign_target_cost_other_history: Array<Coassign_Target_Cost_Other_History>
  /** fetch aggregated fields from the table: "coassign.target_cost_other_history" */
  coassign_target_cost_other_history_aggregate: Coassign_Target_Cost_Other_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.target_cost_other_history" */
  coassign_target_cost_other_history_stream: Array<Coassign_Target_Cost_Other_History>
  /** fetch data from the table in a streaming manner: "coassign.target_cost_other" */
  coassign_target_cost_other_stream: Array<Coassign_Target_Cost_Other>
  /** fetch data from the table: "coassign.tenant" */
  coassign_tenant: Array<Coassign_Tenant>
  /** fetch aggregated fields from the table: "coassign.tenant" */
  coassign_tenant_aggregate: Coassign_Tenant_Aggregate
  /** fetch data from the table: "coassign.tenant" using primary key columns */
  coassign_tenant_by_pk?: Maybe<Coassign_Tenant>
  /** fetch data from the table in a streaming manner: "coassign.tenant" */
  coassign_tenant_stream: Array<Coassign_Tenant>
  /** fetch data from the table: "coassign.user" */
  coassign_user: Array<Coassign_User>
  /** fetch aggregated fields from the table: "coassign.user" */
  coassign_user_aggregate: Coassign_User_Aggregate
  /** fetch data from the table: "coassign.user" using primary key columns */
  coassign_user_by_pk?: Maybe<Coassign_User>
  /** fetch data from the table in a streaming manner: "coassign.user" */
  coassign_user_stream: Array<Coassign_User>
  /** fetch data from the table: "coassign.user_to_department" */
  coassign_user_to_department: Array<Coassign_User_To_Department>
  /** fetch aggregated fields from the table: "coassign.user_to_department" */
  coassign_user_to_department_aggregate: Coassign_User_To_Department_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.user_to_department" */
  coassign_user_to_department_stream: Array<Coassign_User_To_Department>
  /** fetch data from the table: "coassign.user_to_job_skill" */
  coassign_user_to_job_skill: Array<Coassign_User_To_Job_Skill>
  /** fetch aggregated fields from the table: "coassign.user_to_job_skill" */
  coassign_user_to_job_skill_aggregate: Coassign_User_To_Job_Skill_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.user_to_job_skill" */
  coassign_user_to_job_skill_stream: Array<Coassign_User_To_Job_Skill>
  /** fetch data from the table: "coassign.user_to_job_title" */
  coassign_user_to_job_title: Array<Coassign_User_To_Job_Title>
  /** fetch aggregated fields from the table: "coassign.user_to_job_title" */
  coassign_user_to_job_title_aggregate: Coassign_User_To_Job_Title_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.user_to_job_title" */
  coassign_user_to_job_title_stream: Array<Coassign_User_To_Job_Title>
  /** fetch data from the table: "coassign.volumed_assign" */
  coassign_volumed_assign: Array<Coassign_Volumed_Assign>
  /** fetch aggregated fields from the table: "coassign.volumed_assign" */
  coassign_volumed_assign_aggregate: Coassign_Volumed_Assign_Aggregate
  /** fetch data from the table: "coassign.volumed_assign" using primary key columns */
  coassign_volumed_assign_by_pk?: Maybe<Coassign_Volumed_Assign>
  /** fetch data from the table: "coassign.volumed_assign_full_view" */
  coassign_volumed_assign_full_view: Array<Coassign_Volumed_Assign_Full_View>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_full_view" */
  coassign_volumed_assign_full_view_aggregate: Coassign_Volumed_Assign_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_full_view" */
  coassign_volumed_assign_full_view_stream: Array<Coassign_Volumed_Assign_Full_View>
  /** fetch data from the table: "coassign.volumed_assign_history" */
  coassign_volumed_assign_history: Array<Coassign_Volumed_Assign_History>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_history" */
  coassign_volumed_assign_history_aggregate: Coassign_Volumed_Assign_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_history" */
  coassign_volumed_assign_history_stream: Array<Coassign_Volumed_Assign_History>
  /** fetch data from the table: "coassign.volumed_assign_plan" */
  coassign_volumed_assign_plan: Array<Coassign_Volumed_Assign_Plan>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_plan" */
  coassign_volumed_assign_plan_aggregate: Coassign_Volumed_Assign_Plan_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_plan" using primary key columns */
  coassign_volumed_assign_plan_by_pk?: Maybe<Coassign_Volumed_Assign_Plan>
  /** fetch data from the table: "coassign.volumed_assign_plan_full_view" */
  coassign_volumed_assign_plan_full_view: Array<Coassign_Volumed_Assign_Plan_Full_View>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_plan_full_view" */
  coassign_volumed_assign_plan_full_view_aggregate: Coassign_Volumed_Assign_Plan_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_plan_full_view" */
  coassign_volumed_assign_plan_full_view_stream: Array<Coassign_Volumed_Assign_Plan_Full_View>
  /** fetch data from the table: "coassign.volumed_assign_plan_history" */
  coassign_volumed_assign_plan_history: Array<Coassign_Volumed_Assign_Plan_History>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_plan_history" */
  coassign_volumed_assign_plan_history_aggregate: Coassign_Volumed_Assign_Plan_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_plan_history" */
  coassign_volumed_assign_plan_history_stream: Array<Coassign_Volumed_Assign_Plan_History>
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_plan" */
  coassign_volumed_assign_plan_stream: Array<Coassign_Volumed_Assign_Plan>
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign" */
  coassign_volumed_assign_stream: Array<Coassign_Volumed_Assign>
  /** fetch data from the table: "coassign.volumed_assign_to_department" */
  coassign_volumed_assign_to_department: Array<Coassign_Volumed_Assign_To_Department>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_department" */
  coassign_volumed_assign_to_department_aggregate: Coassign_Volumed_Assign_To_Department_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_to_department_history" */
  coassign_volumed_assign_to_department_history: Array<Coassign_Volumed_Assign_To_Department_History>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_department_history" */
  coassign_volumed_assign_to_department_history_aggregate: Coassign_Volumed_Assign_To_Department_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_to_department_history" */
  coassign_volumed_assign_to_department_history_stream: Array<Coassign_Volumed_Assign_To_Department_History>
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_to_department" */
  coassign_volumed_assign_to_department_stream: Array<Coassign_Volumed_Assign_To_Department>
  /** fetch data from the table: "coassign.volumed_assign_to_job_skill" */
  coassign_volumed_assign_to_job_skill: Array<Coassign_Volumed_Assign_To_Job_Skill>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_job_skill" */
  coassign_volumed_assign_to_job_skill_aggregate: Coassign_Volumed_Assign_To_Job_Skill_Aggregate
  /** fetch data from the table: "coassign.volumed_assign_to_job_skill_full_view" */
  coassign_volumed_assign_to_job_skill_full_view: Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_job_skill_full_view" */
  coassign_volumed_assign_to_job_skill_full_view_aggregate: Coassign_Volumed_Assign_To_Job_Skill_Full_View_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_to_job_skill_full_view" */
  coassign_volumed_assign_to_job_skill_full_view_stream: Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View>
  /** fetch data from the table: "coassign.volumed_assign_to_job_skill_history" */
  coassign_volumed_assign_to_job_skill_history: Array<Coassign_Volumed_Assign_To_Job_Skill_History>
  /** fetch aggregated fields from the table: "coassign.volumed_assign_to_job_skill_history" */
  coassign_volumed_assign_to_job_skill_history_aggregate: Coassign_Volumed_Assign_To_Job_Skill_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_to_job_skill_history" */
  coassign_volumed_assign_to_job_skill_history_stream: Array<Coassign_Volumed_Assign_To_Job_Skill_History>
  /** fetch data from the table in a streaming manner: "coassign.volumed_assign_to_job_skill" */
  coassign_volumed_assign_to_job_skill_stream: Array<Coassign_Volumed_Assign_To_Job_Skill>
  /** fetch data from the table: "coassign.work_on_project" */
  coassign_work_on_project: Array<Coassign_Work_On_Project>
  /** fetch aggregated fields from the table: "coassign.work_on_project" */
  coassign_work_on_project_aggregate: Coassign_Work_On_Project_Aggregate
  /** fetch data from the table: "coassign.work_on_project" using primary key columns */
  coassign_work_on_project_by_pk?: Maybe<Coassign_Work_On_Project>
  /** fetch data from the table: "coassign.work_on_project_contract" */
  coassign_work_on_project_contract: Array<Coassign_Work_On_Project_Contract>
  /** fetch aggregated fields from the table: "coassign.work_on_project_contract" */
  coassign_work_on_project_contract_aggregate: Coassign_Work_On_Project_Contract_Aggregate
  /** fetch data from the table: "coassign.work_on_project_contract" using primary key columns */
  coassign_work_on_project_contract_by_pk?: Maybe<Coassign_Work_On_Project_Contract>
  /** fetch data from the table: "coassign.work_on_project_contract_history" */
  coassign_work_on_project_contract_history: Array<Coassign_Work_On_Project_Contract_History>
  /** fetch aggregated fields from the table: "coassign.work_on_project_contract_history" */
  coassign_work_on_project_contract_history_aggregate: Coassign_Work_On_Project_Contract_History_Aggregate
  /** fetch data from the table in a streaming manner: "coassign.work_on_project_contract_history" */
  coassign_work_on_project_contract_history_stream: Array<Coassign_Work_On_Project_Contract_History>
  /** fetch data from the table in a streaming manner: "coassign.work_on_project_contract" */
  coassign_work_on_project_contract_stream: Array<Coassign_Work_On_Project_Contract>
  /** fetch data from the table in a streaming manner: "coassign.work_on_project" */
  coassign_work_on_project_stream: Array<Coassign_Work_On_Project>
}

export type Subscription_RootUpdateMfaStatusArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootCoassign_AssignArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Order_By>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Order_By>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Assign_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Assign_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Assign_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Assign_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Assign_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_History_Order_By>>
  where?: InputMaybe<Coassign_Assign_History_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_History_Order_By>>
  where?: InputMaybe<Coassign_Assign_History_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Assign_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Assign_History_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_PlanArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Plan_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Assign_Plan_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Plan_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Plan_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Assign_Plan_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Assign_Plan_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Plan_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_History_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_History_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Plan_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Assign_Plan_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Assign_Plan_History_Order_By>>
  where?: InputMaybe<Coassign_Assign_Plan_History_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Plan_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Assign_Plan_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Assign_Plan_History_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_Plan_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Assign_Plan_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Assign_Plan_Bool_Exp>
}

export type Subscription_RootCoassign_Assign_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Assign_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Assign_Bool_Exp>
}

export type Subscription_RootCoassign_AttendanceArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Bool_Exp>
}

export type Subscription_RootCoassign_Attendance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Bool_Exp>
}

export type Subscription_RootCoassign_Attendance_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Attendance_ContractArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Attendance_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Attendance_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Attendance_Contract_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_History_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_History_Bool_Exp>
}

export type Subscription_RootCoassign_Attendance_Contract_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Attendance_Contract_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Attendance_Contract_History_Order_By>>
  where?: InputMaybe<Coassign_Attendance_Contract_History_Bool_Exp>
}

export type Subscription_RootCoassign_Attendance_Contract_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Attendance_Contract_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Attendance_Contract_History_Bool_Exp>
}

export type Subscription_RootCoassign_Attendance_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Attendance_Contract_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Attendance_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Attendance_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Attendance_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Attendance_Bool_Exp>
}

export type Subscription_RootCoassign_ClientArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Client_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Client_Order_By>>
  where?: InputMaybe<Coassign_Client_Bool_Exp>
}

export type Subscription_RootCoassign_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Client_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Client_Order_By>>
  where?: InputMaybe<Coassign_Client_Bool_Exp>
}

export type Subscription_RootCoassign_Client_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Client_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Client_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Client_Bool_Exp>
}

export type Subscription_RootCoassign_CommitArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_Order_By>>
  where?: InputMaybe<Coassign_Commit_Bool_Exp>
}

export type Subscription_RootCoassign_Commit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_Order_By>>
  where?: InputMaybe<Coassign_Commit_Bool_Exp>
}

export type Subscription_RootCoassign_Commit_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Commit_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Commit_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Commit_Bool_Exp>
}

export type Subscription_RootCoassign_Commit_With_Project_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_With_Project_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_With_Project_View_Order_By>>
  where?: InputMaybe<Coassign_Commit_With_Project_View_Bool_Exp>
}

export type Subscription_RootCoassign_Commit_With_Project_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Commit_With_Project_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Commit_With_Project_View_Order_By>>
  where?: InputMaybe<Coassign_Commit_With_Project_View_Bool_Exp>
}

export type Subscription_RootCoassign_Commit_With_Project_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Commit_With_Project_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Commit_With_Project_View_Bool_Exp>
}

export type Subscription_RootCoassign_Custom_FieldArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
}

export type Subscription_RootCoassign_Custom_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
}

export type Subscription_RootCoassign_Custom_Field_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Custom_Field_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Choice_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

export type Subscription_RootCoassign_Custom_Field_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Custom_Field_Choice_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Custom_Field_Choice_Order_By>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

export type Subscription_RootCoassign_Custom_Field_Choice_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Custom_Field_Choice_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Custom_Field_Choice_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Custom_Field_Choice_Bool_Exp>
}

export type Subscription_RootCoassign_Custom_Field_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Custom_Field_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Custom_Field_Bool_Exp>
}

export type Subscription_RootCoassign_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Department_Order_By>>
  where?: InputMaybe<Coassign_Department_Bool_Exp>
}

export type Subscription_RootCoassign_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Department_Order_By>>
  where?: InputMaybe<Coassign_Department_Bool_Exp>
}

export type Subscription_RootCoassign_Department_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Department_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Department_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Department_Bool_Exp>
}

export type Subscription_RootCoassign_EmploymentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

export type Subscription_RootCoassign_Employment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Order_By>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

export type Subscription_RootCoassign_Employment_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Employment_ContractArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Contract_Order_By>>
  where?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Employment_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Employment_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Employment_Contract_Order_By>>
  where?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Employment_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Employment_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Employment_Contract_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Employment_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Employment_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Employment_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Employment_Bool_Exp>
}

export type Subscription_RootCoassign_HolidayArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Holiday_Bool_Exp>
}

export type Subscription_RootCoassign_Holiday_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Holiday_Bool_Exp>
}

export type Subscription_RootCoassign_Holiday_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Holiday_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Holiday_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Holiday_Bool_Exp>
}

export type Subscription_RootCoassign_JobArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Order_By>>
  where?: InputMaybe<Coassign_Job_Bool_Exp>
}

export type Subscription_RootCoassign_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Order_By>>
  where?: InputMaybe<Coassign_Job_Bool_Exp>
}

export type Subscription_RootCoassign_Job_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Job_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Definition_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Definition_Order_By>>
  where?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Definition_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Definition_Order_By>>
  where?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Definition_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Job_Definition_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Job_Definition_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Job_Definition_Bool_Exp>
}

export type Subscription_RootCoassign_Job_ResultArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Result_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Result_Order_By>>
  where?: InputMaybe<Coassign_Job_Result_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Result_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Result_Order_By>>
  where?: InputMaybe<Coassign_Job_Result_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Result_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Job_Result_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Job_Result_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Job_Result_Bool_Exp>
}

export type Subscription_RootCoassign_Job_SkillArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Skill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Skill_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Job_Skill_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Job_Skill_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_Job_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Job_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Job_Bool_Exp>
}

export type Subscription_RootCoassign_Job_TitleArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_Job_Title_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Title_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_Job_Title_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Title_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Job_Title_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Job_Title_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Job_Title_Bool_Exp>
}

export type Subscription_RootCoassign_Job_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Trigger_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Trigger_Order_By>>
  where?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Job_Trigger_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Job_Trigger_Order_By>>
  where?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
}

export type Subscription_RootCoassign_Job_Trigger_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Job_Trigger_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Job_Trigger_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Job_Trigger_Bool_Exp>
}

export type Subscription_RootCoassign_PartnerArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Partner_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Partner_Order_By>>
  where?: InputMaybe<Coassign_Partner_Bool_Exp>
}

export type Subscription_RootCoassign_Partner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Partner_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Partner_Order_By>>
  where?: InputMaybe<Coassign_Partner_Bool_Exp>
}

export type Subscription_RootCoassign_Partner_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Partner_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Partner_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Partner_Bool_Exp>
}

export type Subscription_RootCoassign_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Order_By>>
  where?: InputMaybe<Coassign_Project_Bool_Exp>
}

export type Subscription_RootCoassign_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Order_By>>
  where?: InputMaybe<Coassign_Project_Bool_Exp>
}

export type Subscription_RootCoassign_Project_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Project_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_History_Order_By>>
  where?: InputMaybe<Coassign_Project_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_History_Order_By>>
  where?: InputMaybe<Coassign_Project_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_Department_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_Department_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_Department_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_To_Department_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_To_Department_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_Department_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_History_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_Department_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_Department_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_Department_History_Order_By>>
  where?: InputMaybe<Coassign_Project_To_Department_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_Department_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_To_Department_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_To_Department_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_Department_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_To_Department_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_UserArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_User_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_User_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_User_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_To_User_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_To_User_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_User_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_History_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_User_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Project_To_User_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Project_To_User_History_Order_By>>
  where?: InputMaybe<Coassign_Project_To_User_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_User_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_To_User_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_To_User_History_Bool_Exp>
}

export type Subscription_RootCoassign_Project_To_User_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Project_To_User_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Project_To_User_Bool_Exp>
}

export type Subscription_RootCoassign_Regular_HolidayArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Regular_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Regular_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
}

export type Subscription_RootCoassign_Regular_Holiday_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Regular_Holiday_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Regular_Holiday_Order_By>>
  where?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
}

export type Subscription_RootCoassign_Regular_Holiday_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Regular_Holiday_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Regular_Holiday_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Regular_Holiday_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_OtherArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_ActualArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_Actual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Actual_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_Actual_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Target_Cost_Other_Actual_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Target_Cost_Other_Actual_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Actual_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Target_Cost_Other_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Target_Cost_Other_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_History_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Target_Cost_Other_History_Order_By>>
  where?: InputMaybe<Coassign_Target_Cost_Other_History_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Target_Cost_Other_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Target_Cost_Other_History_Bool_Exp>
}

export type Subscription_RootCoassign_Target_Cost_Other_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Target_Cost_Other_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Target_Cost_Other_Bool_Exp>
}

export type Subscription_RootCoassign_TenantArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Tenant_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Tenant_Order_By>>
  where?: InputMaybe<Coassign_Tenant_Bool_Exp>
}

export type Subscription_RootCoassign_Tenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Tenant_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Tenant_Order_By>>
  where?: InputMaybe<Coassign_Tenant_Bool_Exp>
}

export type Subscription_RootCoassign_Tenant_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Tenant_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Tenant_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Tenant_Bool_Exp>
}

export type Subscription_RootCoassign_UserArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_Order_By>>
  where?: InputMaybe<Coassign_User_Bool_Exp>
}

export type Subscription_RootCoassign_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_Order_By>>
  where?: InputMaybe<Coassign_User_Bool_Exp>
}

export type Subscription_RootCoassign_User_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_User_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_User_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_User_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Department_Order_By>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_Department_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_User_To_Department_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_User_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_Job_SkillArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_Job_Skill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_Job_Skill_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_User_To_Job_Skill_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_User_To_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_Job_TitleArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_Job_Title_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_User_To_Job_Title_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_User_To_Job_Title_Order_By>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

export type Subscription_RootCoassign_User_To_Job_Title_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_User_To_Job_Title_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_User_To_Job_Title_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_AssignArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Volumed_Assign_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_PlanArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_Plan_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_Plan_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_Plan_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_Plan_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_Plan_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_Plan_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_DepartmentArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Department_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Department_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Department_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Department_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Department_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_To_Department_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Department_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_To_Department_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Department_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_SkillArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_Skill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_Skill_Full_ViewArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_Skill_Full_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_Skill_Full_View_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Full_View_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_Skill_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_Skill_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Volumed_Assign_To_Job_Skill_History_Order_By>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_Skill_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_History_Bool_Exp>
}

export type Subscription_RootCoassign_Volumed_Assign_To_Job_Skill_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Volumed_Assign_To_Job_Skill_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_Project_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Work_On_Project_ContractArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_Project_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_Project_Contract_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootCoassign_Work_On_Project_Contract_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_History_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_Project_Contract_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Coassign_Work_On_Project_Contract_History_Order_By>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_History_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_Project_Contract_History_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Work_On_Project_Contract_History_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_History_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_Project_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Work_On_Project_Contract_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Work_On_Project_Contract_Bool_Exp>
}

export type Subscription_RootCoassign_Work_On_Project_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Coassign_Work_On_Project_Stream_Cursor_Input>>
  where?: InputMaybe<Coassign_Work_On_Project_Bool_Exp>
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>
  _gt?: InputMaybe<Scalars['timestamptz']['input']>
  _gte?: InputMaybe<Scalars['timestamptz']['input']>
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['timestamptz']['input']>
  _lte?: InputMaybe<Scalars['timestamptz']['input']>
  _neq?: InputMaybe<Scalars['timestamptz']['input']>
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>
}

/** Boolean expression to compare columns of type "tstzrange". All fields are combined with logical 'AND'. */
export type Tstzrange_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tstzrange']['input']>
  _gt?: InputMaybe<Scalars['tstzrange']['input']>
  _gte?: InputMaybe<Scalars['tstzrange']['input']>
  _in?: InputMaybe<Array<Scalars['tstzrange']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['tstzrange']['input']>
  _lte?: InputMaybe<Scalars['tstzrange']['input']>
  _neq?: InputMaybe<Scalars['tstzrange']['input']>
  _nin?: InputMaybe<Array<Scalars['tstzrange']['input']>>
}

/** A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations. */
export type __Schema = {
  __typename?: '__Schema'
  description?: Maybe<Scalars['String']['output']>
  /** A list of all types supported by this server. */
  types: Array<__Type>
  /** The type that query operations will be rooted at. */
  queryType: __Type
  /** If this server supports mutation, the type that mutation operations will be rooted at. */
  mutationType?: Maybe<__Type>
  /** If this server support subscription, the type that subscription operations will be rooted at. */
  subscriptionType?: Maybe<__Type>
  /** A list of all directives supported by this server. */
  directives: Array<__Directive>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type'
  kind: __TypeKind
  name?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  specifiedByURL?: Maybe<Scalars['String']['output']>
  fields?: Maybe<Array<__Field>>
  interfaces?: Maybe<Array<__Type>>
  possibleTypes?: Maybe<Array<__Type>>
  enumValues?: Maybe<Array<__EnumValue>>
  inputFields?: Maybe<Array<__InputValue>>
  ofType?: Maybe<__Type>
  isOneOf?: Maybe<Scalars['Boolean']['output']>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>
}

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field'
  name: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  args: Array<__InputValue>
  type: __Type
  isDeprecated: Scalars['Boolean']['output']
  deprecationReason?: Maybe<Scalars['String']['output']>
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>
}

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue'
  name: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  type: __Type
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>
  isDeprecated: Scalars['Boolean']['output']
  deprecationReason?: Maybe<Scalars['String']['output']>
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue'
  name: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  isDeprecated: Scalars['Boolean']['output']
  deprecationReason?: Maybe<Scalars['String']['output']>
}

/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export type __Directive = {
  __typename?: '__Directive'
  name: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  isRepeatable: Scalars['Boolean']['output']
  locations: Array<__DirectiveLocation>
  args: Array<__InputValue>
}

/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export type __DirectiveArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>
}

/** A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies. */
export enum __DirectiveLocation {
  /** Location adjacent to a query operation. */
  Query = 'QUERY',
  /** Location adjacent to a mutation operation. */
  Mutation = 'MUTATION',
  /** Location adjacent to a subscription operation. */
  Subscription = 'SUBSCRIPTION',
  /** Location adjacent to a field. */
  Field = 'FIELD',
  /** Location adjacent to a fragment definition. */
  FragmentDefinition = 'FRAGMENT_DEFINITION',
  /** Location adjacent to a fragment spread. */
  FragmentSpread = 'FRAGMENT_SPREAD',
  /** Location adjacent to an inline fragment. */
  InlineFragment = 'INLINE_FRAGMENT',
  /** Location adjacent to a variable definition. */
  VariableDefinition = 'VARIABLE_DEFINITION',
  /** Location adjacent to a schema definition. */
  Schema = 'SCHEMA',
  /** Location adjacent to a scalar definition. */
  Scalar = 'SCALAR',
  /** Location adjacent to an object type definition. */
  Object = 'OBJECT',
  /** Location adjacent to a field definition. */
  FieldDefinition = 'FIELD_DEFINITION',
  /** Location adjacent to an argument definition. */
  ArgumentDefinition = 'ARGUMENT_DEFINITION',
  /** Location adjacent to an interface definition. */
  Interface = 'INTERFACE',
  /** Location adjacent to a union definition. */
  Union = 'UNION',
  /** Location adjacent to an enum definition. */
  Enum = 'ENUM',
  /** Location adjacent to an enum value definition. */
  EnumValue = 'ENUM_VALUE',
  /** Location adjacent to an input object type definition. */
  InputObject = 'INPUT_OBJECT',
  /** Location adjacent to an input object field definition. */
  InputFieldDefinition = 'INPUT_FIELD_DEFINITION'
}

export type InsertAssignMutationVariables = Exact<{
  input: Coassign_Assign_Insert_Input
}>

export type InsertAssignMutation = {
  __typename?: 'mutation_root'
  insert_coassign_assign_one?: { __typename?: 'coassign_assign'; created_at: any } | null
}

export type UpdateAssignMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Assign_Set_Input
}>

export type UpdateAssignMutation = {
  __typename?: 'mutation_root'
  update_coassign_assign_by_pk?: { __typename?: 'coassign_assign'; updated_at: any } | null
}

export type UpdateAssignPlanByAssignIdMutationVariables = Exact<{
  assignId: Scalars['String']['input']
  input: Coassign_Assign_Plan_Set_Input
}>

export type UpdateAssignPlanByAssignIdMutation = {
  __typename?: 'mutation_root'
  update_coassign_assign_plan?: {
    __typename?: 'coassign_assign_plan_mutation_response'
    returning: Array<{ __typename?: 'coassign_assign_plan'; updated_at: any }>
  } | null
}

export type UpdateDeletedAtWorkOnProjectFromAssignMutationDocumentMutationVariables = Exact<{
  assignId: Scalars['String']['input']
  input: Coassign_Work_On_Project_Set_Input
}>

export type UpdateDeletedAtWorkOnProjectFromAssignMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_work_on_project?: {
    __typename?: 'coassign_work_on_project_mutation_response'
    affected_rows: number
  } | null
}

export type InsertAssignPlanMutationVariables = Exact<{
  input: Coassign_Assign_Plan_Insert_Input
}>

export type InsertAssignPlanMutation = {
  __typename?: 'mutation_root'
  insert_coassign_assign_plan_one?: { __typename?: 'coassign_assign_plan'; created_at: any } | null
}

export type UpdateAssignPlanMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Assign_Plan_Set_Input
}>

export type UpdateAssignPlanMutation = {
  __typename?: 'mutation_root'
  update_coassign_assign_plan_by_pk?: {
    __typename?: 'coassign_assign_plan'
    updated_at: any
  } | null
}

export type InsertAttendanceMutationVariables = Exact<{
  input: Coassign_Attendance_Insert_Input
}>

export type InsertAttendanceMutation = {
  __typename?: 'mutation_root'
  insert_coassign_attendance_one?: { __typename?: 'coassign_attendance'; created_at: any } | null
}

export type UpdateAttendanceMutationVariables = Exact<{
  id: Scalars['String']['input']
  commit_id: Scalars['String']['input']
  clocks: Scalars['jsonb']['input']
}>

export type UpdateAttendanceMutation = {
  __typename?: 'mutation_root'
  update_coassign_attendance_by_pk?: { __typename?: 'coassign_attendance'; updated_at: any } | null
}

export type RemoveClocksFromAttendanceMutationVariables = Exact<{
  id: Scalars['String']['input']
  commit_id: Scalars['String']['input']
  clocks: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type RemoveClocksFromAttendanceMutation = {
  __typename?: 'mutation_root'
  update_coassign_attendance_by_pk?: { __typename?: 'coassign_attendance'; updated_at: any } | null
}

export type InsertClientMutationVariables = Exact<{
  input: Coassign_Client_Insert_Input
}>

export type InsertClientMutation = {
  __typename?: 'mutation_root'
  insert_coassign_client_one?: { __typename?: 'coassign_client'; created_at: any } | null
}

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Client_Set_Input
}>

export type UpdateClientMutation = {
  __typename?: 'mutation_root'
  update_coassign_client_by_pk?: { __typename?: 'coassign_client'; updated_at: any } | null
}

export type InsertCustomFieldMutationVariables = Exact<{
  input: Coassign_Custom_Field_Insert_Input
}>

export type InsertCustomFieldMutation = {
  __typename?: 'mutation_root'
  insert_coassign_custom_field_one?: {
    __typename?: 'coassign_custom_field'
    created_at: any
  } | null
}

export type UpdateCustomFieldMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Custom_Field_Set_Input
}>

export type UpdateCustomFieldMutation = {
  __typename?: 'mutation_root'
  update_coassign_custom_field_by_pk?: {
    __typename?: 'coassign_custom_field'
    updated_at: any
  } | null
}

export type UpdateCustomFieldChoiceManyMutationVariables = Exact<{
  updates: Array<Coassign_Custom_Field_Choice_Updates> | Coassign_Custom_Field_Choice_Updates
}>

export type UpdateCustomFieldChoiceManyMutation = {
  __typename?: 'mutation_root'
  update_coassign_custom_field_choice_many?: Array<{
    __typename?: 'coassign_custom_field_choice_mutation_response'
    affected_rows: number
  } | null> | null
}

export type InsertCustomFieldChoiceMutationVariables = Exact<{
  input: Coassign_Custom_Field_Choice_Insert_Input
}>

export type InsertCustomFieldChoiceMutation = {
  __typename?: 'mutation_root'
  insert_coassign_custom_field_choice_one?: {
    __typename?: 'coassign_custom_field_choice'
    created_at: any
  } | null
}

export type UpdateCustomFieldChoiceMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Custom_Field_Choice_Set_Input
}>

export type UpdateCustomFieldChoiceMutation = {
  __typename?: 'mutation_root'
  update_coassign_custom_field_choice_by_pk?: {
    __typename?: 'coassign_custom_field_choice'
    updated_at: any
  } | null
}

export type InsertDepartmentMutationVariables = Exact<{
  input: Coassign_Department_Insert_Input
}>

export type InsertDepartmentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_department_one?: { __typename?: 'coassign_department'; created_at: any } | null
}

export type UpdateDepartmentMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Department_Set_Input
}>

export type UpdateDepartmentMutation = {
  __typename?: 'mutation_root'
  update_coassign_department_by_pk?: { __typename?: 'coassign_department'; updated_at: any } | null
}

export type InsertEmploymentMutationVariables = Exact<{
  input: Coassign_Employment_Insert_Input
}>

export type InsertEmploymentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_employment_one?: { __typename?: 'coassign_employment'; created_at: any } | null
}

export type UpdateEmploymentMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Employment_Set_Input
}>

export type UpdateEmploymentMutation = {
  __typename?: 'mutation_root'
  update_coassign_employment_by_pk?: { __typename?: 'coassign_employment'; updated_at: any } | null
}

export type InsertHolidayMutationVariables = Exact<{
  input: Coassign_Holiday_Insert_Input
}>

export type InsertHolidayMutation = {
  __typename?: 'mutation_root'
  insert_coassign_holiday_one?: { __typename?: 'coassign_holiday'; created_at: any } | null
}

export type UpdateHolidayMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Holiday_Set_Input
}>

export type UpdateHolidayMutation = {
  __typename?: 'mutation_root'
  update_coassign_holiday_by_pk?: { __typename?: 'coassign_holiday'; updated_at: any } | null
}

export type InsertJobMutationVariables = Exact<{
  input: Coassign_Job_Insert_Input
}>

export type InsertJobMutation = {
  __typename?: 'mutation_root'
  insert_coassign_job_one?: { __typename?: 'coassign_job'; created_at: any } | null
}

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Job_Set_Input
}>

export type UpdateJobMutation = {
  __typename?: 'mutation_root'
  update_coassign_job_by_pk?: { __typename?: 'coassign_job'; updated_at: any } | null
}

export type InsertJobSkillMutationVariables = Exact<{
  input: Coassign_Job_Skill_Insert_Input
}>

export type InsertJobSkillMutation = {
  __typename?: 'mutation_root'
  insert_coassign_job_skill_one?: { __typename?: 'coassign_job_skill'; created_at: any } | null
}

export type UpdateJobSkillMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Job_Skill_Set_Input
}>

export type UpdateJobSkillMutation = {
  __typename?: 'mutation_root'
  update_coassign_job_skill_by_pk?: { __typename?: 'coassign_job_skill'; updated_at: any } | null
}

export type InsertJobTitleMutationVariables = Exact<{
  input: Coassign_Job_Title_Insert_Input
}>

export type InsertJobTitleMutation = {
  __typename?: 'mutation_root'
  insert_coassign_job_title_one?: { __typename?: 'coassign_job_title'; created_at: any } | null
}

export type UpdateJobTitleMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Job_Title_Set_Input
}>

export type UpdateJobTitleMutation = {
  __typename?: 'mutation_root'
  update_coassign_job_title_by_pk?: { __typename?: 'coassign_job_title'; updated_at: any } | null
}

export type InsertJobTriggerMutationVariables = Exact<{
  input: Coassign_Job_Trigger_Insert_Input
}>

export type InsertJobTriggerMutation = {
  __typename?: 'mutation_root'
  insert_coassign_job_trigger_one?: { __typename?: 'coassign_job_trigger'; created_at: any } | null
}

export type UpdateJobTriggerMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Job_Trigger_Set_Input
}>

export type UpdateJobTriggerMutation = {
  __typename?: 'mutation_root'
  update_coassign_job_trigger_by_pk?: {
    __typename?: 'coassign_job_trigger'
    updated_at: any
  } | null
}

export type InsertPartnerMutationVariables = Exact<{
  input: Coassign_Partner_Insert_Input
}>

export type InsertPartnerMutation = {
  __typename?: 'mutation_root'
  insert_coassign_partner_one?: { __typename?: 'coassign_partner'; created_at: any } | null
}

export type UpdatePartnerMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Partner_Set_Input
}>

export type UpdatePartnerMutation = {
  __typename?: 'mutation_root'
  update_coassign_partner_by_pk?: { __typename?: 'coassign_partner'; updated_at: any } | null
}

export type InsertProjectMutationVariables = Exact<{
  input: Coassign_Project_Insert_Input
}>

export type InsertProjectMutation = {
  __typename?: 'mutation_root'
  insert_coassign_project_one?: { __typename?: 'coassign_project'; created_at: any } | null
}

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Project_Set_Input
}>

export type UpdateProjectMutation = {
  __typename?: 'mutation_root'
  update_coassign_project_by_pk?: { __typename?: 'coassign_project'; updated_at: any } | null
}

export type InsertProjectToUserMutationDocumentMutationVariables = Exact<{
  input: Array<Coassign_Project_To_User_Insert_Input> | Coassign_Project_To_User_Insert_Input
}>

export type InsertProjectToUserMutationDocumentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_project_to_user?: {
    __typename?: 'coassign_project_to_user_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateProjectToUserMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  user_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateProjectToUserMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_project_to_user?: {
    __typename?: 'coassign_project_to_user_mutation_response'
    affected_rows: number
  } | null
}

export type InsertProjectToDepartmentMutationDocumentMutationVariables = Exact<{
  input:
    | Array<Coassign_Project_To_Department_Insert_Input>
    | Coassign_Project_To_Department_Insert_Input
}>

export type InsertProjectToDepartmentMutationDocumentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_project_to_department?: {
    __typename?: 'coassign_project_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateProjectToDepartmentMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  department_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateProjectToDepartmentMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_project_to_department?: {
    __typename?: 'coassign_project_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtProjectToDepartmentMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtProjectToDepartmentMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_project_to_department?: {
    __typename?: 'coassign_project_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtProjectToUserMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtProjectToUserMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_project_to_user?: {
    __typename?: 'coassign_project_to_user_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtAssignPlanMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtAssignPlanMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_assign_plan?: {
    __typename?: 'coassign_assign_plan_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtAssignMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtAssignMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_assign?: {
    __typename?: 'coassign_assign_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtVolumedAssignPlanMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtVolumedAssignPlanMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_plan?: {
    __typename?: 'coassign_volumed_assign_plan_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtVolumedAssignToJobSkillMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtVolumedAssignToJobSkillMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_to_job_skill?: {
    __typename?: 'coassign_volumed_assign_to_job_skill_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtVolumedAssignMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtVolumedAssignMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign?: {
    __typename?: 'coassign_volumed_assign_mutation_response'
    affected_rows: number
  } | null
}

export type DeleteVolumedAssignToDepartmentByProjectMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type DeleteVolumedAssignToDepartmentByProjectMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_to_department?: {
    __typename?: 'coassign_volumed_assign_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtWorkOnProjectMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtWorkOnProjectMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_work_on_project?: {
    __typename?: 'coassign_work_on_project_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtTargetCostOtherByProjectMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtTargetCostOtherByProjectMutation = {
  __typename?: 'mutation_root'
  update_coassign_target_cost_other?: {
    __typename?: 'coassign_target_cost_other_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtMutationDocumentMutationVariables = Exact<{
  project_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_project?: {
    __typename?: 'coassign_project_mutation_response'
    affected_rows: number
  } | null
}

export type InsertRegularHolidayMutationVariables = Exact<{
  input: Coassign_Regular_Holiday_Insert_Input
}>

export type InsertRegularHolidayMutation = {
  __typename?: 'mutation_root'
  insert_coassign_regular_holiday_one?: {
    __typename?: 'coassign_regular_holiday'
    created_at: any
  } | null
}

export type UpdateRegularHolidayMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Regular_Holiday_Set_Input
}>

export type UpdateRegularHolidayMutation = {
  __typename?: 'mutation_root'
  update_coassign_regular_holiday_by_pk?: {
    __typename?: 'coassign_regular_holiday'
    updated_at: any
  } | null
}

export type InsertTargetCostOtherMutationVariables = Exact<{
  input: Coassign_Target_Cost_Other_Insert_Input
}>

export type InsertTargetCostOtherMutation = {
  __typename?: 'mutation_root'
  insert_coassign_target_cost_other_one?: {
    __typename?: 'coassign_target_cost_other'
    created_at: any
  } | null
}

export type UpdateTargetCostOtherMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Target_Cost_Other_Set_Input
}>

export type UpdateTargetCostOtherMutation = {
  __typename?: 'mutation_root'
  update_coassign_target_cost_other_by_pk?: {
    __typename?: 'coassign_target_cost_other'
    updated_at: any
  } | null
}

export type UpdateDeletedAtTargetCostOtherMutationDocumentMutationVariables = Exact<{
  target_cost_other_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtTargetCostOtherMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_target_cost_other?: {
    __typename?: 'coassign_target_cost_other_mutation_response'
    affected_rows: number
  } | null
}

export type InsertTargetCostOtherActualMutationVariables = Exact<{
  input: Coassign_Target_Cost_Other_Actual_Insert_Input
}>

export type InsertTargetCostOtherActualMutation = {
  __typename?: 'mutation_root'
  insert_coassign_target_cost_other_actual_one?: {
    __typename?: 'coassign_target_cost_other_actual'
    created_at: any
  } | null
}

export type UpdateTargetCostOtherActualMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Target_Cost_Other_Actual_Set_Input
}>

export type UpdateTargetCostOtherActualMutation = {
  __typename?: 'mutation_root'
  update_coassign_target_cost_other_actual_by_pk?: {
    __typename?: 'coassign_target_cost_other_actual'
    updated_at: any
  } | null
}

export type UpdateDeletedAtTargetCostOtherActualMutationVariables = Exact<{
  target_cost_other_actual_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtTargetCostOtherActualMutation = {
  __typename?: 'mutation_root'
  update_coassign_target_cost_other_actual?: {
    __typename?: 'coassign_target_cost_other_actual_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateTenantSettingsMutationMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Scalars['json']['input']
  commitId: Scalars['String']['input']
}>

export type UpdateTenantSettingsMutationMutation = {
  __typename?: 'mutation_root'
  update_coassign_tenant_by_pk?: { __typename?: 'coassign_tenant'; created_at: any } | null
}

export type UpdateMfaStatusMutationMutationVariables = Exact<{
  status: Scalars['Boolean']['input']
}>

export type UpdateMfaStatusMutationMutation = { __typename?: 'mutation_root'; UpdateMfaStatus: any }

export type InsertUserMutationDocumentMutationVariables = Exact<{
  input: Coassign_User_Insert_Input
}>

export type InsertUserMutationDocumentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_user_one?: { __typename?: 'coassign_user'; updated_at: any } | null
}

export type UpdateUserMutationDocumentMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_User_Set_Input
}>

export type UpdateUserMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_user_by_pk?: { __typename?: 'coassign_user'; updated_at: any } | null
}

export type InsertUserToDepartmentMutationDocumentMutationVariables = Exact<{
  input: Array<Coassign_User_To_Department_Insert_Input> | Coassign_User_To_Department_Insert_Input
}>

export type InsertUserToDepartmentMutationDocumentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_user_to_department?: {
    __typename?: 'coassign_user_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateUserToDepartmentMutationDocumentMutationVariables = Exact<{
  user_id: Scalars['String']['input']
  department_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateUserToDepartmentMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_user_to_department?: {
    __typename?: 'coassign_user_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type InsertUserToJobTitleMutationDocumentMutationVariables = Exact<{
  input: Array<Coassign_User_To_Job_Title_Insert_Input> | Coassign_User_To_Job_Title_Insert_Input
}>

export type InsertUserToJobTitleMutationDocumentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_user_to_job_title?: {
    __typename?: 'coassign_user_to_job_title_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateUserToJobTitleMutationDocumentMutationVariables = Exact<{
  user_id: Scalars['String']['input']
  job_title_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateUserToJobTitleMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_user_to_job_title?: {
    __typename?: 'coassign_user_to_job_title_mutation_response'
    affected_rows: number
  } | null
}

export type InsertUserToJobSkillMutationDocumentMutationVariables = Exact<{
  input: Array<Coassign_User_To_Job_Skill_Insert_Input> | Coassign_User_To_Job_Skill_Insert_Input
}>

export type InsertUserToJobSkillMutationDocumentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_user_to_job_skill?: {
    __typename?: 'coassign_user_to_job_skill_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateUserToJobSkillMutationDocumentMutationVariables = Exact<{
  user_id: Scalars['String']['input']
  job_skill_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateUserToJobSkillMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_user_to_job_skill?: {
    __typename?: 'coassign_user_to_job_skill_mutation_response'
    affected_rows: number
  } | null
}

export type MutateCreateFirebaseUserMutationVariables = Exact<{
  email: Scalars['String']['input']
  firebase_tenant_id: Scalars['String']['input']
  subdomain: Scalars['String']['input']
}>

export type MutateCreateFirebaseUserMutation = {
  __typename?: 'mutation_root'
  CreateFirebaseUser?: { __typename?: 'Output'; result: string } | null
}

export type MutateUpdateFirebaseUserMutationVariables = Exact<{
  firebase_tenant_id: Scalars['String']['input']
  firebase_uid: Scalars['String']['input']
  email: Scalars['String']['input']
  disabled?: InputMaybe<Scalars['Boolean']['input']>
}>

export type MutateUpdateFirebaseUserMutation = {
  __typename?: 'mutation_root'
  UpdateEmailFirebaseUser?: { __typename?: 'Output'; result: string } | null
}

export type UpdatePasswordMutationVariables = Exact<{
  firebase_tenant_id: Scalars['String']['input']
  firebase_uid: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type UpdatePasswordMutation = {
  __typename?: 'mutation_root'
  UpdateEmailFirebaseUser?: { __typename?: 'Output'; result: string } | null
}

export type InsertVolumedAssignMutationVariables = Exact<{
  input: Coassign_Volumed_Assign_Insert_Input
}>

export type InsertVolumedAssignMutation = {
  __typename?: 'mutation_root'
  insert_coassign_volumed_assign_one?: {
    __typename?: 'coassign_volumed_assign'
    created_at: any
  } | null
}

export type InsertVolumedAssignToJobSkillMutationDocumentMutationVariables = Exact<{
  input:
    | Array<Coassign_Volumed_Assign_To_Job_Skill_Insert_Input>
    | Coassign_Volumed_Assign_To_Job_Skill_Insert_Input
}>

export type InsertVolumedAssignToJobSkillMutationDocumentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_volumed_assign_to_job_skill?: {
    __typename?: 'coassign_volumed_assign_to_job_skill_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateVolumedAssignMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Volumed_Assign_Set_Input
}>

export type UpdateVolumedAssignMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_by_pk?: {
    __typename?: 'coassign_volumed_assign'
    updated_at: any
  } | null
}

export type UpdatVolumedAssignToJobSkillMutationDocumentMutationVariables = Exact<{
  volumed_assign_id: Scalars['String']['input']
  job_skill_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdatVolumedAssignToJobSkillMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_to_job_skill?: {
    __typename?: 'coassign_volumed_assign_to_job_skill_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateVolumedAssignMutationDocumentMutationVariables = Exact<{
  id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateVolumedAssignMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign?: {
    __typename?: 'coassign_volumed_assign_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateVolumedAssignPlanMutationDocumentMutationVariables = Exact<{
  volumedAssignId: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateVolumedAssignPlanMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_plan?: {
    __typename?: 'coassign_volumed_assign_plan_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateVolumedAssignToJobSkillMutationDocumentMutationVariables = Exact<{
  volumedAssignId: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateVolumedAssignToJobSkillMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_to_job_skill?: {
    __typename?: 'coassign_volumed_assign_to_job_skill_mutation_response'
    affected_rows: number
  } | null
}

export type InsertVolumedAssignToDepartmentMutationDocumentMutationVariables = Exact<{
  input:
    | Array<Coassign_Volumed_Assign_To_Department_Insert_Input>
    | Coassign_Volumed_Assign_To_Department_Insert_Input
}>

export type InsertVolumedAssignToDepartmentMutationDocumentMutation = {
  __typename?: 'mutation_root'
  insert_coassign_volumed_assign_to_department?: {
    __typename?: 'coassign_volumed_assign_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateVolumedAssignToDepartmentMutationDocumentMutationVariables = Exact<{
  volumed_assign_id: Scalars['String']['input']
  department_id: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateVolumedAssignToDepartmentMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_to_department?: {
    __typename?: 'coassign_volumed_assign_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateDeletedAtVolumedAssignToDepartmentMutationDocumentMutationVariables = Exact<{
  volumedAssignId: Scalars['String']['input']
  deletedAt: Scalars['timestamptz']['input']
  commit_id: Scalars['String']['input']
}>

export type UpdateDeletedAtVolumedAssignToDepartmentMutationDocumentMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_to_department?: {
    __typename?: 'coassign_volumed_assign_to_department_mutation_response'
    affected_rows: number
  } | null
}

export type InsertVolumedAssignPlanMutationVariables = Exact<{
  input: Coassign_Volumed_Assign_Plan_Insert_Input
}>

export type InsertVolumedAssignPlanMutation = {
  __typename?: 'mutation_root'
  insert_coassign_volumed_assign_plan_one?: {
    __typename?: 'coassign_volumed_assign_plan'
    created_at: any
  } | null
}

export type UpdateVolumedAssignPlanMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: Coassign_Volumed_Assign_Plan_Set_Input
}>

export type UpdateVolumedAssignPlanMutation = {
  __typename?: 'mutation_root'
  update_coassign_volumed_assign_plan_by_pk?: {
    __typename?: 'coassign_volumed_assign_plan'
    updated_at: any
  } | null
}

export type InsertWorkOnProjectMutationVariables = Exact<{
  input: Coassign_Work_On_Project_Insert_Input
}>

export type InsertWorkOnProjectMutation = {
  __typename?: 'mutation_root'
  insert_coassign_work_on_project_one?: {
    __typename?: 'coassign_work_on_project'
    created_at: any
  } | null
}

export type UpdateWorkOnProjectMutationVariables = Exact<{
  id: Scalars['String']['input']
  commit_id: Scalars['String']['input']
  actuals: Scalars['jsonb']['input']
  comments?: InputMaybe<Scalars['jsonb']['input']>
}>

export type UpdateWorkOnProjectMutation = {
  __typename?: 'mutation_root'
  update_coassign_work_on_project_by_pk?: {
    __typename?: 'coassign_work_on_project'
    updated_at: any
  } | null
}

export type InsertCommitMutationVariables = Exact<{
  input: Coassign_Commit_Insert_Input
}>

export type InsertCommitMutation = {
  __typename?: 'mutation_root'
  insert_coassign_commit_one?: { __typename?: 'coassign_commit'; created_at: any } | null
}

export type TriggerJobByIdMutationVariables = Exact<{
  id: Scalars['String']['input']
  jobResultId: Scalars['String']['input']
  params: Scalars['String']['input']
}>

export type TriggerJobByIdMutation = {
  __typename?: 'mutation_root'
  TriggerJobById?: { __typename?: 'TriggerJobByIdOutput'; id: string } | null
}

export type GenerateS3UrlForUploadMutationVariables = Exact<{
  job_id: Scalars['String']['input']
  result_id: Scalars['String']['input']
}>

export type GenerateS3UrlForUploadMutation = {
  __typename?: 'mutation_root'
  GenerateS3UrlForUpload?: {
    __typename?: 'GenerateS3UrlForUploadOutput'
    url?: string | null
  } | null
}

export type GenerateJobResultS3UrlMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GenerateJobResultS3UrlMutation = {
  __typename?: 'mutation_root'
  GenerateJobResultS3Url?: {
    __typename?: 'GenerateJobResultS3UrlOutput'
    url?: string | null
  } | null
}

export type GetJobResultsQueryVariables = Exact<{
  job_id: Scalars['String']['input']
}>

export type GetJobResultsQuery = {
  __typename?: 'query_root'
  coassign_job_result: Array<{
    __typename?: 'coassign_job_result'
    id: string
    created_at: any
    updated_at: any
    job_id: string
    log?: string | null
    state: any
    result?: string | null
    user: { __typename?: 'coassign_user'; name: string }
    job: { __typename?: 'coassign_job'; name: string }
    job_definition: { __typename?: 'coassign_job_definition'; extension?: string | null }
  }>
}

export type GetCommitHistoryQueryVariables = Exact<{
  project_id: Scalars['String']['input']
}>

export type GetCommitHistoryQuery = {
  __typename?: 'query_root'
  coassign_commit_with_project_view: Array<{
    __typename?: 'coassign_commit_with_project_view'
    commit_id?: string | null
    project_id?: string | null
    target?: string | null
    commit_at?: any | null
    message?: string | null
    change_type?: string | null
    diff?: any | null
    context?: any | null
    commit_user?: { __typename?: 'coassign_user'; name: string; id: string } | null
  }>
}

export type ResetMfaUserStatusMutationMutationVariables = Exact<{
  uuid: Scalars['String']['input']
}>

export type ResetMfaUserStatusMutationMutation = {
  __typename?: 'mutation_root'
  ResetMfaUserStatus?: { __typename?: 'ResetMfaUserStatusOutput'; message: string } | null
}

export type HertbeatSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type HertbeatSubscriptionSubscription = {
  __typename?: 'subscription_root'
  coassign_tenant: Array<{ __typename?: 'coassign_tenant'; id: string }>
}

export type IntrospectionQueryVariables = Exact<{ [key: string]: never }>

export type IntrospectionQuery = {
  __typename?: 'query_root'
  __schema: {
    __typename?: '__Schema'
    types: Array<
      { __typename?: '__Type' } & { ' $fragmentRefs'?: { FullTypeFragment: FullTypeFragment } }
    >
  }
}

export type FullTypeFragment = {
  __typename?: '__Type'
  kind: __TypeKind
  name?: string | null
  description?: string | null
  fields?: Array<{
    __typename?: '__Field'
    name: string
    description?: string | null
    isDeprecated: boolean
    deprecationReason?: string | null
    args: Array<
      { __typename?: '__InputValue' } & {
        ' $fragmentRefs'?: { InputValueFragment: InputValueFragment }
      }
    >
    type: { __typename?: '__Type' } & { ' $fragmentRefs'?: { TypeRefFragment: TypeRefFragment } }
  }> | null
  inputFields?: Array<
    { __typename?: '__InputValue' } & {
      ' $fragmentRefs'?: { InputValueFragment: InputValueFragment }
    }
  > | null
  interfaces?: Array<
    { __typename?: '__Type' } & { ' $fragmentRefs'?: { TypeRefFragment: TypeRefFragment } }
  > | null
  enumValues?: Array<{
    __typename?: '__EnumValue'
    name: string
    description?: string | null
    isDeprecated: boolean
    deprecationReason?: string | null
  }> | null
  possibleTypes?: Array<
    { __typename?: '__Type' } & { ' $fragmentRefs'?: { TypeRefFragment: TypeRefFragment } }
  > | null
} & { ' $fragmentName'?: 'FullTypeFragment' }

export type InputValueFragment = {
  __typename?: '__InputValue'
  name: string
  description?: string | null
  defaultValue?: string | null
  type: { __typename?: '__Type' } & { ' $fragmentRefs'?: { TypeRefFragment: TypeRefFragment } }
} & { ' $fragmentName'?: 'InputValueFragment' }

export type TypeRefFragment = {
  __typename?: '__Type'
  kind: __TypeKind
  name?: string | null
  ofType?: {
    __typename?: '__Type'
    kind: __TypeKind
    name?: string | null
    ofType?: {
      __typename?: '__Type'
      kind: __TypeKind
      name?: string | null
      ofType?: {
        __typename?: '__Type'
        kind: __TypeKind
        name?: string | null
        ofType?: {
          __typename?: '__Type'
          kind: __TypeKind
          name?: string | null
          ofType?: {
            __typename?: '__Type'
            kind: __TypeKind
            name?: string | null
            ofType?: {
              __typename?: '__Type'
              kind: __TypeKind
              name?: string | null
              ofType?: { __typename?: '__Type'; kind: __TypeKind; name?: string | null } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
} & { ' $fragmentName'?: 'TypeRefFragment' }

export const TypeRefFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TypeRef' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__Type' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ofType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ofType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ofType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ofType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ofType' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ofType' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'kind' }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'ofType' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'kind' }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'name' }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<TypeRefFragment, unknown>
export const InputValueFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InputValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__InputValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TypeRef' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__Type' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ofType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ofType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ofType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ofType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ofType' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ofType' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'kind' }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'ofType' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'kind' }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'name' }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InputValueFragment, unknown>
export const FullTypeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FullType' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__Type' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeDeprecated' },
                value: { kind: 'BooleanValue', value: true }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'args' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InputValue' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeprecated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deprecationReason' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inputFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InputValue' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interfaces' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enumValues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeDeprecated' },
                value: { kind: 'BooleanValue', value: true }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeprecated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deprecationReason' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'possibleTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TypeRef' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__Type' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ofType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ofType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ofType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ofType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ofType' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ofType' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'kind' }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'ofType' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'kind' }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'name' }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InputValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__InputValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<FullTypeFragment, unknown>
export const InsertAssignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertAssign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_assign_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_assign_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertAssignMutation, InsertAssignMutationVariables>
export const UpdateAssignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAssign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_assign_set_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_assign_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateAssignMutation, UpdateAssignMutationVariables>
export const UpdateAssignPlanByAssignIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAssignPlanByAssignId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_assign_plan_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_assign_plan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assign_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'assignId' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateAssignPlanByAssignIdMutation,
  UpdateAssignPlanByAssignIdMutationVariables
>
export const UpdateDeletedAtWorkOnProjectFromAssignMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtWorkOnProjectFromAssignMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_work_on_project_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_work_on_project' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assign_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'assignId' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtWorkOnProjectFromAssignMutationDocumentMutation,
  UpdateDeletedAtWorkOnProjectFromAssignMutationDocumentMutationVariables
>
export const InsertAssignPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertAssignPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_assign_plan_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_assign_plan_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertAssignPlanMutation, InsertAssignPlanMutationVariables>
export const UpdateAssignPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAssignPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_assign_plan_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_assign_plan_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateAssignPlanMutation, UpdateAssignPlanMutationVariables>
export const InsertAttendanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertAttendance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_attendance_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_attendance_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertAttendanceMutation, InsertAttendanceMutationVariables>
export const UpdateAttendanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAttendance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clocks' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_attendance_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_append' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clocks' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clocks' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateAttendanceMutation, UpdateAttendanceMutationVariables>
export const RemoveClocksFromAttendanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeClocksFromAttendance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clocks' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_attendance_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_delete_at_path' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clocks' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clocks' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RemoveClocksFromAttendanceMutation,
  RemoveClocksFromAttendanceMutationVariables
>
export const InsertClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_client_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_client_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertClientMutation, InsertClientMutationVariables>
export const UpdateClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_client_set_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_client_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateClientMutation, UpdateClientMutationVariables>
export const InsertCustomFieldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertCustomField' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_custom_field_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_custom_field_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertCustomFieldMutation, InsertCustomFieldMutationVariables>
export const UpdateCustomFieldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCustomField' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_custom_field_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_custom_field_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>
export const UpdateCustomFieldChoiceManyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCustomFieldChoiceMany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'coassign_custom_field_choice_updates' }
                }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_custom_field_choice_many' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updates' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateCustomFieldChoiceManyMutation,
  UpdateCustomFieldChoiceManyMutationVariables
>
export const InsertCustomFieldChoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertCustomFieldChoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_custom_field_choice_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_custom_field_choice_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertCustomFieldChoiceMutation,
  InsertCustomFieldChoiceMutationVariables
>
export const UpdateCustomFieldChoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCustomFieldChoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_custom_field_choice_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_custom_field_choice_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateCustomFieldChoiceMutation,
  UpdateCustomFieldChoiceMutationVariables
>
export const InsertDepartmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertDepartment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_department_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_department_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertDepartmentMutation, InsertDepartmentMutationVariables>
export const UpdateDepartmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDepartment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_department_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_department_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>
export const InsertEmploymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertEmployment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_employment_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_employment_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertEmploymentMutation, InsertEmploymentMutationVariables>
export const UpdateEmploymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEmployment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_employment_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_employment_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateEmploymentMutation, UpdateEmploymentMutationVariables>
export const InsertHolidayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertHoliday' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_holiday_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_holiday_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertHolidayMutation, InsertHolidayMutationVariables>
export const UpdateHolidayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateHoliday' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_holiday_set_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_holiday_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateHolidayMutation, UpdateHolidayMutationVariables>
export const InsertJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_job_insert_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_job_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertJobMutation, InsertJobMutationVariables>
export const UpdateJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_job_set_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_job_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateJobMutation, UpdateJobMutationVariables>
export const InsertJobSkillDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertJobSkill' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_job_skill_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_job_skill_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertJobSkillMutation, InsertJobSkillMutationVariables>
export const UpdateJobSkillDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateJobSkill' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_job_skill_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_job_skill_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateJobSkillMutation, UpdateJobSkillMutationVariables>
export const InsertJobTitleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertJobTitle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_job_title_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_job_title_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertJobTitleMutation, InsertJobTitleMutationVariables>
export const UpdateJobTitleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateJobTitle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_job_title_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_job_title_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateJobTitleMutation, UpdateJobTitleMutationVariables>
export const InsertJobTriggerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertJobTrigger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_job_trigger_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_job_trigger_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertJobTriggerMutation, InsertJobTriggerMutationVariables>
export const UpdateJobTriggerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateJobTrigger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_job_trigger_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_job_trigger_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateJobTriggerMutation, UpdateJobTriggerMutationVariables>
export const InsertPartnerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertPartner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_partner_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_partner_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertPartnerMutation, InsertPartnerMutationVariables>
export const UpdatePartnerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePartner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_partner_set_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_partner_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdatePartnerMutation, UpdatePartnerMutationVariables>
export const InsertProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_project_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_project_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertProjectMutation, InsertProjectMutationVariables>
export const UpdateProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_project_set_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_project_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>
export const InsertProjectToUserMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertProjectToUserMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'coassign_project_to_user_insert_input' }
                }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_project_to_user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertProjectToUserMutationDocumentMutation,
  InsertProjectToUserMutationDocumentMutationVariables
>
export const UpdateProjectToUserMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProjectToUserMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_project_to_user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateProjectToUserMutationDocumentMutation,
  UpdateProjectToUserMutationDocumentMutationVariables
>
export const InsertProjectToDepartmentMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertProjectToDepartmentMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'coassign_project_to_department_insert_input' }
                }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_project_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertProjectToDepartmentMutationDocumentMutation,
  InsertProjectToDepartmentMutationDocumentMutationVariables
>
export const UpdateProjectToDepartmentMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProjectToDepartmentMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'department_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_project_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'department_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'department_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateProjectToDepartmentMutationDocumentMutation,
  UpdateProjectToDepartmentMutationDocumentMutationVariables
>
export const UpdateDeletedAtProjectToDepartmentMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtProjectToDepartmentMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_project_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtProjectToDepartmentMutationDocumentMutation,
  UpdateDeletedAtProjectToDepartmentMutationDocumentMutationVariables
>
export const UpdateDeletedAtProjectToUserMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtProjectToUserMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_project_to_user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtProjectToUserMutationDocumentMutation,
  UpdateDeletedAtProjectToUserMutationDocumentMutationVariables
>
export const UpdateDeletedAtAssignPlanMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtAssignPlanMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_assign_plan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assign_plan_assign' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'project_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'project_id' }
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtAssignPlanMutationDocumentMutation,
  UpdateDeletedAtAssignPlanMutationDocumentMutationVariables
>
export const UpdateDeletedAtAssignMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtAssignMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_assign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtAssignMutationDocumentMutation,
  UpdateDeletedAtAssignMutationDocumentMutationVariables
>
export const UpdateDeletedAtVolumedAssignPlanMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtVolumedAssignPlanMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_plan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'volumed_assign_plan_assign' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'project_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'project_id' }
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtVolumedAssignPlanMutationDocumentMutation,
  UpdateDeletedAtVolumedAssignPlanMutationDocumentMutationVariables
>
export const UpdateDeletedAtVolumedAssignToJobSkillMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtVolumedAssignToJobSkillMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_to_job_skill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'volumed_assign' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'project_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'project_id' }
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtVolumedAssignToJobSkillMutationDocumentMutation,
  UpdateDeletedAtVolumedAssignToJobSkillMutationDocumentMutationVariables
>
export const UpdateDeletedAtVolumedAssignMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtVolumedAssignMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtVolumedAssignMutationDocumentMutation,
  UpdateDeletedAtVolumedAssignMutationDocumentMutationVariables
>
export const DeleteVolumedAssignToDepartmentByProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteVolumedAssignToDepartmentByProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'volumed_assign' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'project_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'project_id' }
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  DeleteVolumedAssignToDepartmentByProjectMutation,
  DeleteVolumedAssignToDepartmentByProjectMutationVariables
>
export const UpdateDeletedAtWorkOnProjectMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtWorkOnProjectMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_work_on_project' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtWorkOnProjectMutationDocumentMutation,
  UpdateDeletedAtWorkOnProjectMutationDocumentMutationVariables
>
export const UpdateDeletedAtTargetCostOtherByProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtTargetCostOtherByProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_target_cost_other' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtTargetCostOtherByProjectMutation,
  UpdateDeletedAtTargetCostOtherByProjectMutationVariables
>
export const UpdateDeletedAtMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_project' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtMutationDocumentMutation,
  UpdateDeletedAtMutationDocumentMutationVariables
>
export const InsertRegularHolidayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertRegularHoliday' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_regular_holiday_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_regular_holiday_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertRegularHolidayMutation, InsertRegularHolidayMutationVariables>
export const UpdateRegularHolidayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateRegularHoliday' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_regular_holiday_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_regular_holiday_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateRegularHolidayMutation, UpdateRegularHolidayMutationVariables>
export const InsertTargetCostOtherDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertTargetCostOther' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_target_cost_other_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_target_cost_other_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertTargetCostOtherMutation, InsertTargetCostOtherMutationVariables>
export const UpdateTargetCostOtherDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTargetCostOther' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_target_cost_other_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_target_cost_other_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateTargetCostOtherMutation, UpdateTargetCostOtherMutationVariables>
export const UpdateDeletedAtTargetCostOtherMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtTargetCostOtherMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'target_cost_other_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_target_cost_other' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'target_cost_other_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtTargetCostOtherMutationDocumentMutation,
  UpdateDeletedAtTargetCostOtherMutationDocumentMutationVariables
>
export const InsertTargetCostOtherActualDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertTargetCostOtherActual' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_target_cost_other_actual_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_target_cost_other_actual_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertTargetCostOtherActualMutation,
  InsertTargetCostOtherActualMutationVariables
>
export const UpdateTargetCostOtherActualDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTargetCostOtherActual' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_target_cost_other_actual_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_target_cost_other_actual_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateTargetCostOtherActualMutation,
  UpdateTargetCostOtherActualMutationVariables
>
export const UpdateDeletedAtTargetCostOtherActualDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtTargetCostOtherActual' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'target_cost_other_actual_id' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_target_cost_other_actual' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'target_cost_other_actual_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtTargetCostOtherActualMutation,
  UpdateDeletedAtTargetCostOtherActualMutationVariables
>
export const UpdateTenantSettingsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTenantSettingsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'json' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commitId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_tenant_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'settings' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commitId' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateTenantSettingsMutationMutation,
  UpdateTenantSettingsMutationMutationVariables
>
export const UpdateMfaStatusMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateMfaStatusMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'UpdateMfaStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateMfaStatusMutationMutation,
  UpdateMfaStatusMutationMutationVariables
>
export const InsertUserMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertUserMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_user_insert_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_user_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertUserMutationDocumentMutation,
  InsertUserMutationDocumentMutationVariables
>
export const UpdateUserMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'coassign_user_set_input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_user_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateUserMutationDocumentMutation,
  UpdateUserMutationDocumentMutationVariables
>
export const InsertUserToDepartmentMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertUserToDepartmentMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'coassign_user_to_department_insert_input' }
                }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_user_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertUserToDepartmentMutationDocumentMutation,
  InsertUserToDepartmentMutationDocumentMutationVariables
>
export const UpdateUserToDepartmentMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserToDepartmentMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'department_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_user_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'department_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'department_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateUserToDepartmentMutationDocumentMutation,
  UpdateUserToDepartmentMutationDocumentMutationVariables
>
export const InsertUserToJobTitleMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertUserToJobTitleMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'coassign_user_to_job_title_insert_input' }
                }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_user_to_job_title' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertUserToJobTitleMutationDocumentMutation,
  InsertUserToJobTitleMutationDocumentMutationVariables
>
export const UpdateUserToJobTitleMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserToJobTitleMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'job_title_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_user_to_job_title' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'job_title_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'job_title_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateUserToJobTitleMutationDocumentMutation,
  UpdateUserToJobTitleMutationDocumentMutationVariables
>
export const InsertUserToJobSkillMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertUserToJobSkillMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'coassign_user_to_job_skill_insert_input' }
                }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_user_to_job_skill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertUserToJobSkillMutationDocumentMutation,
  InsertUserToJobSkillMutationDocumentMutationVariables
>
export const UpdateUserToJobSkillMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserToJobSkillMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'job_skill_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_user_to_job_skill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'job_skill_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'job_skill_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateUserToJobSkillMutationDocumentMutation,
  UpdateUserToJobSkillMutationDocumentMutationVariables
>
export const MutateCreateFirebaseUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'mutateCreateFirebaseUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_tenant_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subdomain' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CreateFirebaseUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firebase_tenant_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_tenant_id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subdomain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subdomain' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  MutateCreateFirebaseUserMutation,
  MutateCreateFirebaseUserMutationVariables
>
export const MutateUpdateFirebaseUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'mutateUpdateFirebaseUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_tenant_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_uid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'disabled' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'UpdateEmailFirebaseUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firebase_tenant_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_tenant_id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firebase_uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_uid' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'disabled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'disabled' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  MutateUpdateFirebaseUserMutation,
  MutateUpdateFirebaseUserMutationVariables
>
export const UpdatePasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_tenant_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_uid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'UpdateEmailFirebaseUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firebase_tenant_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_tenant_id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firebase_uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firebase_uid' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdatePasswordMutation, UpdatePasswordMutationVariables>
export const InsertVolumedAssignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertVolumedAssign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_volumed_assign_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_volumed_assign_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertVolumedAssignMutation, InsertVolumedAssignMutationVariables>
export const InsertVolumedAssignToJobSkillMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertVolumedAssignToJobSkillMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'coassign_volumed_assign_to_job_skill_insert_input' }
                }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_volumed_assign_to_job_skill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertVolumedAssignToJobSkillMutationDocumentMutation,
  InsertVolumedAssignToJobSkillMutationDocumentMutationVariables
>
export const UpdateVolumedAssignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVolumedAssign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_volumed_assign_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateVolumedAssignMutation, UpdateVolumedAssignMutationVariables>
export const UpdatVolumedAssignToJobSkillMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatVolumedAssignToJobSkillMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volumed_assign_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'job_skill_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_to_job_skill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'volumed_assign_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'volumed_assign_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'job_skill_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'job_skill_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdatVolumedAssignToJobSkillMutationDocumentMutation,
  UpdatVolumedAssignToJobSkillMutationDocumentMutationVariables
>
export const UpdateVolumedAssignMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVolumedAssignMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateVolumedAssignMutationDocumentMutation,
  UpdateVolumedAssignMutationDocumentMutationVariables
>
export const UpdateVolumedAssignPlanMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVolumedAssignPlanMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volumedAssignId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_plan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'volumed_assign_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'volumedAssignId' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateVolumedAssignPlanMutationDocumentMutation,
  UpdateVolumedAssignPlanMutationDocumentMutationVariables
>
export const UpdateVolumedAssignToJobSkillMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVolumedAssignToJobSkillMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volumedAssignId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_to_job_skill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'volumed_assign_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'volumedAssignId' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateVolumedAssignToJobSkillMutationDocumentMutation,
  UpdateVolumedAssignToJobSkillMutationDocumentMutationVariables
>
export const InsertVolumedAssignToDepartmentMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertVolumedAssignToDepartmentMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'coassign_volumed_assign_to_department_insert_input'
                  }
                }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_volumed_assign_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertVolumedAssignToDepartmentMutationDocumentMutation,
  InsertVolumedAssignToDepartmentMutationDocumentMutationVariables
>
export const UpdateVolumedAssignToDepartmentMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVolumedAssignToDepartmentMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volumed_assign_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'department_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'volumed_assign_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'volumed_assign_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'department_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'department_id' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateVolumedAssignToDepartmentMutationDocumentMutation,
  UpdateVolumedAssignToDepartmentMutationDocumentMutationVariables
>
export const UpdateDeletedAtVolumedAssignToDepartmentMutationDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeletedAtVolumedAssignToDepartmentMutationDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volumedAssignId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_to_department' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'volumed_assign_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'volumedAssignId' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedAt' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateDeletedAtVolumedAssignToDepartmentMutationDocumentMutation,
  UpdateDeletedAtVolumedAssignToDepartmentMutationDocumentMutationVariables
>
export const InsertVolumedAssignPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertVolumedAssignPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_volumed_assign_plan_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_volumed_assign_plan_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  InsertVolumedAssignPlanMutation,
  InsertVolumedAssignPlanMutationVariables
>
export const UpdateVolumedAssignPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVolumedAssignPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_volumed_assign_plan_set_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_volumed_assign_plan_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateVolumedAssignPlanMutation,
  UpdateVolumedAssignPlanMutationVariables
>
export const InsertWorkOnProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertWorkOnProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_work_on_project_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_work_on_project_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertWorkOnProjectMutation, InsertWorkOnProjectMutationVariables>
export const UpdateWorkOnProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateWorkOnProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actuals' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'comments' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_coassign_work_on_project_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'commit_id' } }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'comments' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'comments' } }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_append' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'actuals' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'actuals' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updated_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpdateWorkOnProjectMutation, UpdateWorkOnProjectMutationVariables>
export const InsertCommitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertCommit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'coassign_commit_insert_input' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_coassign_commit_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<InsertCommitMutation, InsertCommitMutationVariables>
export const TriggerJobByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'triggerJobById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobResultId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'TriggerJobById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobResultId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobResultId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<TriggerJobByIdMutation, TriggerJobByIdMutationVariables>
export const GenerateS3UrlForUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'generateS3UrlForUpload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'job_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'result_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'GenerateS3UrlForUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'job_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'job_id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'result_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'result_id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GenerateS3UrlForUploadMutation,
  GenerateS3UrlForUploadMutationVariables
>
export const GenerateJobResultS3UrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'generateJobResultS3Url' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'GenerateJobResultS3Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GenerateJobResultS3UrlMutation,
  GenerateJobResultS3UrlMutationVariables
>
export const GetJobResultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetJobResults' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'job_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coassign_job_result' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'job_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'job_id' } }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deleted_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '10' }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'job_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'log' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'job' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'job_definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'extension' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetJobResultsQuery, GetJobResultsQueryVariables>
export const GetCommitHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCommitHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coassign_commit_with_project_view' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'project_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'project_id' } }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'commit_at' },
                      value: { kind: 'EnumValue', value: 'desc' }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commit_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'project_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commit_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'change_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diff' } },
                { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'commit_user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetCommitHistoryQuery, GetCommitHistoryQueryVariables>
export const ResetMfaUserStatusMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetMfaUserStatusMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ResetMfaUserStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ResetMfaUserStatusMutationMutation,
  ResetMfaUserStatusMutationMutationVariables
>
export const HertbeatSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'hertbeatSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coassign_tenant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  HertbeatSubscriptionSubscription,
  HertbeatSubscriptionSubscriptionVariables
>
export const IntrospectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Introspection' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: '__schema' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'types' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FullType' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TypeRef' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__Type' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ofType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ofType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ofType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ofType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ofType' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'ofType' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'kind' }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'ofType' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'kind' }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'name' }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InputValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__InputValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FullType' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__Type' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeDeprecated' },
                value: { kind: 'BooleanValue', value: true }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'args' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InputValue' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeprecated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deprecationReason' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inputFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InputValue' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interfaces' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enumValues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeDeprecated' },
                value: { kind: 'BooleanValue', value: true }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeprecated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deprecationReason' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'possibleTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TypeRef' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IntrospectionQuery, IntrospectionQueryVariables>
